import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: any; output: any; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** DateTime localized to UTC and formatted as RFC 3339 (ending in 'Z') */
  RFC3339DateTime: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
  join__DirectiveArguments: { input: any; output: any; }
  join__FieldSet: { input: any; output: any; }
  link__Import: { input: any; output: any; }
};

export type AcademicConductCaseAppealView = {
  __typename?: 'AcademicConductCaseAppealView';
  createdAt: Scalars['DateTime']['output'];
  documentName?: Maybe<Scalars['String']['output']>;
  documentUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  signature: Scalars['String']['output'];
  submittedByUser: User;
};

export type AcademicConductCaseHistoryView = {
  __typename?: 'AcademicConductCaseHistoryView';
  action: ConductCaseHistoryAction;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documentName?: Maybe<Scalars['String']['output']>;
  documentUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internalNotes?: Maybe<Scalars['String']['output']>;
  newSeverity?: Maybe<ConductCaseSeverity>;
  newStatus?: Maybe<ConductCaseStatus>;
  performedByUser: StaffUser;
  previousSeverity?: Maybe<ConductCaseSeverity>;
  previousStatus?: Maybe<ConductCaseStatus>;
};

export type AcademicConductCaseLearnerHistoryView = {
  __typename?: 'AcademicConductCaseLearnerHistoryView';
  action: ConductCaseHistoryAction;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documentName?: Maybe<Scalars['String']['output']>;
  documentUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  newSeverity?: Maybe<ConductCaseSeverity>;
  newStatus?: Maybe<ConductCaseStatus>;
  previousSeverity?: Maybe<ConductCaseSeverity>;
  previousStatus?: Maybe<ConductCaseStatus>;
};

export type AcademicConductCaseLearnerView = {
  __typename?: 'AcademicConductCaseLearnerView';
  appeal?: Maybe<AcademicConductCaseAppealView>;
  appealDeadline?: Maybe<Scalars['DateTime']['output']>;
  appealStatus?: Maybe<AppealStatus>;
  appealSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  category: ConductCaseCategory;
  /** The name of the class associated with this case (for integrity violations). Exposed as a simple string instead of the full classEnrollment object to avoid leaking admin-only fields (gradeLockedForIntegrityViolation, LMS details, etc.) to the learner view. */
  className?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  history: Array<AcademicConductCaseLearnerHistoryView>;
  id: Scalars['ID']['output'];
  resolutionType?: Maybe<ConductCaseResolutionType>;
  severity: ConductCaseSeverity;
  status: ConductCaseStatus;
  term: Scalars['String']['output'];
};

export type AcademicConductCaseView = {
  __typename?: 'AcademicConductCaseView';
  appeal?: Maybe<AcademicConductCaseAppealView>;
  appealDeadline?: Maybe<Scalars['DateTime']['output']>;
  appealStatus?: Maybe<AppealStatus>;
  appealSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  category: ConductCaseCategory;
  classEnrollment?: Maybe<AdminClassEnrollmentView>;
  createdAt: Scalars['DateTime']['output'];
  createdByUser: StaffUser;
  history: Array<AcademicConductCaseHistoryView>;
  id: Scalars['ID']['output'];
  resolutionType?: Maybe<ConductCaseResolutionType>;
  severity: ConductCaseSeverity;
  status: ConductCaseStatus;
  term: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum AcademicStanding {
  AcademicDismissal = 'ACADEMIC_DISMISSAL',
  AcademicProbation = 'ACADEMIC_PROBATION',
  AcademicSuspension = 'ACADEMIC_SUSPENSION',
  GoodAcademicStanding = 'GOOD_ACADEMIC_STANDING',
  ScholasticWarning = 'SCHOLASTIC_WARNING'
}

export type Achievement = {
  __typename?: 'Achievement';
  campaigns?: Maybe<Array<Campaign>>;
  campaignsCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  pointsOverride?: Maybe<Array<AchievementPointsOverride>>;
  pointsOverrideCount?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<LegacyPointsTag>>;
  tagsCount?: Maybe<Scalars['Int']['output']>;
};


export type AchievementCampaignsArgs = {
  cursor?: InputMaybe<CampaignWhereUniqueInput>;
  orderBy?: Array<CampaignOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: CampaignWhereInput;
};


export type AchievementCampaignsCountArgs = {
  where?: CampaignWhereInput;
};


export type AchievementPointsOverrideArgs = {
  cursor?: InputMaybe<AchievementPointsOverrideWhereUniqueInput>;
  orderBy?: Array<AchievementPointsOverrideOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: AchievementPointsOverrideWhereInput;
};


export type AchievementPointsOverrideCountArgs = {
  where?: AchievementPointsOverrideWhereInput;
};


export type AchievementTagsArgs = {
  cursor?: InputMaybe<LegacyPointsTagWhereUniqueInput>;
  orderBy?: Array<LegacyPointsTagOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: LegacyPointsTagWhereInput;
};


export type AchievementTagsCountArgs = {
  where?: LegacyPointsTagWhereInput;
};

export type AchievementCreateInput = {
  campaigns?: InputMaybe<CampaignRelateToManyForCreateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  pointsOverride?: InputMaybe<AchievementPointsOverrideRelateToManyForCreateInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<LegacyPointsTagRelateToManyForCreateInput>;
};

export type AchievementManyRelationFilter = {
  every?: InputMaybe<AchievementWhereInput>;
  none?: InputMaybe<AchievementWhereInput>;
  some?: InputMaybe<AchievementWhereInput>;
};

export type AchievementOrderByInput = {
  createdAt?: InputMaybe<OrderDirection>;
  description?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  isActive?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  points?: InputMaybe<OrderDirection>;
  slug?: InputMaybe<OrderDirection>;
};

export type AchievementPointsOverride = {
  __typename?: 'AchievementPointsOverride';
  achievement?: Maybe<Achievement>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  memberAndLearnerCategory?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
};

export type AchievementPointsOverrideCreateInput = {
  achievement?: InputMaybe<AchievementRelateToOneForCreateInput>;
  memberAndLearnerCategory?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
};

export type AchievementPointsOverrideManyRelationFilter = {
  every?: InputMaybe<AchievementPointsOverrideWhereInput>;
  none?: InputMaybe<AchievementPointsOverrideWhereInput>;
  some?: InputMaybe<AchievementPointsOverrideWhereInput>;
};

export type AchievementPointsOverrideOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  memberAndLearnerCategory?: InputMaybe<OrderDirection>;
  points?: InputMaybe<OrderDirection>;
};

export type AchievementPointsOverrideRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<AchievementPointsOverrideWhereUniqueInput>>;
  create?: InputMaybe<Array<AchievementPointsOverrideCreateInput>>;
};

export type AchievementPointsOverrideRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<AchievementPointsOverrideWhereUniqueInput>>;
  create?: InputMaybe<Array<AchievementPointsOverrideCreateInput>>;
  disconnect?: InputMaybe<Array<AchievementPointsOverrideWhereUniqueInput>>;
  set?: InputMaybe<Array<AchievementPointsOverrideWhereUniqueInput>>;
};

export type AchievementPointsOverrideUpdateArgs = {
  data: AchievementPointsOverrideUpdateInput;
  where: AchievementPointsOverrideWhereUniqueInput;
};

export type AchievementPointsOverrideUpdateInput = {
  achievement?: InputMaybe<AchievementRelateToOneForUpdateInput>;
  memberAndLearnerCategory?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
};

export type AchievementPointsOverrideWhereInput = {
  AND?: InputMaybe<Array<AchievementPointsOverrideWhereInput>>;
  NOT?: InputMaybe<Array<AchievementPointsOverrideWhereInput>>;
  OR?: InputMaybe<Array<AchievementPointsOverrideWhereInput>>;
  achievement?: InputMaybe<AchievementWhereInput>;
  id?: InputMaybe<IdFilter>;
  memberAndLearnerCategory?: InputMaybe<StringFilter>;
  points?: InputMaybe<IntFilter>;
};

export type AchievementPointsOverrideWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AchievementRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<AchievementWhereUniqueInput>>;
  create?: InputMaybe<Array<AchievementCreateInput>>;
};

export type AchievementRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<AchievementWhereUniqueInput>>;
  create?: InputMaybe<Array<AchievementCreateInput>>;
  disconnect?: InputMaybe<Array<AchievementWhereUniqueInput>>;
  set?: InputMaybe<Array<AchievementWhereUniqueInput>>;
};

export type AchievementRelateToOneForCreateInput = {
  connect?: InputMaybe<AchievementWhereUniqueInput>;
  create?: InputMaybe<AchievementCreateInput>;
};

export type AchievementRelateToOneForUpdateInput = {
  connect?: InputMaybe<AchievementWhereUniqueInput>;
  create?: InputMaybe<AchievementCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AchievementUpdateArgs = {
  data: AchievementUpdateInput;
  where: AchievementWhereUniqueInput;
};

export type AchievementUpdateInput = {
  campaigns?: InputMaybe<CampaignRelateToManyForUpdateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  pointsOverride?: InputMaybe<AchievementPointsOverrideRelateToManyForUpdateInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<LegacyPointsTagRelateToManyForUpdateInput>;
};

export type AchievementWhereInput = {
  AND?: InputMaybe<Array<AchievementWhereInput>>;
  NOT?: InputMaybe<Array<AchievementWhereInput>>;
  OR?: InputMaybe<Array<AchievementWhereInput>>;
  campaigns?: InputMaybe<CampaignManyRelationFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  isActive?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  points?: InputMaybe<IntFilter>;
  pointsOverride?: InputMaybe<AchievementPointsOverrideManyRelationFilter>;
  slug?: InputMaybe<StringFilter>;
  tags?: InputMaybe<LegacyPointsTagManyRelationFilter>;
};

export type AchievementWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type AddEducationInput = {
  /** The field of study for this education. */
  fieldOfStudy: Scalars['String']['input'];
  /** True if the user graduated this education. */
  graduatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The country of the institution. */
  institutionCountry?: InputMaybe<Scalars['String']['input']>;
  /** The county of the institution. */
  institutionCounty?: InputMaybe<Scalars['String']['input']>;
  /** The locality of the institution. */
  institutionLocality?: InputMaybe<Scalars['String']['input']>;
  /** The institution name of this education. */
  institutionName: Scalars['String']['input'];
  /** An institution id from an external service. */
  knownInstitutionId?: InputMaybe<Scalars['String']['input']>;
  /** The level of study for this education. */
  levelOfStudy: Scalars['String']['input'];
  /** The start date of the user education. */
  startDate: Scalars['DateTime']['input'];
};

export type AddEducationPayload = {
  __typename?: 'AddEducationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated user. */
  user: User;
};

export type AddLanguageSkillInput = {
  /** The language which the user knows. */
  language: LanguageEnum;
  /** The proficiency level the user has in this language */
  proficiencyLevel: LanguageProficiencyLevel;
};

export type AddLanguageSkillsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The list of languages of this user. */
  languages: Array<AddLanguageSkillInput>;
};

export type AddLanguageSkillsPayload = {
  __typename?: 'AddLanguageSkillsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated user. */
  user: User;
};

export type AddLeaveOfAbsenceToLearnerInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description for the leave of absence. */
  leaveOfAbsenceDescription?: InputMaybe<Scalars['String']['input']>;
  /** The reason category for the leave of absence. */
  leaveOfAbsenceReason: DeferralReason;
  /** The program enrollment id. */
  programEnrollmentId: Scalars['ID']['input'];
};

export type AddLeaveOfAbsenceToLearnerPayload = {
  __typename?: 'AddLeaveOfAbsenceToLearnerPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The program enrollment. */
  programEnrollment: ProgramEnrollment;
};

export type AdminAddApiKeyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type AdminAddApiKeyPayload = {
  __typename?: 'AdminAddApiKeyPayload';
  apiKey: Scalars['String']['output'];
  clientMutationId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type AdminAddClassEnrollmentInput = {
  /** The id of the class in which to enroll the learner. */
  classId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the lms class location. If missing will default to a random lms class location of this class. */
  lmsClassLocationId?: InputMaybe<Scalars['ID']['input']>;
  /** The sandId of the learner to enroll. */
  sandId: Scalars['ID']['input'];
  /** The reason for the status of the class enrollment. Defaults to null. */
  statusReason?: InputMaybe<ClassEnrollmentStatusReason>;
};

export type AdminAddClassEnrollmentPayload = {
  __typename?: 'AdminAddClassEnrollmentPayload';
  /** The class enrollment. */
  classEnrollment: AdminClassEnrollmentView;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AdminAddClassInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The cohort key used in the curriculum visualizer. */
  cohortKey?: InputMaybe<Scalars['String']['input']>;
  /** The id of the courseDefinition for which this class is created. */
  courseDefinitionId: Scalars['ID']['input'];
  /** Date when this class ends. */
  endDate: Scalars['DateTime']['input'];
  /** The name of the class to create. */
  name: Scalars['String']['input'];
  /** Date when this class starts. */
  startDate: Scalars['DateTime']['input'];
  /** The academic term this class belongs to (e.g., "2026 Spring"). */
  term?: InputMaybe<Scalars['String']['input']>;
};

export type AdminAddClassPayload = {
  __typename?: 'AdminAddClassPayload';
  /** The created class. */
  class: AdminClassView;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AdminAddCohortInput = {
  /** Can learners in this cohort defer their corresponding ongoing courses. */
  allowCourseDeferral?: InputMaybe<Scalars['Boolean']['input']>;
  /** Can learners in this cohort request leave of absence on their program enrollment. */
  allowLeaveOfAbsence?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Date when this cohort ends. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** A boolean which represents if the payment plan of this cohort is all access or not. */
  isAllAccessPaymentPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the cohort to create. */
  name: Scalars['String']['input'];
  /** The id of the program in which this cohort is enrolled. */
  nileFlowId: Scalars['ID']['input'];
  /** The learners' preferred hub for this cohort. */
  nilePrefferedHubQuestionId?: InputMaybe<Scalars['String']['input']>;
  /** Can learners be enrolled into this cohort at this time, default false. */
  openToEnrollments?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the program in which this cohort is enrolled. */
  programId: Scalars['ID']['input'];
  /** Date when this cohort starts. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdminAddCohortPayload = {
  __typename?: 'AdminAddCohortPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The cohort that was created. */
  cohort: AdminCohortView;
};

export type AdminAddCourseDefinitionInput = {
  /** The abbreviation of the course name. */
  abbreviation: Scalars['String']['input'];
  /** The category of the course. */
  category?: InputMaybe<CourseCategory>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description of the course */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The duration of the course (used for marketing purposes). */
  duration?: InputMaybe<Scalars['String']['input']>;
  /** The name of the course to create. */
  name: Scalars['String']['input'];
};

export type AdminAddCourseDefinitionPayload = {
  __typename?: 'AdminAddCourseDefinitionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The course that was created. */
  course: AdminCourseDefinitionView;
};

export type AdminAddCourseEnrollmentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the course. */
  courseDefinitionId: Scalars['ID']['input'];
  /** The sandId of the learner to enroll. */
  sandId: Scalars['ID']['input'];
  /** The status of the course enrollment. Defaults to ONGOING. */
  status?: InputMaybe<CourseEnrollmentStatus>;
  /** The reason for the status of the course enrollment. Defaults to null. */
  statusReason?: InputMaybe<CourseEnrollmentStatusReason>;
};

export type AdminAddCourseEnrollmentPayload = {
  __typename?: 'AdminAddCourseEnrollmentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The course enrollment. */
  courseEnrollment: AdminCourseEnrollmentView;
};

export type AdminAddCoursePrerequisitesInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A list of courseDefinitionIds of courses that must all be graduated before the student can take this course in this program but which are shorter courses and can be taken during the same term as this course. */
  doneWithPrerequisiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A list of courseDefinitionIds of courses that must all be graduated before the learner can take this course in this program. */
  mustHavePrerequisiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A list of courseDefinitionIds of courses. At least one of the courses in this list needs to be graduated before the learner can take this course in this program. This list should contain the courses intended to be taken in the previous academical term. */
  oneOfPrerequisiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The id of the program. */
  programCourseId: Scalars['ID']['input'];
};

export type AdminAddCoursePrerequisitesPayload = {
  __typename?: 'AdminAddCoursePrerequisitesPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created programCourse. */
  programCourse: AdminProgramCourseView;
};

export type AdminAddEducationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The list of education objects to add to this user. */
  educations: Array<AddEducationInput>;
  /** The sandId of the user to update. */
  sandId: Scalars['ID']['input'];
};

export type AdminAddEducationPayload = {
  __typename?: 'AdminAddEducationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated user. */
  user: StaffUser;
};

export type AdminAddGradesMappingInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The GPA value (0-4) assigned for this letter grade. */
  gradePointsValue: Scalars['Float']['input'];
  /** The letter grade (e.g. A, B+, C). */
  letterGrade: Scalars['String']['input'];
  /** The minimum grade points (0-100) for this letter grade. */
  minGradePoints: Scalars['Float']['input'];
};

export type AdminAddGradesMappingPayload = {
  __typename?: 'AdminAddGradesMappingPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created grades mapping. */
  gradesMapping: AdminGradesMappingView;
};

export type AdminAddLanguageSkillsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The list of languages to add to this user. */
  languages: Array<AddLanguageSkillInput>;
  /** The sandId of the user to update. */
  sandId: Scalars['ID']['input'];
};

export type AdminAddLanguageSkillsPayload = {
  __typename?: 'AdminAddLanguageSkillsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated user. */
  user: StaffUser;
};

export type AdminAddLeaveOfAbsenceToLearnerInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description for the leave of absence. */
  leaveOfAbsenceDescription?: InputMaybe<Scalars['String']['input']>;
  /** The reason category for the leave of absence. */
  leaveOfAbsenceReason: DeferralReason;
  /** The program enrollment id. */
  programEnrollmentId: Scalars['ID']['input'];
};

export type AdminAddLeaveOfAbsenceToLearnerPayload = {
  __typename?: 'AdminAddLeaveOfAbsenceToLearnerPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The program enrollment. */
  programEnrollment: AdminProgramEnrollmentView;
};

export type AdminAddLmsClassLocationInput = {
  /** The id of the class which this lms class location belongs tpo. */
  classId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the course inside the lms. */
  learningPlatform?: InputMaybe<LearningPlatform>;
  /** The id of the cohort inside the lms. */
  lmsCohortId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the course inside the lms. */
  lmsCourseId: Scalars['String']['input'];
  /** The name of this lms class location. */
  name: Scalars['String']['input'];
  /** The country of residence value for the distribution. */
  preferredCountryOfResidence?: InputMaybe<Scalars['String']['input']>;
  /** The preferred hub value for the distribution. */
  preferredHub?: InputMaybe<Scalars['String']['input']>;
};

export type AdminAddLmsClassLocationPayload = {
  __typename?: 'AdminAddLmsClassLocationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created lms class location. */
  lmsClassLocation: AdminLmsClassLocationView;
};

export type AdminAddOAuthClientInput = {
  /** The code key name provided by the client */
  codeKeyName?: InputMaybe<Scalars['String']['input']>;
  /** The name of the OAuth client. */
  name: Scalars['String']['input'];
  /** The redirect URI key name provided by the client */
  redirectUriKeyName?: InputMaybe<Scalars['String']['input']>;
  /** A list of allowed redirect uris. */
  redirectUris: Array<Scalars['String']['input']>;
  /** The response type key name provided by the client */
  responseTypeKeyName?: InputMaybe<Scalars['String']['input']>;
  /** The scope type key name provided by the client */
  scopeTypeKeyName?: InputMaybe<Scalars['String']['input']>;
  /** The state key name provided by the client */
  stateKeyName?: InputMaybe<Scalars['String']['input']>;
};

export type AdminAddOAuthClientPayload = {
  __typename?: 'AdminAddOAuthClientPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The newly created OAuth Client. */
  oauthClient: OAuthClient;
};

export type AdminAddPartnershipInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Discount amount. */
  discount: Scalars['Float']['input'];
  /** The name of the partnership. */
  name: Scalars['String']['input'];
  /** The payment plan id for the partnership. */
  paymentPlanId: Scalars['String']['input'];
  /** Start date for the partnership. */
  startDate: Scalars['DateTime']['input'];
  /** Term tuition amount. */
  termTuition: Scalars['Float']['input'];
  /** Total tuition amount. */
  totalTuition: Scalars['Float']['input'];
  /** Total tuition net of discounts. */
  totalTuitionNetOfDiscounts: Scalars['Float']['input'];
};

export type AdminAddPartnershipPayload = {
  __typename?: 'AdminAddPartnershipPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created partnership. */
  partnership: AdminPartnership;
};

export type AdminAddPermissionToRoleInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The permission to add to the role. */
  permission: Permission;
  /** The id of the role. */
  roleId: Scalars['Int']['input'];
};

export type AdminAddPermissionToRolePayload = {
  __typename?: 'AdminAddPermissionToRolePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  role: Role;
};

export type AdminAddProgramEnrollmentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The cohortId in which to enroll the learner. */
  cohortId?: InputMaybe<Scalars['ID']['input']>;
  /** The preferred hub for this program enrollment. */
  preferredHub?: InputMaybe<Scalars['String']['input']>;
  /** The programId in which to enroll the learner. */
  programId?: InputMaybe<Scalars['ID']['input']>;
  /** The sandId of the learner to enroll. */
  sandId: Scalars['ID']['input'];
};

export type AdminAddProgramEnrollmentPayload = {
  __typename?: 'AdminAddProgramEnrollmentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The program enrollment that was created. */
  programEnrollment: AdminProgramEnrollmentView;
};

export type AdminAddProgramInput = {
  /** The abbreviation of the program name. */
  abbreviation: Scalars['String']['input'];
  /** The access fee price for this program */
  accessFee?: InputMaybe<Scalars['String']['input']>;
  /** Duration in days after class start during which enrollments are allowed. */
  addDropPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  /** Can learners in this program defer their corresponding ongoing courses. */
  allowCourseDeferral?: InputMaybe<Scalars['Boolean']['input']>;
  /** Can learners in this program request leave of absence on their program enrollment. */
  allowLeaveOfAbsence?: InputMaybe<Scalars['Boolean']['input']>;
  /** Can the learner be enrolled into this program while being enrolled into other programs. */
  allowsConcurrentEnrollments?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description of the program */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Does this program have Answerbase support. */
  hasAnswerbaseSupport?: InputMaybe<Scalars['Boolean']['input']>;
  /** Does this program have check-in support at the hubs. */
  hasCheckInSupport?: InputMaybe<Scalars['Boolean']['input']>;
  /** Does this program have Circle support. */
  hasCircleSupport?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the program has overall multiple courses planned. */
  hasMultiCourseDisplay?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of program highlights. */
  highlights: Array<Scalars['String']['input']>;
  /** A boolean which represents if the payment plan of this program is all access or not. */
  isAllAccessPaymentPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the program is a university one or not. */
  isUniversityProgram?: InputMaybe<Scalars['Boolean']['input']>;
  /** The legacy points amount displayed for the program. */
  legacyPoints?: InputMaybe<Scalars['String']['input']>;
  /** The maximum amount of credits worth of courses that a learner can be enrolled into during an academical term. */
  maxTermCredits: Scalars['Int']['input'];
  /** The minimum amount of credits worth of courses that a learner must be enrolled into during an academical term. Used only for deciding if the learner can defer a course, and will not stop a learner from taking fewer course in the case where all of his available courses amount to fewer credits. */
  minTermCredits: Scalars['Int']['input'];
  /** The program name. */
  name: Scalars['String']['input'];
  /** Does the program accept enrollments at this time. */
  openToEnrollments?: InputMaybe<Scalars['Boolean']['input']>;
  /** The payment plan definition id of this program. */
  paymentPlanDefinitionId?: InputMaybe<Scalars['String']['input']>;
  /** The default duration of the program. */
  programDuration?: InputMaybe<Scalars['String']['input']>;
  /** Whether the program requires a tuition questionnaire or not. */
  requiresTuitionQuestionnaire?: InputMaybe<Scalars['Boolean']['input']>;
  /** The summary or long description of the section where the program is explained */
  sectionSummary?: InputMaybe<Scalars['String']['input']>;
  /** The title of the section where the program is explained */
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
  /** A sub title. Usually used to add more information after the title. */
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** The thumbnail we want to display for the video. */
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  /** The expected time commitment from the user in order to successfully complete the program. */
  timeCommitment?: InputMaybe<Scalars['String']['input']>;
  /** The top marketing title, displayed usually under program name. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The specific version of the program as programs with the same name can have different mandatory courses. */
  version: Scalars['String']['input'];
  /** The marketing video for this program. */
  video?: InputMaybe<Scalars['String']['input']>;
};

export type AdminAddProgramPayload = {
  __typename?: 'AdminAddProgramPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  program: AdminProgramView;
};

export type AdminAddUserAsCityStaffInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the hub where you want to create the user's check-in. */
  hubId: Scalars['ID']['input'];
  /** The sand ID of the user you want to manually check in. */
  sandId: Scalars['ID']['input'];
};

export type AdminAddUserAsCityStaffPayload = {
  __typename?: 'AdminAddUserAsCityStaffPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type AdminApproveAcademicConductAppealInput = {
  caseId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  documentName?: InputMaybe<Scalars['String']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  newSeverity?: InputMaybe<ConductCaseSeverity>;
};

export type AdminApproveAcademicConductAppealPayload = {
  __typename?: 'AdminApproveAcademicConductAppealPayload';
  academicConductCase: AcademicConductCaseView;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AdminAssignUserToRoleInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the role to assign to the user */
  roleId: Scalars['Int']['input'];
  /** Id of the user to assign to the role */
  sandId: Scalars['String']['input'];
};

export type AdminAssignUserToRolePayload = {
  __typename?: 'AdminAssignUserToRolePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The user who was assigned to the role. */
  user: StaffUser;
};

/** Audit log entry for admin actions */
export type AdminAuditLog = {
  __typename?: 'AdminAuditLog';
  /** Specific action that was performed */
  action: AuditAction;
  /** Roles of the actor at the time of the action */
  actorRoles: Array<Scalars['String']['output']>;
  /** Sand ID of the admin who performed the action */
  actorSandId: Scalars['String']['output'];
  /** Details of the admin who performed the action */
  actorUser?: Maybe<StaffUser>;
  /** When the action was performed */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier of the audit log entry */
  id: Scalars['ID']['output'];
  /** Arguments passed to the operation */
  inputData: Scalars['JSON']['output'];
  /** Additional context (IP, user agent, etc.) */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Type of GraphQL operation (MUTATION, QUERY, etc.) */
  operationType: OperationType;
  /** ID of the affected entity */
  targetEntityId?: Maybe<Scalars['String']['output']>;
  /** Type of entity affected (e.g., User, ProgramEnrollment) */
  targetEntityType?: Maybe<Scalars['String']['output']>;
  /** Sand ID of the affected user (if applicable) */
  targetSandId?: Maybe<Scalars['String']['output']>;
  /** Details of the affected user (if applicable) */
  targetUser?: Maybe<StaffUser>;
};

export type AdminBulkAssignUsersToRoleInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the role to assign to the users */
  roleId: Scalars['Int']['input'];
  /** List of user sandIds to assign to the role */
  sandIds: Array<Scalars['String']['input']>;
};

export type AdminBulkAssignUsersToRolePayload = {
  __typename?: 'AdminBulkAssignUsersToRolePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Number of users successfully assigned */
  successCount: Scalars['Int']['output'];
  /** The users who were assigned to the role. */
  users: Array<StaffUser>;
};

export type AdminBulkRecalculateGpAsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type AdminBulkRecalculateGpAsPayload = {
  __typename?: 'AdminBulkRecalculateGPAsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The number of program enrollments queued for GPA recalculation. */
  queuedCount: Scalars['Int']['output'];
};

export type AdminChangeProgramEnrollmentProgramInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The new program to assign to this enrollment. */
  newProgramId: Scalars['ID']['input'];
  /** The program enrollment to change. */
  programEnrollmentId: Scalars['ID']['input'];
};

export type AdminChangeProgramEnrollmentProgramPayload = {
  __typename?: 'AdminChangeProgramEnrollmentProgramPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated program enrollment. */
  programEnrollment: AdminProgramEnrollmentView;
};

export type AdminCheckInUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
};

export type AdminCheckInUserPayload = {
  __typename?: 'AdminCheckInUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type AdminClassEnrollmentView = {
  __typename?: 'AdminClassEnrollmentView';
  /** Whether this class enrollment was cancelled. */
  cancelled: Scalars['Boolean']['output'];
  /** The class in which the user is enrolled. */
  class: AdminClassView;
  /** The course enrollment which contains this class enrollment. */
  courseEnrollment: AdminCourseEnrollmentView;
  /** Date & time when this object was initially created. */
  createdAt: Scalars['DateTime']['output'];
  /** The description why the learner was deferred. */
  deferralDescription?: Maybe<Scalars['String']['output']>;
  /** The reason category why the learner was deferred. */
  deferralReason?: Maybe<DeferralReason>;
  /** The datetime when the class enrollment was deferred. */
  deferredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The datetime when the class enrollment was failed. */
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the grade is locked due to an academic integrity violation. */
  gradeLockedForIntegrityViolation: Scalars['Boolean']['output'];
  /** The numerical grade points received for this class. */
  gradePoints?: Maybe<Scalars['Float']['output']>;
  /** The GPA-scale value (0.0-4.0) for this class. */
  gradePointsValue?: Maybe<Scalars['Float']['output']>;
  /** The datetime when the class enrollment was graduated. */
  graduatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the class. */
  id: Scalars['ID']['output'];
  /** The data & time when leave of absence was last taken. */
  lastLeaveOfAbsenceAt?: Maybe<Scalars['DateTime']['output']>;
  /** The description for the learner's leave of absence. */
  leaveOfAbsenceDescription?: Maybe<Scalars['String']['output']>;
  /** The reason category for the learner's leave of absence */
  leaveOfAbsenceReason?: Maybe<DeferralReason>;
  /** The letter grade for this class (e.g., A, A-, B+, W, WF, WP, etc.). */
  letterGrade?: Maybe<Scalars['String']['output']>;
  /** The lms class location for this class. */
  lmsClassLocation: AdminLmsClassLocationView;
  /** The proof of completion of this class enrollment. */
  proofOfCompletion?: Maybe<AdminProofOfCompletionView>;
  /** The user enrolled into this class. */
  regularUser: User;
  /** The data & time when the user was last reinstated. */
  reinstatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The status of the class enrollment. */
  status?: Maybe<ClassEnrollmentStatus>;
  /** The reason for the status of the class enrollment. */
  statusReason?: Maybe<ClassEnrollmentStatusReason>;
  /** Date & time when this object was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The user enrolled into this class. */
  user: StaffUser;
};

export type AdminClassView = {
  __typename?: 'AdminClassView';
  /** The enrollments in this class. */
  classEnrollments: Array<AdminClassEnrollmentView>;
  /** The cohort key used in the curriculum visualizer. */
  cohortKey?: Maybe<Scalars['String']['output']>;
  /** The course taken by this class. */
  course: AdminCourseDefinitionView;
  /** Date & time when this object was initially created. */
  createdAt: Scalars['DateTime']['output'];
  /** Date when this class ends. */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Enrollment counts by status for this class */
  enrollmentCounts: Array<ClassEnrollmentStatusCount>;
  /** Did the class finish. Placeholder for statuses */
  finished: Scalars['Boolean']['output'];
  /** The id of the class. */
  id: Scalars['ID']['output'];
  /** The lms class location. */
  lmsClassLocations: Array<Maybe<AdminLmsClassLocationView>>;
  /** The name of the class. */
  name: Scalars['String']['output'];
  /** Proof of completion type. */
  proofOfCompletionType: ProofOfCompletionType;
  /** Date when this class starts. */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** The academic term this class belongs to (e.g., "2026 Spring"). */
  term?: Maybe<Scalars['String']['output']>;
  /** Date & time when this object was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type AdminCohortView = {
  __typename?: 'AdminCohortView';
  /** Can students in this cohort use the all access payment plan for this program. */
  allAccessPaymentPlan: Scalars['Boolean']['output'];
  /** Can learners in this cohort defer their corresponding ongoing courses. */
  allowCourseDeferral: Scalars['Boolean']['output'];
  /** Can learners in this cohort request leave of absence on their program enrollment. */
  allowLeaveOfAbsence: Scalars['Boolean']['output'];
  /** List of all learner enrollments for this cohort */
  cohortEnrollments: Array<AdminProgramEnrollmentView>;
  /** Date & time when this object was initially created. */
  createdAt: Scalars['DateTime']['output'];
  /** Date when this cohort ends. */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the cohort. */
  id: Scalars['ID']['output'];
  /** The minimum number of checkins per week required as an attendace requirement. */
  minWeeklyCheckins: Scalars['Int']['output'];
  /** The name of the cohort. */
  name: Scalars['String']['output'];
  /** The nile flow id. */
  nileFlowId: Scalars['ID']['output'];
  /** Can learners be enrolled into this cohort at this time, default false. */
  openToEnrollments: Scalars['Boolean']['output'];
  /** Returns a list of users using offset pagination. */
  paginatedCohortEnrollments: AdminPaginatedProgramEnrollments;
  /** The program that this cohort is a part of. */
  program: AdminProgramView;
  /** Date when this cohort starts. */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Date & time when this object was updated. */
  updatedAt: Scalars['DateTime']['output'];
};


export type AdminCohortViewPaginatedCohortEnrollmentsArgs = {
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchString?: InputMaybe<Scalars['String']['input']>;
};

export type AdminCourseDefinitionView = {
  __typename?: 'AdminCourseDefinitionView';
  /** The abbreviation of the course name. */
  abbreviation: Scalars['String']['output'];
  /** The category of the course. */
  category?: Maybe<CourseCategory>;
  /** The classes that takes this course. */
  classes: Array<AdminClassView>;
  /** The enrollments into this course. */
  courseEnrollments: Array<AdminCourseEnrollmentView>;
  /** Date & time when this object was initially created. */
  createdAt: Scalars['DateTime']['output'];
  /** The description of the course */
  description?: Maybe<Scalars['String']['output']>;
  /** The duration of the course (used for marketing purposes). */
  duration?: Maybe<Scalars['String']['output']>;
  /** Enrollment counts by status for this course */
  enrollmentCounts: Array<CourseEnrollmentStatusCount>;
  /** The id of the course definition. */
  id: Scalars['ID']['output'];
  /** The programCourses for this course. */
  linkedProgramCourses: Array<AdminProgramCourseView>;
  /** The name of the course. */
  name: Scalars['String']['output'];
  /** The programs in which this course is taken. */
  programs: Array<AdminProgramView>;
  /** Date & time when this object was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type AdminCourseEnrollmentView = {
  __typename?: 'AdminCourseEnrollmentView';
  /** The class enrollments taken by the learner enrolled in this course. */
  classEnrollments: Array<AdminClassEnrollmentView>;
  /** The course in which the user is enrolled. */
  course: AdminCourseDefinitionView;
  /** Date & time when this object was initially created. */
  createdAt: Scalars['DateTime']['output'];
  /** The datetime when the course enrollment was deferred. */
  deferredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The datetime when the course enrollment was failed. */
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The numerical grade points (0-100). */
  gradePoints?: Maybe<Scalars['Float']['output']>;
  /** The GPA-scale value (0.0-4.0). */
  gradePointsValue?: Maybe<Scalars['Float']['output']>;
  /** The datetime when the course enrollment was graduated. */
  graduatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the course. */
  id: Scalars['ID']['output'];
  /** The letter grade. */
  letterGrade?: Maybe<Scalars['String']['output']>;
  /** The status of the course enrollment. */
  status?: Maybe<CourseEnrollmentStatus>;
  /** The reason for the status of the course enrollment. */
  statusReason?: Maybe<CourseEnrollmentStatusReason>;
  /** Date & time when this object was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The user enrolled into this course. */
  user: StaffUser;
};

export type AdminCreateAcademicConductCaseInput = {
  category: ConductCaseCategory;
  classEnrollmentId?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  documentName?: InputMaybe<Scalars['String']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  programEnrollmentId: Scalars['ID']['input'];
  severity: ConductCaseSeverity;
  term: Scalars['String']['input'];
};

export type AdminCreateAcademicConductCasePayload = {
  __typename?: 'AdminCreateAcademicConductCasePayload';
  academicConductCase: AcademicConductCaseView;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AdminCreateNotificationsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The notifications to be created */
  notifications: Array<NotificationInput>;
};

export type AdminCreateNotificationsPayload = {
  __typename?: 'AdminCreateNotificationsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The number of notifications created */
  count: Scalars['Int']['output'];
};

export type AdminCreateRoleInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the role. */
  name: Scalars['String']['input'];
  /** Initial permissions for the role. */
  permissions?: InputMaybe<Array<Permission>>;
};

export type AdminCreateRolePayload = {
  __typename?: 'AdminCreateRolePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  role: Role;
};

export type AdminCreateStaffUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The email address of the staff user to create. */
  email: Scalars['String']['input'];
  /** The first name of the staff user. */
  firstName: Scalars['String']['input'];
  /** The last name of the staff user. */
  lastName: Scalars['String']['input'];
  /** The list of role IDs to assign to the user. */
  roleIds: Array<Scalars['Int']['input']>;
};

export type AdminCreateStaffUserPayload = {
  __typename?: 'AdminCreateStaffUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The newly created staff user. */
  user: StaffUser;
};

export type AdminCreateTrainingResourceInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A brief description of what the resource contains. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The display name/title of the training resource. */
  title: Scalars['String']['input'];
  /** The URL to the external resource (Google Sheets, Google Docs, PDF, etc.). */
  url: Scalars['String']['input'];
};

export type AdminCreateTrainingResourcePayload = {
  __typename?: 'AdminCreateTrainingResourcePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created training resource. */
  trainingResource: AdminTrainingResource;
};

export type AdminCreateWorkExperienceInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The sandId of the user to update */
  sandId: Scalars['ID']['input'];
  /** The list of new work experiences */
  workExperiences: Array<WorkExperienceCreateInput>;
};

export type AdminCreateWorkExperiencePayload = {
  __typename?: 'AdminCreateWorkExperiencePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated user. */
  user: StaffUser;
};

export type AdminDeleteApiKeyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type AdminDeleteApiKeyPayload = {
  __typename?: 'AdminDeleteApiKeyPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deleted: Scalars['Boolean']['output'];
};

export type AdminDeleteGradesMappingInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the global grades mapping to delete. */
  id: Scalars['ID']['input'];
};

export type AdminDeleteGradesMappingPayload = {
  __typename?: 'AdminDeleteGradesMappingPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The id of the deleted grades mapping. */
  deletedId: Scalars['ID']['output'];
};

export type AdminDeleteOAuthClientInput = {
  clientId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type AdminDeleteOAuthClientPayload = {
  __typename?: 'AdminDeleteOAuthClientPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type AdminDeleteProgramCourseInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the programCourse. */
  programCourseId: Scalars['ID']['input'];
};

export type AdminDeleteProgramCoursePayload = {
  __typename?: 'AdminDeleteProgramCoursePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created programCourse. */
  programCourse?: Maybe<AdminProgramCourseView>;
};

export type AdminDeleteRoleInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the role to be deleted. */
  roleId: Scalars['Int']['input'];
};

export type AdminDeleteRolePayload = {
  __typename?: 'AdminDeleteRolePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  role: Role;
};

export type AdminDeleteTrainingResourceInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the training resource to delete. */
  trainingResourceId: Scalars['ID']['input'];
};

export type AdminDeleteTrainingResourcePayload = {
  __typename?: 'AdminDeleteTrainingResourcePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The deleted training resource. */
  trainingResource: AdminTrainingResource;
};

export type AdminDenyAcademicConductAppealInput = {
  caseId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  documentName?: InputMaybe<Scalars['String']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
};

export type AdminDenyAcademicConductAppealPayload = {
  __typename?: 'AdminDenyAcademicConductAppealPayload';
  academicConductCase: AcademicConductCaseView;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AdminDocusignEnrollmentAgreement = {
  __typename?: 'AdminDocusignEnrollmentAgreement';
  /** First time the applicant reached COMPLETED status. */
  applicantCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** First time the applicant declined. */
  applicantDeclinedAt?: Maybe<Scalars['DateTime']['output']>;
  /** First time the applicant reached DELIVERED status. */
  applicantDeliveredAt?: Maybe<Scalars['DateTime']['output']>;
  /** Applicant email used when creating the envelope. */
  applicantEmail?: Maybe<Scalars['String']['output']>;
  /** Applicant name used when creating the envelope. */
  applicantName?: Maybe<Scalars['String']['output']>;
  /** Latest applicant status reported by DocuSign. */
  applicantStatus?: Maybe<Scalars['String']['output']>;
  /** Client user id set for embedded signing. */
  clientUserId?: Maybe<Scalars['String']['output']>;
  /** When this agreement record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** First time the envelope reached COMPLETED status. */
  envelopeCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** First time the envelope was declined. */
  envelopeDeclinedAt?: Maybe<Scalars['DateTime']['output']>;
  /** First time the envelope reached DELIVERED status. */
  envelopeDeliveredAt?: Maybe<Scalars['DateTime']['output']>;
  /** DocuSign envelope identifier. */
  envelopeId: Scalars['ID']['output'];
  /** First time the envelope reached SENT status. */
  envelopeSentAt?: Maybe<Scalars['DateTime']['output']>;
  /** Latest envelope status reported by DocuSign. */
  envelopeStatus?: Maybe<Scalars['String']['output']>;
  /** First time the envelope was voided. */
  envelopeVoidedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp of the last processed event. */
  lastEventAt?: Maybe<Scalars['DateTime']['output']>;
  /** Most recent DocuSign event type processed. */
  lastEventType?: Maybe<Scalars['String']['output']>;
  /** DocuSign template used to create the envelope. */
  templateId?: Maybe<Scalars['String']['output']>;
  /** When this agreement record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type AdminFinalizeDocusignAgreementInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the program application whose DocuSign agreement should be marked as fully signed. */
  id: Scalars['ID']['input'];
};

export type AdminFinalizeDocusignAgreementPayload = {
  __typename?: 'AdminFinalizeDocusignAgreementPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  programApplication: AdminProgramApplicationView;
};

export type AdminGradesMappingView = {
  __typename?: 'AdminGradesMappingView';
  createdAt: Scalars['DateTime']['output'];
  gradePointsValue: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  letterGrade: Scalars['String']['output'];
  minGradePoints: Scalars['Float']['output'];
  programId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AdminGradesMappingsResult = {
  __typename?: 'AdminGradesMappingsResult';
  /** True if any GradesMapping entries with non-null programId exist. */
  hasProgramSpecificMappings: Scalars['Boolean']['output'];
  mappings: Array<AdminGradesMappingView>;
};

export type AdminHighSchoolCertificate = {
  __typename?: 'AdminHighSchoolCertificate';
  /** The city where the school is located. */
  city: Scalars['String']['output'];
  /** The country where the school is located. */
  country: Scalars['String']['output'];
  /** Date & time when the certificate was initially created. */
  createdAt: Scalars['DateTime']['output'];
  /** The month and year of graduation. */
  graduationDate: Scalars['DateTime']['output'];
  /** The id of the high school certificate. */
  id: Scalars['ID']['output'];
  /** The program application this certificate is associated with. */
  programApplication: AdminProgramApplicationView;
  /** The qualification obtained. */
  qualification: Scalars['String']['output'];
  /** The address of the school. */
  schoolAddress: Scalars['String']['output'];
  /** The name of the school. */
  schoolName: Scalars['String']['output'];
  /** The state where the school is located. */
  state: Scalars['String']['output'];
  /** The status of the high school certificate. */
  status: HighSchoolCertificateStatus;
  /** Date & time when the certificate was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type AdminLinkCourseToProgramInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the course definition. */
  courseDefinitionId: Scalars['ID']['input'];
  /** The number of credits for this course in this program. */
  credits: Scalars['Int']['input'];
  /** A list of courseDefinitionIds of courses that must all be graduated before the student can take this course in this program but which are shorter courses and can be taken during the same term as this course. */
  doneWithPrerequisiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The number of deferrals allowed for this course in this program. */
  maxDeferrals?: InputMaybe<Scalars['Int']['input']>;
  /** The number of retakes allowed for this course in this program. */
  maxRetakes?: InputMaybe<Scalars['Int']['input']>;
  /** A list of courseDefinitionIds of courses that must all be graduated before the learner can take this course in this program. */
  mustHavePrerequisiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The name of the course in this program. */
  name: Scalars['String']['input'];
  /** A list of courseDefinitionIds of courses. At least one of the courses in this list needs to be graduated before the learner can take this course in this program. This list should contain the courses intended to be taken in the previous academical term. */
  oneOfPrerequisiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The priority of this course in this program, must respect the topological order of prerequisites. */
  priority: Scalars['Int']['input'];
  /** The id of the program. */
  programId: Scalars['ID']['input'];
};

export type AdminLinkCourseToProgramPayload = {
  __typename?: 'AdminLinkCourseToProgramPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created programCourse. */
  programCourse: AdminProgramCourseView;
};

export type AdminLmsClassLocationView = {
  __typename?: 'AdminLmsClassLocationView';
  /** The class to which this lms class location belongs. */
  class: AdminClassView;
  /** The classEnrollments that use this lmsClassLocation. */
  classEnrollments: Array<AdminClassEnrollmentView>;
  /** The link to the LMS Course */
  courseLink: Scalars['String']['output'];
  /** Date & time when this object was initially created. */
  createdAt: Scalars['DateTime']['output'];
  /** The id of the lms class location. */
  id: Scalars['ID']['output'];
  /** The lms for this class. */
  learningPlatform?: Maybe<LearningPlatform>;
  /** The id of the cohort inside the lms. */
  lmsCohortId?: Maybe<Scalars['ID']['output']>;
  /** The id of the course inside the lms. */
  lmsCourseId: Scalars['ID']['output'];
  /** The name of this lms class location. */
  name: Scalars['String']['output'];
  /** The preferredCountryOfResidence for the alocation of the LMS location. */
  preferredCountryOfResidence?: Maybe<Scalars['String']['output']>;
  /** The preferredHub for the alocation of the LMS location. */
  preferredHub?: Maybe<Scalars['String']['output']>;
  /** Date & time when this object was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type AdminLockProgressionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The sandId of the user whose progression should be locked. */
  sandId: Scalars['String']['input'];
};

export type AdminLockProgressionPayload = {
  __typename?: 'AdminLockProgressionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: StaffUser;
};

export type AdminLog = {
  __typename?: 'AdminLog';
  actor?: Maybe<AdminUser>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  model?: Maybe<Scalars['String']['output']>;
};

export type AdminLogCreateInput = {
  actor?: InputMaybe<AdminUserRelateToOneForCreateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
};

export type AdminLogOrderByInput = {
  createdAt?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  model?: InputMaybe<OrderDirection>;
};

export type AdminLogUpdateArgs = {
  data: AdminLogUpdateInput;
  where: AdminLogWhereUniqueInput;
};

export type AdminLogUpdateInput = {
  actor?: InputMaybe<AdminUserRelateToOneForUpdateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
};

export type AdminLogWhereInput = {
  AND?: InputMaybe<Array<AdminLogWhereInput>>;
  NOT?: InputMaybe<Array<AdminLogWhereInput>>;
  OR?: InputMaybe<Array<AdminLogWhereInput>>;
  actor?: InputMaybe<AdminUserWhereInput>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IdFilter>;
  model?: InputMaybe<StringFilter>;
};

export type AdminLogWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminManualCheckInInput = {
  /** The date and time in which you want to create the user's check-in. */
  checkInTime: Scalars['DateTime']['input'];
  /** The date and time in which you want to create the user's check-out. */
  checkOutTime?: InputMaybe<Scalars['DateTime']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the hub where you want to create the user's check-in. */
  hubId: Scalars['ID']['input'];
  /** The sand ID of the user you want to manually check in. */
  sandId: Scalars['ID']['input'];
};

export type AdminManualCheckInPayload = {
  __typename?: 'AdminManualCheckInPayload';
  checkIn: HubCheckIn;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AdminMarkClassEnrollmentAsDeferredInput = {
  /** The id of the classEnrollment. */
  classEnrollmentIds: Array<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description why the learner was deferred. */
  deferralDescription?: InputMaybe<Scalars['String']['input']>;
  /** The reason category why the learner was deferred. */
  deferralReason: DeferralReason;
  /** The reason for the status of the class enrollment. Defaults to null. */
  statusReason?: InputMaybe<ClassEnrollmentStatusReason>;
};

export type AdminMarkClassEnrollmentAsDeferredPayload = {
  __typename?: 'AdminMarkClassEnrollmentAsDeferredPayload';
  /** The class enrollments. */
  classEnrollments: Array<AdminClassEnrollmentView>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AdminMarkFailedClassEnrollmentAsGraduatedInput = {
  /** The id of the classEnrollment. */
  classEnrollmentId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The numerical grade points (0-100). The letter grade will be determined during GPA recalculation unless explicitly provided. */
  gradePoints?: InputMaybe<Scalars['Float']['input']>;
  /** The letter grade. Use for admin-assigned grades like WP (withdrawn passing). If not provided, the grade will be determined during GPA recalculation. */
  letterGrade?: InputMaybe<Scalars['String']['input']>;
  /** The reason for the status of the class enrollment. Defaults to null. */
  statusReason?: InputMaybe<ClassEnrollmentStatusReason>;
};

export type AdminMarkFailedClassEnrollmentAsGraduatedPayload = {
  __typename?: 'AdminMarkFailedClassEnrollmentAsGraduatedPayload';
  /** The class enrollment. */
  classEnrollment: AdminClassEnrollmentView;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AdminMarkFailedClassEnrollmentAsOngoingInput = {
  /** The id of the classEnrollment. */
  classEnrollmentId: Scalars['ID']['input'];
  /** If true, clears the grade and gradePoints. If false or not provided, leaves them unchanged. */
  clearGrade?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The reason for the status of the class enrollment. Defaults to null. */
  statusReason?: InputMaybe<ClassEnrollmentStatusReason>;
};

export type AdminMarkFailedClassEnrollmentAsOngoingPayload = {
  __typename?: 'AdminMarkFailedClassEnrollmentAsOngoingPayload';
  /** The class enrollment. */
  classEnrollment: AdminClassEnrollmentView;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AdminMarkGraduatedClassEnrollmentAsFailedInput = {
  /** Whether this is a cancellation (e.g., add/drop period). Cancelled enrollments are excluded from transcripts and GPA. */
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the classEnrollment. */
  classEnrollmentId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The numerical grade points (0-100). Optional for ALX, should be provided for SET/FIT programs. */
  gradePoints?: InputMaybe<Scalars['Float']['input']>;
  /** The letter grade (W, WF, WP, F, or I). Optional for ALX, should be provided for SET/FIT programs. */
  letterGrade?: InputMaybe<Scalars['String']['input']>;
  /** The reason for the status of the class enrollment. Defaults to null. */
  statusReason?: InputMaybe<ClassEnrollmentStatusReason>;
};

export type AdminMarkGraduatedClassEnrollmentAsFailedPayload = {
  __typename?: 'AdminMarkGraduatedClassEnrollmentAsFailedPayload';
  /** The class enrollment. */
  classEnrollment: AdminClassEnrollmentView;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AdminMarkGraduatedClassEnrollmentAsOngoingInput = {
  /** The id of the classEnrollment. */
  classEnrollmentId: Scalars['ID']['input'];
  /** If true, clears the grade and gradePoints. If false or not provided, leaves them unchanged. */
  clearGrade?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The reason for the status of the class enrollment. Defaults to null. */
  statusReason?: InputMaybe<ClassEnrollmentStatusReason>;
};

export type AdminMarkGraduatedClassEnrollmentAsOngoingPayload = {
  __typename?: 'AdminMarkGraduatedClassEnrollmentAsOngoingPayload';
  /** The class enrollment. */
  classEnrollment: AdminClassEnrollmentView;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AdminMarkOngoingClassEnrollmentAsFailedInput = {
  /** Whether this is a cancellation (e.g., add/drop period). Cancelled enrollments are excluded from transcripts and GPA. */
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the classEnrollment. */
  classEnrollmentId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The numerical grade points (0-100). Optional for ALX, should be provided for SET/FIT programs. */
  gradePoints?: InputMaybe<Scalars['Float']['input']>;
  /** The letter grade (W, WF, WP, F, or I). Optional for ALX, should be provided for SET/FIT programs. */
  letterGrade?: InputMaybe<Scalars['String']['input']>;
  /** The reason for the status of the class enrollment. Defaults to null. */
  statusReason?: InputMaybe<ClassEnrollmentStatusReason>;
};

export type AdminMarkOngoingClassEnrollmentAsFailedPayload = {
  __typename?: 'AdminMarkOngoingClassEnrollmentAsFailedPayload';
  /** The class enrollment. */
  classEnrollment: AdminClassEnrollmentView;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AdminMarkOngoingClassEnrollmentAsGraduatedInput = {
  /** The id of the classEnrollment. */
  classEnrollmentId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The numerical grade points (0-100). The letter grade will be determined during GPA recalculation unless explicitly provided. */
  gradePoints?: InputMaybe<Scalars['Float']['input']>;
  /** The letter grade. Use for admin-assigned grades like WP (withdrawn passing). If not provided, the grade will be determined during GPA recalculation. */
  letterGrade?: InputMaybe<Scalars['String']['input']>;
  /** The reason for the status of the class enrollment. Defaults to null. */
  statusReason?: InputMaybe<ClassEnrollmentStatusReason>;
};

export type AdminMarkOngoingClassEnrollmentAsGraduatedPayload = {
  __typename?: 'AdminMarkOngoingClassEnrollmentAsGraduatedPayload';
  /** The class enrollment. */
  classEnrollment: AdminClassEnrollmentView;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AdminMovePaymentInput = {
  paymentId: Scalars['Int']['input'];
  targetPlanId: Scalars['String']['input'];
};

export type AdminPaginatedClassEnrollments = {
  __typename?: 'AdminPaginatedClassEnrollments';
  classEnrollments?: Maybe<Array<AdminClassEnrollmentView>>;
  pageNumber: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type AdminPaginatedCourseEnrollments = {
  __typename?: 'AdminPaginatedCourseEnrollments';
  courseEnrollments?: Maybe<Array<AdminCourseEnrollmentView>>;
  pageNumber: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type AdminPaginatedProgramApplications = {
  __typename?: 'AdminPaginatedProgramApplications';
  pageNumber: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  programApplications: Array<AdminProgramApplicationView>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type AdminPaginatedProgramEnrollments = {
  __typename?: 'AdminPaginatedProgramEnrollments';
  pageNumber: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  programEnrollments: Array<AdminProgramEnrollmentView>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type AdminPartnership = {
  __typename?: 'AdminPartnership';
  /** Date & time when this partnership was initially created. */
  createdAt: Scalars['DateTime']['output'];
  /** Discount amount. */
  discount: Scalars['Float']['output'];
  /** The id of the partnership. */
  id: Scalars['ID']['output'];
  /** The name of the partnership. */
  name: Scalars['String']['output'];
  /** The payment plan id for the partnership. */
  paymentPlanId: Scalars['String']['output'];
  /** Start date for the partnership. */
  startDate: Scalars['DateTime']['output'];
  /** Term tuition amount. */
  termTuition: Scalars['Float']['output'];
  /** Total tuition amount. */
  totalTuition: Scalars['Float']['output'];
  /** Total tuition net of discounts. */
  totalTuitionNetOfDiscounts: Scalars['Float']['output'];
  /** Date & time when this partnership was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type AdminPaymentPlanConnection = {
  __typename?: 'AdminPaymentPlanConnection';
  edges: Array<PaymentPlanEdge>;
  pageInfo: AdminPaymentPlanPageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AdminPaymentPlanInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  cancellationStatus?: InputMaybe<CancellationStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PaymentPlanStatus>;
};

export type AdminPaymentPlanPageInfo = {
  __typename?: 'AdminPaymentPlanPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type AdminPersonaInquiry = {
  __typename?: 'AdminPersonaInquiry';
  /** Persona account ID (acc_...) - links all inquiries for same user. */
  accountId?: Maybe<Scalars['String']['output']>;
  /** Timestamp when decision status was set to APPROVED. */
  approvedStatusAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when lifecycle status was set to COMPLETED. */
  completedStatusAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date & time when this object was initially created. */
  createdAt: Scalars['DateTime']['output'];
  /** Timestamp when lifecycle status was set to CREATED. */
  createdStatusAt?: Maybe<Scalars['DateTime']['output']>;
  /** Decision status of the inquiry (verification outcome). */
  decisionStatus: PersonaInquiryDecisionStatus;
  /** Timestamp when decision status was set to DECLINED. */
  declinedStatusAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when lifecycle status was set to EXPIRED. */
  expiredStatusAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when lifecycle status was set to FAILED. */
  failedStatusAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the persona inquiry. */
  id: Scalars['ID']['output'];
  /** Persona inquiry template ID. */
  inquiryTemplateId: Scalars['String']['output'];
  /** Identifier of the most recent Persona event processed for this inquiry. */
  lastEventId?: Maybe<Scalars['String']['output']>;
  /** Timestamp of the most recent Persona event processed for this inquiry. */
  lastEventTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Lifecycle status of the inquiry (completion progress). */
  lifecycleStatus: PersonaInquiryLifecycleStatus;
  /** Timestamp when decision status was set to NEEDS_REVIEW. */
  needsReviewStatusAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when lifecycle status was set to PENDING. */
  pendingStatusAt?: Maybe<Scalars['DateTime']['output']>;
  /** Type of inquiry (identity, highschool, priorLearning). */
  type: PersonaInquiryType;
  /** Date & time when this object was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The user that this inquiry belongs to. */
  user: StaffUser;
  /** Persona verification ID. */
  verificationId?: Maybe<Scalars['String']['output']>;
  /** Persona verification link. */
  verificationLink?: Maybe<Scalars['String']['output']>;
};

export type AdminProgramApplicationView = {
  __typename?: 'AdminProgramApplicationView';
  additionalInfo?: Maybe<Scalars['String']['output']>;
  /** Admission decision for the program application. */
  admissionStatus: ProgramApplicationAdmissionStatus;
  /** If the user anticipates challenges in paying the tuition. */
  anticipateChallenges?: Maybe<Scalars['Boolean']['output']>;
  /** Date & time when this object was initially created. */
  createdAt: Scalars['DateTime']['output'];
  /** DocuSign enrollment agreement envelope metadata and latest webhook state. */
  docusignEnrollmentAgreement?: Maybe<AdminDocusignEnrollmentAgreement>;
  /** The url of the english proficiency certificate. */
  englishProficiencyFile?: Maybe<Scalars['String']['output']>;
  /** The level of english proficiency. */
  englishProficiencyLevel?: Maybe<LanguageProficiencyLevel>;
  /** The status of the english proficiency. */
  englishProficiencyStatus: EnglishProficiencyStatus;
  /** The type of english proficiency proof provided. */
  englishProficiencyType?: Maybe<EnglishProficiencyType>;
  /** The fee payment mode. */
  feePaymentMode?: Maybe<FeePaymentMode>;
  /** The high school certificate associated with this application. */
  highSchoolCertificate?: Maybe<AdminHighSchoolCertificate>;
  /** The verification method chosen for highschool certificate (manual or persona). */
  highSchoolVerificationMode: HighSchoolVerificationMode;
  /** The id of the program application. */
  id: Scalars['ID']['output'];
  /** The other fee payment mode. */
  otherFeePaymentMode?: Maybe<Scalars['String']['output']>;
  /** The partnership associated with this application. */
  partnership?: Maybe<AdminPartnership>;
  /** The partnership academic standing. */
  partnershipAcademicStanding?: Maybe<Scalars['String']['output']>;
  /** The partnership payment status. */
  partnershipPaymentStatus?: Maybe<Scalars['String']['output']>;
  /** The fee payment mode. */
  partnershipType: PartnershipType;
  /** The persona highschool inquiry associated with this application. */
  personaHighschoolInquiry?: Maybe<AdminPersonaInquiry>;
  /** The persona identity inquiry associated with this application. */
  personaIdentityInquiry?: Maybe<AdminPersonaInquiry>;
  /** The persona prior learning inquiry associated with this application. */
  personaPriorLearningInquiry?: Maybe<AdminPersonaInquiry>;
  /** The program that this application is a part of. */
  program: AdminProgramView;
  /** The program enrollment that this application is a part of. */
  programEnrollment: AdminProgramEnrollmentView;
  sharePersonalDataConsent?: Maybe<Scalars['Boolean']['output']>;
  /** The status of the program application. */
  status: ProgramApplicationStatus;
  /** The tuition fee payment type. */
  tuitionFeePaymentType?: Maybe<TuitionFeePaymentType>;
  /** Date & time when this object was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The user that made this program application. */
  user: StaffUser;
};

export type AdminProgramCourseView = {
  __typename?: 'AdminProgramCourseView';
  /** The course definition */
  courseDefinition: AdminCourseDefinitionView;
  /** Date & time when this object was initially created. */
  createdAt: Scalars['DateTime']['output'];
  /** The number of credits for this course in this program. */
  credits: Scalars['Int']['output'];
  /** A list of courseDefinitions that must all be graduated before the student can take this course in this program but which are shorter courses and can be taken during the same term as this course. */
  doneWithPrerequisites: Array<AdminCourseDefinitionView>;
  /** The id of the programCourse. */
  id: Scalars['ID']['output'];
  /** The number of deferrals allowed for this course in this program. */
  maxDeferrals: Scalars['Int']['output'];
  /** The number of retakes allowed for this course in this program. */
  maxRetakes: Scalars['Int']['output'];
  /** A list of courseDefinitions that must all be graduated before the learner can take this course in this program. */
  mustHavePrerequisites: Array<AdminCourseDefinitionView>;
  /** The name of the course in this program. */
  name: Scalars['String']['output'];
  /** A list of courseDefinitions. At least one of the courses in this list needs to be graduated before the learner can take this course in this program. This list should contain the courses intended to be taken in the previous academical term. */
  oneOfPrerequisites: Array<AdminCourseDefinitionView>;
  /** The priority of this course in this program, must respect the topological order of prerequisites. */
  priority: Scalars['Int']['output'];
  /** The program */
  program: AdminProgramView;
  /** Date & time when this object was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type AdminProgramEnrollmentView = {
  __typename?: 'AdminProgramEnrollmentView';
  /** Academic conduct cases for this program enrollment. */
  academicConductCases: Array<AcademicConductCaseView>;
  /** The academic standing of the student in this program enrollment. */
  academicStanding?: Maybe<AcademicStanding>;
  /** Whether this program enrollment was cancelled. */
  cancelled: Scalars['Boolean']['output'];
  /** The cohort that the user is a part of. */
  cohort?: Maybe<AdminCohortView>;
  /** The course enrollments taken as part of this program. */
  courseEnrollments: Array<AdminCourseEnrollmentView>;
  /** Date & time when this object was initially created. */
  createdAt: Scalars['DateTime']['output'];
  /** The cumulative (institutional) GPA across all courses taken at the institution. */
  cumulativeGPA?: Maybe<Scalars['Float']['output']>;
  /** Date & time when when the failed the program. */
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date & time when when the user graduated. */
  graduatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the program. */
  id: Scalars['ID']['output'];
  /** The description for the leave of absence. */
  leaveOfAbsenceDescription?: Maybe<Scalars['String']['output']>;
  /** The reason category for the leave of absence. */
  leaveOfAbsenceReason?: Maybe<DeferralReason>;
  /** The major GPA for courses in this program only. */
  majorGPA?: Maybe<Scalars['Float']['output']>;
  /** The payment plan that this associated for this enrollment. */
  paymentPlan?: Maybe<PaymentPlan>;
  plannedCourses: Array<PlannedCourse>;
  /** The preferred hub of the user for this program. */
  preferredHub?: Maybe<Scalars['String']['output']>;
  /** The program that this enrollment is a part of. */
  program: AdminProgramView;
  /** History of program/specialization changes. */
  programChanges: Array<ProgramChangeView>;
  /** Date & time when when the user was last reinstated. */
  reinstatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The status of this program enrollment. */
  status?: Maybe<ProgramEnrollmentStatus>;
  /** The term GPAs for this program enrollment. */
  termGPAs: Array<TermGpa>;
  /** Date & time when this object was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The user enrolled in this program. */
  user: StaffUser;
  /** The description why the learner was withdrawn from the program. */
  withdrawalDescription?: Maybe<Scalars['String']['output']>;
  /** The reason category why the learner was withdrawn from the program. */
  withdrawalReason?: Maybe<ProgramWithdrawalReason>;
};

export type AdminProgramView = {
  __typename?: 'AdminProgramView';
  /** The abbreviation of the program name. */
  abbreviation: Scalars['String']['output'];
  /** Duration in days after class start during which enrollments are allowed. */
  addDropPeriodDays: Scalars['Int']['output'];
  /** Can the learner be enrolled into this program while being enrolled into other programs. */
  allowsConcurrentEnrollments: Scalars['Boolean']['output'];
  /** List of enrolled cohorts. */
  cohorts: Array<AdminCohortView>;
  /** Date & time when this object was initially created. */
  createdAt: Scalars['DateTime']['output'];
  /** The description of the program */
  description?: Maybe<Scalars['String']['output']>;
  /** Enrollment counts by status for this program */
  enrollmentCounts: Array<ProgramEnrollmentStatusCount>;
  /** Does this program have Answerbase support. */
  hasAnswerbaseSupport: Scalars['Boolean']['output'];
  /** Does this program have check-in support at the hubs. */
  hasCheckInSupport: Scalars['Boolean']['output'];
  /** Does this program have Circle support. */
  hasCircleSupport: Scalars['Boolean']['output'];
  /** Have all the programCourses for this program been added. */
  hasCompleteCurriculum: Scalars['Boolean']['output'];
  /** Shows if a program has overall multiple courses planned. */
  hasMultiCourseDisplay: Scalars['Boolean']['output'];
  /** The id of the program. */
  id: Scalars['ID']['output'];
  /** Whether the program is a university one or not. */
  isUniversityProgram: Scalars['Boolean']['output'];
  /** The list of courses taken as part of this program. */
  linkedProgramCourses: Array<AdminProgramCourseView>;
  /** Public marketing magic link URL used for campaigns. */
  magicLink: Scalars['String']['output'];
  /** Information about the program that is used for marketing purposes. */
  marketing: ProgramMarketing;
  /** The maximum amount of credits worth of courses that a learner can be enrolled into during an academical term. */
  maxTermCredits: Scalars['Int']['output'];
  /** The minimum amount of credits worth of courses that a learner must be enrolled into during an academical term. Used only for deciding if the learner can defer a course, and will not stop a learner from taking fewer course in the case where all of his available courses amount to fewer credits. */
  minTermCredits: Scalars['Int']['output'];
  /** The name of the program. */
  name: Scalars['String']['output'];
  /** Does the program accept enrollments at this time. */
  openToEnrollments?: Maybe<Scalars['Boolean']['output']>;
  /** Returns a list of program applications using offset pagination. */
  paginatedProgramApplications: AdminPaginatedProgramApplications;
  /** Returns a list of users using offset pagination. */
  paginatedProgramEnrollments: AdminPaginatedProgramEnrollments;
  /** List of all student enrollments in this program from all cohorts. */
  programEnrollments: Array<AdminProgramEnrollmentView>;
  /** Whether the program requires a tuition questionnaire or not. */
  requiresTuitionQuestionnaire: Scalars['Boolean']['output'];
  /** Date & time when this object was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** A specific version of the program as programs with the same name can have different mandatory courses. */
  version: Scalars['String']['output'];
};


export type AdminProgramViewPaginatedProgramApplicationsArgs = {
  admissionStatus?: InputMaybe<Array<ProgramApplicationAdmissionStatus>>;
  englishProficiencyStatus?: InputMaybe<Array<InputMaybe<EnglishProficiencyStatus>>>;
  highSchoolCertificateStatus?: InputMaybe<Array<HighSchoolCertificateStatus>>;
  highSchoolVerificationMode?: InputMaybe<Array<HighSchoolVerificationMode>>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  partnershipType?: InputMaybe<Array<PartnershipType>>;
  personaHighschoolInquiryDecisionStatus?: InputMaybe<Array<PersonaInquiryDecisionStatus>>;
  personaHighschoolInquiryLifecycleStatus?: InputMaybe<Array<PersonaInquiryLifecycleStatus>>;
  personaIdentityInquiryDecisionStatus?: InputMaybe<Array<PersonaInquiryDecisionStatus>>;
  personaIdentityInquiryLifecycleStatus?: InputMaybe<Array<PersonaInquiryLifecycleStatus>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<ProgramApplicationStatus>>;
};


export type AdminProgramViewPaginatedProgramEnrollmentsArgs = {
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchString?: InputMaybe<Scalars['String']['input']>;
};

export type AdminProofOfCompletionView = {
  __typename?: 'AdminProofOfCompletionView';
  /** The class enrollment of the user that submitted this proof of completion. */
  classEnrollment: AdminClassEnrollmentView;
  /** Date & time when this object was initially created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The email of the learner that took the exam. */
  email?: Maybe<Scalars['String']['output']>;
  /** The location where the exam was taken. */
  examLocation?: Maybe<ProofOfCompletionExamLocation>;
  /** The score received in the exam. */
  examScore?: Maybe<Scalars['Int']['output']>;
  /** The exam statement for both SA and AWS. */
  examStatement?: Maybe<ExamStatementType>;
  /** The validation number of the exam. */
  examValidationNumber?: Maybe<Scalars['String']['output']>;
  /** The first name of the learner that took the exam. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The last name of the learner that took the exam. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The user that submitted this proof of completion. */
  regularUser: User;
  /** The status of the proof of completion. */
  status: ProofOfCompletionStatus;
  /** The trailblazer profile link of the learner that took the exam. */
  trailblazerProfileLink?: Maybe<Scalars['String']['output']>;
  /** Date & time when this object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that submitted this proof of completion. */
  user: StaffUser;
};

export type AdminPushEventsToBusInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The events to be pushed */
  events: Array<EventInput>;
};

export type AdminPushEventsToBusPayload = {
  __typename?: 'AdminPushEventsToBusPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The number of events pushed */
  count: Scalars['Int']['output'];
};

export type AdminRecomputeProgramEnrollmentGpAsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The program enrollment id. */
  programEnrollmentId: Scalars['ID']['input'];
};

export type AdminRecomputeProgramEnrollmentGpAsPayload = {
  __typename?: 'AdminRecomputeProgramEnrollmentGPAsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The program enrollment with updated GPA. */
  programEnrollment: AdminProgramEnrollmentView;
};

export type AdminReinstateLearnerIntoProgramInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** If true, allows reinstating into classes that have already ended. Requires LEARNING_REINSTATE_INTO_FINISHED_CLASS permission. */
  forceReinstateIntoFinishedClasses?: InputMaybe<Scalars['Boolean']['input']>;
  /** The program enrollment id. */
  programEnrollmentId: Scalars['ID']['input'];
};

export type AdminReinstateLearnerIntoProgramPayload = {
  __typename?: 'AdminReinstateLearnerIntoProgramPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The program enrollment. */
  programEnrollment: AdminProgramEnrollmentView;
};

export type AdminRemoveCoursePrerequisitesInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A list of courseDefinitionIds to remove. */
  doneWithPrerequisiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A list of courseDefinitionIds to remove. */
  mustHavePrerequisiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A list of courseDefinitionIds to remove. */
  oneOfPrerequisiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The id of the program. */
  programCourseId: Scalars['ID']['input'];
};

export type AdminRemoveCoursePrerequisitesPayload = {
  __typename?: 'AdminRemoveCoursePrerequisitesPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created programCourse. */
  programCourse: AdminProgramCourseView;
};

export type AdminRemoveGraduationFromProgramEnrollmentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The program enrollment id. */
  programEnrollmentId: Scalars['ID']['input'];
};

export type AdminRemoveGraduationFromProgramEnrollmentPayload = {
  __typename?: 'AdminRemoveGraduationFromProgramEnrollmentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The program enrollment. */
  programEnrollment: AdminProgramEnrollmentView;
};

export type AdminRemovePermissionFromRoleInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The permission to remove from the role. */
  permission: Permission;
  /** The id of the role. */
  roleId: Scalars['Int']['input'];
};

export type AdminRemovePermissionFromRolePayload = {
  __typename?: 'AdminRemovePermissionFromRolePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  role: Role;
};

export type AdminRemoveUserFromRoleInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the role to remove from the user */
  roleId: Scalars['Int']['input'];
  /** Id of the user to remove from the role */
  sandId: Scalars['String']['input'];
};

export type AdminRemoveUserFromRolePayload = {
  __typename?: 'AdminRemoveUserFromRolePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The user who was removed from the role. */
  user: StaffUser;
};

export type AdminReopenAcademicConductCaseInput = {
  caseId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
};

export type AdminReopenAcademicConductCasePayload = {
  __typename?: 'AdminReopenAcademicConductCasePayload';
  academicConductCase: AcademicConductCaseView;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AdminResolveAcademicConductCaseInput = {
  caseId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  documentName?: InputMaybe<Scalars['String']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  resolutionType: ConductCaseResolutionType;
};

export type AdminResolveAcademicConductCasePayload = {
  __typename?: 'AdminResolveAcademicConductCasePayload';
  academicConductCase: AcademicConductCaseView;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AdminRunEnrollmentProgressionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The nonce for this run. */
  nonce: Scalars['ID']['input'];
  /** The id of the program enrollment for which to run the learner progression algorithm. */
  programEnrollmentId: Scalars['ID']['input'];
};

export type AdminRunEnrollmentProgressionPayload = {
  __typename?: 'AdminRunEnrollmentProgressionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  programEnrollment: AdminProgramEnrollmentView;
};

export type AdminRunLearnerProgressionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The nonce for this run. */
  nonce: Scalars['ID']['input'];
  /** The id of the program in which to run the learner progression algorithm. */
  programId: Scalars['ID']['input'];
};

export type AdminRunLearnerProgressionPayload = {
  __typename?: 'AdminRunLearnerProgressionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  programEnrollments: Array<AdminProgramEnrollmentView>;
};

export type AdminSetHubAdministratorInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the hub. */
  hubId: Scalars['String']['input'];
  /** The sandId of the staff member to be set as hub administrator. */
  sandId: Scalars['String']['input'];
};

export type AdminSetHubAdministratorPayload = {
  __typename?: 'AdminSetHubAdministratorPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: StaffUser;
};

export type AdminStartImpersonationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Sand ID of the user to impersonate. */
  targetSandId: Scalars['String']['input'];
};

export type AdminStartImpersonationPayload = {
  __typename?: 'AdminStartImpersonationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The newly created impersonation session. */
  session?: Maybe<ImpersonationSession>;
};

export type AdminStopImpersonationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type AdminStopImpersonationPayload = {
  __typename?: 'AdminStopImpersonationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Number of sessions that were ended. */
  endedCount: Scalars['Int']['output'];
  /** Whether any sessions were ended. */
  success: Scalars['Boolean']['output'];
};

export type AdminTrainingResource = {
  __typename?: 'AdminTrainingResource';
  /** Date & time when this training resource was initially created. */
  createdAt: Scalars['DateTime']['output'];
  /** The sandId of the user who created this resource. */
  createdBy: Scalars['String']['output'];
  /** The user who created this training resource. */
  creator?: Maybe<StaffUser>;
  /** A brief description of what the resource contains. */
  description?: Maybe<Scalars['String']['output']>;
  /** The id of the training resource. */
  id: Scalars['ID']['output'];
  /** The display name/title of the training resource. */
  title: Scalars['String']['output'];
  /** Date & time when this training resource was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The URL to the external resource. */
  url: Scalars['String']['output'];
};

export type AdminUnlockProgressionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The sandId of the user whose progression should be unlocked. */
  sandId: Scalars['String']['input'];
};

export type AdminUnlockProgressionPayload = {
  __typename?: 'AdminUnlockProgressionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: StaffUser;
};

export type AdminUpdateAcademicConductCaseInput = {
  caseId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  documentName?: InputMaybe<Scalars['String']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<ConductCaseSeverity>;
};

export type AdminUpdateAcademicConductCasePayload = {
  __typename?: 'AdminUpdateAcademicConductCasePayload';
  academicConductCase: AcademicConductCaseView;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AdminUpdateClassEnrollmentGradePointsInput = {
  /** Whether this class enrollment is cancelled. When set to true, grades are cleared. */
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the class enrollment to update. */
  classEnrollmentId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The numerical grade points (0-100). Set to null to clear. */
  gradePoints?: InputMaybe<Scalars['Float']['input']>;
  /** The letter grade (e.g., A, B+, W, WF, WP, I, IF). Set to null to clear. */
  letterGrade?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUpdateClassEnrollmentGradePointsPayload = {
  __typename?: 'AdminUpdateClassEnrollmentGradePointsPayload';
  /** The updated class enrollment. */
  classEnrollment: AdminClassEnrollmentView;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AdminUpdateClassInput = {
  /** The id class. */
  classId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The cohort key used in the curriculum visualizer. */
  cohortKey?: InputMaybe<Scalars['String']['input']>;
  /** Date when this class ends. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Is this class already finished */
  finished?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the class. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Date when this class starts. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The academic term this class belongs to (e.g., "2026 Spring"). */
  term?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUpdateClassPayload = {
  __typename?: 'AdminUpdateClassPayload';
  /** The created class. */
  class: AdminClassView;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AdminUpdateCohortInput = {
  /** Can learners in this cohort defer their corresponding ongoing courses. */
  allowCourseDeferral?: InputMaybe<Scalars['Boolean']['input']>;
  /** Can learners in this cohort request leave of absence on their program enrollment. */
  allowLeaveOfAbsence?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the cohort to update. */
  cohortId: Scalars['ID']['input'];
  /** Date when this cohort ends. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The new name of the cohort. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Can learners be enrolled into this cohort at this time, default false. */
  openToEnrollments?: InputMaybe<Scalars['Boolean']['input']>;
  /** Date when this cohort starts. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdminUpdateCohortPayload = {
  __typename?: 'AdminUpdateCohortPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The cohort that was updated. */
  cohort: AdminCohortView;
};

export type AdminUpdateCourseDefinitionInput = {
  /** The category of the course. */
  category?: InputMaybe<CourseCategory>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the course which will be updated. */
  courseDefinitionId: Scalars['String']['input'];
  /** The description of the course */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The duration of the course (used for marketing purposes). */
  duration?: InputMaybe<Scalars['String']['input']>;
  /** The name of the course. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUpdateCourseDefinitionPayload = {
  __typename?: 'AdminUpdateCourseDefinitionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The course that was updated. */
  course: AdminCourseDefinitionView;
};

export type AdminUpdateGradesMappingInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The GPA value (0-4) assigned for this letter grade. */
  gradePointsValue: Scalars['Float']['input'];
  /** The id of the grades mapping to update. */
  id: Scalars['ID']['input'];
  /** The letter grade (e.g. A, B+, C). */
  letterGrade: Scalars['String']['input'];
  /** The minimum grade points (0-100) for this letter grade. */
  minGradePoints: Scalars['Float']['input'];
};

export type AdminUpdateGradesMappingPayload = {
  __typename?: 'AdminUpdateGradesMappingPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated grades mapping. */
  gradesMapping: AdminGradesMappingView;
};

export type AdminUpdateOAuthClientInput = {
  /** The id of the client. */
  clientId: Scalars['ID']['input'];
  /** The code key name provided by the client */
  codeKeyName?: InputMaybe<Scalars['String']['input']>;
  /** The name of the OAuth client. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The redirect URI key name provided by the client */
  redirectUriKeyName?: InputMaybe<Scalars['String']['input']>;
  /** A list of allowed redirect uris. */
  redirectUris?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The response type key name provided by the client */
  responseTypeKeyName?: InputMaybe<Scalars['String']['input']>;
  /** The scope type key name provided by the client */
  scopeTypeKeyName?: InputMaybe<Scalars['String']['input']>;
  /** The state key name provided by the client */
  stateKeyName?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUpdateOAuthClientPayload = {
  __typename?: 'AdminUpdateOAuthClientPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The newly created OAuth Client. */
  oauthClient: OAuthClient;
};

export type AdminUpdatePartnershipInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Discount amount. */
  discount?: InputMaybe<Scalars['Float']['input']>;
  /** The name of the partnership. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The id of the partnership. */
  partnershipId: Scalars['ID']['input'];
  /** The payment plan id for the partnership. */
  paymentPlanId?: InputMaybe<Scalars['String']['input']>;
  /** Start date for the partnership. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Term tuition amount. */
  termTuition?: InputMaybe<Scalars['Float']['input']>;
  /** Total tuition amount. */
  totalTuition?: InputMaybe<Scalars['Float']['input']>;
  /** Total tuition net of discounts. */
  totalTuitionNetOfDiscounts?: InputMaybe<Scalars['Float']['input']>;
};

export type AdminUpdatePartnershipPayload = {
  __typename?: 'AdminUpdatePartnershipPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated partnership. */
  partnership: AdminPartnership;
};

export type AdminUpdateProgramApplicationAdmissionStatusInput = {
  /** The admission decision for the application. */
  admissionStatus: ProgramApplicationAdmissionStatus;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the program application. */
  id: Scalars['ID']['input'];
};

export type AdminUpdateProgramApplicationAdmissionStatusPayload = {
  __typename?: 'AdminUpdateProgramApplicationAdmissionStatusPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  programApplication: AdminProgramApplicationView;
};

export type AdminUpdateProgramApplicationEnglishProficiencyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the program application. */
  id: Scalars['ID']['input'];
  /** The english proficiency status of the program application. */
  status: EnglishProficiencyStatus;
};

export type AdminUpdateProgramApplicationEnglishProficiencyPayload = {
  __typename?: 'AdminUpdateProgramApplicationEnglishProficiencyPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  programApplication: AdminProgramApplicationView;
};

export type AdminUpdateProgramApplicationHighSchoolCertificateInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the high school certificate. */
  highSchoolCertificateId: Scalars['ID']['input'];
  /** The high school certificate status. */
  status: HighSchoolCertificateStatus;
};

export type AdminUpdateProgramApplicationHighSchoolCertificatePayload = {
  __typename?: 'AdminUpdateProgramApplicationHighSchoolCertificatePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  highSchoolCertificate: AdminHighSchoolCertificate;
};

export type AdminUpdateProgramApplicationPartnershipInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the program application. */
  id: Scalars['ID']['input'];
  /** The id of the partnership. Pass null to remove the partnership. */
  partnershipId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminUpdateProgramApplicationPartnershipPayload = {
  __typename?: 'AdminUpdateProgramApplicationPartnershipPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  programApplication: AdminProgramApplicationView;
};

export type AdminUpdateProgramApplicationPartnershipTypeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the program application. */
  id: Scalars['ID']['input'];
  /** The partnership type for the program application. */
  partnershipType: PartnershipType;
};

export type AdminUpdateProgramApplicationPartnershipTypePayload = {
  __typename?: 'AdminUpdateProgramApplicationPartnershipTypePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  programApplication: AdminProgramApplicationView;
};

export type AdminUpdateProgramApplicationStatusInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the program application. */
  id: Scalars['ID']['input'];
  /** The status of the program application. */
  status: ProgramApplicationStatus;
};

export type AdminUpdateProgramApplicationStatusPayload = {
  __typename?: 'AdminUpdateProgramApplicationStatusPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  programApplication: AdminProgramApplicationView;
};

export type AdminUpdateProgramCourseInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The number of credits for this course in this program. */
  credits?: InputMaybe<Scalars['Int']['input']>;
  /** The number of deferrals allowed for this course in this program. */
  maxDeferrals?: InputMaybe<Scalars['Int']['input']>;
  /** The number of retakes allowed for this course in this program. */
  maxRetakes?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the programCourse. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The priority of this course in this program, must respect the topological order of prerequisites. */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** The id of the programCourse. */
  programCourseId: Scalars['ID']['input'];
};

export type AdminUpdateProgramCoursePayload = {
  __typename?: 'AdminUpdateProgramCoursePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created programCourse. */
  programCourse: AdminProgramCourseView;
};

export type AdminUpdateProgramInput = {
  /** The abbreviation of the program name. */
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  /** The access fee price for this program */
  accessFee?: InputMaybe<Scalars['String']['input']>;
  /** Duration in days after class start during which enrollments are allowed. */
  addDropPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  /** Can learners in this program defer their corresponding ongoing courses. */
  allowCourseDeferral?: InputMaybe<Scalars['Boolean']['input']>;
  /** Can learners in this program request leave of absence on their program enrollment. */
  allowLeaveOfAbsence?: InputMaybe<Scalars['Boolean']['input']>;
  /** Can the learner be enrolled into this program while being enrolled into other programs. */
  allowsConcurrentEnrollments?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description of the program */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Does this program have Answerbase support. */
  hasAnswerbaseSupport?: InputMaybe<Scalars['Boolean']['input']>;
  /** Does this program have check-in support at the hubs. */
  hasCheckInSupport?: InputMaybe<Scalars['Boolean']['input']>;
  /** Does this program have Circle support. */
  hasCircleSupport?: InputMaybe<Scalars['Boolean']['input']>;
  /** Have all the programCourses for this program been added. */
  hasCompleteCurriculum?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the program has overall multiple courses planned. */
  hasMultiCourseDisplay?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of program highlights. */
  highlights: Array<Scalars['String']['input']>;
  /** A boolean which represents if the payment plan of this program is all access or not. */
  isAllAccessPaymentPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the program is a university one or not. */
  isUniversityProgram?: InputMaybe<Scalars['Boolean']['input']>;
  /** The legacy points amount displayed for the program. */
  legacyPoints?: InputMaybe<Scalars['String']['input']>;
  /** The maximum amount of credits worth of courses that a learner can be enrolled into during an academical term. */
  maxTermCredits?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum amount of credits worth of courses that a learner must be enrolled into during an academical term. Used only for deciding if the learner can defer a course, and will not stop a learner from taking fewer course in the case where all of his available courses amount to fewer credits. */
  minTermCredits?: InputMaybe<Scalars['Int']['input']>;
  /** The program name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Does the program accept enrollments at this time. */
  openToEnrollments?: InputMaybe<Scalars['Boolean']['input']>;
  /** The payment plan definition id of this program. */
  paymentPlanDefinitionId?: InputMaybe<Scalars['String']['input']>;
  /** The default duration of the program. */
  programDuration?: InputMaybe<Scalars['String']['input']>;
  /** The id of the program to update. */
  programId: Scalars['String']['input'];
  /** Whether the program requires a tuition questionnaire or not. */
  requiresTuitionQuestionnaire?: InputMaybe<Scalars['Boolean']['input']>;
  /** The summary or long description of the section where the program is explained */
  sectionSummary?: InputMaybe<Scalars['String']['input']>;
  /** The title of the section where the program is explained */
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
  /** A sub title. Usually used to add more information after the title. */
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** The thumbnail we want to display for the video. */
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  /** The expected time commitment from the user in order to successfully complete the program. */
  timeCommitment?: InputMaybe<Scalars['String']['input']>;
  /** The top marketing title, displayed usually under program name. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The specific version of the program as programs with the same name can have different mandatory courses. */
  version?: InputMaybe<Scalars['String']['input']>;
  /** The marketing video for this program. */
  video?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUpdateProgramPayload = {
  __typename?: 'AdminUpdateProgramPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  program: AdminProgramView;
};

export type AdminUpdateRoleInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the role. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Updated permissions for the role. This will replace all existing permissions. */
  permissions?: InputMaybe<Array<Permission>>;
  /** The id of the role to be updated. */
  roleId: Scalars['Int']['input'];
};

export type AdminUpdateRolePayload = {
  __typename?: 'AdminUpdateRolePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  role: Role;
};

export type AdminUpdateUserConsentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  communityExpectationsConsentAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailStorageConsentAt?: InputMaybe<Scalars['DateTime']['input']>;
  infoAccuracyConsentAt?: InputMaybe<Scalars['DateTime']['input']>;
  marketingConsentAt?: InputMaybe<Scalars['DateTime']['input']>;
  paymentPolicyConsentAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The sandId of the user whose consent will be updated. */
  sandId: Scalars['String']['input'];
};

export type AdminUpdateUserConsentPayload = {
  __typename?: 'AdminUpdateUserConsentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userConsent: UserConsent;
};

export type AdminUpdateUserInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The home country of the user. */
  countryOfOrigin?: InputMaybe<Scalars['String']['input']>;
  /** The residence country of the user. */
  countryOfResidence?: InputMaybe<Scalars['String']['input']>;
  /** The home county of the user. */
  countyOfOrigin?: InputMaybe<Scalars['String']['input']>;
  /** The residence county of the user. */
  countyOfResidence?: InputMaybe<Scalars['String']['input']>;
  /** Does the user have a disability? */
  disability?: InputMaybe<Disability>;
  /** The type of employment, e.g. full time or part time, etc. */
  employmentType?: InputMaybe<EmploymentTypeEnum>;
  facebookURL?: InputMaybe<Scalars['String']['input']>;
  /** The field of study at the institution [ Mathematics, Agriculture,…]. */
  fieldOfStudy?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  githubUrl?: InputMaybe<Scalars['String']['input']>;
  /** The current guardianship of the user. */
  guardianship?: InputMaybe<Guardianship>;
  /** The highest level of education [high school, bachelors, master’s,…]. */
  highestLevelOfStudy?: InputMaybe<Scalars['String']['input']>;
  /** Household monthly income in USD. */
  householdMonthlyIncomeUSD?: InputMaybe<Scalars['Int']['input']>;
  /** Is the user in a humanitarian status situation? (Yes, No, Prefer not to answer). */
  humanitarianStatus?: InputMaybe<HumanitarianStatus>;
  /** Which type of humanitarian status situation? (Refugee, Asylum seeker, Not Applicable, etc). */
  humanitarianStatusType?: InputMaybe<HumanitarianStatusType>;
  isEmployed?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedInURL?: InputMaybe<Scalars['String']['input']>;
  /** Current living circumstances (Homeless, Shelter, Prefer not to say, etc). */
  livingCircumstances?: InputMaybe<LivingCircumstances>;
  /** The home locality of the user. */
  localityOfOrigin?: InputMaybe<Scalars['String']['input']>;
  /** The residence locality of the user. */
  localityOfResidence?: InputMaybe<Scalars['String']['input']>;
  /** Current location description (Urban, Rural, Prefer not to say). */
  locationDescription?: InputMaybe<LocationDescription>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** If the user is open to new positions. */
  openToNewPositions?: InputMaybe<Scalars['Boolean']['input']>;
  /** The phone number of this user. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** A list of descriptions or urls (e.g. github repos, apps made by the user, etc). */
  portfolioAndProjects?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Has this user been enrolled in ALX programs in the past, including using other accounts. */
  previouslyEnrolledInALX?: InputMaybe<Scalars['Boolean']['input']>;
  /** The sandId of the user to be updated. */
  sandId: Scalars['String']['input'];
  tikTokUrl?: InputMaybe<Scalars['String']['input']>;
  /** The job title of this user. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Top career goal (e.g. "become CEO of a company"). */
  topCareerGoal?: InputMaybe<Scalars['String']['input']>;
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
  /** The WhatsApp phone number of this user. */
  whatsAppNumber?: InputMaybe<Scalars['String']['input']>;
  youtubeUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUpdateUserPayload = {
  __typename?: 'AdminUpdateUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: StaffUser;
};

export type AdminUpdateUserRolesInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The list of ids of roles this user will have after this operation. */
  roleIds: Array<Scalars['Int']['input']>;
  /** Id of the user whose roles will be updated */
  sandId: Scalars['String']['input'];
};

export type AdminUpdateUserRolesPayload = {
  __typename?: 'AdminUpdateUserRolesPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The user whose roles were updated. */
  user: User;
};

export type AdminUpdateUserSkipPaywallInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The sandId of the user to be updated. */
  sandId: Scalars['String']['input'];
  skipPaywallReason: Scalars['String']['input'];
  skipPaywallUntil: Scalars['DateTime']['input'];
};

export type AdminUpdateUserSkipPaywallPayload = {
  __typename?: 'AdminUpdateUserSkipPaywallPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: StaffUser;
};

export type AdminUser = {
  __typename?: 'AdminUser';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isSuperAdmin?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<PasswordState>;
};

export type AdminUserAuthenticationWithPasswordFailure = {
  __typename?: 'AdminUserAuthenticationWithPasswordFailure';
  message: Scalars['String']['output'];
};

export type AdminUserAuthenticationWithPasswordResult = AdminUserAuthenticationWithPasswordFailure | AdminUserAuthenticationWithPasswordSuccess;

export type AdminUserAuthenticationWithPasswordSuccess = {
  __typename?: 'AdminUserAuthenticationWithPasswordSuccess';
  item: AdminUser;
  sessionToken: Scalars['String']['output'];
};

export type AdminUserCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isSuperAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUserOrderByInput = {
  createdAt?: InputMaybe<OrderDirection>;
  email?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  isSuperAdmin?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type AdminUserRelateToOneForCreateInput = {
  connect?: InputMaybe<AdminUserWhereUniqueInput>;
  create?: InputMaybe<AdminUserCreateInput>;
};

export type AdminUserRelateToOneForUpdateInput = {
  connect?: InputMaybe<AdminUserWhereUniqueInput>;
  create?: InputMaybe<AdminUserCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminUserUpdateArgs = {
  data: AdminUserUpdateInput;
  where: AdminUserWhereUniqueInput;
};

export type AdminUserUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isSuperAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUserWhereInput = {
  AND?: InputMaybe<Array<AdminUserWhereInput>>;
  NOT?: InputMaybe<Array<AdminUserWhereInput>>;
  OR?: InputMaybe<Array<AdminUserWhereInput>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  isSuperAdmin?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
};

export type AdminUserWhereUniqueInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminWithdrawLearnerFromProgramInput = {
  /** Whether this is a cancellation (e.g., add/drop period). Cancelled enrollments are excluded from transcripts and GPA. */
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The letter grade to set on withdrawn class enrollments (e.g., W or WF). Only used when not cancelled. */
  letterGrade?: InputMaybe<Scalars['String']['input']>;
  /** The program enrollment id. */
  programEnrollmentId: Scalars['ID']['input'];
  /** The description why the student was withdrawn from the program. */
  withdrawalDescription?: InputMaybe<Scalars['String']['input']>;
  /** The reason category why the student was withdrawn from the program */
  withdrawalReason: DeferralReason;
};

export type AdminWithdrawLearnerFromProgramPayload = {
  __typename?: 'AdminWithdrawLearnerFromProgramPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The program enrollment. */
  programEnrollment: AdminProgramEnrollmentView;
};

export type AllocateToProgramme = {
  classId: Scalars['Int']['input'];
  className: Scalars['String']['input'];
  classYear: ClassYearEnum;
  programmeId: Scalars['Int']['input'];
};

export enum AppealStatus {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Pending = 'PENDING'
}

export type ApplyCouponByHashInput = {
  accountId: Scalars['Int']['input'];
  couponCode: Scalars['String']['input'];
  hashPlan: Scalars['String']['input'];
};

export type ApplyCouponInput = {
  couponCode: Scalars['String']['input'];
  paymentPlanId: Scalars['String']['input'];
};

export type ApplyCouponResult = {
  __typename?: 'ApplyCouponResult';
  coupon: Coupon;
  paymentPlan: PaymentPlan;
};

export type ApplyCouponResultResultPayload = {
  __typename?: 'ApplyCouponResultResultPayload';
  error?: Maybe<Scalars['String']['output']>;
  result?: Maybe<ApplyCouponResult>;
  success: Scalars['Boolean']['output'];
};

export type ApplyToProgramInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The preferred hub for this program enrollment. */
  preferredHub?: InputMaybe<Scalars['String']['input']>;
  /** The programId in which to enroll the learner. */
  programId: Scalars['ID']['input'];
};

export type ApplyToProgramPayload = {
  __typename?: 'ApplyToProgramPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The user that has been enrolled. */
  user: User;
};

export type AssignStudentToProgrammeResponse = {
  __typename?: 'AssignStudentToProgrammeResponse';
  code?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  studentInfo?: Maybe<AthenaStudentInfo>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AthenaClassTrackDetails = {
  __typename?: 'AthenaClassTrackDetails';
  classCertificateReleased?: Maybe<Scalars['Boolean']['output']>;
  classId: Scalars['Int']['output'];
  classIsActive: Scalars['Boolean']['output'];
  className: Scalars['String']['output'];
  classProgramLink: Scalars['String']['output'];
  classYear: Scalars['Int']['output'];
};

export type AthenaCourse = {
  __typename?: 'AthenaCourse';
  athenaCourseDescription?: Maybe<Scalars['String']['output']>;
  athenaCourseId?: Maybe<Scalars['ID']['output']>;
  athenaCourseName?: Maybe<Scalars['String']['output']>;
};

/** The type of an event which represents a course failure in Athena */
export type AthenaCourseFailedInput = {
  /** The id of the Athena class */
  athenaClassId: Scalars['ID']['input'];
  /** The name of the Athena class */
  athenaClassName: Scalars['String']['input'];
  /** The year of the Athena class */
  athenaClassYear: Scalars['String']['input'];
  /** The id of the Athena program */
  athenaProgramId: Scalars['ID']['input'];
  /** The sandId of the user that failed the course */
  sandId: Scalars['ID']['input'];
};

/** The type of an event which represents a course graduation in Athena */
export type AthenaCourseGraduatedInput = {
  /** The id of the Athena class */
  athenaClassId: Scalars['ID']['input'];
  /** The name of the Athena class */
  athenaClassName: Scalars['String']['input'];
  /** The year of the Athena class */
  athenaClassYear: Scalars['String']['input'];
  /** The id of the Athena program */
  athenaProgramId: Scalars['ID']['input'];
  /** The sandId of the user that graduated the course */
  sandId: Scalars['ID']['input'];
};

export type AthenaProgramme = {
  __typename?: 'AthenaProgramme';
  athenaProgrammeAddedOn?: Maybe<Scalars['String']['output']>;
  athenaProgrammeCategory?: Maybe<Scalars['Int']['output']>;
  athenaProgrammeDescription?: Maybe<Scalars['String']['output']>;
  athenaProgrammeId?: Maybe<Scalars['Int']['output']>;
  athenaProgrammeIsSelfPlaced?: Maybe<Scalars['Boolean']['output']>;
  athenaProgrammeName?: Maybe<Scalars['String']['output']>;
  athenaProgrammeType?: Maybe<Scalars['Int']['output']>;
};

export type AthenaProgrammeClassTrack = {
  __typename?: 'AthenaProgrammeClassTrack';
  athenaProgrammeClassTrackData: Array<AthenaProgrammeClassTrackData>;
  year: Scalars['Int']['output'];
};

export type AthenaProgrammeClassTrackData = {
  __typename?: 'AthenaProgrammeClassTrackData';
  athenaClassTrackDetails: Array<AthenaClassTrackDetails>;
  athenaProgrammeCategory: Scalars['Int']['output'];
  athenaProgrammeDescription?: Maybe<Scalars['String']['output']>;
  athenaProgrammeId: Scalars['Int']['output'];
  athenaProgrammeName: Scalars['String']['output'];
  athenaProgrammeType: Scalars['Int']['output'];
};

export type AthenaStudentInfo = {
  __typename?: 'AthenaStudentInfo';
  athenaStudentEmail?: Maybe<Scalars['String']['output']>;
  athenaStudentFirstName?: Maybe<Scalars['String']['output']>;
  athenaStudentId?: Maybe<Scalars['ID']['output']>;
  athenaStudentIsDropped?: Maybe<Scalars['Int']['output']>;
  athenaStudentMiddleName?: Maybe<Scalars['String']['output']>;
  athenaStudentNumber?: Maybe<Scalars['String']['output']>;
  athenaStudentProgrammeData?: Maybe<Array<Maybe<StudentProgrammeData>>>;
  athenaStudentProgrammeId?: Maybe<Scalars['Int']['output']>;
  athenaStudentStatus?: Maybe<Scalars['Int']['output']>;
  athenaStudentSurname?: Maybe<Scalars['String']['output']>;
};

/** The type of an event which represents a test completion in Athena */
export type AthenaTestCompletedInput = {
  /** The pass mark average for the assessment */
  assessmentPassMarkAverage: Scalars['String']['input'];
  /** The sandId of the user that completed the test */
  sandId: Scalars['ID']['input'];
  /** The number of attempts made by the student */
  studentsNumberOfAttempts: Scalars['Int']['input'];
  /** The average mark obtained by the student */
  studentsObtainedMarkAverage: Scalars['Int']['input'];
  /** The date when the test was submitted */
  submissionDate: Scalars['DateTime']['input'];
  /** The due date for the test */
  testDueDate: Scalars['DateTime']['input'];
  /** The id of the completed test */
  testId: Scalars['ID']['input'];
};

export type AthenaUserDetails = {
  __typename?: 'AthenaUserDetails';
  athenaStudentInfo?: Maybe<AthenaStudentInfo>;
  athenaUserInfo?: Maybe<AthenaUserInfo>;
};

export type AthenaUserInfo = {
  __typename?: 'AthenaUserInfo';
  athenaSystemId?: Maybe<Scalars['Int']['output']>;
  athenaSystemUserId?: Maybe<Scalars['Int']['output']>;
  athenaSystemUserRoleId?: Maybe<Scalars['Int']['output']>;
  athenaSystemUserSSOId?: Maybe<Scalars['String']['output']>;
  athenaSystemUsername?: Maybe<Scalars['String']['output']>;
  athenaUserId?: Maybe<Scalars['ID']['output']>;
  athenaUserIsDeleted?: Maybe<Scalars['Int']['output']>;
  athenaUserName?: Maybe<Scalars['String']['output']>;
  athenaUserType?: Maybe<Scalars['Int']['output']>;
  sandId?: Maybe<Scalars['String']['output']>;
};

export type AttendanceBucketsType = {
  __typename?: 'AttendanceBucketsType';
  buckets: Array<Scalars['Int']['output']>;
  bucketsActive: Array<Scalars['Int']['output']>;
  now: Scalars['DateTime']['output'];
};

export type AttendanceStats = {
  __typename?: 'AttendanceStats';
  hubIds: Array<Scalars['String']['output']>;
  lastCheckInEndDate?: Maybe<Scalars['String']['output']>;
  lastCheckInStartDate?: Maybe<Scalars['String']['output']>;
  /** The paginated list of users. */
  learners: PaginatedUsers;
  pageNumber: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  searchString?: Maybe<Scalars['String']['output']>;
  /** Top 10 most recent check-ins. */
  top10MostRecentCheckIns: Array<HubCheckIn>;
  /** Total number of hub check-ins in the last 24 hours. */
  totalDaily: Scalars['Int']['output'];
  /** Difference in percentage between hub check-ins in the last 2 days. */
  totalDailyDiffPercentage: Scalars['Float']['output'];
  /** Total number of hub check-ins in the last 30 days. */
  totalMonthly: Scalars['Int']['output'];
  /** Difference in percentage between hub check-ins in the last 2 months. */
  totalMonthlyDiffPercentage: Scalars['Float']['output'];
  /** Total and active number of hub check-ins in the last 24 hours, per hour. Includes last hour partially. The array starts with hour T - 23. */
  totalPerHourLast24Hours: AttendanceBucketsType;
  /** Total number of hub check-ins in the last 7 days. */
  totalWeekly: Scalars['Int']['output'];
  /** Difference in percentage between hub check-ins in the last 2 weeks. */
  totalWeeklyDiffPercentage: Scalars['Float']['output'];
};

/** Specific actions that can be audited */
export enum AuditAction {
  AddClassEnrollment = 'ADD_CLASS_ENROLLMENT',
  AddCourseEnrollment = 'ADD_COURSE_ENROLLMENT',
  AddGradesMapping = 'ADD_GRADES_MAPPING',
  ApproveAcademicConductAppeal = 'APPROVE_ACADEMIC_CONDUCT_APPEAL',
  BulkRecalculateGpas = 'BULK_RECALCULATE_GPAS',
  ChangeProgramEnrollmentProgram = 'CHANGE_PROGRAM_ENROLLMENT_PROGRAM',
  CreateAcademicConductCase = 'CREATE_ACADEMIC_CONDUCT_CASE',
  CreateBadgeDefinition = 'CREATE_BADGE_DEFINITION',
  CreateCertificateDefinition = 'CREATE_CERTIFICATE_DEFINITION',
  CreateClass = 'CREATE_CLASS',
  CreatePartnership = 'CREATE_PARTNERSHIP',
  CreateStaffUser = 'CREATE_STAFF_USER',
  CreateTrainingResource = 'CREATE_TRAINING_RESOURCE',
  DeleteGradesMapping = 'DELETE_GRADES_MAPPING',
  DeleteTrainingResource = 'DELETE_TRAINING_RESOURCE',
  DenyAcademicConductAppeal = 'DENY_ACADEMIC_CONDUCT_APPEAL',
  EndImpersonationSession = 'END_IMPERSONATION_SESSION',
  EnrollIntoProgram = 'ENROLL_INTO_PROGRAM',
  IssueBadge = 'ISSUE_BADGE',
  IssueCertificate = 'ISSUE_CERTIFICATE',
  LockLearningProgression = 'LOCK_LEARNING_PROGRESSION',
  MarkClassEnrollmentDeferred = 'MARK_CLASS_ENROLLMENT_DEFERRED',
  MarkFailedClassEnrollmentAsGraduated = 'MARK_FAILED_CLASS_ENROLLMENT_AS_GRADUATED',
  MarkFailedClassEnrollmentAsOngoing = 'MARK_FAILED_CLASS_ENROLLMENT_AS_ONGOING',
  MarkGraduatedClassEnrollmentAsFailed = 'MARK_GRADUATED_CLASS_ENROLLMENT_AS_FAILED',
  MarkGraduatedClassEnrollmentAsOngoing = 'MARK_GRADUATED_CLASS_ENROLLMENT_AS_ONGOING',
  MarkOngoingClassEnrollmentAsFailed = 'MARK_ONGOING_CLASS_ENROLLMENT_AS_FAILED',
  MarkOngoingClassEnrollmentAsGraduated = 'MARK_ONGOING_CLASS_ENROLLMENT_AS_GRADUATED',
  ReinstateIntoProgram = 'REINSTATE_INTO_PROGRAM',
  RemovePaywall = 'REMOVE_PAYWALL',
  RemoveProgramGraduation = 'REMOVE_PROGRAM_GRADUATION',
  ReopenAcademicConductCase = 'REOPEN_ACADEMIC_CONDUCT_CASE',
  ResolveAcademicConductCase = 'RESOLVE_ACADEMIC_CONDUCT_CASE',
  RevokeBadge = 'REVOKE_BADGE',
  RevokeCertificate = 'REVOKE_CERTIFICATE',
  StartImpersonationSession = 'START_IMPERSONATION_SESSION',
  UnlockLearningProgression = 'UNLOCK_LEARNING_PROGRESSION',
  UpdateAcademicConductCase = 'UPDATE_ACADEMIC_CONDUCT_CASE',
  UpdateBadgeDefinition = 'UPDATE_BADGE_DEFINITION',
  UpdateCertificateDefinition = 'UPDATE_CERTIFICATE_DEFINITION',
  UpdateClass = 'UPDATE_CLASS',
  UpdateClassEnrollmentGradePoints = 'UPDATE_CLASS_ENROLLMENT_GRADE_POINTS',
  UpdateGradesMapping = 'UPDATE_GRADES_MAPPING',
  UpdatePartnership = 'UPDATE_PARTNERSHIP',
  UpdateProgramApplicationAdmissionStatus = 'UPDATE_PROGRAM_APPLICATION_ADMISSION_STATUS',
  UpdateProgramApplicationPartnership = 'UPDATE_PROGRAM_APPLICATION_PARTNERSHIP',
  UpdateProgramApplicationPartnershipType = 'UPDATE_PROGRAM_APPLICATION_PARTNERSHIP_TYPE',
  UpdateUser = 'UPDATE_USER',
  WithdrawFromProgram = 'WITHDRAW_FROM_PROGRAM'
}

export type AuthenticatedItem = AdminUser;

export type BadgeDefinition = {
  __typename?: 'BadgeDefinition';
  courseAbbreviation?: Maybe<Scalars['String']['output']>;
  courseDefinitionId: Scalars['String']['output'];
  courseName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  criteriaText: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: BadgeDefinitionStatus;
  templateConfig?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum BadgeDefinitionStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT'
}

export enum BadgeStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED'
}

export type BadgeVerification = {
  __typename?: 'BadgeVerification';
  badgeDescription: Scalars['String']['output'];
  badgeImageUrl?: Maybe<Scalars['String']['output']>;
  badgeName: Scalars['String']['output'];
  criteriaText: Scalars['String']['output'];
  isValid: Scalars['Boolean']['output'];
  issuedAt: Scalars['DateTime']['output'];
  issuer: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
  status: BadgeStatus;
};

/** A batch. */
export type Batch = {
  __typename?: 'Batch';
  /** The batch's unique identifier. */
  id: Scalars['ID']['output'];
  /** The batch's name. */
  name: Scalars['String']['output'];
  /** The batch's school location. */
  schoolLocation: SchoolLocation;
};

export enum BillingState {
  AtRisk = 'AT_RISK',
  AwaitingPaymentConfirmation = 'AWAITING_PAYMENT_CONFIRMATION',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  DueNow = 'DUE_NOW',
  DueSoon = 'DUE_SOON',
  Grace = 'GRACE',
  Inactive = 'INACTIVE',
  InAdvance = 'IN_ADVANCE',
  InArrears = 'IN_ARREARS',
  Pending = 'PENDING',
  UpToDate = 'UP_TO_DATE'
}

export type BooleanFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilter>;
};

export type Campaign = {
  __typename?: 'Campaign';
  achievements?: Maybe<Array<Achievement>>;
  achievementsCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  lgCampaignId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};


export type CampaignAchievementsArgs = {
  cursor?: InputMaybe<AchievementWhereUniqueInput>;
  orderBy?: Array<AchievementOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: AchievementWhereInput;
};


export type CampaignAchievementsCountArgs = {
  where?: AchievementWhereInput;
};

export type CampaignCreateInput = {
  achievements?: InputMaybe<AchievementRelateToManyForCreateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lgCampaignId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignManyRelationFilter = {
  every?: InputMaybe<CampaignWhereInput>;
  none?: InputMaybe<CampaignWhereInput>;
  some?: InputMaybe<CampaignWhereInput>;
};

export type CampaignOrderByInput = {
  createdAt?: InputMaybe<OrderDirection>;
  description?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  isActive?: InputMaybe<OrderDirection>;
  lgCampaignId?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  slug?: InputMaybe<OrderDirection>;
};

export type CampaignRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<CampaignWhereUniqueInput>>;
  create?: InputMaybe<Array<CampaignCreateInput>>;
};

export type CampaignRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<CampaignWhereUniqueInput>>;
  create?: InputMaybe<Array<CampaignCreateInput>>;
  disconnect?: InputMaybe<Array<CampaignWhereUniqueInput>>;
  set?: InputMaybe<Array<CampaignWhereUniqueInput>>;
};

export type CampaignRelateToOneForCreateInput = {
  connect?: InputMaybe<CampaignWhereUniqueInput>;
  create?: InputMaybe<CampaignCreateInput>;
};

export type CampaignRelateToOneForUpdateInput = {
  connect?: InputMaybe<CampaignWhereUniqueInput>;
  create?: InputMaybe<CampaignCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CampaignUpdateArgs = {
  data: CampaignUpdateInput;
  where: CampaignWhereUniqueInput;
};

export type CampaignUpdateInput = {
  achievements?: InputMaybe<AchievementRelateToManyForUpdateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lgCampaignId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignWhereInput = {
  AND?: InputMaybe<Array<CampaignWhereInput>>;
  NOT?: InputMaybe<Array<CampaignWhereInput>>;
  OR?: InputMaybe<Array<CampaignWhereInput>>;
  achievements?: InputMaybe<AchievementManyRelationFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  isActive?: InputMaybe<BooleanFilter>;
  lgCampaignId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
};

export type CampaignWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the learner's financial status after a payment plan is cancelled or completed. */
export enum CancellationStatus {
  /** The learner has paid all dues; no balance remains. */
  BalanceCleared = 'BALANCE_CLEARED',
  /** No financial action is required; the account is fully reconciled. */
  NoActionRequired = 'NO_ACTION_REQUIRED',
  /** The learner still has an outstanding balance to pay at the time of cancellation. */
  OwesBalance = 'OWES_BALANCE',
  /** The refund owed to the learner has already been processed. */
  RefundCompleted = 'REFUND_COMPLETED',
  /** The learner has overpaid and is entitled to a refund. */
  RefundDue = 'REFUND_DUE'
}

export type CertificateDefinition = {
  __typename?: 'CertificateDefinition';
  createdAt: Scalars['DateTime']['output'];
  criteriaText: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  programAbbreviation?: Maybe<Scalars['String']['output']>;
  programId: Scalars['String']['output'];
  programName?: Maybe<Scalars['String']['output']>;
  status: CertificateDefinitionStatus;
  templateConfig?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum CertificateDefinitionStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT'
}

export enum CertificateStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED'
}

export type CertificateVerification = {
  __typename?: 'CertificateVerification';
  certificateDescription: Scalars['String']['output'];
  certificateName: Scalars['String']['output'];
  criteriaText: Scalars['String']['output'];
  /** Public CDN URL for the rendered certificate PNG. Null when no image has been generated (e.g. cert definition has no template). */
  imageUrl?: Maybe<Scalars['String']['output']>;
  isValid: Scalars['Boolean']['output'];
  issuedAt: Scalars['DateTime']['output'];
  issuer: Scalars['String']['output'];
  /** LinkedIn "Add to Profile" URL. Returns null when the viewer is not the recipient of this certificate. */
  linkedInCertificateUrl?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  recipientName: Scalars['String']['output'];
  recipientSandId?: Maybe<Scalars['String']['output']>;
  status: CertificateStatus;
  verificationCode: Scalars['String']['output'];
};

/** The type of an event which represents verifying if a program application is ready for next steps. */
export type CheckApplicationStatusInput = {
  /** The id of the user's program application */
  programApplicationId: Scalars['ID']['input'];
};

export type Class = {
  __typename?: 'Class';
  /** The date when the learner can be shown then university upsell flow. */
  canShowUniversityUpsellAfter?: Maybe<Scalars['DateTime']['output']>;
  /** The cohort key used in the curriculum visualizer. */
  cohortKey?: Maybe<Scalars['String']['output']>;
  /** Date when this class ends. */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Did the class finish. Placeholder for statuses */
  finished: Scalars['Boolean']['output'];
  /** The id of the class. */
  id: Scalars['ID']['output'];
  /** The name of the class. */
  name: Scalars['String']['output'];
  /** Proof of completion type. */
  proofOfCompletionType: ProofOfCompletionType;
  /** The date when the learner should start to complete PoC. */
  requiresProofOfCompletionAfter?: Maybe<Scalars['DateTime']['output']>;
  /** Date when this class starts. */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** The academic term this class belongs to (e.g., "2026 Spring"). */
  term?: Maybe<Scalars['String']['output']>;
};

export type ClassEnrollment = {
  __typename?: 'ClassEnrollment';
  /** The class in which the user is enrolled. */
  class: Class;
  /** The course enrollment which contains this class enrollment. */
  courseEnrollment: CourseEnrollment;
  /** Date & time when this object was initially created. */
  createdAt: Scalars['DateTime']['output'];
  /** The description why the learner was deferred. */
  deferralDescription?: Maybe<Scalars['String']['output']>;
  /** The reason category why the learner was deferred. */
  deferralReason?: Maybe<DeferralReason>;
  /** The datetime when the class enrollment was deferred. */
  deferredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The datetime when the class enrollment was failed. */
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the grade is locked due to an academic integrity violation. */
  gradeLockedForIntegrityViolation: Scalars['Boolean']['output'];
  /** The numerical grade points received for this class. */
  gradePoints?: Maybe<Scalars['Float']['output']>;
  /** The GPA-scale value (0.0-4.0) for this class. */
  gradePointsValue?: Maybe<Scalars['Float']['output']>;
  /** The datetime when the class enrollment was graduated. */
  graduatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the class. */
  id: Scalars['ID']['output'];
  /** The data & time when leave of absence was last taken. */
  lastLeaveOfAbsenceAt?: Maybe<Scalars['DateTime']['output']>;
  /** The description for the learner's leave of absence. */
  leaveOfAbsenceDescription?: Maybe<Scalars['String']['output']>;
  /** The reason category for the learner's leave of absence */
  leaveOfAbsenceReason?: Maybe<DeferralReason>;
  /** The letter grade for this class (e.g., A, A-, B+, W, WF, WP, etc.). */
  letterGrade?: Maybe<Scalars['String']['output']>;
  /** The lms class location for this class. */
  lmsClassLocation: LmsClassLocation;
  /** The proof of completion of this class enrollment. */
  proofOfCompletion?: Maybe<ProofOfCompletion>;
  /** The data & time when the user was last reinstated. */
  reinstatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The status of the class enrollment. */
  status: ClassEnrollmentStatus;
  /** The reason for the status of the class enrollment. */
  statusReason?: Maybe<ClassEnrollmentStatusReason>;
  /** Date & time when this object was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export enum ClassEnrollmentStatus {
  Deferred = 'DEFERRED',
  Failed = 'FAILED',
  Graduated = 'GRADUATED',
  LeaveOfAbsence = 'LEAVE_OF_ABSENCE',
  Ongoing = 'ONGOING'
}

export type ClassEnrollmentStatusCount = {
  __typename?: 'ClassEnrollmentStatusCount';
  /** The number of class enrollments with this status */
  count: Scalars['Int']['output'];
  /** The class enrollment status */
  status: ClassEnrollmentStatus;
};

export enum ClassEnrollmentStatusReason {
  FailedByAdmin = 'FAILED_BY_ADMIN',
  FailedMilestone = 'FAILED_MILESTONE',
  FailedThePrerequisites = 'FAILED_THE_PREREQUISITES',
  GraduatedByAdmin = 'GRADUATED_BY_ADMIN',
  GraduatedByFinishingCourse = 'GRADUATED_BY_FINISHING_COURSE'
}

export enum ClassYearEnum {
  Year_2023 = 'YEAR_2023',
  Year_2024 = 'YEAR_2024',
  Year_2025 = 'YEAR_2025',
  Year_2026 = 'YEAR_2026'
}

export type Cohort = {
  __typename?: 'Cohort';
  /** Can students in this cohort use the all access payment plan for this program. */
  allAccessPaymentPlan: Scalars['Boolean']['output'];
  /** Can learners in this cohort defer their corresponding ongoing courses. */
  allowCourseDeferral: Scalars['Boolean']['output'];
  /** Can learners in this cohort request leave of absence on their program enrollment. */
  allowLeaveOfAbsence: Scalars['Boolean']['output'];
  /** Date when this cohort ends. */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the cohort. */
  id: Scalars['ID']['output'];
  /** The name of the cohort. */
  name: Scalars['String']['output'];
  /** The program that this cohort is a part of. */
  program: Program;
  /** Date when this cohort starts. */
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export enum CommsConditionTypeDateType {
  CreationDate = 'CREATION_DATE',
  CurrentDate = 'CURRENT_DATE',
  DueDate = 'DUE_DATE',
  EndDate = 'END_DATE',
  LastDueDate = 'LAST_DUE_DATE',
  NextInstalmentDate = 'NEXT_INSTALMENT_DATE',
  NextPaymentDate = 'NEXT_PAYMENT_DATE',
  SemesterEndDate = 'SEMESTER_END_DATE',
  SemesterInstalmentDeficit = 'SEMESTER_INSTALMENT_DEFICIT',
  StartDate = 'START_DATE'
}

export enum CommsMediumType {
  Email = 'EMAIL'
}

export enum CommsPaymentPlanStatus {
  Active = 'ACTIVE',
  AtRisk = 'AT_RISK',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Inactive = 'INACTIVE'
}

export type CommsPreviewDetailInput = {
  date: Scalars['Date']['input'];
  templateId: Scalars['ID']['input'];
};

export type CommsPreviewInput = {
  code: CommsTemplateCode;
  date: Scalars['Date']['input'];
  status?: InputMaybe<CommsTemplateStatus>;
};

export type CommsPreviewPlanItem = {
  __typename?: 'CommsPreviewPlanItem';
  date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  plan?: Maybe<PaymentPlan>;
  planId: Scalars['ID']['output'];
};

export type CommsPreviewPlanItemConnection = {
  __typename?: 'CommsPreviewPlanItemConnection';
  /** Contains the nodes in this connection */
  edges: Array<CommsPreviewPlanItemEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CommsPreviewPlanItemEdge = {
  __typename?: 'CommsPreviewPlanItemEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CommsPreviewPlanItem;
};

export type CommsPreviewSummaryResult = {
  __typename?: 'CommsPreviewSummaryResult';
  items: Array<CommsTemplateSummaryItem>;
};

/** CommsTemplate */
export type CommsTemplate = {
  __typename?: 'CommsTemplate';
  code: Scalars['String']['output'];
  commsConditionTypeDate?: Maybe<CommsConditionTypeDateType>;
  commsConditionTypePlanStatus?: Maybe<CommsPaymentPlanStatus>;
  commsEvent: CommsTemplateEvent;
  customProperties: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  medium: CommsMediumType;
  offset: Scalars['Int']['output'];
  status: CommsTemplateStatus;
  templateId: Scalars['String']['output'];
};

export enum CommsTemplateCode {
  AllAccess = 'ALL_ACCESS',
  Pathway = 'PATHWAY',
  Set = 'SET'
}

export enum CommsTemplateEvent {
  CouponApplied = 'COUPON_APPLIED',
  PaymentCompleted = 'PAYMENT_COMPLETED',
  PaymentFailure = 'PAYMENT_FAILURE',
  PaymentReminders = 'PAYMENT_REMINDERS',
  PaymentSuccess = 'PAYMENT_SUCCESS'
}

export type CommsTemplateQueryInput = {
  id: Scalars['String']['input'];
};

export type CommsTemplateResult = {
  __typename?: 'CommsTemplateResult';
  commsTemplate: CommsTemplate;
};

export type CommsTemplateResultResultPayload = {
  __typename?: 'CommsTemplateResultResultPayload';
  error?: Maybe<Scalars['String']['output']>;
  result?: Maybe<CommsTemplateResult>;
  success: Scalars['Boolean']['output'];
};

export enum CommsTemplateStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type CommsTemplateSummaryItem = {
  __typename?: 'CommsTemplateSummaryItem';
  count: Scalars['Int']['output'];
  template: CommsTemplate;
};

export type CommsTemplatesQueryInput = {
  code: Scalars['String']['input'];
  commsEvent?: InputMaybe<CommsTemplateEvent>;
  status?: InputMaybe<CommsTemplateStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type CommsTemplatesResult = {
  __typename?: 'CommsTemplatesResult';
  commsTemplates: Array<CommsTemplate>;
  totalCount: Scalars['Int']['output'];
};

export type CommsTemplatesResultResultPayload = {
  __typename?: 'CommsTemplatesResultResultPayload';
  error?: Maybe<Scalars['String']['output']>;
  result?: Maybe<CommsTemplatesResult>;
  success: Scalars['Boolean']['output'];
};

/** The enum of communication mediums that can be used to send communications to a user. */
export enum CommunicationMedium {
  Email = 'EMAIL'
}

export enum ConductCaseCategory {
  AcademicIntegrityViolation = 'ACADEMIC_INTEGRITY_VIOLATION',
  GpaBelowMinimum = 'GPA_BELOW_MINIMUM'
}

export enum ConductCaseHistoryAction {
  AppealApproved = 'APPEAL_APPROVED',
  AppealDenied = 'APPEAL_DENIED',
  AppealSubmitted = 'APPEAL_SUBMITTED',
  CaseCreated = 'CASE_CREATED',
  CaseReopened = 'CASE_REOPENED',
  CaseResolved = 'CASE_RESOLVED',
  DocumentUploaded = 'DOCUMENT_UPLOADED',
  NoteAdded = 'NOTE_ADDED',
  SeverityUpdated = 'SEVERITY_UPDATED',
  StatusUpdated = 'STATUS_UPDATED'
}

export enum ConductCaseResolutionType {
  Dismissed = 'DISMISSED',
  Exonerated = 'EXONERATED',
  Remediated = 'REMEDIATED'
}

export enum ConductCaseSeverity {
  AcademicDismissal = 'ACADEMIC_DISMISSAL',
  AcademicProbation = 'ACADEMIC_PROBATION',
  AcademicSuspension = 'ACADEMIC_SUSPENSION',
  ScholasticWarning = 'SCHOLASTIC_WARNING'
}

export enum ConductCaseStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  UnderAppeal = 'UNDER_APPEAL'
}

/** Coupon */
export type Coupon = {
  __typename?: 'Coupon';
  batch: CouponBatch;
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoice?: Maybe<Invoice>;
  sandId?: Maybe<Scalars['ID']['output']>;
  usedAt?: Maybe<Scalars['RFC3339DateTime']['output']>;
  usedBy?: Maybe<User>;
};

/** CouponBatch */
export type CouponBatch = {
  __typename?: 'CouponBatch';
  code: Scalars['String']['output'];
  coupons: Array<Coupon>;
  definition: PaymentPlanDefinition;
  description: Scalars['String']['output'];
  duration: CouponBatchDuration;
  id: Scalars['ID']['output'];
  invoiceItemName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  remaining: Scalars['Int']['output'];
  status: CouponBatchStatus;
  total: Scalars['Int']['output'];
  type: CouponBatchType;
  used: Scalars['Int']['output'];
  validFrom?: Maybe<Scalars['Date']['output']>;
  validUntil?: Maybe<Scalars['Date']['output']>;
};

export type CouponBatchCreateInput = {
  accountId: Scalars['Int']['input'];
  definitionId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration: CouponDurationInput;
  invoiceItemName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  status?: CouponBatchStatus;
  type: CouponBatchType;
  validFrom?: InputMaybe<Scalars['String']['input']>;
  validUntil?: InputMaybe<Scalars['String']['input']>;
};

export type CouponBatchDeleteInput = {
  id: Scalars['ID']['input'];
};

export type CouponBatchDuration = {
  __typename?: 'CouponBatchDuration';
  fixedDate?: Maybe<Scalars['Date']['output']>;
  months?: Maybe<Scalars['Int']['output']>;
  years?: Maybe<Scalars['Int']['output']>;
};

export type CouponBatchQueryInput = {
  id: Scalars['String']['input'];
};

export type CouponBatchResult = {
  __typename?: 'CouponBatchResult';
  couponBatch: CouponBatch;
};

export type CouponBatchResultResultPayload = {
  __typename?: 'CouponBatchResultResultPayload';
  error?: Maybe<Scalars['String']['output']>;
  result?: Maybe<CouponBatchResult>;
  success: Scalars['Boolean']['output'];
};

export enum CouponBatchStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export enum CouponBatchType {
  FixedDate = 'FIXED_DATE',
  Months = 'MONTHS',
  Years = 'YEARS'
}

export type CouponBatchUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  duration: CouponDurationInput;
  id: Scalars['ID']['input'];
  invoiceItemName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  status?: CouponBatchStatus;
  type: CouponBatchType;
  validFrom?: InputMaybe<Scalars['String']['input']>;
  validUntil?: InputMaybe<Scalars['String']['input']>;
};

export type CouponBatchesQueryInput = {
  accountId: Scalars['Int']['input'];
  definitionId: Scalars['String']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CouponBatchesResult = {
  __typename?: 'CouponBatchesResult';
  couponBatches: Array<CouponBatch>;
};

export type CouponBatchesResultResultPayload = {
  __typename?: 'CouponBatchesResultResultPayload';
  error?: Maybe<Scalars['String']['output']>;
  result?: Maybe<CouponBatchesResult>;
  success: Scalars['Boolean']['output'];
};

export type CouponDurationInput = {
  fixedDate?: InputMaybe<Scalars['String']['input']>;
  months?: InputMaybe<Scalars['Int']['input']>;
  years?: InputMaybe<Scalars['Int']['input']>;
};

export type CouponForPlanByHashResult = {
  __typename?: 'CouponForPlanByHashResult';
  coupon: Coupon;
  paymentPlan: PaymentPlan;
};

export type CouponForPlanByHashResultResultPayload = {
  __typename?: 'CouponForPlanByHashResultResultPayload';
  error?: Maybe<Scalars['String']['output']>;
  result?: Maybe<CouponForPlanByHashResult>;
  success: Scalars['Boolean']['output'];
};

export type CouponsInput = {
  batchId: Scalars['String']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};

export type CouponsResult = {
  __typename?: 'CouponsResult';
  coupons: Array<Coupon>;
};

export type CouponsResultResultPayload = {
  __typename?: 'CouponsResultResultPayload';
  error?: Maybe<Scalars['String']['output']>;
  result?: Maybe<CouponsResult>;
  success: Scalars['Boolean']['output'];
};

export enum CourseCategory {
  DataScience = 'DATA_SCIENCE',
  Entrepreneurship = 'ENTREPRENEURSHIP',
  GeneralEducation = 'GENERAL_EDUCATION',
  SoftwareEngineering = 'SOFTWARE_ENGINEERING',
  SoftwareEngineeringBackendSpecialization = 'SOFTWARE_ENGINEERING_BACKEND_SPECIALIZATION',
  SoftwareEngineeringFrontendSpecialization = 'SOFTWARE_ENGINEERING_FRONTEND_SPECIALIZATION',
  TechnicalElective = 'TECHNICAL_ELECTIVE'
}

export type CourseDefinition = {
  __typename?: 'CourseDefinition';
  /** The abbreviation of the course name. */
  abbreviation: Scalars['String']['output'];
  /** The badge awarded to learners who graduate this course, if defined. */
  badgeDefinition?: Maybe<BadgeDefinition>;
  /** The description of the course */
  description?: Maybe<Scalars['String']['output']>;
  /** The duration of the course (used for marketing purposes). */
  duration?: Maybe<Scalars['String']['output']>;
  /** The id of the course definition. */
  id: Scalars['ID']['output'];
  /** The badge issued to the current viewer for this course, if they have earned it. */
  issuedBadge?: Maybe<IssuedBadge>;
  /** The name of the course. */
  name: Scalars['String']['output'];
  /** Free-form type label for the course (e.g. self-paced-short-course). */
  type?: Maybe<Scalars['String']['output']>;
};

export type CourseEnrollment = {
  __typename?: 'CourseEnrollment';
  /** The class enrollments taken by the learner enrolled in this course. */
  classEnrollments: Array<ClassEnrollment>;
  /** The course in which the user is enrolled. */
  course: CourseDefinition;
  /** Date & time when this object was initially created. */
  createdAt: Scalars['DateTime']['output'];
  /** The class enrollments taken by the learner enrolled in this course. */
  currentClass?: Maybe<ClassEnrollment>;
  /** The datetime when the course enrollment was deferred. */
  deferredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The datetime when the course enrollment was failed. */
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The numerical grade points (0-100). */
  gradePoints?: Maybe<Scalars['Float']['output']>;
  /** The GPA-scale value (0.0-4.0). */
  gradePointsValue?: Maybe<Scalars['Float']['output']>;
  /** The datetime when the course enrollment was graduated. */
  graduatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the course. */
  id: Scalars['ID']['output'];
  /** The letter grade. */
  letterGrade?: Maybe<Scalars['String']['output']>;
  /** The status of the course enrollment. */
  status: CourseEnrollmentStatus;
  /** The reason for the status of the course enrollment. */
  statusReason?: Maybe<CourseEnrollmentStatusReason>;
  /** Date & time when this object was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The user enrolled into this course. */
  user: User;
};

export enum CourseEnrollmentStatus {
  Deferred = 'DEFERRED',
  Failed = 'FAILED',
  Graduated = 'GRADUATED',
  Ongoing = 'ONGOING'
}

export type CourseEnrollmentStatusCount = {
  __typename?: 'CourseEnrollmentStatusCount';
  /** The number of course enrollments with this status */
  count: Scalars['Int']['output'];
  /** The course enrollment status */
  status: CourseEnrollmentStatus;
};

export enum CourseEnrollmentStatusReason {
  EnrolledByAlgorithm = 'ENROLLED_BY_ALGORITHM',
  FailedByAdmin = 'FAILED_BY_ADMIN',
  FailedMaximumNumberOfRetakes = 'FAILED_MAXIMUM_NUMBER_OF_RETAKES',
  FailedTheClass = 'FAILED_THE_CLASS',
  FailedThePrerequisites = 'FAILED_THE_PREREQUISITES',
  GraduatedByAdmin = 'GRADUATED_BY_ADMIN',
  GraduatedTheClass = 'GRADUATED_THE_CLASS'
}

export type CreateANewAthenaUserData = {
  /** A Programme/class allocation is required when creating an Athena User. */
  allocateToProgramme?: InputMaybe<AllocateToProgramme>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBadgeDefinitionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  courseDefinitionId: Scalars['String']['input'];
  criteriaText: Scalars['String']['input'];
  description: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  templateConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateBadgeDefinitionPayload = {
  __typename?: 'CreateBadgeDefinitionPayload';
  badgeDefinition: BadgeDefinition;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateCertificateDefinitionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  criteriaText: Scalars['String']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  programId: Scalars['String']['input'];
  templateConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateCertificateDefinitionPayload = {
  __typename?: 'CreateCertificateDefinitionPayload';
  certificateDefinition: CertificateDefinition;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateCommsTemplateInput = {
  code: Scalars['String']['input'];
  commsEvent: CommsTemplateEvent;
  customProperties: Array<Scalars['String']['input']>;
  dateType: CommsConditionTypeDateType;
  medium: CommsMediumType;
  offset: Scalars['Int']['input'];
  planStatus: PaymentPlanStatus;
  status: CommsTemplateStatus;
  templateId: Scalars['String']['input'];
};

export type CreateDashboardInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverPhotoUrl?: InputMaybe<Scalars['String']['input']>;
  dashboardId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateDashboardPayload = {
  __typename?: 'CreateDashboardPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: StaffUser;
};

export type CreateInitialAdminUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type CreateNewUserResponse = {
  __typename?: 'CreateNewUserResponse';
  code?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<AthenaUserDetails>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateOrUpdateProofOfCompletionInput = {
  /** The id of the classEnrollment. */
  classEnrollmentId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The email of the learner that took the exam. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The location where the exam was taken. */
  examLocation?: InputMaybe<ProofOfCompletionExamLocation>;
  /** The score received in the exam. */
  examScore?: InputMaybe<Scalars['Int']['input']>;
  /** The exam statement for both SA and AWS. */
  examStatement?: InputMaybe<ExamStatementType>;
  /** The validation number of the exam. */
  examValidationNumber?: InputMaybe<Scalars['String']['input']>;
  /** The first name of the learner that took the exam. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The last name of the learner that took the exam. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The trailblazer profile link of the learner that took the exam. */
  trailblazerProfileLink?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrUpdateProofOfCompletionPayload = {
  __typename?: 'CreateOrUpdateProofOfCompletionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The newly created proof of completion. */
  proofOfCompletion: ProofOfCompletion;
};

export type CreatePaymentPlanDefinitionInput = {
  accountId?: Scalars['Int']['input'];
  amount: Scalars['Int']['input'];
  code: Scalars['String']['input'];
  daysOfGrace?: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  instalments?: Scalars['Int']['input'];
  interval: Interval;
  name: Scalars['String']['input'];
};

export type CreateProgramApplicationInput = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  /** If the user anticipates challenges in paying the tuition. */
  anticipateChallenges?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The fee payment mode. */
  feePaymentMode?: InputMaybe<FeePaymentMode>;
  /** The other fee payment mode. */
  otherFeePaymentMode?: InputMaybe<Scalars['String']['input']>;
  /** The preferred hub for this program enrollment. */
  preferredHub?: InputMaybe<Scalars['String']['input']>;
  /** The programId in which to enroll the learner. */
  programId: Scalars['ID']['input'];
  sharePersonalDataConsent?: InputMaybe<Scalars['Boolean']['input']>;
  /** The tuition fee payment type. */
  tuitionFeePaymentType?: InputMaybe<TuitionFeePaymentType>;
};

export type CreateProgramApplicationPayload = {
  __typename?: 'CreateProgramApplicationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  programApplication: ProgramApplication;
  programEnrollment: ProgramEnrollment;
};

export type CreateUploadInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  scope: UploadScope;
};

export type CreateUploadPayload = {
  __typename?: 'CreateUploadPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The list of form fields that have to be included in the POST request. */
  fields: Array<FormDataField>;
  /** The uploaded file url. */
  fileUrl: Scalars['String']['output'];
  /** The URL that has to be used as the target of the POST request. */
  uploadUrl: Scalars['String']['output'];
};

export type CreateWorkExperienceInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The new work experience */
  workExperience: WorkExperienceCreateInput;
};

export type CreateWorkExperiencePayload = {
  __typename?: 'CreateWorkExperiencePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated user. */
  user: User;
};

/** Currency */
export type Currency = {
  __typename?: 'Currency';
  iso2: Scalars['String']['output'];
  name: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

/** A curriculum. */
export type Curriculum = {
  __typename?: 'Curriculum';
  /** The curriculum's unique identifier. */
  id: Scalars['ID']['output'];
  /** The curriculum's name. */
  name: Scalars['String']['output'];
};

export type Dashboard = {
  __typename?: 'Dashboard';
  /** The cover photo of the dashboard */
  coverPhoto?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The name of the dashboard */
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** The public URL of the dashboard */
  url?: Maybe<Scalars['String']['output']>;
};

export type DashboardForLearnerByHash = {
  __typename?: 'DashboardForLearnerByHash';
  paymentPlans: Array<PaymentPlan>;
};

export type DashboardForLearnerByHashResultPayload = {
  __typename?: 'DashboardForLearnerByHashResultPayload';
  error?: Maybe<Scalars['String']['output']>;
  result?: Maybe<DashboardForLearnerByHash>;
  success: Scalars['Boolean']['output'];
};

export type DashboardUrl = {
  __typename?: 'DashboardUrl';
  dashboardUrl: Scalars['String']['output'];
};

export type DashboardUrlResultPayload = {
  __typename?: 'DashboardUrlResultPayload';
  error?: Maybe<Scalars['String']['output']>;
  result?: Maybe<DashboardUrl>;
  success: Scalars['Boolean']['output'];
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DecimalNullableFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<DecimalNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export enum DeferralReason {
  FamilyIssues = 'FAMILY_ISSUES',
  FinanceIssues = 'FINANCE_ISSUES',
  MissedPayment = 'MISSED_PAYMENT',
  Other = 'OTHER',
  Sickness = 'SICKNESS'
}

export type DeleteCommsTemplateInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCommsTemplateResult = {
  __typename?: 'DeleteCommsTemplateResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteCommsTemplateResultResultPayload = {
  __typename?: 'DeleteCommsTemplateResultResultPayload';
  error?: Maybe<Scalars['String']['output']>;
  result?: Maybe<DeleteCommsTemplateResult>;
  success: Scalars['Boolean']['output'];
};

export type DeleteCvInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteCvPayload = {
  __typename?: 'DeleteCvPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type DeleteDashboardInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteDashboardPayload = {
  __typename?: 'DeleteDashboardPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: StaffUser;
};

export type DeleteEducationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the user education */
  id: Scalars['ID']['input'];
};

export type DeleteEducationPayload = {
  __typename?: 'DeleteEducationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type DeletePaymentPlanDefinitionInput = {
  id: Scalars['String']['input'];
};

export type DeleteRefugeeCardInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteRefugeeCardPayload = {
  __typename?: 'DeleteRefugeeCardPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type DeleteWorkExperienceInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the work experience to be deleted */
  id: Scalars['ID']['input'];
};

export type DeleteWorkExperiencePayload = {
  __typename?: 'DeleteWorkExperiencePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated user */
  user: User;
};

export enum Disability {
  ChronicHealthConditions = 'CHRONIC_HEALTH_CONDITIONS',
  DevelopmentalDisabilities = 'DEVELOPMENTAL_DISABILITIES',
  HearingImpairments = 'HEARING_IMPAIRMENTS',
  IntellectualDisabilities = 'INTELLECTUAL_DISABILITIES',
  LearningDisabilities = 'LEARNING_DISABILITIES',
  MobilityImpairments = 'MOBILITY_IMPAIRMENTS',
  NeurologicalDisabilities = 'NEUROLOGICAL_DISABILITIES',
  None = 'NONE',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
  PsychiatricDisabilities = 'PSYCHIATRIC_DISABILITIES',
  SpeechAndLanguageDisabilities = 'SPEECH_AND_LANGUAGE_DISABILITIES',
  VisualImpairments = 'VISUAL_IMPAIRMENTS'
}

export type DismissPaymentHistoryResult = {
  __typename?: 'DismissPaymentHistoryResult';
  paymentHistoryTransaction: PaymentHistoryTransaction;
};

export type DismissPaymentHistoryResultResultPayload = {
  __typename?: 'DismissPaymentHistoryResultResultPayload';
  error?: Maybe<Scalars['String']['output']>;
  result?: Maybe<DismissPaymentHistoryResult>;
  success: Scalars['Boolean']['output'];
};

export type DocusignEnrollmentAgreement = {
  __typename?: 'DocusignEnrollmentAgreement';
  /** Latest applicant status reported by DocuSign. */
  applicantStatus?: Maybe<Scalars['String']['output']>;
  /** When the envelope was completed, if applicable. */
  envelopeCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Latest envelope status reported by DocuSign. */
  envelopeStatus?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

export type DocusignEnvelopeCreatedInput = {
  docusignAgreementId: Scalars['ID']['input'];
};

export type DocusignEnvelopeFullySignedInput = {
  docusignAgreementId: Scalars['ID']['input'];
};

export type DocusignEnvelopeSignedInput = {
  docusignAgreementId: Scalars['ID']['input'];
};

/** The type of an event which represents a badge was issued to a learner. */
export type EHubBadgeIssuedInput = {
  /** The id of the issued badge */
  issuedBadgeId: Scalars['ID']['input'];
};

/** The type of an event which represents a certificate was issued to a learner. */
export type EHubCertificateIssuedInput = {
  /** The id of the issued certificate */
  issuedCertificateId: Scalars['ID']['input'];
};

/** The type of an event which represents a class enrollment grade has been updated. */
export type EHubClassEnrollmentGradeUpdatedInput = {
  /** The id of the user's class enrollment */
  classEnrollmentId: Scalars['ID']['input'];
};

/** The type of an event which represents a existing class enrollment was deferred. */
export type EHubDeferredClassEnrollmentInput = {
  /** The id of the user's class enrollment */
  classEnrollmentId: Scalars['ID']['input'];
};

/** The type of an event which represents a existing class enrollment has failed. */
export type EHubFailedClassEnrollmentInput = {
  /** The id of the user's class enrollment */
  classEnrollmentId: Scalars['ID']['input'];
};

/** The type of an event which represents a course enrollment was failed. */
export type EHubFailedCourseEnrollmentInput = {
  /** The id of the user's course enrollment */
  courseEnrollmentId: Scalars['ID']['input'];
};

/** The type of an event which represents a course enrollment was graduated. */
export type EHubGraduatedCourseEnrollmentInput = {
  /** The internal abbreviation of the course definition. */
  courseAbbreviation?: InputMaybe<Scalars['String']['input']>;
  /** The id of the user's course enrollment */
  courseEnrollmentId: Scalars['ID']['input'];
  /** The name of the course definition. */
  courseName?: InputMaybe<Scalars['String']['input']>;
  /** The tier of the course definition. */
  courseTier?: InputMaybe<Scalars['String']['input']>;
  /** The free-form type label of the course definition. */
  courseType?: InputMaybe<Scalars['String']['input']>;
  /** The datetime the course enrollment was marked graduated. */
  graduatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The sandId of the learner who graduated the course. */
  sandId?: InputMaybe<Scalars['ID']['input']>;
};

/** The type of an event which represents a program enrollment was graduated. */
export type EHubGraduatedProgramEnrollmentInput = {
  /** The datetime the program enrollment was marked graduated. */
  graduatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The abbreviation of the program. */
  programAbbreviation?: InputMaybe<Scalars['String']['input']>;
  /** The id of the user's program enrollment */
  programEnrollmentId: Scalars['ID']['input'];
  /** The id of the program that was graduated. */
  programId?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the program. */
  programName?: InputMaybe<Scalars['String']['input']>;
  /** The version of the program (programs with the same name can have different mandatory courses). */
  programVersion?: InputMaybe<Scalars['String']['input']>;
  /** The sandId of the learner who graduated the program. */
  sandId?: InputMaybe<Scalars['ID']['input']>;
};

/** The type of an event which represents a new class enrollment was created. */
export type EHubNewClassEnrollmentInput = {
  /** The id of the user's class enrollment */
  classEnrollmentId: Scalars['ID']['input'];
};

/** The type of event which represents a class enrollment was created. */
export type EHubNewClassEnrollmentNotificationInput = {
  /** The ID of the class enrollment that has been created. */
  classEnrollmentId: Scalars['ID']['input'];
};

export type EHubNewClassEnrollmentNotificationPayload = {
  __typename?: 'EHubNewClassEnrollmentNotificationPayload';
  classEnrollment?: Maybe<ClassEnrollment>;
  classEnrollmentId: Scalars['String']['output'];
  /** The type of notification */
  type: NotificationType;
};

/** The type of event which represents new class enrollment reinstatement was been created. */
export type EHubNewClassReinstateEnrollmentInput = {
  /** The id of the user's class enrollment */
  classEnrollmentId: Scalars['ID']['input'];
};

/** The type of an event which represents a new nile identity has been created. */
export type EHubNewNileIdentityInput = {
  /** The nileId of the user */
  nileId: Scalars['ID']['input'];
  /** The sandId of the user */
  sandId: Scalars['ID']['input'];
};

/** The type of an event which represents a new program enrollment was created. */
export type EHubNewProgramEnrollmentInput = {
  /** The id of the user's program enrollment */
  programEnrollmentId: Scalars['ID']['input'];
};

/** The type of event which represents a program enrollment was created. */
export type EHubNewProgramEnrollmentNotificationInput = {
  /** The ID of the program enrollment that has been created. */
  programEnrollmentId: Scalars['ID']['input'];
};

export type EHubNewProgramEnrollmentNotificationPayload = {
  __typename?: 'EHubNewProgramEnrollmentNotificationPayload';
  programEnrollment?: Maybe<ProgramEnrollment>;
  programEnrollmentId: Scalars['String']['output'];
  /** The type of notification */
  type: NotificationType;
};

/** The type of event which represents that a new user was created in EHub. */
export type EHubNewUserInput = {
  /** The sandId of the newly created user. */
  sandId: Scalars['ID']['input'];
};

/** The type of event which represents that a new user finished onboarding in EHub. */
export type EHubOnboardingFinishedInput = {
  /** The time at which the onboarding was finished. */
  finishedOnboardingAt: Scalars['DateTime']['input'];
  /** The sandId of the user that finished the EHub onboarding */
  sandId: Scalars['ID']['input'];
};

/** The type of an event which represents a program enrollment was paused. */
export type EHubPausedProgramEnrollmentInput = {
  /** The id of the user's program enrollment */
  programEnrollmentId: Scalars['ID']['input'];
};

/** The type of an event which represents a program enrollment status changed from PENDING to ONGOING. */
export type EHubProgramEnrollmentActivatedInput = {
  /** The id of the user's program enrollment */
  programEnrollmentId: Scalars['ID']['input'];
};

/** The type of an event which represents a program enrollment was canceled. */
export type EHubWithdrawProgramEnrollmentInput = {
  /** The id of the user's program enrollment */
  programEnrollmentId: Scalars['ID']['input'];
};

export type Education = {
  __typename?: 'Education';
  /** Date & time when the education was initially created. */
  createdAt: Scalars['DateTime']['output'];
  /** The field of study. */
  fieldOfStudy: Scalars['String']['output'];
  /** The date when the user graduated this education. */
  graduatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the education. */
  id: Scalars['String']['output'];
  /** The country of the institution. */
  institutionCountry?: Maybe<Scalars['String']['output']>;
  /** The county of the institution. */
  institutionCounty?: Maybe<Scalars['String']['output']>;
  /** The locality of the institution. */
  institutionLocality?: Maybe<Scalars['String']['output']>;
  /** The institution name of the education. */
  institutionName: Scalars['String']['output'];
  /** The external institution id. */
  knownInstitutionId?: Maybe<Scalars['String']['output']>;
  /** The level of study. */
  levelOfStudy: Scalars['String']['output'];
  /** The start date of the user education. */
  startDate: Scalars['DateTime']['output'];
  /** Date & time when the education was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The type of an event which represents a new program application has proof of english accepted. */
export type EhubApplicationProofOfEnglishAcceptedInput = {
  /** The id of the user's program application */
  programApplicationId: Scalars['ID']['input'];
};

/** The type of an event which represents a new program application now has a proof of english. */
export type EhubApplicationProofOfEnglishSubmittedInput = {
  /** The id of the user's program application */
  programApplicationId: Scalars['ID']['input'];
};

/** The type of an event which triggers GPA recalculation for a program enrollment. */
export type EhubBulkGpaRecalculationInput = {
  /** The id of the program enrollment */
  programEnrollmentId: Scalars['String']['input'];
};

/** The type of an event which represents a new program application was created. */
export type EhubNewProgramApplicationInput = {
  /** The id of the user's program application */
  programApplicationId: Scalars['ID']['input'];
};

/** The type of an event which represents a new referral was created (a referee signed up with a referrer code). */
export type EhubNewReferralInput = {
  /** The datetime the referral was created. */
  createdAt: Scalars['DateTime']['input'];
  /** The datetime the referral will expire if the referee has not paid. */
  expiresAt: Scalars['DateTime']['input'];
  /** The sandId of the user who signed up via the referral. */
  refereeSandId: Scalars['ID']['input'];
  /** The id of the newly created referral. */
  referralId: Scalars['ID']['input'];
  /** The sandId of the user who owns the referral link. */
  referrerSandId: Scalars['ID']['input'];
  /** The status of the referral at creation (always AWAITING_PROGRAM_APPLICATION, carried for consistency). */
  status: ReferralStatus;
};

/** The type of event which represents that an admin removed/skipped paywall for a learner. */
export type EhubPaywallRemovedByAdminInput = {
  /** The datetime when paywall was removed by admin. */
  removedPaywallAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The sandId of the learner whose paywall was removed. */
  sandId: Scalars['ID']['input'];
  /** The reason provided by admin when skipping paywall. */
  skipPaywallReason?: InputMaybe<Scalars['String']['input']>;
  /** The datetime until when paywall is skipped. */
  skipPaywallUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

/** The type of an event which represents a referral's status transitioned. */
export type EhubReferralStatusUpdatedInput = {
  /** The current expiry datetime of the referral. */
  expiresAt: Scalars['DateTime']['input'];
  /** The status of the referral after the transition. */
  newStatus: ReferralStatus;
  /** The status of the referral before the transition. */
  previousStatus: ReferralStatus;
  /** The datetime the referee applied/enrolled to a program (set on transition into AWAITING_PAYMENT). */
  programApplicationAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The datetime of the referee's first on-time payment (set on transition into PAYMENT_COMPLETE). */
  refereeFirstPaymentAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The sandId of the referee. */
  refereeSandId: Scalars['ID']['input'];
  /** The datetime the referee's second-month milestone was reached. */
  refereeSecondPaymentAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The id of the referral whose status changed. */
  referralId: Scalars['ID']['input'];
  /** The sandId of the referrer. */
  referrerSandId: Scalars['ID']['input'];
  /** The datetime the referral row was updated. */
  updatedAt: Scalars['DateTime']['input'];
};

export enum EmploymentTypeEnum {
  Contract = 'CONTRACT',
  FullTime = 'FULL_TIME',
  PartTime = 'PART_TIME',
  Seasonal = 'SEASONAL'
}

export enum EnglishProficiencyStatus {
  Failed = 'FAILED',
  NotSubmitted = 'NOT_SUBMITTED',
  Passed = 'PASSED',
  Pending = 'PENDING',
  RequiresResubmission = 'REQUIRES_RESUBMISSION'
}

export enum EnglishProficiencyType {
  EnglishTestScores = 'ENGLISH_TEST_SCORES',
  HighSchoolDiploma = 'HIGH_SCHOOL_DIPLOMA',
  NativeLanguage = 'NATIVE_LANGUAGE',
  UniversityTranscript = 'UNIVERSITY_TRANSCRIPT'
}

export type EnrollmentFeatureAccess = {
  __typename?: 'EnrollmentFeatureAccess';
  hasAnswerbaseAccess: Scalars['Boolean']['output'];
  hasCheckInAccess: Scalars['Boolean']['output'];
  hasCircleAccess: Scalars['Boolean']['output'];
};

export type EnrollmentStatusCount = {
  __typename?: 'EnrollmentStatusCount';
  /** The number of enrollments with this status */
  count: Scalars['Int']['output'];
  /** The enrollment status (will be cast to appropriate enum) */
  status: Scalars['String']['output'];
};

/** Input fields for creating an event */
export type EventInput = {
  /** The id of the event */
  id: Scalars['ID']['input'];
  payload: EventPayloadInput;
  /** The platform which wants to push this event */
  platform: EventPlatform;
  /** The type of event */
  type: EventType;
};

/** The input shape of an event payload, it must contain exactly one non-null payload type for the request to pass input validation */
export type EventPayloadInput = {
  /** The type of event which represents a course failure in Athena. */
  athenaCourseFailed?: InputMaybe<AthenaCourseFailedInput>;
  /** The type of event which represents a course graduation in Athena. */
  athenaCourseGraduated?: InputMaybe<AthenaCourseGraduatedInput>;
  /** The type of event which represents a test completion in Athena. */
  athenaTestCompleted?: InputMaybe<AthenaTestCompletedInput>;
  /** The type of event which represents verifying if a program application is ready for next steps. */
  checkApplicationStatus?: InputMaybe<CheckApplicationStatusInput>;
  docusignEnvelopeCreated?: InputMaybe<DocusignEnvelopeCreatedInput>;
  docusignEnvelopeFullySigned?: InputMaybe<DocusignEnvelopeFullySignedInput>;
  docusignEnvelopeSigned?: InputMaybe<DocusignEnvelopeSignedInput>;
  /** The type of event which represents a new identity for nile has been created. */
  eHubNewNileIdentity?: InputMaybe<EHubNewNileIdentityInput>;
  /** The type of event which represents a new program enrollment was created. */
  eHubNewProgramEnrollment?: InputMaybe<EHubNewProgramEnrollmentInput>;
  /** The type of event which represents that a new user was created in EHub. */
  eHubNewUser?: InputMaybe<EHubNewUserInput>;
  /** The type of event which represents that a new user finished onboarding in EHub. */
  eHubOnboardingFinished?: InputMaybe<EHubOnboardingFinishedInput>;
  /** The type of event which represents a program enrollment was paused. */
  eHubPausedProgramEnrollment?: InputMaybe<EHubPausedProgramEnrollmentInput>;
  /** The type of event which represents a program enrollment status changed from PENDING to ONGOING. */
  eHubProgramEnrollmentActivated?: InputMaybe<EHubProgramEnrollmentActivatedInput>;
  /** The type of event which represents a program enrollment was canceled. */
  eHubWithdrawProgramEnrollment?: InputMaybe<EHubWithdrawProgramEnrollmentInput>;
  /** The type of event which represents a new program enrollment was created. */
  ehubApplicationProofOfEnglishAccepted?: InputMaybe<EhubApplicationProofOfEnglishAcceptedInput>;
  /** The type of event which represents a new program enrollment was created. */
  ehubApplicationProofOfEnglishSubmitted?: InputMaybe<EhubApplicationProofOfEnglishSubmittedInput>;
  /** The type of event which represents a badge was issued to a learner. */
  ehubBadgeIssued?: InputMaybe<EHubBadgeIssuedInput>;
  /** The type of event which triggers GPA recalculation for a program enrollment. */
  ehubBulkGpaRecalculation?: InputMaybe<EhubBulkGpaRecalculationInput>;
  /** The type of event which represents a certificate was issued to a learner. */
  ehubCertificateIssued?: InputMaybe<EHubCertificateIssuedInput>;
  /** The type of event which represents a class enrollment grade has been updated. */
  ehubClassEnrollmentGradeUpdated?: InputMaybe<EHubClassEnrollmentGradeUpdatedInput>;
  /** The type of event which represents a class enrollment has been deferred. */
  ehubDeferredClassEnrollment?: InputMaybe<EHubDeferredClassEnrollmentInput>;
  /** The type of event which represents a class enrollment has been failed. */
  ehubFailedClassEnrollment?: InputMaybe<EHubFailedClassEnrollmentInput>;
  /** The type of event which represents a course enrollment was failed. */
  ehubFailedCourseEnrollment?: InputMaybe<EHubFailedCourseEnrollmentInput>;
  /** The type of event which represents a course enrollment was graduated. */
  ehubGraduatedCourseEnrollment?: InputMaybe<EHubGraduatedCourseEnrollmentInput>;
  /** The type of event which represents a program enrollment was graduated. */
  ehubGraduatedProgramEnrollment?: InputMaybe<EHubGraduatedProgramEnrollmentInput>;
  /** The type of event which represents new class enrollment was been created. */
  ehubNewClassEnrollment?: InputMaybe<EHubNewClassEnrollmentInput>;
  /** The type of event which represents a new program enrollment was created. */
  ehubNewProgramApplication?: InputMaybe<EhubNewProgramApplicationInput>;
  /** The type of event which represents a new referral was created. */
  ehubNewReferral?: InputMaybe<EhubNewReferralInput>;
  /** The type of event which represents that an admin removed/skipped paywall for a learner. */
  ehubPaywallRemovedByAdmin?: InputMaybe<EhubPaywallRemovedByAdminInput>;
  /** The type of event which represents a referral's status transitioned. */
  ehubReferralStatusUpdated?: InputMaybe<EhubReferralStatusUpdatedInput>;
  /** The type of event which represents new class enrollment reinstatement was been created. */
  ehubReinstateClassEnrollment?: InputMaybe<EHubNewClassReinstateEnrollmentInput>;
  /** The type of event which represents impact questions submitted during account validation. */
  fingoAccountValidationImpact?: InputMaybe<FingoAccountValidationImpactInput>;
  /** The type of event which represents budget creation through Fingo. */
  fingoBudgetCreated?: InputMaybe<FingoBudgetCreatedInput>;
  /** The type of event which represents salary identification through Fingo. */
  fingoBudgetEvent?: InputMaybe<FingoBudgetEventInput>;
  /** The type of event which represents budget maintenance tracking through Fingo. */
  fingoBudgetMaintained?: InputMaybe<FingoBudgetMaintainedInput>;
  /** The type of event which represents dignified job impact questions submission for ALX members. */
  fingoDignifiedJobImpact?: InputMaybe<FingoDignifiedJobImpactInput>;
  /** The type of event which represents employment status II impact questions submission for ALX members. */
  fingoEmploymentStatusImpact?: InputMaybe<FingoEmploymentStatusImpactInput>;
  /** The type of event which represents salary identification through Fingo. */
  fingoImpactFormSubmission?: InputMaybe<FingoImpactFormSubmissionInput>;
  /** The type of event which represents salary identification through Fingo. */
  fingoSalaryIdentified?: InputMaybe<FingoSalaryIdentifiedInput>;
  /** The type of event which represents salary maintenance tracking through Fingo. */
  fingoSalaryMaintained?: InputMaybe<FingoSalaryMaintainedInput>;
  /** The type of event which represents a linkedind url that was added to a user's profile */
  linkedinAddedToProfile?: InputMaybe<LinkedinAddedToProfileInput>;
  /** The type of event which represents a new user was enrolled in a flow in Nile. */
  nileEnrolledInFlow?: InputMaybe<NileEnrolledInFlowInput>;
  /** The type of event which represents a new user was created in Nile. */
  nileNewUserInPlatform?: InputMaybe<NileNewUserInPlatformInput>;
  /** The type of event which represents payment plan become active. */
  paymentPlanActive?: InputMaybe<PaymentPlanActiveInput>;
  /** The type of event which represents a payment plan that was cancelled. */
  paymentPlanCancelled?: InputMaybe<PaymentPlanCancelledInput>;
  /** The type of event which represents a successful payment made by a learner. */
  paymentsNewPaymentMade?: InputMaybe<PaymentsNewPaymentMadeInput>;
  /** The type of event which represents impact questions submitted during account validation. */
  personaInquiryApproved?: InputMaybe<PersonaInquiryApprovedInput>;
  /** The type of event which represents impact questions submitted during account validation. */
  personaInquiryCompleted?: InputMaybe<PersonaInquiryCompletedInput>;
  /** The type of event which represents impact questions submitted during account validation. */
  personaInquiryDeclined?: InputMaybe<PersonaInquiryDeclinedInput>;
  /** The type of event which represents a resume uploaded by a user. */
  resumeUploaded?: InputMaybe<ResumeUploadedInput>;
  /** The type of event which represents that all failed events should be retried. */
  retryFailedEvents?: InputMaybe<RetryFailedEvents>;
  /** The type of event which represents a learner completed an achievement in the Rewards platform. */
  rewardAchievementComplete?: InputMaybe<RewardAchievementCompleteInput>;
  /** The type of event which represents a course that was failed in Savanna. */
  savannaCourseFailed?: InputMaybe<SavannaCourseFailedInput>;
  /** The type of event which represents a course that was graduated in Savanna. */
  savannaCourseGraduated?: InputMaybe<SavannaCourseGraduatedInput>;
  /** The type of event which represents a milestone that was completed in Savanna. */
  savannaMilestoneCompleted?: InputMaybe<SavannaMilestoneCompletedInput>;
  /** The type of event which represents a test that was completed in Savanna. */
  savannaTestCompleted?: InputMaybe<SavannaTestCompletedInput>;
  /** The type of event which represents a resume uploaded by a user. */
  sendCommunication?: InputMaybe<SendCommunicationInput>;
};

/** The enum of platforms that can be attributed to an event */
export enum EventPlatform {
  Athena = 'ATHENA',
  Ehub = 'EHUB',
  Fingo = 'FINGO',
  Nile = 'NILE',
  Payment = 'PAYMENT',
  Rewards = 'REWARDS',
  Savanna = 'SAVANNA'
}

/** The enum of event types */
export enum EventType {
  AthenaCourseFailed = 'ATHENA_COURSE_FAILED',
  AthenaCourseGraduated = 'ATHENA_COURSE_GRADUATED',
  AthenaTestCompleted = 'ATHENA_TEST_COMPLETED',
  CheckApplicationStatus = 'CHECK_APPLICATION_STATUS',
  DocusignEnvelopeCreated = 'DOCUSIGN_ENVELOPE_CREATED',
  DocusignEnvelopeFullySigned = 'DOCUSIGN_ENVELOPE_FULLY_SIGNED',
  DocusignEnvelopeSigned = 'DOCUSIGN_ENVELOPE_SIGNED',
  EhubApplicationProofOfEnglishAccepted = 'EHUB_APPLICATION_PROOF_OF_ENGLISH_ACCEPTED',
  EhubApplicationProofOfEnglishSubmitted = 'EHUB_APPLICATION_PROOF_OF_ENGLISH_SUBMITTED',
  EhubBadgeIssued = 'EHUB_BADGE_ISSUED',
  EhubBulkGpaRecalculation = 'EHUB_BULK_GPA_RECALCULATION',
  EhubCertificateIssued = 'EHUB_CERTIFICATE_ISSUED',
  EhubClassEnrollmentGradeUpdated = 'EHUB_CLASS_ENROLLMENT_GRADE_UPDATED',
  EhubDeferredClassEnrollment = 'EHUB_DEFERRED_CLASS_ENROLLMENT',
  EhubFailedClassEnrollment = 'EHUB_FAILED_CLASS_ENROLLMENT',
  EhubFailedCourseEnrollment = 'EHUB_FAILED_COURSE_ENROLLMENT',
  EhubGraduatedCourseEnrollment = 'EHUB_GRADUATED_COURSE_ENROLLMENT',
  EhubGraduatedProgramEnrollment = 'EHUB_GRADUATED_PROGRAM_ENROLLMENT',
  EhubNewClassEnrollment = 'EHUB_NEW_CLASS_ENROLLMENT',
  EhubNewNileIdentity = 'EHUB_NEW_NILE_IDENTITY',
  EhubNewProgramApplication = 'EHUB_NEW_PROGRAM_APPLICATION',
  EhubNewProgramEnrollment = 'EHUB_NEW_PROGRAM_ENROLLMENT',
  EhubNewReferral = 'EHUB_NEW_REFERRAL',
  EhubNewUser = 'EHUB_NEW_USER',
  EhubOnboardingFinished = 'EHUB_ONBOARDING_FINISHED',
  EhubPausedProgramEnrollment = 'EHUB_PAUSED_PROGRAM_ENROLLMENT',
  EhubPaywallRemovedByAdmin = 'EHUB_PAYWALL_REMOVED_BY_ADMIN',
  EhubProgramEnrollmentActivated = 'EHUB_PROGRAM_ENROLLMENT_ACTIVATED',
  EhubReferralStatusUpdated = 'EHUB_REFERRAL_STATUS_UPDATED',
  EhubReinstateClassEnrollment = 'EHUB_REINSTATE_CLASS_ENROLLMENT',
  EhubWithdrawProgramEnrollment = 'EHUB_WITHDRAW_PROGRAM_ENROLLMENT',
  FingoAccountValidationImpact = 'FINGO_ACCOUNT_VALIDATION_IMPACT',
  FingoBudgetCreated = 'FINGO_BUDGET_CREATED',
  FingoBudgetEvent = 'FINGO_BUDGET_EVENT',
  FingoBudgetMaintained = 'FINGO_BUDGET_MAINTAINED',
  FingoDignifiedJobImpact = 'FINGO_DIGNIFIED_JOB_IMPACT',
  FingoEmploymentStatusImpact = 'FINGO_EMPLOYMENT_STATUS_IMPACT',
  FingoImpactFormSubmission = 'FINGO_IMPACT_FORM_SUBMISSION',
  FingoSalaryIdentified = 'FINGO_SALARY_IDENTIFIED',
  FingoSalaryMaintained = 'FINGO_SALARY_MAINTAINED',
  LinkedinAddedToProfile = 'LINKEDIN_ADDED_TO_PROFILE',
  NileEnrolledInFlow = 'NILE_ENROLLED_IN_FLOW',
  NileNewUserInPlatform = 'NILE_NEW_USER_IN_PLATFORM',
  PaymentsNewPaymentMade = 'PAYMENTS_NEW_PAYMENT_MADE',
  PaymentPlanActive = 'PAYMENT_PLAN_ACTIVE',
  PaymentPlanCancelled = 'PAYMENT_PLAN_CANCELLED',
  PersonaInquiryApproved = 'PERSONA_INQUIRY_APPROVED',
  PersonaInquiryCompleted = 'PERSONA_INQUIRY_COMPLETED',
  PersonaInquiryDeclined = 'PERSONA_INQUIRY_DECLINED',
  ResumeUploaded = 'RESUME_UPLOADED',
  RetryFailedEvents = 'RETRY_FAILED_EVENTS',
  RewardAchievementComplete = 'REWARD_ACHIEVEMENT_COMPLETE',
  SavannaCourseFailed = 'SAVANNA_COURSE_FAILED',
  SavannaCourseGraduated = 'SAVANNA_COURSE_GRADUATED',
  SavannaMilestoneCompleted = 'SAVANNA_MILESTONE_COMPLETED',
  SavannaTestCompleted = 'SAVANNA_TEST_COMPLETED',
  SendCommunication = 'SEND_COMMUNICATION'
}

export enum ExamStatementType {
  DidNotCompleteExam = 'DID_NOT_COMPLETE_EXAM',
  EarnedBeforeAlx = 'EARNED_BEFORE_ALX',
  TakenAndFailed = 'TAKEN_AND_FAILED',
  TakenAndPassed = 'TAKEN_AND_PASSED'
}

export enum FeePaymentMode {
  Bursary = 'BURSARY',
  FamilySupport = 'FAMILY_SUPPORT',
  Other = 'OTHER',
  Scholarship = 'SCHOLARSHIP',
  SelfPaying = 'SELF_PAYING',
  Sponsorship = 'SPONSORSHIP'
}

/** The type of event which represents impact questions submitted during account validation */
export type FingoAccountValidationImpactInput = {
  /** JSON data containing account validation impact responses */
  data: Scalars['JSON']['input'];
  /** The sandId of the user submitting account validation impact questions */
  sandId: Scalars['ID']['input'];
};

/** The type of event which represents budget creation through Fingo */
export type FingoBudgetCreatedInput = {
  /** JSON data containing budget creation details from Fingo */
  data: Scalars['JSON']['input'];
  /** The sandId of the user who created a budget */
  sandId: Scalars['ID']['input'];
};

/** The type of event which represents budget information through Fingo */
export type FingoBudgetEventInput = {
  /** JSON data containing salary identification details from Fingo */
  data: Scalars['JSON']['input'];
  /** The sandId of the user whose salary was identified */
  sandId: Scalars['ID']['input'];
};

/** The type of event which represents budget maintenance tracking through Fingo */
export type FingoBudgetMaintainedInput = {
  /** JSON data containing budget maintenance details from Fingo */
  data: Scalars['JSON']['input'];
  /** The sandId of the user who is maintaining their budget */
  sandId: Scalars['ID']['input'];
};

/** The type of event which represents dignified job impact questions submission for ALX members */
export type FingoDignifiedJobImpactInput = {
  /** JSON data containing dignified job impact assessment details and legacy points information */
  data: Scalars['JSON']['input'];
  /** The sandId of the ALX member submitting dignified job impact questions */
  sandId: Scalars['ID']['input'];
};

/** The type of event which represents employment status II impact questions submission for ALX members */
export type FingoEmploymentStatusImpactInput = {
  /** JSON data containing employment status impact assessment details and legacy points information */
  data: Scalars['JSON']['input'];
  /** The sandId of the ALX member submitting impact questions */
  sandId: Scalars['ID']['input'];
};

/** The type of event which represents salary identification through Fingo */
export type FingoImpactFormSubmissionInput = {
  /** JSON data containing salary identification details from Fingo */
  data: Scalars['JSON']['input'];
  /** The sandId of the user whose salary was identified */
  sandId: Scalars['ID']['input'];
};

/** The type of event which represents salary identification through Fingo */
export type FingoSalaryIdentifiedInput = {
  /** JSON data containing salary identification details from Fingo */
  data: Scalars['JSON']['input'];
  /** The sandId of the user whose salary was identified */
  sandId: Scalars['ID']['input'];
};

/** The type of event which represents salary maintenance tracking through Fingo */
export type FingoSalaryMaintainedInput = {
  /** JSON data containing salary maintenance details from Fingo */
  data: Scalars['JSON']['input'];
  /** The sandId of the user whose salary is being maintained */
  sandId: Scalars['ID']['input'];
};

export type ForgotPasswordInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The email of the user for which the forgot password will be sent again. */
  email: Scalars['String']['input'];
  /** Whether the user belongs to the staff Cognito pool. */
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ForgotPasswordPayload = {
  __typename?: 'ForgotPasswordPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type FormDataField = {
  __typename?: 'FormDataField';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER'
}

export type GenerateCouponsInput = {
  count: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};

export enum Guardianship {
  Adopted = 'ADOPTED',
  NoneOfTheAbove = 'NONE_OF_THE_ABOVE',
  Orphaned = 'ORPHANED',
  Other = 'OTHER',
  ParentsDeceased = 'PARENTS_DECEASED',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
  Refugee = 'REFUGEE',
  SiblingCaregiver = 'SIBLING_CAREGIVER',
  SingleParentHome = 'SINGLE_PARENT_HOME',
  TwoParentHome = 'TWO_PARENT_HOME'
}

export type HealthStatus = {
  __typename?: 'HealthStatus';
  status?: Maybe<Scalars['String']['output']>;
};

export type HighSchoolCertificate = {
  __typename?: 'HighSchoolCertificate';
  /** The city where the school is located. */
  city: Scalars['String']['output'];
  /** The country where the school is located. */
  country: Scalars['String']['output'];
  /** The month and year of graduation. */
  graduationDate: Scalars['DateTime']['output'];
  /** The id of the high school certificate. */
  id: Scalars['ID']['output'];
  /** The program application this certificate is associated with. */
  programApplication?: Maybe<ProgramApplication>;
  /** The qualification obtained. */
  qualification: Scalars['String']['output'];
  /** The address of the school. */
  schoolAddress: Scalars['String']['output'];
  /** The name of the school. */
  schoolName: Scalars['String']['output'];
  /** The state where the school is located. */
  state: Scalars['String']['output'];
  /** The status of the high school certificate. */
  status: HighSchoolCertificateStatus;
};

export enum HighSchoolCertificateStatus {
  Failed = 'FAILED',
  NotSubmitted = 'NOT_SUBMITTED',
  Passed = 'PASSED',
  Pending = 'PENDING',
  RequiresResubmission = 'REQUIRES_RESUBMISSION'
}

export enum HighSchoolVerificationMode {
  Manual = 'MANUAL',
  NotSet = 'NOT_SET',
  Persona = 'PERSONA'
}

export type Hub = {
  __typename?: 'Hub';
  /** The full address of the Hub. */
  address?: Maybe<Scalars['String']['output']>;
  /** The home country of the Hub. */
  country?: Maybe<Scalars['String']['output']>;
  /** The home county of the Hub. */
  county?: Maybe<Scalars['String']['output']>;
  /** Date & time when the hub was initially created. */
  createdAt: Scalars['DateTime']['output'];
  /** A short description of the Hub. */
  description: Scalars['String']['output'];
  /** The list of things the hub is equipped with. */
  equippedWith: Array<Scalars['String']['output']>;
  /** The id of the OAuth client. */
  id: Scalars['ID']['output'];
  /** The home locality of the Hub. */
  locality?: Maybe<Scalars['String']['output']>;
  /** The name of the Hub. */
  name: Scalars['String']['output'];
  /** Date & time when the hub was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type HubCheckIn = {
  __typename?: 'HubCheckIn';
  /** The yyyy-MM-dd when the user checked into the Hub */
  checkInDay: Scalars['String']['output'];
  /** Date & time when the check-in was done. */
  checkedInAt: Scalars['DateTime']['output'];
  /** Date & time when the check-out was done. */
  checkedOutAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date & time when the check-in was created. */
  createdAt: Scalars['DateTime']['output'];
  hub: Hub;
  type?: Maybe<HubCheckInType>;
  user: User;
};

export type HubCheckInCode = {
  __typename?: 'HubCheckInCode';
  /** Time left is seconds that the code is active for. */
  timeLeft?: Maybe<Scalars['Int']['output']>;
  /** The value of the check-in code. */
  value?: Maybe<Scalars['String']['output']>;
};

export enum HubCheckInType {
  AdminManualOverwrite = 'ADMIN_MANUAL_OVERWRITE',
  Qr = 'QR',
  Self = 'SELF'
}

export type HubCheckOutCode = {
  __typename?: 'HubCheckOutCode';
  /** Time left is seconds that the code is active for. */
  timeLeft?: Maybe<Scalars['Int']['output']>;
  /** The value of the check-out code. */
  value?: Maybe<Scalars['String']['output']>;
};

export enum HumanitarianStatus {
  No = 'NO',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
  Yes = 'YES'
}

export enum HumanitarianStatusType {
  AsylumSeeker = 'ASYLUM_SEEKER',
  InternallyDisplacedPerson = 'INTERNALLY_DISPLACED_PERSON',
  NotAplicable = 'NOT_APLICABLE',
  Refugee = 'REFUGEE'
}

export type IdFilter = {
  equals?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilter>;
  notIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum ImageExtension {
  Gif = 'gif',
  Jpg = 'jpg',
  Png = 'png',
  Webp = 'webp'
}

export type ImageFieldInput = {
  upload: Scalars['Upload']['input'];
};

export type ImageFieldOutput = {
  __typename?: 'ImageFieldOutput';
  extension: ImageExtension;
  filesize: Scalars['Int']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

/** Active or historical admin impersonation session. */
export type ImpersonationSession = {
  __typename?: 'ImpersonationSession';
  /** Sand ID of the admin who started the session. */
  adminSandId: Scalars['String']['output'];
  /** When the session was created. */
  createdAt: Scalars['DateTime']['output'];
  /** When the session was explicitly ended. */
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the session expires automatically. */
  expiresAt: Scalars['DateTime']['output'];
  /** Unique identifier for the impersonation session. */
  id: Scalars['ID']['output'];
  /** Sand ID of the impersonated user. */
  targetSandId: Scalars['String']['output'];
  /** The impersonated user. */
  targetUser?: Maybe<User>;
};

/** Lifecycle status of an impersonation session used for filtering. */
export enum ImpersonationSessionStatus {
  Ended = 'ENDED',
  Ongoing = 'ONGOING'
}

export enum IncompleteTransactionStatus {
  Abandoned = 'ABANDONED',
  Canceled = 'CANCELED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Initialized = 'INITIALIZED',
  Pending = 'PENDING',
  Unknown = 'UNKNOWN'
}

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum Interval {
  FirstDay = 'FIRST_DAY',
  LastDay = 'LAST_DAY',
  SameDay = 'SAME_DAY'
}

/** Invoice */
export type Invoice = {
  __typename?: 'Invoice';
  amount: Scalars['Int']['output'];
  coupon?: Maybe<Coupon>;
  createdAt: Scalars['RFC3339DateTime']['output'];
  currency: Scalars['String']['output'];
  downloadInvoiceUrl: Scalars['String']['output'];
  dueDate: Scalars['RFC3339DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  payment?: Maybe<Payment>;
  status: InvoiceStatus;
  updatedAt: Scalars['RFC3339DateTime']['output'];
  viewInvoiceUrl: Scalars['String']['output'];
};

/** Invoice item */
export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  uPrice: Scalars['Float']['output'];
};

export enum InvoiceStatus {
  Paid = 'PAID',
  Refunded = 'REFUNDED',
  Unpaid = 'UNPAID'
}

export enum IsFacultyEnum {
  No = 'NO',
  Yes = 'YES'
}

export type IssuedBadge = {
  __typename?: 'IssuedBadge';
  badgeDefinition?: Maybe<BadgeDefinition>;
  badgeDefinitionId: Scalars['String']['output'];
  courseEnrollmentId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  credentialJwt: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  issuedAt: Scalars['DateTime']['output'];
  linkedInShareUrl: Scalars['String']['output'];
  revocationReason?: Maybe<Scalars['String']['output']>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  sandId: Scalars['String']['output'];
  status: BadgeStatus;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  verificationCode: Scalars['String']['output'];
  verificationUrl: Scalars['String']['output'];
};

export type IssuedCertificate = {
  __typename?: 'IssuedCertificate';
  certificateDefinition?: Maybe<CertificateDefinition>;
  certificateDefinitionId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  credentialJwt: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  /** Public CDN URL for the rendered certificate PNG. Null when no image has been generated (e.g. cert definition has no template). */
  imageUrl?: Maybe<Scalars['String']['output']>;
  issuedAt: Scalars['DateTime']['output'];
  linkedInCertificateUrl: Scalars['String']['output'];
  programEnrollmentId: Scalars['String']['output'];
  revocationReason?: Maybe<Scalars['String']['output']>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  sandId: Scalars['String']['output'];
  status: CertificateStatus;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  verificationCode: Scalars['String']['output'];
  verificationUrl: Scalars['String']['output'];
};

/** The type of event which represents that a user should join the community. */
export type JoinCommunityInput = {
  /** The sandId of the user. */
  sandId: Scalars['ID']['input'];
};

export type JoinCommunityPayload = {
  __typename?: 'JoinCommunityPayload';
  sandId: Scalars['ID']['output'];
  /** The type of notification */
  type: NotificationType;
};

export type KeystoneAdminMeta = {
  __typename?: 'KeystoneAdminMeta';
  list?: Maybe<KeystoneAdminUiListMeta>;
  lists: Array<KeystoneAdminUiListMeta>;
};


export type KeystoneAdminMetaListArgs = {
  key: Scalars['String']['input'];
};

export type KeystoneAdminUiFieldGroupMeta = {
  __typename?: 'KeystoneAdminUIFieldGroupMeta';
  description?: Maybe<Scalars['String']['output']>;
  fields: Array<KeystoneAdminUiFieldMeta>;
  label: Scalars['String']['output'];
};

export type KeystoneAdminUiFieldMeta = {
  __typename?: 'KeystoneAdminUIFieldMeta';
  createView: KeystoneAdminUiFieldMetaCreateView;
  customViewsIndex?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fieldMeta?: Maybe<Scalars['JSON']['output']>;
  isFilterable: Scalars['Boolean']['output'];
  isNonNull?: Maybe<Array<KeystoneAdminUiFieldMetaIsNonNull>>;
  isOrderable: Scalars['Boolean']['output'];
  itemView?: Maybe<KeystoneAdminUiFieldMetaItemView>;
  label: Scalars['String']['output'];
  listView: KeystoneAdminUiFieldMetaListView;
  path: Scalars['String']['output'];
  search?: Maybe<QueryMode>;
  viewsIndex: Scalars['Int']['output'];
};


export type KeystoneAdminUiFieldMetaItemViewArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type KeystoneAdminUiFieldMetaCreateView = {
  __typename?: 'KeystoneAdminUIFieldMetaCreateView';
  fieldMode: KeystoneAdminUiFieldMetaCreateViewFieldMode;
};

export enum KeystoneAdminUiFieldMetaCreateViewFieldMode {
  Edit = 'edit',
  Hidden = 'hidden'
}

export enum KeystoneAdminUiFieldMetaIsNonNull {
  Create = 'create',
  Read = 'read',
  Update = 'update'
}

export type KeystoneAdminUiFieldMetaItemView = {
  __typename?: 'KeystoneAdminUIFieldMetaItemView';
  fieldMode?: Maybe<KeystoneAdminUiFieldMetaItemViewFieldMode>;
  fieldPosition?: Maybe<KeystoneAdminUiFieldMetaItemViewFieldPosition>;
};

export enum KeystoneAdminUiFieldMetaItemViewFieldMode {
  Edit = 'edit',
  Hidden = 'hidden',
  Read = 'read'
}

export enum KeystoneAdminUiFieldMetaItemViewFieldPosition {
  Form = 'form',
  Sidebar = 'sidebar'
}

export type KeystoneAdminUiFieldMetaListView = {
  __typename?: 'KeystoneAdminUIFieldMetaListView';
  fieldMode: KeystoneAdminUiFieldMetaListViewFieldMode;
};

export enum KeystoneAdminUiFieldMetaListViewFieldMode {
  Hidden = 'hidden',
  Read = 'read'
}

export type KeystoneAdminUiListMeta = {
  __typename?: 'KeystoneAdminUIListMeta';
  description?: Maybe<Scalars['String']['output']>;
  fields: Array<KeystoneAdminUiFieldMeta>;
  groups: Array<KeystoneAdminUiFieldGroupMeta>;
  hideCreate: Scalars['Boolean']['output'];
  hideDelete: Scalars['Boolean']['output'];
  initialColumns: Array<Scalars['String']['output']>;
  initialSort?: Maybe<KeystoneAdminUiSort>;
  isHidden: Scalars['Boolean']['output'];
  isSingleton: Scalars['Boolean']['output'];
  itemQueryName: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  labelField: Scalars['String']['output'];
  listQueryName: Scalars['String']['output'];
  pageSize: Scalars['Int']['output'];
  path: Scalars['String']['output'];
  plural: Scalars['String']['output'];
  singular: Scalars['String']['output'];
};

export type KeystoneAdminUiSort = {
  __typename?: 'KeystoneAdminUISort';
  direction: KeystoneAdminUiSortDirection;
  field: Scalars['String']['output'];
};

export enum KeystoneAdminUiSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type KeystoneMeta = {
  __typename?: 'KeystoneMeta';
  adminMeta: KeystoneAdminMeta;
};

export enum LanguageEnum {
  Amharic = 'AMHARIC',
  Arabic = 'ARABIC',
  Bengali = 'BENGALI',
  English = 'ENGLISH',
  French = 'FRENCH',
  German = 'GERMAN',
  Hausa = 'HAUSA',
  Hindi = 'HINDI',
  Igbo = 'IGBO',
  Japanese = 'JAPANESE',
  Javanese = 'JAVANESE',
  Kanuri = 'KANURI',
  Kikuyu = 'KIKUYU',
  Korean = 'KOREAN',
  Lingala = 'LINGALA',
  Makonde = 'MAKONDE',
  Malagasy = 'MALAGASY',
  MandarinChinese = 'MANDARIN_CHINESE',
  Marathi = 'MARATHI',
  Oromo = 'OROMO',
  Portuguese = 'PORTUGUESE',
  Punjabi = 'PUNJABI',
  Russian = 'RUSSIAN',
  Setswana = 'SETSWANA',
  Shona = 'SHONA',
  Somali = 'SOMALI',
  Spanish = 'SPANISH',
  Swahili = 'SWAHILI',
  Telugu = 'TELUGU',
  Thai = 'THAI',
  Tswana = 'TSWANA',
  Turkish = 'TURKISH',
  Vietnamese = 'VIETNAMESE',
  WuChinese = 'WU_CHINESE',
  Yoruba = 'YORUBA',
  Zulu = 'ZULU'
}

export enum LanguageProficiencyLevel {
  Advanced = 'ADVANCED',
  Beginner = 'BEGINNER',
  Elementary = 'ELEMENTARY',
  Fluent = 'FLUENT',
  Intermediate = 'INTERMEDIATE',
  Native = 'NATIVE',
  UpperIntermediate = 'UPPER_INTERMEDIATE'
}

export type LanguageSkill = {
  __typename?: 'LanguageSkill';
  /** Date & time when the language skill was initially created. */
  createdAt: Scalars['DateTime']['output'];
  /** The id of the language skill. */
  id: Scalars['String']['output'];
  /** The type of language (e.g. ENGLISH). */
  language: LanguageEnum;
  /** The proficiency level of the language skill */
  proficiencyLevel: LanguageProficiencyLevel;
  /** Date & time when the language skill was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export enum LearningPlatform {
  Athena = 'ATHENA',
  Canvas = 'CANVAS',
  Savanna = 'SAVANNA',
  Trailhead = 'TRAILHEAD'
}

export type LegacyPointsTag = {
  __typename?: 'LegacyPointsTag';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type LegacyPointsTagCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type LegacyPointsTagManyRelationFilter = {
  every?: InputMaybe<LegacyPointsTagWhereInput>;
  none?: InputMaybe<LegacyPointsTagWhereInput>;
  some?: InputMaybe<LegacyPointsTagWhereInput>;
};

export type LegacyPointsTagOrderByInput = {
  createdAt?: InputMaybe<OrderDirection>;
  description?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type LegacyPointsTagRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<LegacyPointsTagWhereUniqueInput>>;
  create?: InputMaybe<Array<LegacyPointsTagCreateInput>>;
};

export type LegacyPointsTagRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<LegacyPointsTagWhereUniqueInput>>;
  create?: InputMaybe<Array<LegacyPointsTagCreateInput>>;
  disconnect?: InputMaybe<Array<LegacyPointsTagWhereUniqueInput>>;
  set?: InputMaybe<Array<LegacyPointsTagWhereUniqueInput>>;
};

export type LegacyPointsTagUpdateArgs = {
  data: LegacyPointsTagUpdateInput;
  where: LegacyPointsTagWhereUniqueInput;
};

export type LegacyPointsTagUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type LegacyPointsTagWhereInput = {
  AND?: InputMaybe<Array<LegacyPointsTagWhereInput>>;
  NOT?: InputMaybe<Array<LegacyPointsTagWhereInput>>;
  OR?: InputMaybe<Array<LegacyPointsTagWhereInput>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type LegacyPointsTagWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** The type of event which represents a linkedind url that was added to a user's profile */
export type LinkedinAddedToProfileInput = {
  /** The linkedin url */
  linkedinUrl: Scalars['String']['input'];
  /** The sandId of the learner which added the linkedin url to its profile */
  sandId: Scalars['ID']['input'];
  /** The time when the profile was updated with the linkedin url */
  submissionTime: Scalars['DateTime']['input'];
};

export enum LivingCircumstances {
  CareFacilityInstitution = 'CARE_FACILITY_INSTITUTION',
  Homeless = 'HOMELESS',
  Other = 'OTHER',
  OwnStableAdequate = 'OWN_STABLE_ADEQUATE',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
  RentingStableAdequate = 'RENTING_STABLE_ADEQUATE',
  RentingUnstableInadequate = 'RENTING_UNSTABLE_INADEQUATE',
  ShelterTemporaryHousing = 'SHELTER_TEMPORARY_HOUSING'
}

export type LmsClassLocation = {
  __typename?: 'LmsClassLocation';
  /** The link to the LMS Course */
  courseLink: Scalars['String']['output'];
  /** The id of the lms class location. */
  id: Scalars['ID']['output'];
  /** The lms for this class. */
  learningPlatform?: Maybe<LearningPlatform>;
  /** The name of this lms class location. */
  name: Scalars['String']['output'];
};

/** Location */
export type Location = {
  __typename?: 'Location';
  countryCode: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
};

export enum LocationDescription {
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
  Rural = 'RURAL',
  Urban = 'URBAN'
}

export type LpUser = {
  __typename?: 'LpUser';
  actions?: Maybe<Array<LpUserAction>>;
  actionsCount?: Maybe<Scalars['Int']['output']>;
  balance?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  loyaltyGatorEmail?: Maybe<Scalars['String']['output']>;
  memberTalentRepositoryId?: Maybe<Scalars['String']['output']>;
  sandId?: Maybe<Scalars['String']['output']>;
};


export type LpUserActionsArgs = {
  cursor?: InputMaybe<LpUserActionWhereUniqueInput>;
  orderBy?: Array<LpUserActionOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: LpUserActionWhereInput;
};


export type LpUserActionsCountArgs = {
  where?: LpUserActionWhereInput;
};

export type LpUserAction = {
  __typename?: 'LpUserAction';
  achievement?: Maybe<Achievement>;
  amount?: Maybe<Scalars['Int']['output']>;
  campaign?: Maybe<Campaign>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lgTransactionId?: Maybe<Scalars['String']['output']>;
  lpUser?: Maybe<LpUser>;
  memberAndLearnerCategories?: Maybe<Array<Scalars['String']['output']>>;
  metadata?: Maybe<Scalars['String']['output']>;
  redeemIsSatisfied?: Maybe<Scalars['Boolean']['output']>;
  reward?: Maybe<Reward>;
  type?: Maybe<Scalars['String']['output']>;
};

export type LpUserActionCreateInput = {
  achievement?: InputMaybe<AchievementRelateToOneForCreateInput>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  campaign?: InputMaybe<CampaignRelateToOneForCreateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  lgTransactionId?: InputMaybe<Scalars['String']['input']>;
  lpUser?: InputMaybe<LpUserRelateToOneForCreateInput>;
  memberAndLearnerCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  redeemIsSatisfied?: InputMaybe<Scalars['Boolean']['input']>;
  reward?: InputMaybe<RewardRelateToOneForCreateInput>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type LpUserActionManyRelationFilter = {
  every?: InputMaybe<LpUserActionWhereInput>;
  none?: InputMaybe<LpUserActionWhereInput>;
  some?: InputMaybe<LpUserActionWhereInput>;
};

export type LpUserActionOrderByInput = {
  amount?: InputMaybe<OrderDirection>;
  createdAt?: InputMaybe<OrderDirection>;
  description?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  lgTransactionId?: InputMaybe<OrderDirection>;
  metadata?: InputMaybe<OrderDirection>;
  redeemIsSatisfied?: InputMaybe<OrderDirection>;
  type?: InputMaybe<OrderDirection>;
};

export type LpUserActionRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<LpUserActionWhereUniqueInput>>;
  create?: InputMaybe<Array<LpUserActionCreateInput>>;
};

export type LpUserActionRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<LpUserActionWhereUniqueInput>>;
  create?: InputMaybe<Array<LpUserActionCreateInput>>;
  disconnect?: InputMaybe<Array<LpUserActionWhereUniqueInput>>;
  set?: InputMaybe<Array<LpUserActionWhereUniqueInput>>;
};

export type LpUserActionUpdateArgs = {
  data: LpUserActionUpdateInput;
  where: LpUserActionWhereUniqueInput;
};

export type LpUserActionUpdateInput = {
  achievement?: InputMaybe<AchievementRelateToOneForUpdateInput>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  campaign?: InputMaybe<CampaignRelateToOneForUpdateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  lgTransactionId?: InputMaybe<Scalars['String']['input']>;
  lpUser?: InputMaybe<LpUserRelateToOneForUpdateInput>;
  memberAndLearnerCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  redeemIsSatisfied?: InputMaybe<Scalars['Boolean']['input']>;
  reward?: InputMaybe<RewardRelateToOneForUpdateInput>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type LpUserActionWhereInput = {
  AND?: InputMaybe<Array<LpUserActionWhereInput>>;
  NOT?: InputMaybe<Array<LpUserActionWhereInput>>;
  OR?: InputMaybe<Array<LpUserActionWhereInput>>;
  achievement?: InputMaybe<AchievementWhereInput>;
  amount?: InputMaybe<IntNullableFilter>;
  campaign?: InputMaybe<CampaignWhereInput>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  lgTransactionId?: InputMaybe<StringNullableFilter>;
  lpUser?: InputMaybe<LpUserWhereInput>;
  metadata?: InputMaybe<StringFilter>;
  redeemIsSatisfied?: InputMaybe<BooleanFilter>;
  reward?: InputMaybe<RewardWhereInput>;
  type?: InputMaybe<StringNullableFilter>;
};

export type LpUserActionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type LpUserCreateInput = {
  actions?: InputMaybe<LpUserActionRelateToManyForCreateInput>;
  balance?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  loyaltyGatorEmail?: InputMaybe<Scalars['String']['input']>;
  memberTalentRepositoryId?: InputMaybe<Scalars['String']['input']>;
  sandId?: InputMaybe<Scalars['String']['input']>;
};

export type LpUserOrderByInput = {
  balance?: InputMaybe<OrderDirection>;
  createdAt?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  isActive?: InputMaybe<OrderDirection>;
  loyaltyGatorEmail?: InputMaybe<OrderDirection>;
  memberTalentRepositoryId?: InputMaybe<OrderDirection>;
  sandId?: InputMaybe<OrderDirection>;
};

export type LpUserRelateToOneForCreateInput = {
  connect?: InputMaybe<LpUserWhereUniqueInput>;
  create?: InputMaybe<LpUserCreateInput>;
};

export type LpUserRelateToOneForUpdateInput = {
  connect?: InputMaybe<LpUserWhereUniqueInput>;
  create?: InputMaybe<LpUserCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LpUserUpdateArgs = {
  data: LpUserUpdateInput;
  where: LpUserWhereUniqueInput;
};

export type LpUserUpdateInput = {
  actions?: InputMaybe<LpUserActionRelateToManyForUpdateInput>;
  balance?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  loyaltyGatorEmail?: InputMaybe<Scalars['String']['input']>;
  memberTalentRepositoryId?: InputMaybe<Scalars['String']['input']>;
  sandId?: InputMaybe<Scalars['String']['input']>;
};

export type LpUserWhereInput = {
  AND?: InputMaybe<Array<LpUserWhereInput>>;
  NOT?: InputMaybe<Array<LpUserWhereInput>>;
  OR?: InputMaybe<Array<LpUserWhereInput>>;
  actions?: InputMaybe<LpUserActionManyRelationFilter>;
  balance?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IdFilter>;
  isActive?: InputMaybe<BooleanFilter>;
  loyaltyGatorEmail?: InputMaybe<StringNullableFilter>;
  memberTalentRepositoryId?: InputMaybe<StringFilter>;
  sandId?: InputMaybe<StringNullableFilter>;
};

export type LpUserWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  memberTalentRepositoryId?: InputMaybe<Scalars['String']['input']>;
  sandId?: InputMaybe<Scalars['String']['input']>;
};

export type ManagePersonaInquiryInput = {
  /** Whether to generate a new inquiry (when previous failed) or resume an in-progress one. */
  action: PersonaInquiryAction;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Type of Persona inquiry to manage (identity, highschool, prior learning). */
  inquiryType: PersonaInquiryType;
  /** Program application identifier that should be linked with the Persona inquiry. */
  programApplicationId: Scalars['ID']['input'];
};

export type ManagePersonaInquiryPayload = {
  __typename?: 'ManagePersonaInquiryPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Hosted Persona URL that the client should open to continue or resume the verification flow. */
  redirectUrl: Scalars['String']['output'];
};

export type MarkActivatedProfileAsCompletedInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type MarkActivatedProfileAsCompletedPayload = {
  __typename?: 'MarkActivatedProfileAsCompletedPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The user object. */
  user: User;
};

export type MarkClassEnrollmentAsDeferredInput = {
  /** The id of the classEnrollment. */
  classEnrollmentIds: Array<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description why the learner was deferred. */
  deferralDescription?: InputMaybe<Scalars['String']['input']>;
  /** The reason category why the learner was deferred. */
  deferralReason: DeferralReason;
  /** The reason for the status of the class enrollment. Defaults to null. */
  statusReason?: InputMaybe<ClassEnrollmentStatusReason>;
};

export type MarkClassEnrollmentAsDeferredPayload = {
  __typename?: 'MarkClassEnrollmentAsDeferredPayload';
  /** The class enrollments. */
  classEnrollments: Array<ClassEnrollment>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type MarkExploredAndEngagedWithCommunityAsCompletedInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type MarkExploredAndEngagedWithCommunityAsCompletedPayload = {
  __typename?: 'MarkExploredAndEngagedWithCommunityAsCompletedPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The user object. */
  user: User;
};

export type MarkNotificationsAsDismissedInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ids of the notifications to be marked as dismissed */
  ids: Array<Scalars['Int']['input']>;
};

export type MarkNotificationsAsDismissedPayload = {
  __typename?: 'MarkNotificationsAsDismissedPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The user whose notifications were dismissed */
  user: User;
};

export type MarkNotificationsAsSeenInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ids of the notifications to be marked as seen */
  ids: Array<Scalars['Int']['input']>;
};

export type MarkNotificationsAsSeenPayload = {
  __typename?: 'MarkNotificationsAsSeenPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The user whose notifications were marked as seen */
  user: User;
};

export type MarkOnboardingAsFinishedInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type MarkOnboardingAsFinishedPayload = {
  __typename?: 'MarkOnboardingAsFinishedPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The user object. */
  user: User;
};

export type MarkWatchedOnboardingVideoAsCompletedInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type MarkWatchedOnboardingVideoAsCompletedPayload = {
  __typename?: 'MarkWatchedOnboardingVideoAsCompletedPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The user object. */
  user: User;
};

export type MarkWatchedWelcomeVideoAsCompletedInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type MarkWatchedWelcomeVideoAsCompletedPayload = {
  __typename?: 'MarkWatchedWelcomeVideoAsCompletedPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The user object. */
  user: User;
};

export type ModifyStudentCourseInfoResponse = {
  __typename?: 'ModifyStudentCourseInfoResponse';
  code?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<AthenaUserDetails>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ModifyStudentCourseState = {
  athenaClassId: Scalars['Int']['input'];
  athenaProgrammeId: Scalars['Int']['input'];
  modifyStudentStateTo: ModifyStudentEnrolmentStateOptions;
  stateChangeReason: Scalars['String']['input'];
};

export enum ModifyStudentEnrolmentStateOptions {
  Drop = 'DROP',
  No = 'NO',
  Reinstate = 'REINSTATE'
}

/** The mutation root of this schema */
export type Mutation = {
  __typename?: 'Mutation';
  addEducation: AddEducationPayload;
  addLanguageSkills: AddLanguageSkillsPayload;
  addLeaveOfAbsenceToLearner: AddLeaveOfAbsenceToLearnerPayload;
  adminAddApiKey: AdminAddApiKeyPayload;
  adminAddClass: AdminAddClassPayload;
  adminAddClassEnrollment: AdminAddClassEnrollmentPayload;
  adminAddCohort: AdminAddCohortPayload;
  adminAddCourseDefinition: AdminAddCourseDefinitionPayload;
  adminAddCourseEnrollment: AdminAddCourseEnrollmentPayload;
  adminAddCoursePrerequisites: AdminAddCoursePrerequisitesPayload;
  adminAddEducation: AdminAddEducationPayload;
  adminAddGradesMapping: AdminAddGradesMappingPayload;
  adminAddLanguageSkills: AdminAddLanguageSkillsPayload;
  adminAddLeaveOfAbsenceToLearner: AdminAddLeaveOfAbsenceToLearnerPayload;
  adminAddLmsClassLocation: AdminAddLmsClassLocationPayload;
  adminAddOAuthClient: AdminAddOAuthClientPayload;
  adminAddPartnership: AdminAddPartnershipPayload;
  adminAddPermissionToRole: AdminAddPermissionToRolePayload;
  adminAddProgram: AdminAddProgramPayload;
  adminAddProgramEnrollment: AdminAddProgramEnrollmentPayload;
  adminAddUserAsCityStaff: AdminAddUserAsCityStaffPayload;
  adminApproveAcademicConductAppeal: AdminApproveAcademicConductAppealPayload;
  adminAssignUserToRole: AdminAssignUserToRolePayload;
  adminBulkAssignUsersToRole: AdminBulkAssignUsersToRolePayload;
  adminBulkRecalculateGPAs: AdminBulkRecalculateGpAsPayload;
  adminChangeProgramEnrollmentProgram: AdminChangeProgramEnrollmentProgramPayload;
  adminCheckInUser: AdminCheckInUserPayload;
  adminCreateAcademicConductCase: AdminCreateAcademicConductCasePayload;
  adminCreateNotifications: AdminCreateNotificationsPayload;
  adminCreatePaymentPlanDefinition: PaymentPlanDefinitionResultResultPayload;
  adminCreateRole: AdminCreateRolePayload;
  adminCreateStaffUser: AdminCreateStaffUserPayload;
  adminCreateTrainingResource: AdminCreateTrainingResourcePayload;
  adminCreateWorkExperience: AdminCreateWorkExperiencePayload;
  adminDeleteApiKey: AdminDeleteApiKeyPayload;
  adminDeleteGradesMapping: AdminDeleteGradesMappingPayload;
  adminDeleteOAuthClient: AdminDeleteOAuthClientPayload;
  adminDeletePaymentPlanDefinition: PaymentPlanDefinitionResultResultPayload;
  adminDeleteProgramCourse: AdminDeleteProgramCoursePayload;
  adminDeleteRole: AdminDeleteRolePayload;
  adminDeleteTrainingResource: AdminDeleteTrainingResourcePayload;
  adminDenyAcademicConductAppeal: AdminDenyAcademicConductAppealPayload;
  adminFinalizeDocusignAgreement: AdminFinalizeDocusignAgreementPayload;
  adminLinkCourseToProgram: AdminLinkCourseToProgramPayload;
  adminLockProgression: AdminLockProgressionPayload;
  adminManualCheckIn: AdminManualCheckInPayload;
  adminMarkClassEnrollmentAsDeferred: AdminMarkClassEnrollmentAsDeferredPayload;
  adminMarkFailedClassEnrollmentAsGraduated: AdminMarkFailedClassEnrollmentAsGraduatedPayload;
  adminMarkFailedClassEnrollmentAsOngoing: AdminMarkFailedClassEnrollmentAsOngoingPayload;
  adminMarkGraduatedClassEnrollmentAsFailed: AdminMarkGraduatedClassEnrollmentAsFailedPayload;
  adminMarkGraduatedClassEnrollmentAsOngoing: AdminMarkGraduatedClassEnrollmentAsOngoingPayload;
  adminMarkOngoingClassEnrollmentAsFailed: AdminMarkOngoingClassEnrollmentAsFailedPayload;
  adminMarkOngoingClassEnrollmentAsGraduated: AdminMarkOngoingClassEnrollmentAsGraduatedPayload;
  /** Move a payment to a different payment plan */
  adminMovePayment: Payment;
  adminPushEventsToBus: AdminPushEventsToBusPayload;
  adminRecomputeProgramEnrollmentGPAs: AdminRecomputeProgramEnrollmentGpAsPayload;
  adminReinstateLearnerIntoProgram: AdminReinstateLearnerIntoProgramPayload;
  adminRemoveCoursePrerequisites: AdminRemoveCoursePrerequisitesPayload;
  adminRemoveGraduationFromProgramEnrollment: AdminRemoveGraduationFromProgramEnrollmentPayload;
  adminRemovePermissionFromRole: AdminRemovePermissionFromRolePayload;
  adminRemoveUserFromRole: AdminRemoveUserFromRolePayload;
  adminReopenAcademicConductCase: AdminReopenAcademicConductCasePayload;
  adminResolveAcademicConductCase: AdminResolveAcademicConductCasePayload;
  adminRunEnrollmentProgression: AdminRunEnrollmentProgressionPayload;
  adminRunLearnerProgression: AdminRunLearnerProgressionPayload;
  adminSetHubAdministrator: AdminSetHubAdministratorPayload;
  adminStartImpersonation: AdminStartImpersonationPayload;
  adminStopImpersonation: AdminStopImpersonationPayload;
  adminUnlockProgression: AdminUnlockProgressionPayload;
  adminUpdateAcademicConductCase: AdminUpdateAcademicConductCasePayload;
  adminUpdateClass: AdminUpdateClassPayload;
  adminUpdateClassEnrollmentGradePoints: AdminUpdateClassEnrollmentGradePointsPayload;
  adminUpdateCohort: AdminUpdateCohortPayload;
  adminUpdateCourseDefinition: AdminUpdateCourseDefinitionPayload;
  adminUpdateGradesMapping: AdminUpdateGradesMappingPayload;
  adminUpdateOAuthClient: AdminUpdateOAuthClientPayload;
  adminUpdatePartnership: AdminUpdatePartnershipPayload;
  adminUpdatePaymentPlanDefinition: PaymentPlanDefinitionResultResultPayload;
  adminUpdateProgram: AdminUpdateProgramPayload;
  adminUpdateProgramApplicationAdmissionStatus: AdminUpdateProgramApplicationAdmissionStatusPayload;
  adminUpdateProgramApplicationEnglishProficiency: AdminUpdateProgramApplicationEnglishProficiencyPayload;
  adminUpdateProgramApplicationHighSchoolCertificate: AdminUpdateProgramApplicationHighSchoolCertificatePayload;
  adminUpdateProgramApplicationPartnership: AdminUpdateProgramApplicationPartnershipPayload;
  adminUpdateProgramApplicationPartnershipType: AdminUpdateProgramApplicationPartnershipTypePayload;
  adminUpdateProgramApplicationStatus: AdminUpdateProgramApplicationStatusPayload;
  adminUpdateProgramCourse: AdminUpdateProgramCoursePayload;
  adminUpdateRole: AdminUpdateRolePayload;
  adminUpdateUser: AdminUpdateUserPayload;
  adminUpdateUserConsent: AdminUpdateUserConsentPayload;
  adminUpdateUserRoles: AdminUpdateUserRolesPayload;
  adminUpdateUserSkipPaywall: AdminUpdateUserSkipPaywallPayload;
  adminWithdrawLearnerFromProgram: AdminWithdrawLearnerFromProgramPayload;
  /** Apply a coupon to a payment plan based on the payment plan id */
  applyCoupon: ApplyCouponResultResultPayload;
  /** Apply a coupon to a payment plan based on the payment plan hash */
  applyCouponByHash: ApplyCouponResultResultPayload;
  applyToProgram: ApplyToProgramPayload;
  /** Allocate an existing Student to another course. */
  athenaAssignStudentToAProgramme?: Maybe<AssignStudentToProgrammeResponse>;
  /** Provisions an Athena User account requires programme<<>>class allocation. */
  athenaCreateANewUserAccount?: Maybe<CreateNewUserResponse>;
  /** Drop/Disable, Undrop/ReActivate a Student from a course. */
  athenaModifyStudentCourseEnrolmentInfo?: Maybe<ModifyStudentCourseInfoResponse>;
  authenticateAdminUserWithPassword?: Maybe<AdminUserAuthenticationWithPasswordResult>;
  /** Cancel a payment plan. Idempotent */
  cancelPaymentPlan: PaymentPlan;
  createAchievement?: Maybe<Achievement>;
  createAchievementPointsOverride?: Maybe<AchievementPointsOverride>;
  createAchievementPointsOverrides?: Maybe<Array<Maybe<AchievementPointsOverride>>>;
  createAchievements?: Maybe<Array<Maybe<Achievement>>>;
  createAdminLog?: Maybe<AdminLog>;
  createAdminLogs?: Maybe<Array<Maybe<AdminLog>>>;
  createAdminUser?: Maybe<AdminUser>;
  createAdminUsers?: Maybe<Array<Maybe<AdminUser>>>;
  createBadgeDefinition: CreateBadgeDefinitionPayload;
  createCampaign?: Maybe<Campaign>;
  createCampaigns?: Maybe<Array<Maybe<Campaign>>>;
  /** Create a payment hash for the cancellation balance payment for a payment plan. Note this does not save the payment in the database yet */
  createCancellationBalancePaymentForPaymentPlanByHash: Payment;
  createCertificateDefinition: CreateCertificateDefinitionPayload;
  /** Create a comms template */
  createCommsTemplate: CommsTemplateResultResultPayload;
  /** Create a new coupon batch */
  createCouponBatch: CouponBatchResultResultPayload;
  createDashboard: CreateDashboardPayload;
  createInitialAdminUser: AdminUserAuthenticationWithPasswordSuccess;
  createLegacyPointsTag?: Maybe<LegacyPointsTag>;
  createLegacyPointsTags?: Maybe<Array<Maybe<LegacyPointsTag>>>;
  createLpUser?: Maybe<LpUser>;
  createLpUserAction?: Maybe<LpUserAction>;
  createLpUserActions?: Maybe<Array<Maybe<LpUserAction>>>;
  createLpUsers?: Maybe<Array<Maybe<LpUser>>>;
  createOrUpdateProofOfCompletion: CreateOrUpdateProofOfCompletionPayload;
  /** Create a payment hash for all outstanding payments for a fixed-duration payment plan. Note this does not save the payment in the database yet */
  createPayAllPaymentForPaymentPlanByHash: Payment;
  /** Create (or get) a payment by account ID and hash transaction */
  createPayment?: Maybe<Payment>;
  /** Create a payment hash for a payment plan. Note this does not save the payment in the database yet */
  createPaymentForPaymentPlanByHash: Payment;
  /** Create Payment Plan for a user */
  createPaymentPlan: PaymentPlan;
  createProgramApplication: CreateProgramApplicationPayload;
  createReward?: Maybe<Reward>;
  createRewardCost?: Maybe<RewardCost>;
  createRewardCosts?: Maybe<Array<Maybe<RewardCost>>>;
  createRewardLimitation?: Maybe<RewardLimitation>;
  createRewardLimitations?: Maybe<Array<Maybe<RewardLimitation>>>;
  createRewards?: Maybe<Array<Maybe<Reward>>>;
  createUpload: CreateUploadPayload;
  createWorkExperience: CreateWorkExperiencePayload;
  deleteAchievement?: Maybe<Achievement>;
  deleteAchievementPointsOverride?: Maybe<AchievementPointsOverride>;
  deleteAchievementPointsOverrides?: Maybe<Array<Maybe<AchievementPointsOverride>>>;
  deleteAchievements?: Maybe<Array<Maybe<Achievement>>>;
  deleteAdminLog?: Maybe<AdminLog>;
  deleteAdminLogs?: Maybe<Array<Maybe<AdminLog>>>;
  deleteAdminUser?: Maybe<AdminUser>;
  deleteAdminUsers?: Maybe<Array<Maybe<AdminUser>>>;
  deleteCampaign?: Maybe<Campaign>;
  deleteCampaigns?: Maybe<Array<Maybe<Campaign>>>;
  /** Delete a comms template */
  deleteCommsTemplate: DeleteCommsTemplateResultResultPayload;
  /** Delete an existing coupon batch */
  deleteCouponBatch: CouponBatchResultResultPayload;
  deleteCv: DeleteCvPayload;
  deleteDashboard: DeleteDashboardPayload;
  deleteEducation: DeleteEducationPayload;
  deleteLegacyPointsTag?: Maybe<LegacyPointsTag>;
  deleteLegacyPointsTags?: Maybe<Array<Maybe<LegacyPointsTag>>>;
  deleteLpUser?: Maybe<LpUser>;
  deleteLpUserAction?: Maybe<LpUserAction>;
  deleteLpUserActions?: Maybe<Array<Maybe<LpUserAction>>>;
  deleteLpUsers?: Maybe<Array<Maybe<LpUser>>>;
  deleteRefugeeCard: DeleteRefugeeCardPayload;
  deleteReward?: Maybe<Reward>;
  deleteRewardCost?: Maybe<RewardCost>;
  deleteRewardCosts?: Maybe<Array<Maybe<RewardCost>>>;
  deleteRewardLimitation?: Maybe<RewardLimitation>;
  deleteRewardLimitations?: Maybe<Array<Maybe<RewardLimitation>>>;
  deleteRewards?: Maybe<Array<Maybe<Reward>>>;
  deleteWorkExperience: DeleteWorkExperiencePayload;
  /** Dismiss a payment history transaction by setting dismissed_at timestamp */
  dismissIncompletePaymentTransaction: DismissPaymentHistoryResultResultPayload;
  endSession: Scalars['Boolean']['output'];
  forgotPassword: ForgotPasswordPayload;
  /** Generate coupons for an existing coupon batch */
  generateCoupons: CouponBatchResultResultPayload;
  /** Lookup status of Payment in Gateway */
  lookUpPaymentInGateway?: Maybe<Payment>;
  managePersonaInquiry: ManagePersonaInquiryPayload;
  markActivatedProfileAsCompleted: MarkActivatedProfileAsCompletedPayload;
  markClassEnrollmentAsDeferred: MarkClassEnrollmentAsDeferredPayload;
  markExploredAndEngagedWithCommunityAsCompleted: MarkExploredAndEngagedWithCommunityAsCompletedPayload;
  markNotificationsAsDismissed: MarkNotificationsAsDismissedPayload;
  markNotificationsAsSeen: MarkNotificationsAsSeenPayload;
  markOnboardingAsFinished: MarkOnboardingAsFinishedPayload;
  markWatchedOnboardingVideoAsCompleted: MarkWatchedOnboardingVideoAsCompletedPayload;
  markWatchedWelcomeVideoAsCompleted: MarkWatchedWelcomeVideoAsCompletedPayload;
  resendVerificationCode: ResendVerificationCodePayload;
  /** Resume a payment plan. Idempotent */
  resumePaymentPlan: PaymentPlan;
  /** Add a learner to a program */
  savannaAssignLearnerToProgram?: Maybe<SavannaAssignLearnerToProgramPayload>;
  /** Create a new learner */
  savannaCreateLearner?: Maybe<SavannaCreateLearnerPayload>;
  /** Update a learner */
  savannaUpdateLearner?: Maybe<SavannaUpdateLearnerPayload>;
  /** Update the SandId of a user */
  savannaUpdateSandId?: Maybe<SavannaUpdateSandIdPayload>;
  /** Withdraw a learner */
  savannaWithdrawLearner?: Maybe<SavannaWithdrawLearnerPayload>;
  selfCheckIn: SelfCheckInPayload;
  submitAcademicConductAppeal: SubmitAcademicConductAppealPayload;
  updateAchievement?: Maybe<Achievement>;
  updateAchievementPointsOverride?: Maybe<AchievementPointsOverride>;
  updateAchievementPointsOverrides?: Maybe<Array<Maybe<AchievementPointsOverride>>>;
  updateAchievements?: Maybe<Array<Maybe<Achievement>>>;
  updateAdminLog?: Maybe<AdminLog>;
  updateAdminLogs?: Maybe<Array<Maybe<AdminLog>>>;
  updateAdminUser?: Maybe<AdminUser>;
  updateAdminUsers?: Maybe<Array<Maybe<AdminUser>>>;
  updateBadgeDefinition: UpdateBadgeDefinitionPayload;
  updateCampaign?: Maybe<Campaign>;
  updateCampaigns?: Maybe<Array<Maybe<Campaign>>>;
  /** Update cancellation status for a payment plan */
  updateCancellationStatusForPaymentPlan: PaymentPlan;
  updateCertificateDefinition: UpdateCertificateDefinitionPayload;
  /** Update a comms template */
  updateCommsTemplate: CommsTemplateResultResultPayload;
  /** Update a coupon batch */
  updateCouponBatch: CouponBatchResultResultPayload;
  updateCoverPhoto: UpdateCoverPhotoPayload;
  updateCv: UpdateCvPayload;
  updateEducation: UpdateEducationPayload;
  updateInterests: UpdateInterestsPayload;
  updateLegacyPointsTag?: Maybe<LegacyPointsTag>;
  updateLegacyPointsTags?: Maybe<Array<Maybe<LegacyPointsTag>>>;
  updateLpUser?: Maybe<LpUser>;
  updateLpUserAction?: Maybe<LpUserAction>;
  updateLpUserActions?: Maybe<Array<Maybe<LpUserAction>>>;
  updateLpUsers?: Maybe<Array<Maybe<LpUser>>>;
  updateNotificationSettings: UpdateNotificationSettingsPayload;
  /** SuperAdmin: update date fields on a payment plan. All date fields are optional; only provided fields are updated. */
  updatePaymentPlanDates: PaymentPlan;
  updateProfilePhoto: UpdateProfilePhotoPayload;
  updateProgramApplicationEnglishProficiencyProof: UpdateProgramApplicationEnglishProficiencyProofPayload;
  updateProgramApplicationHighSchoolCertificate: UpdateProgramApplicationHighSchoolCertificatePayload;
  updateRefugeeCard: UpdateRefugeeCardPayload;
  updateReward?: Maybe<Reward>;
  updateRewardCost?: Maybe<RewardCost>;
  updateRewardCosts?: Maybe<Array<Maybe<RewardCost>>>;
  updateRewardLimitation?: Maybe<RewardLimitation>;
  updateRewardLimitations?: Maybe<Array<Maybe<RewardLimitation>>>;
  updateRewards?: Maybe<Array<Maybe<Reward>>>;
  updateSkills: UpdateSkillsPayload;
  updateUser: UpdateUserPayload;
  updateUserConsent: UpdateUserConsentPayload;
  updateWorkExperience: UpdateWorkExperiencePayload;
  withdrawFromProgram: WithdrawFromProgramPayload;
};


/** The mutation root of this schema */
export type MutationAddEducationArgs = {
  input: AddEducationInput;
};


/** The mutation root of this schema */
export type MutationAddLanguageSkillsArgs = {
  input: AddLanguageSkillsInput;
};


/** The mutation root of this schema */
export type MutationAddLeaveOfAbsenceToLearnerArgs = {
  input: AddLeaveOfAbsenceToLearnerInput;
};


/** The mutation root of this schema */
export type MutationAdminAddApiKeyArgs = {
  input: AdminAddApiKeyInput;
};


/** The mutation root of this schema */
export type MutationAdminAddClassArgs = {
  input: AdminAddClassInput;
};


/** The mutation root of this schema */
export type MutationAdminAddClassEnrollmentArgs = {
  input: AdminAddClassEnrollmentInput;
};


/** The mutation root of this schema */
export type MutationAdminAddCohortArgs = {
  input: AdminAddCohortInput;
};


/** The mutation root of this schema */
export type MutationAdminAddCourseDefinitionArgs = {
  input: AdminAddCourseDefinitionInput;
};


/** The mutation root of this schema */
export type MutationAdminAddCourseEnrollmentArgs = {
  input: AdminAddCourseEnrollmentInput;
};


/** The mutation root of this schema */
export type MutationAdminAddCoursePrerequisitesArgs = {
  input: AdminAddCoursePrerequisitesInput;
};


/** The mutation root of this schema */
export type MutationAdminAddEducationArgs = {
  input: AdminAddEducationInput;
};


/** The mutation root of this schema */
export type MutationAdminAddGradesMappingArgs = {
  input: AdminAddGradesMappingInput;
};


/** The mutation root of this schema */
export type MutationAdminAddLanguageSkillsArgs = {
  input: AdminAddLanguageSkillsInput;
};


/** The mutation root of this schema */
export type MutationAdminAddLeaveOfAbsenceToLearnerArgs = {
  input: AdminAddLeaveOfAbsenceToLearnerInput;
};


/** The mutation root of this schema */
export type MutationAdminAddLmsClassLocationArgs = {
  input: AdminAddLmsClassLocationInput;
};


/** The mutation root of this schema */
export type MutationAdminAddOAuthClientArgs = {
  input: AdminAddOAuthClientInput;
};


/** The mutation root of this schema */
export type MutationAdminAddPartnershipArgs = {
  input: AdminAddPartnershipInput;
};


/** The mutation root of this schema */
export type MutationAdminAddPermissionToRoleArgs = {
  input: AdminAddPermissionToRoleInput;
};


/** The mutation root of this schema */
export type MutationAdminAddProgramArgs = {
  input: AdminAddProgramInput;
};


/** The mutation root of this schema */
export type MutationAdminAddProgramEnrollmentArgs = {
  input: AdminAddProgramEnrollmentInput;
};


/** The mutation root of this schema */
export type MutationAdminAddUserAsCityStaffArgs = {
  input: AdminAddUserAsCityStaffInput;
};


/** The mutation root of this schema */
export type MutationAdminApproveAcademicConductAppealArgs = {
  input: AdminApproveAcademicConductAppealInput;
};


/** The mutation root of this schema */
export type MutationAdminAssignUserToRoleArgs = {
  input: AdminAssignUserToRoleInput;
};


/** The mutation root of this schema */
export type MutationAdminBulkAssignUsersToRoleArgs = {
  input: AdminBulkAssignUsersToRoleInput;
};


/** The mutation root of this schema */
export type MutationAdminBulkRecalculateGpAsArgs = {
  input: AdminBulkRecalculateGpAsInput;
};


/** The mutation root of this schema */
export type MutationAdminChangeProgramEnrollmentProgramArgs = {
  input: AdminChangeProgramEnrollmentProgramInput;
};


/** The mutation root of this schema */
export type MutationAdminCheckInUserArgs = {
  input: AdminCheckInUserInput;
};


/** The mutation root of this schema */
export type MutationAdminCreateAcademicConductCaseArgs = {
  input: AdminCreateAcademicConductCaseInput;
};


/** The mutation root of this schema */
export type MutationAdminCreateNotificationsArgs = {
  input: AdminCreateNotificationsInput;
};


/** The mutation root of this schema */
export type MutationAdminCreatePaymentPlanDefinitionArgs = {
  input: CreatePaymentPlanDefinitionInput;
};


/** The mutation root of this schema */
export type MutationAdminCreateRoleArgs = {
  input: AdminCreateRoleInput;
};


/** The mutation root of this schema */
export type MutationAdminCreateStaffUserArgs = {
  input: AdminCreateStaffUserInput;
};


/** The mutation root of this schema */
export type MutationAdminCreateTrainingResourceArgs = {
  input: AdminCreateTrainingResourceInput;
};


/** The mutation root of this schema */
export type MutationAdminCreateWorkExperienceArgs = {
  input: AdminCreateWorkExperienceInput;
};


/** The mutation root of this schema */
export type MutationAdminDeleteApiKeyArgs = {
  input: AdminDeleteApiKeyInput;
};


/** The mutation root of this schema */
export type MutationAdminDeleteGradesMappingArgs = {
  input: AdminDeleteGradesMappingInput;
};


/** The mutation root of this schema */
export type MutationAdminDeleteOAuthClientArgs = {
  input: AdminDeleteOAuthClientInput;
};


/** The mutation root of this schema */
export type MutationAdminDeletePaymentPlanDefinitionArgs = {
  input: DeletePaymentPlanDefinitionInput;
};


/** The mutation root of this schema */
export type MutationAdminDeleteProgramCourseArgs = {
  input: AdminDeleteProgramCourseInput;
};


/** The mutation root of this schema */
export type MutationAdminDeleteRoleArgs = {
  input: AdminDeleteRoleInput;
};


/** The mutation root of this schema */
export type MutationAdminDeleteTrainingResourceArgs = {
  input: AdminDeleteTrainingResourceInput;
};


/** The mutation root of this schema */
export type MutationAdminDenyAcademicConductAppealArgs = {
  input: AdminDenyAcademicConductAppealInput;
};


/** The mutation root of this schema */
export type MutationAdminFinalizeDocusignAgreementArgs = {
  input: AdminFinalizeDocusignAgreementInput;
};


/** The mutation root of this schema */
export type MutationAdminLinkCourseToProgramArgs = {
  input: AdminLinkCourseToProgramInput;
};


/** The mutation root of this schema */
export type MutationAdminLockProgressionArgs = {
  input: AdminLockProgressionInput;
};


/** The mutation root of this schema */
export type MutationAdminManualCheckInArgs = {
  input: AdminManualCheckInInput;
};


/** The mutation root of this schema */
export type MutationAdminMarkClassEnrollmentAsDeferredArgs = {
  input: AdminMarkClassEnrollmentAsDeferredInput;
};


/** The mutation root of this schema */
export type MutationAdminMarkFailedClassEnrollmentAsGraduatedArgs = {
  input: AdminMarkFailedClassEnrollmentAsGraduatedInput;
};


/** The mutation root of this schema */
export type MutationAdminMarkFailedClassEnrollmentAsOngoingArgs = {
  input: AdminMarkFailedClassEnrollmentAsOngoingInput;
};


/** The mutation root of this schema */
export type MutationAdminMarkGraduatedClassEnrollmentAsFailedArgs = {
  input: AdminMarkGraduatedClassEnrollmentAsFailedInput;
};


/** The mutation root of this schema */
export type MutationAdminMarkGraduatedClassEnrollmentAsOngoingArgs = {
  input: AdminMarkGraduatedClassEnrollmentAsOngoingInput;
};


/** The mutation root of this schema */
export type MutationAdminMarkOngoingClassEnrollmentAsFailedArgs = {
  input: AdminMarkOngoingClassEnrollmentAsFailedInput;
};


/** The mutation root of this schema */
export type MutationAdminMarkOngoingClassEnrollmentAsGraduatedArgs = {
  input: AdminMarkOngoingClassEnrollmentAsGraduatedInput;
};


/** The mutation root of this schema */
export type MutationAdminMovePaymentArgs = {
  input: AdminMovePaymentInput;
};


/** The mutation root of this schema */
export type MutationAdminPushEventsToBusArgs = {
  input: AdminPushEventsToBusInput;
};


/** The mutation root of this schema */
export type MutationAdminRecomputeProgramEnrollmentGpAsArgs = {
  input: AdminRecomputeProgramEnrollmentGpAsInput;
};


/** The mutation root of this schema */
export type MutationAdminReinstateLearnerIntoProgramArgs = {
  input: AdminReinstateLearnerIntoProgramInput;
};


/** The mutation root of this schema */
export type MutationAdminRemoveCoursePrerequisitesArgs = {
  input: AdminRemoveCoursePrerequisitesInput;
};


/** The mutation root of this schema */
export type MutationAdminRemoveGraduationFromProgramEnrollmentArgs = {
  input: AdminRemoveGraduationFromProgramEnrollmentInput;
};


/** The mutation root of this schema */
export type MutationAdminRemovePermissionFromRoleArgs = {
  input: AdminRemovePermissionFromRoleInput;
};


/** The mutation root of this schema */
export type MutationAdminRemoveUserFromRoleArgs = {
  input: AdminRemoveUserFromRoleInput;
};


/** The mutation root of this schema */
export type MutationAdminReopenAcademicConductCaseArgs = {
  input: AdminReopenAcademicConductCaseInput;
};


/** The mutation root of this schema */
export type MutationAdminResolveAcademicConductCaseArgs = {
  input: AdminResolveAcademicConductCaseInput;
};


/** The mutation root of this schema */
export type MutationAdminRunEnrollmentProgressionArgs = {
  input: AdminRunEnrollmentProgressionInput;
};


/** The mutation root of this schema */
export type MutationAdminRunLearnerProgressionArgs = {
  input: AdminRunLearnerProgressionInput;
};


/** The mutation root of this schema */
export type MutationAdminSetHubAdministratorArgs = {
  input: AdminSetHubAdministratorInput;
};


/** The mutation root of this schema */
export type MutationAdminStartImpersonationArgs = {
  input: AdminStartImpersonationInput;
};


/** The mutation root of this schema */
export type MutationAdminStopImpersonationArgs = {
  input: AdminStopImpersonationInput;
};


/** The mutation root of this schema */
export type MutationAdminUnlockProgressionArgs = {
  input: AdminUnlockProgressionInput;
};


/** The mutation root of this schema */
export type MutationAdminUpdateAcademicConductCaseArgs = {
  input: AdminUpdateAcademicConductCaseInput;
};


/** The mutation root of this schema */
export type MutationAdminUpdateClassArgs = {
  input: AdminUpdateClassInput;
};


/** The mutation root of this schema */
export type MutationAdminUpdateClassEnrollmentGradePointsArgs = {
  input: AdminUpdateClassEnrollmentGradePointsInput;
};


/** The mutation root of this schema */
export type MutationAdminUpdateCohortArgs = {
  input: AdminUpdateCohortInput;
};


/** The mutation root of this schema */
export type MutationAdminUpdateCourseDefinitionArgs = {
  input: AdminUpdateCourseDefinitionInput;
};


/** The mutation root of this schema */
export type MutationAdminUpdateGradesMappingArgs = {
  input: AdminUpdateGradesMappingInput;
};


/** The mutation root of this schema */
export type MutationAdminUpdateOAuthClientArgs = {
  input: AdminUpdateOAuthClientInput;
};


/** The mutation root of this schema */
export type MutationAdminUpdatePartnershipArgs = {
  input: AdminUpdatePartnershipInput;
};


/** The mutation root of this schema */
export type MutationAdminUpdatePaymentPlanDefinitionArgs = {
  input: UpdatePaymentPlanDefinitionInput;
};


/** The mutation root of this schema */
export type MutationAdminUpdateProgramArgs = {
  input: AdminUpdateProgramInput;
};


/** The mutation root of this schema */
export type MutationAdminUpdateProgramApplicationAdmissionStatusArgs = {
  input: AdminUpdateProgramApplicationAdmissionStatusInput;
};


/** The mutation root of this schema */
export type MutationAdminUpdateProgramApplicationEnglishProficiencyArgs = {
  input: AdminUpdateProgramApplicationEnglishProficiencyInput;
};


/** The mutation root of this schema */
export type MutationAdminUpdateProgramApplicationHighSchoolCertificateArgs = {
  input: AdminUpdateProgramApplicationHighSchoolCertificateInput;
};


/** The mutation root of this schema */
export type MutationAdminUpdateProgramApplicationPartnershipArgs = {
  input: AdminUpdateProgramApplicationPartnershipInput;
};


/** The mutation root of this schema */
export type MutationAdminUpdateProgramApplicationPartnershipTypeArgs = {
  input: AdminUpdateProgramApplicationPartnershipTypeInput;
};


/** The mutation root of this schema */
export type MutationAdminUpdateProgramApplicationStatusArgs = {
  input: AdminUpdateProgramApplicationStatusInput;
};


/** The mutation root of this schema */
export type MutationAdminUpdateProgramCourseArgs = {
  input: AdminUpdateProgramCourseInput;
};


/** The mutation root of this schema */
export type MutationAdminUpdateRoleArgs = {
  input: AdminUpdateRoleInput;
};


/** The mutation root of this schema */
export type MutationAdminUpdateUserArgs = {
  input: AdminUpdateUserInput;
};


/** The mutation root of this schema */
export type MutationAdminUpdateUserConsentArgs = {
  input: AdminUpdateUserConsentInput;
};


/** The mutation root of this schema */
export type MutationAdminUpdateUserRolesArgs = {
  input: AdminUpdateUserRolesInput;
};


/** The mutation root of this schema */
export type MutationAdminUpdateUserSkipPaywallArgs = {
  input: AdminUpdateUserSkipPaywallInput;
};


/** The mutation root of this schema */
export type MutationAdminWithdrawLearnerFromProgramArgs = {
  input: AdminWithdrawLearnerFromProgramInput;
};


/** The mutation root of this schema */
export type MutationApplyCouponArgs = {
  input: ApplyCouponInput;
};


/** The mutation root of this schema */
export type MutationApplyCouponByHashArgs = {
  input: ApplyCouponByHashInput;
};


/** The mutation root of this schema */
export type MutationApplyToProgramArgs = {
  input: ApplyToProgramInput;
};


/** The mutation root of this schema */
export type MutationAthenaAssignStudentToAProgrammeArgs = {
  input: AllocateToProgramme;
  sandId: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type MutationAthenaCreateANewUserAccountArgs = {
  input: CreateANewAthenaUserData;
  sandId: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type MutationAthenaModifyStudentCourseEnrolmentInfoArgs = {
  input: ModifyStudentCourseState;
  sandId: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type MutationAuthenticateAdminUserWithPasswordArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type MutationCancelPaymentPlanArgs = {
  paymentPlanId: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type MutationCreateAchievementArgs = {
  data: AchievementCreateInput;
};


/** The mutation root of this schema */
export type MutationCreateAchievementPointsOverrideArgs = {
  data: AchievementPointsOverrideCreateInput;
};


/** The mutation root of this schema */
export type MutationCreateAchievementPointsOverridesArgs = {
  data: Array<AchievementPointsOverrideCreateInput>;
};


/** The mutation root of this schema */
export type MutationCreateAchievementsArgs = {
  data: Array<AchievementCreateInput>;
};


/** The mutation root of this schema */
export type MutationCreateAdminLogArgs = {
  data: AdminLogCreateInput;
};


/** The mutation root of this schema */
export type MutationCreateAdminLogsArgs = {
  data: Array<AdminLogCreateInput>;
};


/** The mutation root of this schema */
export type MutationCreateAdminUserArgs = {
  data: AdminUserCreateInput;
};


/** The mutation root of this schema */
export type MutationCreateAdminUsersArgs = {
  data: Array<AdminUserCreateInput>;
};


/** The mutation root of this schema */
export type MutationCreateBadgeDefinitionArgs = {
  input: CreateBadgeDefinitionInput;
};


/** The mutation root of this schema */
export type MutationCreateCampaignArgs = {
  data: CampaignCreateInput;
};


/** The mutation root of this schema */
export type MutationCreateCampaignsArgs = {
  data: Array<CampaignCreateInput>;
};


/** The mutation root of this schema */
export type MutationCreateCancellationBalancePaymentForPaymentPlanByHashArgs = {
  accountId: Scalars['Int']['input'];
  hashPlan: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type MutationCreateCertificateDefinitionArgs = {
  input: CreateCertificateDefinitionInput;
};


/** The mutation root of this schema */
export type MutationCreateCommsTemplateArgs = {
  input: CreateCommsTemplateInput;
};


/** The mutation root of this schema */
export type MutationCreateCouponBatchArgs = {
  input: CouponBatchCreateInput;
};


/** The mutation root of this schema */
export type MutationCreateDashboardArgs = {
  input: CreateDashboardInput;
};


/** The mutation root of this schema */
export type MutationCreateInitialAdminUserArgs = {
  data: CreateInitialAdminUserInput;
};


/** The mutation root of this schema */
export type MutationCreateLegacyPointsTagArgs = {
  data: LegacyPointsTagCreateInput;
};


/** The mutation root of this schema */
export type MutationCreateLegacyPointsTagsArgs = {
  data: Array<LegacyPointsTagCreateInput>;
};


/** The mutation root of this schema */
export type MutationCreateLpUserArgs = {
  data: LpUserCreateInput;
};


/** The mutation root of this schema */
export type MutationCreateLpUserActionArgs = {
  data: LpUserActionCreateInput;
};


/** The mutation root of this schema */
export type MutationCreateLpUserActionsArgs = {
  data: Array<LpUserActionCreateInput>;
};


/** The mutation root of this schema */
export type MutationCreateLpUsersArgs = {
  data: Array<LpUserCreateInput>;
};


/** The mutation root of this schema */
export type MutationCreateOrUpdateProofOfCompletionArgs = {
  input: CreateOrUpdateProofOfCompletionInput;
};


/** The mutation root of this schema */
export type MutationCreatePayAllPaymentForPaymentPlanByHashArgs = {
  accountId: Scalars['Int']['input'];
  hashPlan: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type MutationCreatePaymentArgs = {
  accountId: Scalars['Int']['input'];
  hashTrans: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type MutationCreatePaymentForPaymentPlanByHashArgs = {
  accountId: Scalars['Int']['input'];
  hashPlan: Scalars['String']['input'];
  numberOfInstalments: Scalars['Int']['input'];
  paymentMode?: InputMaybe<PaymentMode>;
};


/** The mutation root of this schema */
export type MutationCreatePaymentPlanArgs = {
  paymentPlanDefinitionId: Scalars['String']['input'];
  planIdentifier: Scalars['String']['input'];
  sandId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type MutationCreateProgramApplicationArgs = {
  input: CreateProgramApplicationInput;
};


/** The mutation root of this schema */
export type MutationCreateRewardArgs = {
  data: RewardCreateInput;
};


/** The mutation root of this schema */
export type MutationCreateRewardCostArgs = {
  data: RewardCostCreateInput;
};


/** The mutation root of this schema */
export type MutationCreateRewardCostsArgs = {
  data: Array<RewardCostCreateInput>;
};


/** The mutation root of this schema */
export type MutationCreateRewardLimitationArgs = {
  data: RewardLimitationCreateInput;
};


/** The mutation root of this schema */
export type MutationCreateRewardLimitationsArgs = {
  data: Array<RewardLimitationCreateInput>;
};


/** The mutation root of this schema */
export type MutationCreateRewardsArgs = {
  data: Array<RewardCreateInput>;
};


/** The mutation root of this schema */
export type MutationCreateUploadArgs = {
  input: CreateUploadInput;
};


/** The mutation root of this schema */
export type MutationCreateWorkExperienceArgs = {
  input: CreateWorkExperienceInput;
};


/** The mutation root of this schema */
export type MutationDeleteAchievementArgs = {
  where: AchievementWhereUniqueInput;
};


/** The mutation root of this schema */
export type MutationDeleteAchievementPointsOverrideArgs = {
  where: AchievementPointsOverrideWhereUniqueInput;
};


/** The mutation root of this schema */
export type MutationDeleteAchievementPointsOverridesArgs = {
  where: Array<AchievementPointsOverrideWhereUniqueInput>;
};


/** The mutation root of this schema */
export type MutationDeleteAchievementsArgs = {
  where: Array<AchievementWhereUniqueInput>;
};


/** The mutation root of this schema */
export type MutationDeleteAdminLogArgs = {
  where: AdminLogWhereUniqueInput;
};


/** The mutation root of this schema */
export type MutationDeleteAdminLogsArgs = {
  where: Array<AdminLogWhereUniqueInput>;
};


/** The mutation root of this schema */
export type MutationDeleteAdminUserArgs = {
  where: AdminUserWhereUniqueInput;
};


/** The mutation root of this schema */
export type MutationDeleteAdminUsersArgs = {
  where: Array<AdminUserWhereUniqueInput>;
};


/** The mutation root of this schema */
export type MutationDeleteCampaignArgs = {
  where: CampaignWhereUniqueInput;
};


/** The mutation root of this schema */
export type MutationDeleteCampaignsArgs = {
  where: Array<CampaignWhereUniqueInput>;
};


/** The mutation root of this schema */
export type MutationDeleteCommsTemplateArgs = {
  input: DeleteCommsTemplateInput;
};


/** The mutation root of this schema */
export type MutationDeleteCouponBatchArgs = {
  input: CouponBatchDeleteInput;
};


/** The mutation root of this schema */
export type MutationDeleteCvArgs = {
  input: DeleteCvInput;
};


/** The mutation root of this schema */
export type MutationDeleteDashboardArgs = {
  input: DeleteDashboardInput;
};


/** The mutation root of this schema */
export type MutationDeleteEducationArgs = {
  input: DeleteEducationInput;
};


/** The mutation root of this schema */
export type MutationDeleteLegacyPointsTagArgs = {
  where: LegacyPointsTagWhereUniqueInput;
};


/** The mutation root of this schema */
export type MutationDeleteLegacyPointsTagsArgs = {
  where: Array<LegacyPointsTagWhereUniqueInput>;
};


/** The mutation root of this schema */
export type MutationDeleteLpUserArgs = {
  where: LpUserWhereUniqueInput;
};


/** The mutation root of this schema */
export type MutationDeleteLpUserActionArgs = {
  where: LpUserActionWhereUniqueInput;
};


/** The mutation root of this schema */
export type MutationDeleteLpUserActionsArgs = {
  where: Array<LpUserActionWhereUniqueInput>;
};


/** The mutation root of this schema */
export type MutationDeleteLpUsersArgs = {
  where: Array<LpUserWhereUniqueInput>;
};


/** The mutation root of this schema */
export type MutationDeleteRefugeeCardArgs = {
  input: DeleteRefugeeCardInput;
};


/** The mutation root of this schema */
export type MutationDeleteRewardArgs = {
  where: RewardWhereUniqueInput;
};


/** The mutation root of this schema */
export type MutationDeleteRewardCostArgs = {
  where: RewardCostWhereUniqueInput;
};


/** The mutation root of this schema */
export type MutationDeleteRewardCostsArgs = {
  where: Array<RewardCostWhereUniqueInput>;
};


/** The mutation root of this schema */
export type MutationDeleteRewardLimitationArgs = {
  where: RewardLimitationWhereUniqueInput;
};


/** The mutation root of this schema */
export type MutationDeleteRewardLimitationsArgs = {
  where: Array<RewardLimitationWhereUniqueInput>;
};


/** The mutation root of this schema */
export type MutationDeleteRewardsArgs = {
  where: Array<RewardWhereUniqueInput>;
};


/** The mutation root of this schema */
export type MutationDeleteWorkExperienceArgs = {
  input: DeleteWorkExperienceInput;
};


/** The mutation root of this schema */
export type MutationDismissIncompletePaymentTransactionArgs = {
  paymentHistoryTransactionId: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type MutationForgotPasswordArgs = {
  input: ForgotPasswordInput;
};


/** The mutation root of this schema */
export type MutationGenerateCouponsArgs = {
  input: GenerateCouponsInput;
};


/** The mutation root of this schema */
export type MutationLookUpPaymentInGatewayArgs = {
  accountId: Scalars['Int']['input'];
  hashTrans: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type MutationManagePersonaInquiryArgs = {
  input: ManagePersonaInquiryInput;
};


/** The mutation root of this schema */
export type MutationMarkActivatedProfileAsCompletedArgs = {
  input: MarkActivatedProfileAsCompletedInput;
};


/** The mutation root of this schema */
export type MutationMarkClassEnrollmentAsDeferredArgs = {
  input: MarkClassEnrollmentAsDeferredInput;
};


/** The mutation root of this schema */
export type MutationMarkExploredAndEngagedWithCommunityAsCompletedArgs = {
  input: MarkExploredAndEngagedWithCommunityAsCompletedInput;
};


/** The mutation root of this schema */
export type MutationMarkNotificationsAsDismissedArgs = {
  input: MarkNotificationsAsDismissedInput;
};


/** The mutation root of this schema */
export type MutationMarkNotificationsAsSeenArgs = {
  input: MarkNotificationsAsSeenInput;
};


/** The mutation root of this schema */
export type MutationMarkOnboardingAsFinishedArgs = {
  input: MarkOnboardingAsFinishedInput;
};


/** The mutation root of this schema */
export type MutationMarkWatchedOnboardingVideoAsCompletedArgs = {
  input: MarkWatchedOnboardingVideoAsCompletedInput;
};


/** The mutation root of this schema */
export type MutationMarkWatchedWelcomeVideoAsCompletedArgs = {
  input: MarkWatchedWelcomeVideoAsCompletedInput;
};


/** The mutation root of this schema */
export type MutationResendVerificationCodeArgs = {
  input: ResendVerificationCodeInput;
};


/** The mutation root of this schema */
export type MutationResumePaymentPlanArgs = {
  paymentPlanId: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type MutationSavannaAssignLearnerToProgramArgs = {
  input: SavannaAssignLearnerToProgramInput;
};


/** The mutation root of this schema */
export type MutationSavannaCreateLearnerArgs = {
  input: SavannaCreateLearnerInput;
};


/** The mutation root of this schema */
export type MutationSavannaUpdateLearnerArgs = {
  input: SavannaUpdateLearnerInput;
};


/** The mutation root of this schema */
export type MutationSavannaUpdateSandIdArgs = {
  input: SavannaUpdateSandIdInput;
};


/** The mutation root of this schema */
export type MutationSavannaWithdrawLearnerArgs = {
  input: SavannaWithdrawLearnerInput;
};


/** The mutation root of this schema */
export type MutationSelfCheckInArgs = {
  input: SelfCheckInInput;
};


/** The mutation root of this schema */
export type MutationSubmitAcademicConductAppealArgs = {
  input: SubmitAcademicConductAppealInput;
};


/** The mutation root of this schema */
export type MutationUpdateAchievementArgs = {
  data: AchievementUpdateInput;
  where: AchievementWhereUniqueInput;
};


/** The mutation root of this schema */
export type MutationUpdateAchievementPointsOverrideArgs = {
  data: AchievementPointsOverrideUpdateInput;
  where: AchievementPointsOverrideWhereUniqueInput;
};


/** The mutation root of this schema */
export type MutationUpdateAchievementPointsOverridesArgs = {
  data: Array<AchievementPointsOverrideUpdateArgs>;
};


/** The mutation root of this schema */
export type MutationUpdateAchievementsArgs = {
  data: Array<AchievementUpdateArgs>;
};


/** The mutation root of this schema */
export type MutationUpdateAdminLogArgs = {
  data: AdminLogUpdateInput;
  where: AdminLogWhereUniqueInput;
};


/** The mutation root of this schema */
export type MutationUpdateAdminLogsArgs = {
  data: Array<AdminLogUpdateArgs>;
};


/** The mutation root of this schema */
export type MutationUpdateAdminUserArgs = {
  data: AdminUserUpdateInput;
  where: AdminUserWhereUniqueInput;
};


/** The mutation root of this schema */
export type MutationUpdateAdminUsersArgs = {
  data: Array<AdminUserUpdateArgs>;
};


/** The mutation root of this schema */
export type MutationUpdateBadgeDefinitionArgs = {
  input: UpdateBadgeDefinitionInput;
};


/** The mutation root of this schema */
export type MutationUpdateCampaignArgs = {
  data: CampaignUpdateInput;
  where: CampaignWhereUniqueInput;
};


/** The mutation root of this schema */
export type MutationUpdateCampaignsArgs = {
  data: Array<CampaignUpdateArgs>;
};


/** The mutation root of this schema */
export type MutationUpdateCancellationStatusForPaymentPlanArgs = {
  input: UpdateCancellationStatusInput;
};


/** The mutation root of this schema */
export type MutationUpdateCertificateDefinitionArgs = {
  input: UpdateCertificateDefinitionInput;
};


/** The mutation root of this schema */
export type MutationUpdateCommsTemplateArgs = {
  input: UpdateCommsTemplateInput;
};


/** The mutation root of this schema */
export type MutationUpdateCouponBatchArgs = {
  input: CouponBatchUpdateInput;
};


/** The mutation root of this schema */
export type MutationUpdateCoverPhotoArgs = {
  input: UpdateCoverPhotoInput;
};


/** The mutation root of this schema */
export type MutationUpdateCvArgs = {
  input: UpdateCvInput;
};


/** The mutation root of this schema */
export type MutationUpdateEducationArgs = {
  input: UpdateEducationInput;
};


/** The mutation root of this schema */
export type MutationUpdateInterestsArgs = {
  input: UpdateInterestsInput;
};


/** The mutation root of this schema */
export type MutationUpdateLegacyPointsTagArgs = {
  data: LegacyPointsTagUpdateInput;
  where: LegacyPointsTagWhereUniqueInput;
};


/** The mutation root of this schema */
export type MutationUpdateLegacyPointsTagsArgs = {
  data: Array<LegacyPointsTagUpdateArgs>;
};


/** The mutation root of this schema */
export type MutationUpdateLpUserArgs = {
  data: LpUserUpdateInput;
  where: LpUserWhereUniqueInput;
};


/** The mutation root of this schema */
export type MutationUpdateLpUserActionArgs = {
  data: LpUserActionUpdateInput;
  where: LpUserActionWhereUniqueInput;
};


/** The mutation root of this schema */
export type MutationUpdateLpUserActionsArgs = {
  data: Array<LpUserActionUpdateArgs>;
};


/** The mutation root of this schema */
export type MutationUpdateLpUsersArgs = {
  data: Array<LpUserUpdateArgs>;
};


/** The mutation root of this schema */
export type MutationUpdateNotificationSettingsArgs = {
  input: UpdateNotificationSettingsInput;
};


/** The mutation root of this schema */
export type MutationUpdatePaymentPlanDatesArgs = {
  input: UpdatePaymentPlanDatesInput;
};


/** The mutation root of this schema */
export type MutationUpdateProfilePhotoArgs = {
  input: UpdateProfilePhotoInput;
};


/** The mutation root of this schema */
export type MutationUpdateProgramApplicationEnglishProficiencyProofArgs = {
  input: UpdateProgramApplicationEnglishProficiencyProofInput;
};


/** The mutation root of this schema */
export type MutationUpdateProgramApplicationHighSchoolCertificateArgs = {
  input: UpdateProgramApplicationHighSchoolCertificateInput;
};


/** The mutation root of this schema */
export type MutationUpdateRefugeeCardArgs = {
  input: UpdateRefugeeCardInput;
};


/** The mutation root of this schema */
export type MutationUpdateRewardArgs = {
  data: RewardUpdateInput;
  where: RewardWhereUniqueInput;
};


/** The mutation root of this schema */
export type MutationUpdateRewardCostArgs = {
  data: RewardCostUpdateInput;
  where: RewardCostWhereUniqueInput;
};


/** The mutation root of this schema */
export type MutationUpdateRewardCostsArgs = {
  data: Array<RewardCostUpdateArgs>;
};


/** The mutation root of this schema */
export type MutationUpdateRewardLimitationArgs = {
  data: RewardLimitationUpdateInput;
  where: RewardLimitationWhereUniqueInput;
};


/** The mutation root of this schema */
export type MutationUpdateRewardLimitationsArgs = {
  data: Array<RewardLimitationUpdateArgs>;
};


/** The mutation root of this schema */
export type MutationUpdateRewardsArgs = {
  data: Array<RewardUpdateArgs>;
};


/** The mutation root of this schema */
export type MutationUpdateSkillsArgs = {
  input: UpdateSkillsInput;
};


/** The mutation root of this schema */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


/** The mutation root of this schema */
export type MutationUpdateUserConsentArgs = {
  input: UpdateUserConsentInput;
};


/** The mutation root of this schema */
export type MutationUpdateWorkExperienceArgs = {
  input: UpdateWorkExperienceInput;
};


/** The mutation root of this schema */
export type MutationWithdrawFromProgramArgs = {
  input: WithdrawFromProgramInput;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

/** The type of event which represents a program enrollment was created. */
export type NileAcceptedToProgramInput = {
  /** The ID of the payment plan that was become active. */
  programEnrollmentId: Scalars['ID']['input'];
};

export type NileAcceptedToProgramNotificationPayload = {
  __typename?: 'NileAcceptedToProgramNotificationPayload';
  programEnrollment?: Maybe<ProgramEnrollment>;
  programEnrollmentId: Scalars['String']['output'];
  /** The type of notification */
  type: NotificationType;
};

/** The type of an event which represents a user enrolled in a program in Nile */
export type NileEnrolledInFlowInput = {
  /** The id of the Nile flow. */
  nileFlowId: Scalars['String']['input'];
  /** The user id of the learner to enroll. */
  nileId: Scalars['ID']['input'];
};

/** The type of an event which represents a new user was created in Nile */
export type NileNewUserInPlatformInput = {
  /** The ISO Datetime of the birth date. */
  birthDate?: InputMaybe<Scalars['String']['input']>;
  /** The city of residence of the user. */
  cityOfResidence?: InputMaybe<Scalars['String']['input']>;
  /** The country of origin of the user. */
  countryOfOrigin?: InputMaybe<Scalars['String']['input']>;
  /** The country of residence of the user. */
  countryOfResidence?: InputMaybe<Scalars['String']['input']>;
  /** The email of the user in the Nile platform. */
  email: Scalars['String']['input'];
  /** The first name of the user in the Nile platform. */
  firstName: Scalars['String']['input'];
  /** The string value of the gender. */
  gender?: InputMaybe<Scalars['String']['input']>;
  /** The hubspot Id used for this user. */
  hubspotId?: InputMaybe<Scalars['String']['input']>;
  /** The last name of the user in the Nile platform. */
  lastName: Scalars['String']['input'];
  /** The user id of the user in the Nile platform. */
  nileId: Scalars['ID']['input'];
  /** The phone number of the user in the Nile platform. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Notification = {
  __typename?: 'Notification';
  /** The creation time of this object */
  createdAt: Scalars['DateTime']['output'];
  /** Whether or not the user has dismissed this notification */
  dismissed: Scalars['Boolean']['output'];
  /** The id of the notification */
  id: Scalars['Int']['output'];
  /** Contains ad-hoc data of the notification. */
  payload: NotificationPayload;
  /** The platform for which this notification is relevant orthe platform which created this notification */
  platform: NotificationPlatform;
  /** Whether or not the user has seen this notification */
  seen: Scalars['Boolean']['output'];
  /** The type of notification */
  type: NotificationType;
};

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  /** https://relay.dev/graphql/connections.htm#sec-Edge-Types */
  edges: Array<NotificationEdge>;
  /** https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  /** https://relay.dev/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String']['output'];
  /** https://relay.dev/graphql/connections.htm#sec-Node */
  node: Notification;
};

/** Input fields for creating a notification */
export type NotificationInput = {
  payload: NotificationPayloadInput;
  /** The platform for which this notification is relevant orthe platform which created this notification */
  platform: NotificationPlatform;
  /** Id of the user which receives this notification */
  sandId: Scalars['String']['input'];
  /** The type of notification */
  type: NotificationType;
};

/** The union of payload types */
export type NotificationPayload = EHubNewClassEnrollmentNotificationPayload | EHubNewProgramEnrollmentNotificationPayload | JoinCommunityPayload | NileAcceptedToProgramNotificationPayload | OnboardingCompletedPayload | PaymentIsDueSoonPayload | SavannaAssignmentDuePayload;

/** The input shape of a notification payload, it must contain exactly one non-null payload type for the request to pass input validation */
export type NotificationPayloadInput = {
  /** The type of event which represents a class enrollment was created. */
  eHubNewClassEnrollmentNotification?: InputMaybe<EHubNewClassEnrollmentNotificationInput>;
  /** The type of event which represents a program enrollment was created. */
  eHubNewProgramEnrollmentNotification?: InputMaybe<EHubNewProgramEnrollmentNotificationInput>;
  /** The type of event which represents that a user should join the community. */
  joinCommunity?: InputMaybe<JoinCommunityInput>;
  /** The type of event which represents a program enrollment was created. */
  nileAcceptedToProgram?: InputMaybe<NileAcceptedToProgramInput>;
  /** The type of event which represents that the user completed the onboarding. */
  onboardingCompleted?: InputMaybe<OnboardingCompletedInput>;
  /** The type of event which represents a payment that is due soon. */
  paymentIsDueSoon?: InputMaybe<PaymentIsDueSoonInput>;
  /** The type of event which represents that an assignment is due in Savanna. */
  savannaAssignmentDue?: InputMaybe<SavannaAssignmentDueInput>;
};

/** The enum of platforms that can be attributed to a notification */
export enum NotificationPlatform {
  Ehub = 'EHUB',
  Nile = 'NILE',
  Payment = 'PAYMENT',
  Rewards = 'REWARDS',
  Savanna = 'SAVANNA'
}

export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  /** Enable admission notifications over email. */
  admissionEmail: Scalars['Boolean']['output'];
  /** Enable admission notifications in-app. */
  admissionInApp: Scalars['Boolean']['output'];
  /** Enable community notifications over email. */
  communityEmail: Scalars['Boolean']['output'];
  /** Enable community notifications over email regarding mentions. */
  communityEmailMentions: Scalars['Boolean']['output'];
  /** Enable community notifications over email regarding spaces. */
  communityEmailSpaces: Scalars['Boolean']['output'];
  /** Enable community notifications in-app. */
  communityInApp: Scalars['Boolean']['output'];
  /** Enable community notifications in-app regarding mentions. */
  communityInAppMentions: Scalars['Boolean']['output'];
  /** Enable community notifications in-app regarding spaces. */
  communityInAppSpaces: Scalars['Boolean']['output'];
  /** The creation time of this object. */
  createdAt: Scalars['DateTime']['output'];
  /** Enable customer support notifications over email. */
  customerSupportEmail: Scalars['Boolean']['output'];
  /** Enable customer support notifications in-app. */
  customerSupportInApp: Scalars['Boolean']['output'];
  /** Enable eHub notifications over email. */
  eHubEmail: Scalars['Boolean']['output'];
  /** Enable eHub notifications in-app. */
  eHubInApp: Scalars['Boolean']['output'];
  /** Enable notifications about upcoming events over email. */
  eventsEmail: Scalars['Boolean']['output'];
  /** Enable push notifications about upcoming events. */
  eventsPush: Scalars['Boolean']['output'];
  /** Enable learning notifications over email. */
  learningEmail: Scalars['Boolean']['output'];
  /** Enable learning notifications in-app. */
  learningInApp: Scalars['Boolean']['output'];
  /** The sandId of this notificationSetting (same as the user's). */
  sandId: Scalars['ID']['output'];
  /** Enable security and privacy notifications over email. */
  securityAndPrivacyEmail: Scalars['Boolean']['output'];
  /** Enable security and privacy notifications in-app. */
  securityAndPrivacyInApp: Scalars['Boolean']['output'];
  /** Enable security and privacy push notifications. */
  securityAndPrivacyPush: Scalars['Boolean']['output'];
  /** The last time this object was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Notification settings input. */
export type NotificationSettingsInput = {
  /** Enable admission notifications over email. */
  admissionEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable admission notifications in-app. */
  admissionInApp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable community notifications over email. */
  communityEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable community notifications over email regarding mentions. */
  communityEmailMentions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable community notifications over email regarding spaces. */
  communityEmailSpaces?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable community notifications in-app. */
  communityInApp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable community notifications in-app regarding mentions. */
  communityInAppMentions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable community notifications in-app regarding spaces. */
  communityInAppSpaces?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable customer support notifications over email. */
  customerSupportEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable customer support notifications in-app. */
  customerSupportInApp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable eHub notifications over email. */
  eHubEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable eHub notifications in-app. */
  eHubInApp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable notifications about upcoming events over email. */
  eventsEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable push notifications about upcoming events. */
  eventsPush?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable learning notifications over email. */
  learningEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable learning notifications in-app. */
  learningInApp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable security and privacy notifications over email. */
  securityAndPrivacyEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable security and privacy notifications in-app. */
  securityAndPrivacyInApp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable security and privacy push notifications. */
  securityAndPrivacyPush?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The enum of notification types */
export enum NotificationType {
  EhubNewClassEnrollment = 'EHUB_NEW_CLASS_ENROLLMENT',
  EhubNewProgramEnrollment = 'EHUB_NEW_PROGRAM_ENROLLMENT',
  EhubOnboardingCompleted = 'EHUB_ONBOARDING_COMPLETED',
  JoinCommunity = 'JOIN_COMMUNITY',
  NileAcceptedToProgram = 'NILE_ACCEPTED_TO_PROGRAM',
  PaymentIsDueSoon = 'PAYMENT_IS_DUE_SOON',
  SavannaAssignmentDue = 'SAVANNA_ASSIGNMENT_DUE'
}

export type OAuthClient = {
  __typename?: 'OAuthClient';
  /** The id of the OAuth client. */
  clientId: Scalars['String']['output'];
  /** The client secret. */
  clientSecret: Scalars['String']['output'];
  /** The code key name provided by the client */
  codeKeyName: Scalars['String']['output'];
  /** Date & time when the client was initially created. */
  createdAt: Scalars['DateTime']['output'];
  /** The name of the OAuth client. */
  name: Scalars['String']['output'];
  /** The redirect URI key name provided by the client */
  redirectUriKeyName: Scalars['String']['output'];
  /** A list of allowed redirect uris. */
  redirectUris: Array<Scalars['String']['output']>;
  /** The response type key name provided by the client */
  responseTypeKeyName: Scalars['String']['output'];
  /** The scope type key name provided by the client */
  scopeTypeKeyName: Scalars['String']['output'];
  /** The state key name provided by the client */
  stateKeyName: Scalars['String']['output'];
  /** Date & time when the client was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The type of event which represents that the user completed the onboarding. */
export type OnboardingCompletedInput = {
  /** The sandId of the user. */
  sandId: Scalars['ID']['input'];
};

export type OnboardingCompletedPayload = {
  __typename?: 'OnboardingCompletedPayload';
  sandId: Scalars['ID']['output'];
  /** The type of notification */
  type: NotificationType;
};

export type OnboardingPanel = {
  __typename?: 'OnboardingPanel';
  /** Did the user activate his profile. */
  activatedProfile?: Maybe<Scalars['DateTime']['output']>;
  /** Date & time when the onboarding panel was initially created. */
  createdAt: Scalars['DateTime']['output'];
  /** Did the user explore community and engage. */
  exploredAndEngagedWithCommunity?: Maybe<Scalars['DateTime']['output']>;
  /** Date & time when the user finished their onboarding. */
  finishedOnboardingAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the OnboardingPanel object. Coincides with the sandId of the user to which this onboarding panel belongs. */
  sandId: Scalars['ID']['output'];
  /** Date & time when the onboarding panel was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Did the user watch the onboarding video. */
  watchedOnboardingVideo?: Maybe<Scalars['DateTime']['output']>;
  /** Did the user watch the welcome video. */
  watchedWelcomeVideo?: Maybe<Scalars['DateTime']['output']>;
};

/** Type of GraphQL operation being audited */
export enum OperationType {
  Field = 'FIELD',
  Mutation = 'MUTATION',
  Query = 'QUERY',
  Subscription = 'SUBSCRIPTION'
}

export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

/** PageInfo cursor, as defined in https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** The cursor corresponding to the last nodes in edges. Null if the connection is empty. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Used to indicate whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Used to indicate whether more edges exist prior to the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The cursor corresponding to the first nodes in edges. Null if the connection is empty. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Paginated list of audit logs */
export type PaginatedAdminAuditLogs = {
  __typename?: 'PaginatedAdminAuditLogs';
  /** List of audit log entries */
  auditLogs: Array<AdminAuditLog>;
  /** Current page number (1-indexed) */
  pageNumber: Scalars['Int']['output'];
  /** Number of items per page */
  pageSize: Scalars['Int']['output'];
  /** Total number of audit logs matching the filters */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages */
  totalPages: Scalars['Int']['output'];
};

export type PaginatedHubCheckIns = {
  __typename?: 'PaginatedHubCheckIns';
  hubCheckIns: Array<Maybe<HubCheckIn>>;
  pageNumber: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

/** Paginated list of impersonation sessions. */
export type PaginatedImpersonationSessions = {
  __typename?: 'PaginatedImpersonationSessions';
  pageNumber: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  /** List of impersonation sessions for the current page. */
  sessions: Array<ImpersonationSession>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedProgramEnrollments = {
  __typename?: 'PaginatedProgramEnrollments';
  pageNumber: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  programEnrollments?: Maybe<Array<ProgramEnrollment>>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedStaffUsers = {
  __typename?: 'PaginatedStaffUsers';
  pageNumber: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
  users?: Maybe<Array<StaffUser>>;
};

export type PaginatedUsers = {
  __typename?: 'PaginatedUsers';
  pageNumber: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
  users: Array<Maybe<User>>;
};

export enum PartnershipType {
  AlxPathwayC1 = 'ALX_PATHWAY_C1',
  AlxPathwayC2 = 'ALX_PATHWAY_C2',
  NotSet = 'NOT_SET'
}

export type PasswordState = {
  __typename?: 'PasswordState';
  isSet: Scalars['Boolean']['output'];
};

/** Payment */
export type Payment = {
  __typename?: 'Payment';
  accountId: Scalars['Int']['output'];
  amount: Scalars['Float']['output'];
  amountReceived?: Maybe<Scalars['Float']['output']>;
  amountRefunded?: Maybe<Scalars['Float']['output']>;
  attemptCount: Scalars['Int']['output'];
  currencies: Array<Currency>;
  currency: Scalars['String']['output'];
  currencyFxRate?: Maybe<Scalars['Float']['output']>;
  currencyUsed?: Maybe<Scalars['String']['output']>;
  downloadInvoiceUrl?: Maybe<Scalars['String']['output']>;
  downloadReceiptUrl?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['RFC3339DateTime']['output']>;
  id: Scalars['Int']['output'];
  invoiceItems: Array<InvoiceItem>;
  name: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['RFC3339DateTime']['output']>;
  paymentHistory: Array<PaymentHistory>;
  paymentOptions: Array<PaymentOptions>;
  paymentPlan?: Maybe<PaymentPlan>;
  paymentPlanData?: Maybe<PaymentPlanData>;
  refundReason?: Maybe<Scalars['String']['output']>;
  relativeUrl?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  transId: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
  userCurrency?: Maybe<Scalars['String']['output']>;
  viewInvoiceUrl?: Maybe<Scalars['String']['output']>;
  viewReceiptUrl?: Maybe<Scalars['String']['output']>;
};

/** Payment history for payment */
export type PaymentHistory = {
  __typename?: 'PaymentHistory';
  amountInCurrency?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['RFC3339DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  dismissedAt?: Maybe<Scalars['RFC3339DateTime']['output']>;
  fxRate?: Maybe<Scalars['String']['output']>;
  gateway: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  option?: Maybe<Scalars['String']['output']>;
  paymentId: Scalars['Int']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  txRef?: Maybe<Scalars['String']['output']>;
};

export type PaymentHistoryTransaction = {
  __typename?: 'PaymentHistoryTransaction';
  amount: Scalars['Int']['output'];
  amountInCurrency?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['RFC3339DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dismissedAt?: Maybe<Scalars['RFC3339DateTime']['output']>;
  fxRate?: Maybe<Scalars['String']['output']>;
  gateway?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  option?: Maybe<Scalars['String']['output']>;
  paymentId: Scalars['Int']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  retryUrl?: Maybe<Scalars['String']['output']>;
  status: IncompleteTransactionStatus;
};

/** The type of event which represents a payment that is due soon. */
export type PaymentIsDueSoonInput = {
  /** The ID of the payment. */
  paymentId: Scalars['ID']['input'];
  /** The ID of the payment plan. */
  paymentPlanId: Scalars['ID']['input'];
};

export type PaymentIsDueSoonPayload = {
  __typename?: 'PaymentIsDueSoonPayload';
  /** The ID of the payment. */
  paymentId: Scalars['ID']['output'];
  paymentPlan?: Maybe<PaymentPlan>;
  /** The type of notification */
  type: NotificationType;
};

export enum PaymentMode {
  Full = 'FULL',
  One = 'ONE',
  OneOrMore = 'ONE_OR_MORE',
  Owe = 'OWE',
  Semester = 'SEMESTER',
  Term = 'TERM',
  Year = 'YEAR'
}

/** Payment option */
export type PaymentOption = {
  __typename?: 'PaymentOption';
  active: Scalars['Boolean']['output'];
  availableCountries?: Maybe<Array<Scalars['String']['output']>>;
  cancelUrl?: Maybe<Scalars['String']['output']>;
  gateway: Scalars['String']['output'];
  initUrl: Scalars['String']['output'];
  loadUrl?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<PaymentOptionMeta>;
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Payment option metadata */
export type PaymentOptionMeta = {
  __typename?: 'PaymentOptionMeta';
  code?: Maybe<Scalars['String']['output']>;
  expires?: Maybe<Scalars['Int']['output']>;
  option?: Maybe<Scalars['String']['output']>;
};

/** Payment options per currency */
export type PaymentOptions = {
  __typename?: 'PaymentOptions';
  currency: Scalars['String']['output'];
  options: Array<PaymentOption>;
};

export type PaymentPlan = {
  __typename?: 'PaymentPlan';
  /** Currently active payment, if one exists. */
  activePayment?: Maybe<Payment>;
  /** Fixed amount due per instalment. */
  amountPerInstalment: Scalars['Int']['output'];
  /** Total amount due per semester (calculated). */
  amountPerSemester?: Maybe<Scalars['Int']['output']>;
  /** Current billing state of the plan based on payment activity. */
  billingState: BillingState;
  /** Date when the payment plan was cancelled, either due to non-payment or voluntary withdrawal. */
  cancelDate?: Maybe<Scalars['RFC3339DateTime']['output']>;
  /** Amount associated with the cancellation status — positive if learner owes money, negative if refund is due. */
  cancellationAmount?: Maybe<Scalars['Int']['output']>;
  /** Learner's financial status after plan cancellation. */
  cancellationStatus?: Maybe<CancellationStatus>;
  /** Unique plan code representing the type or category of plan i.e. all-access, pathway or set. */
  code: Scalars['String']['output'];
  /** Index (starting from 0) of the current active semester. */
  currentSemesterIndex?: Maybe<Scalars['Int']['output']>;
  /** Name of the current active semester, if available. */
  currentSemesterName?: Maybe<Scalars['String']['output']>;
  /** Amount paid in the current semester. */
  currentSemesterPaidAmount?: Maybe<Scalars['Int']['output']>;
  /** Number of instalments paid in the current semester. */
  currentSemesterPaidInstalments?: Maybe<Scalars['Int']['output']>;
  /** Remaining amount to be paid in the current semester. */
  currentSemesterRemainingAmount?: Maybe<Scalars['Int']['output']>;
  /** Number of instalments remaining in the current semester. */
  currentSemesterRemainingInstalments?: Maybe<Scalars['Int']['output']>;
  /** Definition of a payment plan */
  definition?: Maybe<PaymentPlanDefinition>;
  /** Email address linked to the plan, if available. */
  email?: Maybe<Scalars['String']['output']>;
  /** End date of the payment plan, if applicable. */
  endDate?: Maybe<Scalars['RFC3339DateTime']['output']>;
  /** The grace date for this payment plan, if applicable. */
  graceDate?: Maybe<Scalars['RFC3339DateTime']['output']>;
  /** Hashed reference used for generating the public view URL. */
  hashForUrl: Scalars['String']['output'];
  /** List of incomplete or failed transactions linked to this plan. */
  incompleteTransactions: Array<PaymentHistoryTransaction>;
  /** Total number of instalments that have been paid. */
  instalmentsPaid: Scalars['Int']['output'];
  /** Number of instalments per semester for this plan. */
  instalmentsPerSemester?: Maybe<Scalars['Int']['output']>;
  /** List of invoices generated for this payment plan. */
  invoices?: Maybe<Array<Invoice>>;
  /** Date when the next instalment is scheduled. For SET/FIT plans, this may differ from the next payment date. */
  nextInstalmentDate?: Maybe<Scalars['RFC3339DateTime']['output']>;
  /** The next invoice that will be due for payment. */
  nextInvoice?: Maybe<Invoice>;
  /** Date when the next payment is scheduled. */
  nextPaymentDate?: Maybe<Scalars['RFC3339DateTime']['output']>;
  /** Amount already paid toward the next semester. */
  nextSemesterPaidAmount?: Maybe<Scalars['Int']['output']>;
  /** Number of instalments paid in the next semester (prepayments). */
  nextSemesterPaidInstalments?: Maybe<Scalars['Int']['output']>;
  /** Remaining amount to be paid for the next semester. */
  nextSemesterRemainingAmount?: Maybe<Scalars['Int']['output']>;
  /** Number of instalments remaining in the next semester. */
  nextSemesterRemainingInstalments?: Maybe<Scalars['Int']['output']>;
  /** The id of the payment plan. */
  paymentPlanId: Scalars['ID']['output'];
  /** List of payments made under this plan. (this does not include payments pending) */
  payments: Array<Payment>;
  /** System identifier used to group or reference this plan. */
  planIdentifier: Scalars['String']['output'];
  /** Amount paid in the previous semester. */
  previousSemesterPaidAmount?: Maybe<Scalars['Int']['output']>;
  /** Number of instalments paid in the previous semester. */
  previousSemesterPaidInstalments?: Maybe<Scalars['Int']['output']>;
  /** Remaining amount due from the previous semester. */
  previousSemesterRemainingAmount?: Maybe<Scalars['Int']['output']>;
  /** Number of instalments remaining in the previous semester. */
  previousSemesterRemainingInstalments?: Maybe<Scalars['Int']['output']>;
  /** Identifier for the learner or user linked to this payment plan. */
  sandId: Scalars['ID']['output'];
  /** Number of seconds remaining before plan cancellation. */
  secondsToCancellation?: Maybe<Scalars['Int']['output']>;
  /** Number of seconds until the next payment is due. */
  secondsToNextPayment: Scalars['Int']['output'];
  /** Mapping of semester index to total amount paid per semester. */
  semestersPaidAmount?: Maybe<Scalars['JSON']['output']>;
  /** Mapping of semester index to instalments paid per semester. */
  semestersPaidInstalments?: Maybe<Scalars['JSON']['output']>;
  /** Start date of the payment plan. */
  startDate: Scalars['RFC3339DateTime']['output'];
  /** Current status of the payment plan (e.g., active, grace, cancelled). */
  status: PaymentPlanStatus;
  /** Total amount that must be paid for this plan. */
  totalAmount: Scalars['Int']['output'];
  /** Total amount already paid for this plan. */
  totalPaidAmount: Scalars['Int']['output'];
  /** Public URL to view the payment plan details. */
  viewUrl: Scalars['String']['output'];
};

/** The type of event which represents payment plan become active. */
export type PaymentPlanActiveInput = {
  /** The ID of the payment plan that was become active. */
  paymentPlanId: Scalars['ID']['input'];
};

/** The type of event which represents a payment plan that was cancelled. */
export type PaymentPlanCancelledInput = {
  /** The payment plan ID that was cancelled. */
  paymentPlanId: Scalars['ID']['input'];
};

/** Payment plan data for payment */
export type PaymentPlanData = {
  __typename?: 'PaymentPlanData';
  invoiceIndices?: Maybe<Array<Scalars['Int']['output']>>;
  numberOfInstalments: Scalars['Int']['output'];
  paymentMode: PaymentMode;
};

/** Payment plan definition */
export type PaymentPlanDefinition = {
  __typename?: 'PaymentPlanDefinition';
  amount: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  daysOfGrace: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  instalments: Scalars['Int']['output'];
  instalmentsPerPeriod: Scalars['Int']['output'];
  interval: Interval;
  name: Scalars['String']['output'];
  paymentPlans: Array<PaymentPlan>;
  periods: Scalars['Int']['output'];
  status: PaymentPlanDefinitionStatus;
};

export type PaymentPlanDefinitionResult = {
  __typename?: 'PaymentPlanDefinitionResult';
  paymentPlanDefinition: PaymentPlanDefinition;
};

export type PaymentPlanDefinitionResultResultPayload = {
  __typename?: 'PaymentPlanDefinitionResultResultPayload';
  error?: Maybe<Scalars['String']['output']>;
  result?: Maybe<PaymentPlanDefinitionResult>;
  success: Scalars['Boolean']['output'];
};

export enum PaymentPlanDefinitionStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export type PaymentPlanDefinitionsInput = {
  accountId: Scalars['Int']['input'];
  keyword: Scalars['String']['input'];
  statuses?: InputMaybe<Array<PaymentPlanDefinitionStatus>>;
};

export type PaymentPlanEdge = {
  __typename?: 'PaymentPlanEdge';
  cursor: Scalars['String']['output'];
  node: PaymentPlan;
};

export enum PaymentPlanStatus {
  Active = 'ACTIVE',
  AtRisk = 'AT_RISK',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Inactive = 'INACTIVE'
}

/** The type of event which represents a successful payment made by a learner. */
export type PaymentsNewPaymentMadeInput = {
  /** The payment details object. */
  payment: Scalars['JSON']['input'];
  /** The payment plan ID. */
  paymentPlanId: Scalars['String']['input'];
  /** The learner's sandId. */
  sandId: Scalars['String']['input'];
};

/** The enum of available permissions in the system */
export enum Permission {
  AdminImpersonateUser = 'ADMIN_IMPERSONATE_USER',
  BadgeDefinitionsManage = 'BADGE_DEFINITIONS_MANAGE',
  BadgeIssue = 'BADGE_ISSUE',
  BadgeRevoke = 'BADGE_REVOKE',
  BadgeViewAll = 'BADGE_VIEW_ALL',
  CertificateDefinitionsManage = 'CERTIFICATE_DEFINITIONS_MANAGE',
  CertificateIssue = 'CERTIFICATE_ISSUE',
  CertificateRevoke = 'CERTIFICATE_REVOKE',
  CertificateViewAll = 'CERTIFICATE_VIEW_ALL',
  DashboardViewSensitiveInformation = 'DASHBOARD_VIEW_SENSITIVE_INFORMATION',
  GradingSystemManage = 'GRADING_SYSTEM_MANAGE',
  LearningChangeUserState = 'LEARNING_CHANGE_USER_STATE',
  LearningLockAutomaticProgression = 'LEARNING_LOCK_AUTOMATIC_PROGRESSION',
  LearningReinstateIntoFinishedClass = 'LEARNING_REINSTATE_INTO_FINISHED_CLASS',
  LearningUnlockAutomaticProgression = 'LEARNING_UNLOCK_AUTOMATIC_PROGRESSION',
  PaymentAdminRemovePaywall = 'PAYMENT_ADMIN_REMOVE_PAYWALL',
  PaymentAdminViewInformation = 'PAYMENT_ADMIN_VIEW_INFORMATION',
  RolesAdminCreateRole = 'ROLES_ADMIN_CREATE_ROLE',
  RolesAdminDeleteRole = 'ROLES_ADMIN_DELETE_ROLE',
  RolesAdminManageUsersRoles = 'ROLES_ADMIN_MANAGE_USERS_ROLES',
  RolesAdminUpdateRole = 'ROLES_ADMIN_UPDATE_ROLE',
  RolesAdminViewInformation = 'ROLES_ADMIN_VIEW_INFORMATION',
  SavannaAdminViewUsersCurriculumStatus = 'SAVANNA_ADMIN_VIEW_USERS_CURRICULUM_STATUS',
  StaffAdminCreateUser = 'STAFF_ADMIN_CREATE_USER',
  TrainingResourcesCreate = 'TRAINING_RESOURCES_CREATE',
  TrainingResourcesDelete = 'TRAINING_RESOURCES_DELETE',
  TrainingResourcesView = 'TRAINING_RESOURCES_VIEW'
}

export type PersonaInquiry = {
  __typename?: 'PersonaInquiry';
  /** Decision status of the inquiry (verification outcome). */
  decisionStatus: PersonaInquiryDecisionStatus;
  /** The id of the persona inquiry. */
  id: Scalars['ID']['output'];
  /** Lifecycle status of the inquiry (completion progress). */
  lifecycleStatus: PersonaInquiryLifecycleStatus;
};

export enum PersonaInquiryAction {
  Generate = 'GENERATE',
  Resume = 'RESUME'
}

export type PersonaInquiryApprovedInput = {
  /** The inquiryId that is being updated */
  inquiryId: Scalars['ID']['input'];
};

export type PersonaInquiryCompletedInput = {
  /** The inquiryId that is being updated */
  inquiryId: Scalars['ID']['input'];
};

export enum PersonaInquiryDecisionStatus {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  NeedsReview = 'NEEDS_REVIEW',
  None = 'NONE'
}

export type PersonaInquiryDeclinedInput = {
  /** The inquiryId that is being updated */
  inquiryId: Scalars['ID']['input'];
};

export enum PersonaInquiryLifecycleStatus {
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export enum PersonaInquiryType {
  Highschool = 'HIGHSCHOOL',
  Identity = 'IDENTITY',
  PriorLearning = 'PRIOR_LEARNING'
}

export type PlannedCourse = {
  __typename?: 'PlannedCourse';
  courseDefinitionId: Scalars['String']['output'];
  courseGroupKey?: Maybe<Scalars['String']['output']>;
  credits: Scalars['Int']['output'];
  /** The course in which the user is enrolled. */
  details: CourseDefinition;
  /** The course in which the user is enrolled. */
  enrollment?: Maybe<CourseEnrollment>;
  id: Scalars['ID']['output'];
  sandId: Scalars['String']['output'];
};

export type PotentialCourseEnrollment = {
  __typename?: 'PotentialCourseEnrollment';
  courseDetails?: Maybe<CourseDefinition>;
  courseGroupKey?: Maybe<Scalars['String']['output']>;
  /** A GRADUATED or ONGOING class enrollment of the user in this course. */
  existingEnrollment?: Maybe<ClassEnrollment>;
  /** The class in which the user would be enrolled into for this course if he applies to this program. */
  firstAvailableClass?: Maybe<Class>;
  id: Scalars['ID']['output'];
};

export type PotentialProgramJourney = {
  __typename?: 'PotentialProgramJourney';
  /** The list containing existing or simulated class enrollments for the courses in this program. */
  potentialCourseEnrollments: Array<PotentialCourseEnrollment>;
  /** The start date of the first class that the learner would take as part of this program, excluding classes he's already enrolled into. */
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type PreferredHubOption = {
  __typename?: 'PreferredHubOption';
  /** The expected time commitment from the user in order to successfully complete the program. */
  displayName: Scalars['String']['output'];
  /** The value of this preferred hub enum */
  value: Scalars['String']['output'];
};

export type Program = {
  __typename?: 'Program';
  /** The abbreviation of the program name. */
  abbreviation: Scalars['String']['output'];
  /** Duration in days after class start during which enrollments are allowed. */
  addDropPeriodDays: Scalars['Int']['output'];
  /** Is this program exclusive to the all access payment plan. */
  allAccessPaymentPlan: Scalars['Boolean']['output'];
  /** Whether the program allows course deferral. */
  allowCourseDeferral: Scalars['Boolean']['output'];
  /** Whether the program allows leave of absence. */
  allowLeaveOfAbsence: Scalars['Boolean']['output'];
  /** Returns if the current logged in users can enroll in this program. */
  canEnroll: Scalars['Boolean']['output'];
  /** The certificate template that this program awards on graduation, if any. */
  certificateDefinition?: Maybe<CertificateDefinition>;
  /** The description of the program. */
  description?: Maybe<Scalars['String']['output']>;
  /** Shows if a program has overall multiple courses planned. */
  hasMultiCourseDisplay: Scalars['Boolean']['output'];
  /** The id of the program. */
  id: Scalars['ID']['output'];
  /** Returns if the current logged in users is enrolled in this program. */
  isEnrolled: Scalars['Boolean']['output'];
  /** Returns if the current logged in user has graduated from this program. */
  isGraduated: Scalars['Boolean']['output'];
  /** Whether the program is a university one or not. */
  isUniversityProgram: Scalars['Boolean']['output'];
  /** The certificate awarded to the current viewer for this program, if they have earned it. */
  issuedCertificate?: Maybe<IssuedCertificate>;
  /** Public marketing magic link URL used for campaigns. */
  magicLink: Scalars['String']['output'];
  /** Information about the program that is used for marketing purposes. */
  marketing: ProgramMarketing;
  /** The maximum amount of credits worth of courses that a learner can be enrolled into during an academical term. */
  maxTermCredits: Scalars['Int']['output'];
  /** The minimum amount of credits worth of courses that a learner must be enrolled into during an academical term. Used only for deciding if the learner can defer a course, and will not stop a learner from taking fewer course in the case where all of his available courses amount to fewer credits. */
  minTermCredits: Scalars['Int']['output'];
  /** The name of the program. */
  name: Scalars['String']['output'];
  /** The link to the Nile program application. */
  nileProgramApplicationLink?: Maybe<Scalars['String']['output']>;
  /** Returns the possible journey of the learner through this program as a list of past, current and possible future classes. */
  potentialProgramJourney?: Maybe<PotentialProgramJourney>;
  /** Information about the program that is used for marketing purposes. */
  preferredHubOption: Array<PreferredHubOption>;
  requiresAdditionalQuestionnaire: Scalars['Boolean']['output'];
  /** Requires selecting preferred Hub for enrollment */
  requiresPreferredHubForEnrollment: Scalars['Boolean']['output'];
  /** Whether the program requires a tuition questionnaire or not. */
  requiresTuitionQuestionnaire: Scalars['Boolean']['output'];
  /** Returns if the current logged in users was enrolled in this program. */
  wasEnrolled: Scalars['Boolean']['output'];
};

export type ProgramApplication = {
  __typename?: 'ProgramApplication';
  additionalInfo?: Maybe<Scalars['String']['output']>;
  /** Admission decision for the program application. */
  admissionStatus: ProgramApplicationAdmissionStatus;
  /** If the user anticipates challenges in paying the tuition. */
  anticipateChallenges?: Maybe<Scalars['Boolean']['output']>;
  /** DocuSign enrollment agreement envelope metadata and latest webhook state. */
  docusignEnrollmentAgreement?: Maybe<DocusignEnrollmentAgreement>;
  /** The status of the english proficiency. */
  englishProficiencyStatus: EnglishProficiencyStatus;
  /** The type of english proficiency proof provided. */
  englishProficiencyType?: Maybe<EnglishProficiencyType>;
  /** The fee payment mode. */
  feePaymentMode?: Maybe<FeePaymentMode>;
  /** The high school certificate associated with this application. */
  highSchoolCertificate?: Maybe<HighSchoolCertificate>;
  /** The verification method chosen for highschool certificate (manual or persona). */
  highSchoolVerificationMode: HighSchoolVerificationMode;
  /** The id of the program application. */
  id: Scalars['ID']['output'];
  /** The other fee payment mode. */
  otherFeePaymentMode?: Maybe<Scalars['String']['output']>;
  /** The partnership academic standing. */
  partnershipAcademicStanding?: Maybe<Scalars['String']['output']>;
  /** The partnership payment status. */
  partnershipPaymentStatus?: Maybe<Scalars['String']['output']>;
  /** The fee payment mode. */
  partnershipType: PartnershipType;
  /** The persona highschool inquiry status associated with this application. */
  personaHighschoolInquiry?: Maybe<PersonaInquiry>;
  /** The persona identity inquiry status associated with this application. */
  personaIdentityInquiry?: Maybe<PersonaInquiry>;
  /** The persona prior learning inquiry status associated with this application. */
  personaPriorLearningInquiry?: Maybe<PersonaInquiry>;
  /** The program that this application is a part of. */
  program: Program;
  /** The program enrollment that this application is a part of. */
  programEnrollment: ProgramEnrollment;
  sharePersonalDataConsent?: Maybe<Scalars['Boolean']['output']>;
  /** The status of the program application. */
  status: ProgramApplicationStatus;
  /** The tuition fee payment type. */
  tuitionFeePaymentType?: Maybe<TuitionFeePaymentType>;
  /** The user that made this program application. */
  user: User;
};

export enum ProgramApplicationAdmissionStatus {
  Admitted = 'ADMITTED',
  ConditionallyAdmitted = 'CONDITIONALLY_ADMITTED',
  NotSet = 'NOT_SET'
}

export enum ProgramApplicationStatus {
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Success = 'SUCCESS'
}

export type ProgramChangeView = {
  __typename?: 'ProgramChangeView';
  /** The admin who made the change. */
  changedByUser: StaffUser;
  /** When the program change was made. */
  createdAt: Scalars['DateTime']['output'];
  /** The program the student was in before the change. */
  fromProgram: AdminProgramView;
  id: Scalars['ID']['output'];
  /** The program the student was changed to. */
  toProgram: AdminProgramView;
};

export type ProgramCourse = {
  __typename?: 'ProgramCourse';
  /** The course definition */
  courseDefinition: CourseDefinition;
  /** Date & time when this object was initially created. */
  createdAt: Scalars['DateTime']['output'];
  /** The number of credits for this course in this program. */
  credits: Scalars['Int']['output'];
  /** A list of courseDefinitions that must all be graduated before the student can take this course in this program but which are shorter courses and can be taken during the same term as this course. */
  doneWithPrerequisites: Array<CourseDefinition>;
  /** The id of the programCourse. */
  id: Scalars['ID']['output'];
  /** The number of deferrals allowed for this course in this program. */
  maxDeferrals: Scalars['Int']['output'];
  /** The number of retakes allowed for this course in this program. */
  maxRetakes: Scalars['Int']['output'];
  /** A list of courseDefinitions that must all be graduated before the learner can take this course in this program. */
  mustHavePrerequisites: Array<CourseDefinition>;
  /** The name of the course in this program. */
  name: Scalars['String']['output'];
  /** A list of courseDefinitions. At least one of the courses in this list needs to be graduated before the learner can take this course in this program. This list should contain the courses intended to be taken in the previous academical term. */
  oneOfPrerequisites: Array<CourseDefinition>;
  /** The priority of this course in this program, must respect the topological order of prerequisites. */
  priority: Scalars['Int']['output'];
  /** The program */
  program: Program;
  /** Date & time when this object was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type ProgramEnrollment = {
  __typename?: 'ProgramEnrollment';
  /** Academic conduct cases for this program enrollment. */
  academicConductCases: Array<AcademicConductCaseLearnerView>;
  /** The academic standing of the student in this program enrollment. */
  academicStanding?: Maybe<AcademicStanding>;
  /** The cohort that the user is a part of. */
  cohort?: Maybe<Cohort>;
  /** The course enrollments taken as part of this program. */
  courseEnrollments: Array<CourseEnrollment>;
  /** Date & time when this object was initially created. */
  createdAt: Scalars['DateTime']['output'];
  /** The cumulative (institutional) GPA across all courses taken at the institution. */
  cumulativeGPA?: Maybe<Scalars['Float']['output']>;
  /** Date & time when when the failed the program. */
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date & time when when the user graduated. */
  graduatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the program. */
  id: Scalars['ID']['output'];
  /** The description for the leave of absence. */
  leaveOfAbsenceDescription?: Maybe<Scalars['String']['output']>;
  /** The reason category for the leave of absence. */
  leaveOfAbsenceReason?: Maybe<DeferralReason>;
  /** The major GPA for courses in this program only. */
  majorGPA?: Maybe<Scalars['Float']['output']>;
  /** The payment plan that this associated for this enrollment. */
  paymentPlan?: Maybe<PaymentPlan>;
  plannedCourses: Array<PlannedCourse>;
  /** The preferred hub of the user for this program. */
  preferredHub?: Maybe<Scalars['String']['output']>;
  /** The program that this enrollment is a part of. */
  program: Program;
  /** The program application that this enrollment may have. */
  programApplication?: Maybe<ProgramApplication>;
  /** Date & time when when the user was last reinstated. */
  reinstatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The status of this program enrollment. */
  status: ProgramEnrollmentStatus;
  /** The term GPAs for this program enrollment. */
  termGPAs: Array<TermGpa>;
  /** Date & time when this object was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The user enrolled in this program. */
  user: User;
  /** The description why the learner was withdrawn from the program. */
  withdrawalDescription?: Maybe<Scalars['String']['output']>;
  /** The reason category why the learner was withdrawn from the program. */
  withdrawalReason?: Maybe<ProgramWithdrawalReason>;
};

export enum ProgramEnrollmentStatus {
  Failed = 'FAILED',
  Graduated = 'GRADUATED',
  Ongoing = 'ONGOING',
  Pending = 'PENDING'
}

export type ProgramEnrollmentStatusCount = {
  __typename?: 'ProgramEnrollmentStatusCount';
  /** The number of program enrollments with this status */
  count: Scalars['Int']['output'];
  /** The program enrollment status */
  status: ProgramEnrollmentStatus;
};

export type ProgramMarketing = {
  __typename?: 'ProgramMarketing';
  /** The access fee price for this program */
  accessFee?: Maybe<Scalars['String']['output']>;
  /** A list of program highlights. */
  highlights: Array<Scalars['String']['output']>;
  /** The legacy points amount displayed for the program. */
  legacyPoints?: Maybe<Scalars['String']['output']>;
  /** The default duration of the program. */
  programDuration?: Maybe<Scalars['String']['output']>;
  /** The summary or long description of the section where the program is explained */
  sectionSummary?: Maybe<Scalars['String']['output']>;
  /** The title of the section where the program is explained */
  sectionTitle?: Maybe<Scalars['String']['output']>;
  /** A sub title. Usually used to add more information after the title. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** The thumbnail we want to display for the video. */
  thumbnail?: Maybe<Scalars['String']['output']>;
  /** The expected time commitment from the user in order to successfully complete the program. */
  timeCommitment?: Maybe<Scalars['String']['output']>;
  /** The top marketing title, displayed usually under program name. */
  title?: Maybe<Scalars['String']['output']>;
  /** The marketing video for this program. */
  video?: Maybe<Scalars['String']['output']>;
};

export enum ProgramWithdrawalReason {
  FamilyIssues = 'FAMILY_ISSUES',
  FinanceIssues = 'FINANCE_ISSUES',
  MissedPayment = 'MISSED_PAYMENT',
  Other = 'OTHER',
  Sickness = 'SICKNESS'
}

export type ProgrammeClassTrackQueryInput = {
  /** Year Student is/being allocated to. */
  classYear: Array<ClassYearEnum>;
};

export type ProgrammeClassTrackResponse = {
  __typename?: 'ProgrammeClassTrackResponse';
  athenaProgrammeClassTrack: Array<AthenaProgrammeClassTrack>;
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ProofOfCompletion = {
  __typename?: 'ProofOfCompletion';
  /** The class enrollment of the user that submitted this proof of completion. */
  classEnrollment: ClassEnrollment;
  /** The email of the learner that took the exam. */
  email?: Maybe<Scalars['String']['output']>;
  /** The location where the exam was taken. */
  examLocation?: Maybe<ProofOfCompletionExamLocation>;
  /** The score received in the exam. */
  examScore?: Maybe<Scalars['Int']['output']>;
  /** The exam statement for both SA and AWS. */
  examStatement?: Maybe<ExamStatementType>;
  /** The validation number of the exam. */
  examValidationNumber?: Maybe<Scalars['String']['output']>;
  /** The first name of the learner that took the exam. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The last name of the learner that took the exam. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The status of the proof of completion. */
  status: ProofOfCompletionStatus;
  /** The trailblazer profile link of the learner that took the exam. */
  trailblazerProfileLink?: Maybe<Scalars['String']['output']>;
  /** The user that submitted this proof of completion. */
  user: User;
};

export enum ProofOfCompletionExamLocation {
  Online = 'ONLINE',
  OnlineVpAlxHub = 'ONLINE_VP_ALX_HUB',
  Onsite = 'ONSITE'
}

export enum ProofOfCompletionStatus {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE',
  Pending = 'PENDING'
}

export enum ProofOfCompletionType {
  AwsCloudComputing = 'AWS_CLOUD_COMPUTING',
  AwsSolutionsArchitect = 'AWS_SOLUTIONS_ARCHITECT',
  None = 'NONE',
  SalesforceAdministrator = 'SALESFORCE_ADMINISTRATOR',
  SalesforceAssociate = 'SALESFORCE_ASSOCIATE'
}

export type PublicEducation = {
  __typename?: 'PublicEducation';
  /** The field of study. */
  fieldOfStudy: Scalars['String']['output'];
  /** The date when the user graduated this education. */
  graduatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the education */
  id: Scalars['String']['output'];
  /** The country of the institution. */
  institutionCountry?: Maybe<Scalars['String']['output']>;
  /** The locality of the institution. */
  institutionLocality?: Maybe<Scalars['String']['output']>;
  /** The institution name of the education. */
  institutionName: Scalars['String']['output'];
  /** The external institution id. */
  knownInstitutionId?: Maybe<Scalars['String']['output']>;
  /** The level of study. */
  levelOfStudy: Scalars['String']['output'];
  /** The start date of the user education. */
  startDate: Scalars['DateTime']['output'];
};

export type PublicLanguageSkill = {
  __typename?: 'PublicLanguageSkill';
  /** The id of the language skill. */
  id: Scalars['String']['output'];
  /** The type of language (e.g. ENGLISH). */
  language: LanguageEnum;
  /** The proficiency level of the language skill */
  proficiencyLevel: LanguageProficiencyLevel;
};

export type PublicUser = {
  __typename?: 'PublicUser';
  /** The bio of the user. */
  bio?: Maybe<Scalars['String']['output']>;
  /** The residence country of the user. */
  countryOfResidence?: Maybe<Scalars['String']['output']>;
  /** The cover photo of the user. */
  coverPhoto?: Maybe<Scalars['String']['output']>;
  /** The latest CV of the user. */
  cv?: Maybe<Scalars['String']['output']>;
  educationHistory?: Maybe<Array<PublicEducation>>;
  /** The type of employment, e.g. full time or part time, etc. */
  employmentType?: Maybe<EmploymentTypeEnum>;
  /** The field of study at the institution [ Mathematics, Agriculture,…]. */
  fieldOfStudy?: Maybe<Scalars['String']['output']>;
  /** The first name of the user. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The level of education [high school, bachelors, master’s,…]. */
  highestLevelOfStudy?: Maybe<Scalars['String']['output']>;
  issuedBadges: Array<IssuedBadge>;
  /** User's language skills. */
  languages: Array<PublicLanguageSkill>;
  /** The middle name of the user. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The residence locality of the user. */
  localityOfResidence?: Maybe<Scalars['String']['output']>;
  /** The middle name of the user. */
  middleName?: Maybe<Scalars['String']['output']>;
  /** If the user is open to new positions. */
  openToNewPositions?: Maybe<Scalars['Boolean']['output']>;
  /** The phone number of this user. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** A list of descriptions or urls (e.g. github repos, apps made by the user, etc). */
  portfolioAndProjects: Array<Scalars['String']['output']>;
  /** Has this user been enrolled in ALX programs in the past, including using other accounts. */
  previouslyEnrolledInALX?: Maybe<Scalars['Boolean']['output']>;
  /** The primary email of the user. */
  primaryEmail: Scalars['String']['output'];
  /** The profile picture of the user. */
  profilePhoto?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for this person within the Sand Ecosystem. */
  sandId: Scalars['ID']['output'];
  /** The skills of the user. */
  skills: Array<Scalars['String']['output']>;
  socialLinks: SocialLinks;
  /** The tech work experience duration */
  techWorkExperienceDuration: Scalars['Int']['output'];
  /** The job title of this user */
  title?: Maybe<Scalars['String']['output']>;
  /** Top career goal (e.g. "become CEO of a company"). */
  topCareerGoal?: Maybe<Scalars['String']['output']>;
  /** The total work experience duration */
  totalWorkExperienceDuration: Scalars['Int']['output'];
  /** The WhatsApp phone number of this user. */
  whatsAppNumber?: Maybe<Scalars['String']['output']>;
  workExperience: Array<PublicWorkExperience>;
};

export type PublicWorkExperience = {
  __typename?: 'PublicWorkExperience';
  /** The name of the company for which the person worked */
  companyName: Scalars['String']['output'];
  /** The country where this job is performed */
  country?: Maybe<Scalars['String']['output']>;
  /** Description, up to 1024 characters */
  description?: Maybe<Scalars['String']['output']>;
  /** The type of employment, e.g. full time, part time, etc */
  employmentType: EmploymentTypeEnum;
  /** End date (month + year) of the employment, optional if isOngoing is true */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Is this a technical job. Useful for determining the technical experience of the user separate from his total work experience. */
  isInTech: Scalars['Boolean']['output'];
  /** Is the person still working at this job at the present moment */
  isOngoing: Scalars['Boolean']['output'];
  /** The locality where this job is performed */
  locality?: Maybe<Scalars['String']['output']>;
  /** Start date (month + year) of the employment */
  startDate: Scalars['DateTime']['output'];
  /** Job title */
  title: Scalars['String']['output'];
};

/** The query root of this schema */
export type Query = {
  __typename?: 'Query';
  achievement?: Maybe<Achievement>;
  achievementPointsOverride?: Maybe<AchievementPointsOverride>;
  achievementPointsOverrides?: Maybe<Array<AchievementPointsOverride>>;
  achievementPointsOverridesCount?: Maybe<Scalars['Int']['output']>;
  achievements?: Maybe<Array<Achievement>>;
  achievementsCount?: Maybe<Scalars['Int']['output']>;
  /** Preview payment plans that would receive a comms template on a selected date. */
  adminCommsPreviewDetail: CommsPreviewPlanItemConnection;
  /** Preview comms templates that would fire on a selected date. */
  adminCommsPreviewSummary: CommsPreviewSummaryResult;
  adminGetAvailableClasses: Array<AdminClassView>;
  adminGetAvailableCourses: Array<AdminCourseDefinitionView>;
  adminGetAvailablePrograms: Array<AdminProgramView>;
  adminGetClassDetails?: Maybe<AdminClassView>;
  adminGetClassEnrollmentDetails?: Maybe<AdminClassEnrollmentView>;
  adminGetCohortDetails?: Maybe<AdminCohortView>;
  adminGetCourseDetails?: Maybe<AdminCourseDefinitionView>;
  adminGetCourseEnrollmentDetails?: Maybe<AdminCourseEnrollmentView>;
  adminGetExtendedUserDetails?: Maybe<StaffUser>;
  adminGetGradesMappings: AdminGradesMappingsResult;
  /** Returns a paginated list of audit logs for admin actions. Supports filtering by actor, target user, action type, and operation type. */
  adminGetPaginatedAuditLogs: PaginatedAdminAuditLogs;
  /** Returns a list of classEnrollments using offset pagination. */
  adminGetPaginatedClassEnrollments: AdminPaginatedClassEnrollments;
  /** Returns a list of courseEnrollments using offset pagination. */
  adminGetPaginatedCourseEnrollments: AdminPaginatedCourseEnrollments;
  /** Returns impersonation sessions using offset pagination with optional sandId and status filters. */
  adminGetPaginatedImpersonationSessions: PaginatedImpersonationSessions;
  /** Returns a list of programEnrollments using offset pagination. */
  adminGetPaginatedProgramEnrollments: AdminPaginatedProgramEnrollments;
  /** Returns a list of users using offset pagination. */
  adminGetPaginatedUsers: PaginatedStaffUsers;
  adminGetProgramDetails?: Maybe<AdminProgramView>;
  adminGetProgramEnrollmentDetails?: Maybe<ProgramEnrollment>;
  adminGetUserDetails?: Maybe<User>;
  adminLog?: Maybe<AdminLog>;
  adminLogs?: Maybe<Array<AdminLog>>;
  adminLogsCount?: Maybe<Scalars['Int']['output']>;
  /** List all partnerships. */
  adminPartnerships: Array<AdminPartnership>;
  /** Get Admin info on PaymentPlan */
  adminPaymentPlan: PaymentPlan;
  /** Get payment plan definitions */
  adminPaymentPlanDefinitions: Array<PaymentPlanDefinition>;
  /** Get payment plans for admin users */
  adminPaymentPlans: AdminPaymentPlanConnection;
  /** Returns a list of classEnrollments using offset pagination. It has search functionality. */
  adminSearchPaginatedClassEnrollments: AdminPaginatedClassEnrollments;
  adminSearchUsersForRole?: Maybe<StaffUserSearchResult>;
  /** List all training resources. */
  adminTrainingResources: Array<AdminTrainingResource>;
  adminUser?: Maybe<AdminUser>;
  adminUsers?: Maybe<Array<AdminUser>>;
  adminUsersCount?: Maybe<Scalars['Int']['output']>;
  /** Get details about a student assessment/test. */
  athenaEvaluationAssessmentDetails: Array<StudentEvaluationAssessmentDetails>;
  /** Get available Athena courses. */
  athenaGetAthenaCourses?: Maybe<Array<Maybe<AthenaCourse>>>;
  /** Get available Athena programmes. */
  athenaGetProgrammes?: Maybe<Array<Maybe<AthenaProgramme>>>;
  /** Get available Athena programmes with their allocated classes. */
  athenaGetProgrammesWithClasses?: Maybe<ProgrammeClassTrackResponse>;
  /** Get Student Details and Assigned Courses/Programmes. */
  athenaGetStudentDetails?: Maybe<StudentInfoDetails>;
  /** Attendance stats. Arguments lastCheckInStartDate and lastCheckInEndDate should have yyyy-mm-dd format. Page number starts from 1. */
  attendanceStats?: Maybe<AttendanceStats>;
  authenticatedItem?: Maybe<AuthenticatedItem>;
  /** Get a single badge definition by ID. */
  badgeDefinition?: Maybe<BadgeDefinition>;
  /** List all badge definitions. */
  badgeDefinitions: Array<BadgeDefinition>;
  campaign?: Maybe<Campaign>;
  campaigns?: Maybe<Array<Campaign>>;
  campaignsCount?: Maybe<Scalars['Int']['output']>;
  /** Get a single certificate definition by ID. */
  certificateDefinition?: Maybe<CertificateDefinition>;
  /** List all certificate definitions. */
  certificateDefinitions: Array<CertificateDefinition>;
  /** Get comms template by ID */
  commsTemplate: CommsTemplateResultResultPayload;
  /** Get comms templates by plan_definition.code with optional filtering by template_id, status, and comms_event */
  commsTemplates: CommsTemplatesResultResultPayload;
  /** Get coupon batch by ID */
  couponBatch: CouponBatchResultResultPayload;
  /** Get coupon batches with optional filtering by name, description, and statuses */
  couponBatches: CouponBatchesResultResultPayload;
  /** Get coupon for payment plan by plan hash */
  couponForPaymentPlanByHash: CouponForPlanByHashResultResultPayload;
  /** Get coupons */
  coupons: CouponsResultResultPayload;
  dashboard?: Maybe<Dashboard>;
  /** List issued badges with optional filters. */
  issuedBadges: Array<IssuedBadge>;
  /** List issued certificates with optional filters. */
  issuedCertificates: Array<IssuedCertificate>;
  keystone: KeystoneMeta;
  legacyPointsTag?: Maybe<LegacyPointsTag>;
  legacyPointsTags?: Maybe<Array<LegacyPointsTag>>;
  legacyPointsTagsCount?: Maybe<Scalars['Int']['output']>;
  /** Get location by request IP */
  location?: Maybe<Location>;
  lpUser?: Maybe<LpUser>;
  lpUserAction?: Maybe<LpUserAction>;
  lpUserActions?: Maybe<Array<LpUserAction>>;
  lpUserActionsCount?: Maybe<Scalars['Int']['output']>;
  lpUsers?: Maybe<Array<LpUser>>;
  lpUsersCount?: Maybe<Scalars['Int']['output']>;
  /** Get a payment by account ID and public transaction hash. Intentionally does not require SSO: the hash is the capability for hosted and external payers loading checkout from a payment link. */
  payment?: Maybe<Payment>;
  /** Returns the payment dashboard for users with permission to view sensitive information. */
  paymentDashboard: Dashboard;
  /** Get a payment by account ID and hash transaction */
  paymentDashboardForLearnerByHash?: Maybe<DashboardForLearnerByHashResultPayload>;
  /** Get a payment by account ID and hash transaction */
  paymentDashboardUrlForLearner?: Maybe<DashboardUrlResultPayload>;
  /** Get payment plan by plan hash */
  paymentPlanByHash: PaymentPlan;
  /** Get payment plan definition */
  paymentPlanDefinition?: Maybe<PaymentPlanDefinition>;
  /** The public view of a user. */
  publicViewer: PublicUser;
  reward?: Maybe<Reward>;
  rewardCost?: Maybe<RewardCost>;
  rewardCosts?: Maybe<Array<RewardCost>>;
  rewardCostsCount?: Maybe<Scalars['Int']['output']>;
  rewardLimitation?: Maybe<RewardLimitation>;
  rewardLimitations?: Maybe<Array<RewardLimitation>>;
  rewardLimitationsCount?: Maybe<Scalars['Int']['output']>;
  rewards?: Maybe<Array<Reward>>;
  rewardsCount?: Maybe<Scalars['Int']['output']>;
  roles: Array<Role>;
  staffHubs: Array<Hub>;
  /** The staff user's view of a user. */
  staffViewUser: StaffUser;
  /** The staff user's view of a his profile. */
  staffViewer: StaffUser;
  /** Find a user by ID */
  user?: Maybe<User>;
  userAgreedToAllConsents: Scalars['Boolean']['output'];
  userStats?: Maybe<UserStats>;
  /** Publicly verify a badge by verification code. No auth required. */
  verifyBadge?: Maybe<BadgeVerification>;
  /** Publicly verify a certificate by verification code. No auth required. */
  verifyCertificate?: Maybe<CertificateVerification>;
  /** The currently authenticated user. */
  viewer: User;
};


/** The query root of this schema */
export type QueryAchievementArgs = {
  where: AchievementWhereUniqueInput;
};


/** The query root of this schema */
export type QueryAchievementPointsOverrideArgs = {
  where: AchievementPointsOverrideWhereUniqueInput;
};


/** The query root of this schema */
export type QueryAchievementPointsOverridesArgs = {
  cursor?: InputMaybe<AchievementPointsOverrideWhereUniqueInput>;
  orderBy?: Array<AchievementPointsOverrideOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: AchievementPointsOverrideWhereInput;
};


/** The query root of this schema */
export type QueryAchievementPointsOverridesCountArgs = {
  where?: AchievementPointsOverrideWhereInput;
};


/** The query root of this schema */
export type QueryAchievementsArgs = {
  cursor?: InputMaybe<AchievementWhereUniqueInput>;
  orderBy?: Array<AchievementOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: AchievementWhereInput;
};


/** The query root of this schema */
export type QueryAchievementsCountArgs = {
  where?: AchievementWhereInput;
};


/** The query root of this schema */
export type QueryAdminCommsPreviewDetailArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: CommsPreviewDetailInput;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query root of this schema */
export type QueryAdminCommsPreviewSummaryArgs = {
  input: CommsPreviewInput;
};


/** The query root of this schema */
export type QueryAdminGetClassDetailsArgs = {
  classId: Scalars['ID']['input'];
};


/** The query root of this schema */
export type QueryAdminGetClassEnrollmentDetailsArgs = {
  classEnrollmentId: Scalars['ID']['input'];
};


/** The query root of this schema */
export type QueryAdminGetCohortDetailsArgs = {
  cohortId: Scalars['ID']['input'];
};


/** The query root of this schema */
export type QueryAdminGetCourseDetailsArgs = {
  courseId: Scalars['ID']['input'];
};


/** The query root of this schema */
export type QueryAdminGetCourseEnrollmentDetailsArgs = {
  courseEnrollmentId: Scalars['ID']['input'];
};


/** The query root of this schema */
export type QueryAdminGetExtendedUserDetailsArgs = {
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  sandId?: InputMaybe<Scalars['String']['input']>;
};


/** The query root of this schema */
export type QueryAdminGetPaginatedAuditLogsArgs = {
  action?: InputMaybe<AuditAction>;
  actions?: InputMaybe<Array<AuditAction>>;
  actorSandId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  operationType?: InputMaybe<OperationType>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  targetSandId?: InputMaybe<Scalars['String']['input']>;
};


/** The query root of this schema */
export type QueryAdminGetPaginatedClassEnrollmentsArgs = {
  classEnrollmentStatus?: InputMaybe<ClassEnrollmentStatus>;
  classId?: InputMaybe<Scalars['String']['input']>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sandId?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<ClassEnrollmentStatus>>;
};


/** The query root of this schema */
export type QueryAdminGetPaginatedCourseEnrollmentsArgs = {
  courseDefinitionId?: InputMaybe<Scalars['String']['input']>;
  courseEnrollmentStatus?: InputMaybe<CourseEnrollmentStatus>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sandId?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<CourseEnrollmentStatus>>;
};


/** The query root of this schema */
export type QueryAdminGetPaginatedImpersonationSessionsArgs = {
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  statuses?: InputMaybe<Array<ImpersonationSessionStatus>>;
  targetSandId?: InputMaybe<Scalars['String']['input']>;
};


/** The query root of this schema */
export type QueryAdminGetPaginatedProgramEnrollmentsArgs = {
  academicStandings?: InputMaybe<Array<AcademicStanding>>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  hasWithdrawalReason?: InputMaybe<Scalars['Boolean']['input']>;
  orderByDirection?: InputMaybe<Scalars['String']['input']>;
  orderByField?: InputMaybe<Scalars['String']['input']>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  programId: Scalars['String']['input'];
  searchString?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<ProgramEnrollmentStatus>>;
};


/** The query root of this schema */
export type QueryAdminGetPaginatedUsersArgs = {
  lockedProgression?: InputMaybe<Scalars['Boolean']['input']>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchString?: InputMaybe<Scalars['String']['input']>;
};


/** The query root of this schema */
export type QueryAdminGetProgramDetailsArgs = {
  programId: Scalars['ID']['input'];
};


/** The query root of this schema */
export type QueryAdminGetProgramEnrollmentDetailsArgs = {
  programEnrollmentId: Scalars['ID']['input'];
};


/** The query root of this schema */
export type QueryAdminGetUserDetailsArgs = {
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  sandId?: InputMaybe<Scalars['ID']['input']>;
};


/** The query root of this schema */
export type QueryAdminLogArgs = {
  where: AdminLogWhereUniqueInput;
};


/** The query root of this schema */
export type QueryAdminLogsArgs = {
  cursor?: InputMaybe<AdminLogWhereUniqueInput>;
  orderBy?: Array<AdminLogOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: AdminLogWhereInput;
};


/** The query root of this schema */
export type QueryAdminLogsCountArgs = {
  where?: AdminLogWhereInput;
};


/** The query root of this schema */
export type QueryAdminPaymentPlanArgs = {
  paymentPlanId: Scalars['String']['input'];
};


/** The query root of this schema */
export type QueryAdminPaymentPlanDefinitionsArgs = {
  input: PaymentPlanDefinitionsInput;
};


/** The query root of this schema */
export type QueryAdminPaymentPlansArgs = {
  input: AdminPaymentPlanInput;
};


/** The query root of this schema */
export type QueryAdminSearchPaginatedClassEnrollmentsArgs = {
  classId: Scalars['String']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchString?: InputMaybe<Scalars['String']['input']>;
  showSelfReported?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The query root of this schema */
export type QueryAdminSearchUsersForRoleArgs = {
  hasRole?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  roleId: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


/** The query root of this schema */
export type QueryAdminUserArgs = {
  where: AdminUserWhereUniqueInput;
};


/** The query root of this schema */
export type QueryAdminUsersArgs = {
  cursor?: InputMaybe<AdminUserWhereUniqueInput>;
  orderBy?: Array<AdminUserOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: AdminUserWhereInput;
};


/** The query root of this schema */
export type QueryAdminUsersCountArgs = {
  where?: AdminUserWhereInput;
};


/** The query root of this schema */
export type QueryAthenaEvaluationAssessmentDetailsArgs = {
  input: Array<StudentAssessmentInput>;
};


/** The query root of this schema */
export type QueryAthenaGetAthenaCoursesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** The query root of this schema */
export type QueryAthenaGetProgrammesWithClassesArgs = {
  input?: InputMaybe<ProgrammeClassTrackQueryInput>;
};


/** The query root of this schema */
export type QueryAthenaGetStudentDetailsArgs = {
  userAttrs: Array<InputMaybe<UserAttributes>>;
};


/** The query root of this schema */
export type QueryAttendanceStatsArgs = {
  hubIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastCheckInEndDate?: InputMaybe<Scalars['String']['input']>;
  lastCheckInStartDate?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


/** The query root of this schema */
export type QueryBadgeDefinitionArgs = {
  id: Scalars['String']['input'];
};


/** The query root of this schema */
export type QueryBadgeDefinitionsArgs = {
  status?: InputMaybe<BadgeDefinitionStatus>;
};


/** The query root of this schema */
export type QueryCampaignArgs = {
  where: CampaignWhereUniqueInput;
};


/** The query root of this schema */
export type QueryCampaignsArgs = {
  cursor?: InputMaybe<CampaignWhereUniqueInput>;
  orderBy?: Array<CampaignOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: CampaignWhereInput;
};


/** The query root of this schema */
export type QueryCampaignsCountArgs = {
  where?: CampaignWhereInput;
};


/** The query root of this schema */
export type QueryCertificateDefinitionArgs = {
  id: Scalars['String']['input'];
};


/** The query root of this schema */
export type QueryCertificateDefinitionsArgs = {
  status?: InputMaybe<CertificateDefinitionStatus>;
};


/** The query root of this schema */
export type QueryCommsTemplateArgs = {
  input: CommsTemplateQueryInput;
};


/** The query root of this schema */
export type QueryCommsTemplatesArgs = {
  input: CommsTemplatesQueryInput;
};


/** The query root of this schema */
export type QueryCouponBatchArgs = {
  input: CouponBatchQueryInput;
};


/** The query root of this schema */
export type QueryCouponBatchesArgs = {
  input: CouponBatchesQueryInput;
};


/** The query root of this schema */
export type QueryCouponForPaymentPlanByHashArgs = {
  accountId: Scalars['Int']['input'];
  couponId: Scalars['String']['input'];
  hashPlan: Scalars['String']['input'];
};


/** The query root of this schema */
export type QueryCouponsArgs = {
  input: CouponsInput;
};


/** The query root of this schema */
export type QueryDashboardArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type QueryIssuedBadgesArgs = {
  badgeDefinitionId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sandId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BadgeStatus>;
};


/** The query root of this schema */
export type QueryIssuedCertificatesArgs = {
  certificateDefinitionId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sandId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CertificateStatus>;
};


/** The query root of this schema */
export type QueryLegacyPointsTagArgs = {
  where: LegacyPointsTagWhereUniqueInput;
};


/** The query root of this schema */
export type QueryLegacyPointsTagsArgs = {
  cursor?: InputMaybe<LegacyPointsTagWhereUniqueInput>;
  orderBy?: Array<LegacyPointsTagOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: LegacyPointsTagWhereInput;
};


/** The query root of this schema */
export type QueryLegacyPointsTagsCountArgs = {
  where?: LegacyPointsTagWhereInput;
};


/** The query root of this schema */
export type QueryLpUserArgs = {
  where: LpUserWhereUniqueInput;
};


/** The query root of this schema */
export type QueryLpUserActionArgs = {
  where: LpUserActionWhereUniqueInput;
};


/** The query root of this schema */
export type QueryLpUserActionsArgs = {
  cursor?: InputMaybe<LpUserActionWhereUniqueInput>;
  orderBy?: Array<LpUserActionOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: LpUserActionWhereInput;
};


/** The query root of this schema */
export type QueryLpUserActionsCountArgs = {
  where?: LpUserActionWhereInput;
};


/** The query root of this schema */
export type QueryLpUsersArgs = {
  cursor?: InputMaybe<LpUserWhereUniqueInput>;
  orderBy?: Array<LpUserOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: LpUserWhereInput;
};


/** The query root of this schema */
export type QueryLpUsersCountArgs = {
  where?: LpUserWhereInput;
};


/** The query root of this schema */
export type QueryPaymentArgs = {
  accountId: Scalars['Int']['input'];
  hashTrans: Scalars['String']['input'];
};


/** The query root of this schema */
export type QueryPaymentDashboardForLearnerByHashArgs = {
  accountId: Scalars['Int']['input'];
  code: Scalars['String']['input'];
  dashboardHash: Scalars['String']['input'];
};


/** The query root of this schema */
export type QueryPaymentDashboardUrlForLearnerArgs = {
  accountId: Scalars['Int']['input'];
};


/** The query root of this schema */
export type QueryPaymentPlanByHashArgs = {
  accountId: Scalars['Int']['input'];
  hashPlan: Scalars['String']['input'];
};


/** The query root of this schema */
export type QueryPaymentPlanDefinitionArgs = {
  id: Scalars['String']['input'];
};


/** The query root of this schema */
export type QueryPublicViewerArgs = {
  sandId: Scalars['ID']['input'];
};


/** The query root of this schema */
export type QueryRewardArgs = {
  where: RewardWhereUniqueInput;
};


/** The query root of this schema */
export type QueryRewardCostArgs = {
  where: RewardCostWhereUniqueInput;
};


/** The query root of this schema */
export type QueryRewardCostsArgs = {
  cursor?: InputMaybe<RewardCostWhereUniqueInput>;
  orderBy?: Array<RewardCostOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: RewardCostWhereInput;
};


/** The query root of this schema */
export type QueryRewardCostsCountArgs = {
  where?: RewardCostWhereInput;
};


/** The query root of this schema */
export type QueryRewardLimitationArgs = {
  where: RewardLimitationWhereUniqueInput;
};


/** The query root of this schema */
export type QueryRewardLimitationsArgs = {
  cursor?: InputMaybe<RewardLimitationWhereUniqueInput>;
  orderBy?: Array<RewardLimitationOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: RewardLimitationWhereInput;
};


/** The query root of this schema */
export type QueryRewardLimitationsCountArgs = {
  where?: RewardLimitationWhereInput;
};


/** The query root of this schema */
export type QueryRewardsArgs = {
  cursor?: InputMaybe<RewardWhereUniqueInput>;
  orderBy?: Array<RewardOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: RewardWhereInput;
};


/** The query root of this schema */
export type QueryRewardsCountArgs = {
  where?: RewardWhereInput;
};


/** The query root of this schema */
export type QueryStaffViewUserArgs = {
  sandId: Scalars['ID']['input'];
};


/** The query root of this schema */
export type QueryUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  sandId: Scalars['ID']['input'];
};


/** The query root of this schema */
export type QueryUserAgreedToAllConsentsArgs = {
  sandId: Scalars['ID']['input'];
};


/** The query root of this schema */
export type QueryVerifyBadgeArgs = {
  verificationCode: Scalars['String']['input'];
};


/** The query root of this schema */
export type QueryVerifyCertificateArgs = {
  verificationCode: Scalars['String']['input'];
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type Referral = {
  __typename?: 'Referral';
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  programApplicationAt?: Maybe<Scalars['DateTime']['output']>;
  referee: ReferralPerson;
  refereeFirstPaymentAt?: Maybe<Scalars['DateTime']['output']>;
  refereeSandId: Scalars['String']['output'];
  refereeSecondPaymentAt?: Maybe<Scalars['DateTime']['output']>;
  referrer: ReferralPerson;
  referrerSandId: Scalars['String']['output'];
  status: ReferralStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type ReferralPerson = {
  __typename?: 'ReferralPerson';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export enum ReferralStatus {
  AwaitingPayment = 'AWAITING_PAYMENT',
  AwaitingProgramApplication = 'AWAITING_PROGRAM_APPLICATION',
  Expired = 'EXPIRED',
  Invalid = 'INVALID',
  PaymentComplete = 'PAYMENT_COMPLETE'
}

export type ResendVerificationCodeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The email of the user for which the verification code will be sent again */
  email: Scalars['String']['input'];
};

export type ResendVerificationCodePayload = {
  __typename?: 'ResendVerificationCodePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** The type of event which represents a resume uploaded by a user. */
export type ResumeUploadedInput = {
  /** The sandId of the user that uploaded the resume. */
  sandId: Scalars['ID']['input'];
};

/** The type of event which represents that all failed events should be retried. */
export type RetryFailedEvents = {
  /** Optional field that acts as a placeholder. */
  retry?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Reward = {
  __typename?: 'Reward';
  campaign?: Maybe<Array<Campaign>>;
  campaignCount?: Maybe<Scalars['Int']['output']>;
  costInCurrency?: Maybe<Scalars['Decimal']['output']>;
  costInPoints?: Maybe<Scalars['Int']['output']>;
  costPerCategory?: Maybe<Array<RewardCost>>;
  costPerCategoryCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  ctaLink?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<ImageFieldOutput>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  limitations?: Maybe<Array<RewardLimitation>>;
  limitationsCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<LegacyPointsTag>>;
  tagsCount?: Maybe<Scalars['Int']['output']>;
};


export type RewardCampaignArgs = {
  cursor?: InputMaybe<CampaignWhereUniqueInput>;
  orderBy?: Array<CampaignOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: CampaignWhereInput;
};


export type RewardCampaignCountArgs = {
  where?: CampaignWhereInput;
};


export type RewardCostPerCategoryArgs = {
  cursor?: InputMaybe<RewardCostWhereUniqueInput>;
  orderBy?: Array<RewardCostOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: RewardCostWhereInput;
};


export type RewardCostPerCategoryCountArgs = {
  where?: RewardCostWhereInput;
};


export type RewardLimitationsArgs = {
  cursor?: InputMaybe<RewardLimitationWhereUniqueInput>;
  orderBy?: Array<RewardLimitationOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: RewardLimitationWhereInput;
};


export type RewardLimitationsCountArgs = {
  where?: RewardLimitationWhereInput;
};


export type RewardTagsArgs = {
  cursor?: InputMaybe<LegacyPointsTagWhereUniqueInput>;
  orderBy?: Array<LegacyPointsTagOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: LegacyPointsTagWhereInput;
};


export type RewardTagsCountArgs = {
  where?: LegacyPointsTagWhereInput;
};

/** The type of an event which represents a learner completed an achievement in the Rewards platform. */
export type RewardAchievementCompleteInput = {
  /** The slug identifying the completed achievement. */
  achievementSlug: Scalars['String']['input'];
  /** A unique key to deduplicate the achievement completion event. */
  idempotencyKey: Scalars['String']['input'];
  /** The sandId of the learner who completed the achievement. */
  sandId: Scalars['ID']['input'];
  /** The Savanna curriculum id associated with the achievement. */
  savannaCurriculumId: Scalars['ID']['input'];
  /** The title of the completed achievement. */
  title: Scalars['String']['input'];
};

export type RewardCost = {
  __typename?: 'RewardCost';
  costInPoints?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  memberAndLearnerCategory?: Maybe<Scalars['String']['output']>;
  reward?: Maybe<Reward>;
};

export type RewardCostCreateInput = {
  costInPoints?: InputMaybe<Scalars['Int']['input']>;
  memberAndLearnerCategory?: InputMaybe<Scalars['String']['input']>;
  reward?: InputMaybe<RewardRelateToOneForCreateInput>;
};

export type RewardCostManyRelationFilter = {
  every?: InputMaybe<RewardCostWhereInput>;
  none?: InputMaybe<RewardCostWhereInput>;
  some?: InputMaybe<RewardCostWhereInput>;
};

export type RewardCostOrderByInput = {
  costInPoints?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  memberAndLearnerCategory?: InputMaybe<OrderDirection>;
};

export type RewardCostRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<RewardCostWhereUniqueInput>>;
  create?: InputMaybe<Array<RewardCostCreateInput>>;
};

export type RewardCostRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<RewardCostWhereUniqueInput>>;
  create?: InputMaybe<Array<RewardCostCreateInput>>;
  disconnect?: InputMaybe<Array<RewardCostWhereUniqueInput>>;
  set?: InputMaybe<Array<RewardCostWhereUniqueInput>>;
};

export type RewardCostUpdateArgs = {
  data: RewardCostUpdateInput;
  where: RewardCostWhereUniqueInput;
};

export type RewardCostUpdateInput = {
  costInPoints?: InputMaybe<Scalars['Int']['input']>;
  memberAndLearnerCategory?: InputMaybe<Scalars['String']['input']>;
  reward?: InputMaybe<RewardRelateToOneForUpdateInput>;
};

export type RewardCostWhereInput = {
  AND?: InputMaybe<Array<RewardCostWhereInput>>;
  NOT?: InputMaybe<Array<RewardCostWhereInput>>;
  OR?: InputMaybe<Array<RewardCostWhereInput>>;
  costInPoints?: InputMaybe<IntFilter>;
  id?: InputMaybe<IdFilter>;
  memberAndLearnerCategory?: InputMaybe<StringFilter>;
  reward?: InputMaybe<RewardWhereInput>;
};

export type RewardCostWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type RewardCreateInput = {
  campaign?: InputMaybe<CampaignRelateToManyForCreateInput>;
  costInCurrency?: InputMaybe<Scalars['Decimal']['input']>;
  costInPoints?: InputMaybe<Scalars['Int']['input']>;
  costPerCategory?: InputMaybe<RewardCostRelateToManyForCreateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<ImageFieldInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limitations?: InputMaybe<RewardLimitationRelateToManyForCreateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<LegacyPointsTagRelateToManyForCreateInput>;
};

export type RewardLimitation = {
  __typename?: 'RewardLimitation';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  memberAndLearnerCategory?: Maybe<Scalars['String']['output']>;
  reward?: Maybe<Reward>;
};

export type RewardLimitationCreateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Array<Scalars['String']['input']>>;
  memberAndLearnerCategory?: InputMaybe<Scalars['String']['input']>;
  reward?: InputMaybe<RewardRelateToOneForCreateInput>;
};

export type RewardLimitationManyRelationFilter = {
  every?: InputMaybe<RewardLimitationWhereInput>;
  none?: InputMaybe<RewardLimitationWhereInput>;
  some?: InputMaybe<RewardLimitationWhereInput>;
};

export type RewardLimitationOrderByInput = {
  city?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  memberAndLearnerCategory?: InputMaybe<OrderDirection>;
};

export type RewardLimitationRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<RewardLimitationWhereUniqueInput>>;
  create?: InputMaybe<Array<RewardLimitationCreateInput>>;
};

export type RewardLimitationRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<RewardLimitationWhereUniqueInput>>;
  create?: InputMaybe<Array<RewardLimitationCreateInput>>;
  disconnect?: InputMaybe<Array<RewardLimitationWhereUniqueInput>>;
  set?: InputMaybe<Array<RewardLimitationWhereUniqueInput>>;
};

export type RewardLimitationUpdateArgs = {
  data: RewardLimitationUpdateInput;
  where: RewardLimitationWhereUniqueInput;
};

export type RewardLimitationUpdateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Array<Scalars['String']['input']>>;
  memberAndLearnerCategory?: InputMaybe<Scalars['String']['input']>;
  reward?: InputMaybe<RewardRelateToOneForUpdateInput>;
};

export type RewardLimitationWhereInput = {
  AND?: InputMaybe<Array<RewardLimitationWhereInput>>;
  NOT?: InputMaybe<Array<RewardLimitationWhereInput>>;
  OR?: InputMaybe<Array<RewardLimitationWhereInput>>;
  city?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  memberAndLearnerCategory?: InputMaybe<StringNullableFilter>;
  reward?: InputMaybe<RewardWhereInput>;
};

export type RewardLimitationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type RewardOrderByInput = {
  costInCurrency?: InputMaybe<OrderDirection>;
  costInPoints?: InputMaybe<OrderDirection>;
  createdAt?: InputMaybe<OrderDirection>;
  ctaLink?: InputMaybe<OrderDirection>;
  description?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  isActive?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  slug?: InputMaybe<OrderDirection>;
};

export type RewardRelateToOneForCreateInput = {
  connect?: InputMaybe<RewardWhereUniqueInput>;
  create?: InputMaybe<RewardCreateInput>;
};

export type RewardRelateToOneForUpdateInput = {
  connect?: InputMaybe<RewardWhereUniqueInput>;
  create?: InputMaybe<RewardCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RewardUpdateArgs = {
  data: RewardUpdateInput;
  where: RewardWhereUniqueInput;
};

export type RewardUpdateInput = {
  campaign?: InputMaybe<CampaignRelateToManyForUpdateInput>;
  costInCurrency?: InputMaybe<Scalars['Decimal']['input']>;
  costInPoints?: InputMaybe<Scalars['Int']['input']>;
  costPerCategory?: InputMaybe<RewardCostRelateToManyForUpdateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<ImageFieldInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limitations?: InputMaybe<RewardLimitationRelateToManyForUpdateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<LegacyPointsTagRelateToManyForUpdateInput>;
};

export type RewardWhereInput = {
  AND?: InputMaybe<Array<RewardWhereInput>>;
  NOT?: InputMaybe<Array<RewardWhereInput>>;
  OR?: InputMaybe<Array<RewardWhereInput>>;
  campaign?: InputMaybe<CampaignManyRelationFilter>;
  costInCurrency?: InputMaybe<DecimalNullableFilter>;
  costInPoints?: InputMaybe<IntFilter>;
  costPerCategory?: InputMaybe<RewardCostManyRelationFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  ctaLink?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  isActive?: InputMaybe<BooleanFilter>;
  limitations?: InputMaybe<RewardLimitationManyRelationFilter>;
  name?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
  tags?: InputMaybe<LegacyPointsTagManyRelationFilter>;
};

export type RewardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type Role = {
  __typename?: 'Role';
  /** Date & time when the role was initially created. */
  createdAt: Scalars['DateTime']['output'];
  /** A unique identifier for this role */
  id: Scalars['ID']['output'];
  /** The name of this role */
  name: Scalars['String']['output'];
  /** The permissions assigned to this role */
  permissions: Array<Permission>;
  /** Date & time when the role was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The number of users assigned to this role */
  userCount: Scalars['Int']['output'];
};

/** Autogenerated input type of AssignLearnerToProgram */
export type SavannaAssignLearnerToProgramInput = {
  /** ID of the batch to add the learner to */
  batchId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the curriculum to assign to the learner */
  curriculumId: Scalars['ID']['input'];
  /** Email of the learner to add to the batch */
  email?: InputMaybe<Scalars['String']['input']>;
  /** ID of the learner to add to the batch */
  sandId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of AssignLearnerToProgram. */
export type SavannaAssignLearnerToProgramPayload = {
  __typename?: 'SavannaAssignLearnerToProgramPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors while assigning the learner to the program */
  errors?: Maybe<Scalars['String']['output']>;
  /** The learner that was assigned to the program */
  learner?: Maybe<User>;
};

/** The type of event which represents that an assignment is due in Savanna. */
export type SavannaAssignmentDueInput = {
  /** The ID of the project in Savanna. */
  id: Scalars['ID']['input'];
};

export type SavannaAssignmentDuePayload = {
  __typename?: 'SavannaAssignmentDuePayload';
  savannaProject?: Maybe<SavannaProject>;
  /** The type of notification */
  type: NotificationType;
};

export type SavannaCourseFailedInput = {
  /** The sandId of the user that failed the course. */
  sandId: Scalars['ID']['input'];
  /** The id of the batch. */
  savannaBatchId: Scalars['ID']['input'];
  /** The id of the curriculum. */
  savannaCurriculumId: Scalars['ID']['input'];
  /** The final numerical score (0-100) for this class. */
  score?: InputMaybe<Scalars['Float']['input']>;
};

export type SavannaCourseGraduatedInput = {
  /** The sandId of the user that graduated the course. */
  sandId: Scalars['ID']['input'];
  /** The id of the batch. */
  savannaBatchId: Scalars['ID']['input'];
  /** The id of the curriculum. */
  savannaCurriculumId: Scalars['ID']['input'];
  /** The final numerical score (0-100) for this class. */
  score?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated input type of CreateLearner */
export type SavannaCreateLearnerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Attributes to create a learner */
  learner: SavannaLearnerInput;
};

/** Autogenerated return type of CreateLearner. */
export type SavannaCreateLearnerPayload = {
  __typename?: 'SavannaCreateLearnerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors that prevented the learner from being created */
  errors?: Maybe<Scalars['String']['output']>;
  /** The learner that was created */
  learner?: Maybe<User>;
};

/** Attributes to create a learner */
export type SavannaLearnerInput = {
  /** Country of the learner */
  addressCountry?: InputMaybe<Scalars['String']['input']>;
  /** Email of the learner */
  email: Scalars['String']['input'];
  /** First name of the learner */
  firstName: Scalars['String']['input'];
  /** Last name of the learner */
  lastName: Scalars['String']['input'];
  /** ID of the learner in SAND ecosystem */
  sandId?: InputMaybe<Scalars['String']['input']>;
};

export type SavannaMilestoneCompletedInput = {
  /** The sandId of the user that completed the milestone. */
  sandId: Scalars['ID']['input'];
  /** The id of the batch. */
  savannaBatchId: Scalars['ID']['input'];
  /** The id of the curriculum. */
  savannaCurriculumId: Scalars['ID']['input'];
  /** The id of the project. */
  savannaProjectId: Scalars['ID']['input'];
};

export type SavannaProject = {
  __typename?: 'SavannaProject';
  /** The id of the project in Savanna. */
  id: Scalars['ID']['output'];
};

export type SavannaTestCompletedInput = {
  /** The sandId of the user that completed the test. */
  sandId: Scalars['ID']['input'];
  /** The id of the batch. */
  savannaBatchId: Scalars['ID']['input'];
  /** The id of the curriculum. */
  savannaCurriculumId: Scalars['ID']['input'];
  /** The id of the evaluation quiz. */
  savannaEvaluationQuizId: Scalars['ID']['input'];
};

/** Autogenerated input type of UpdateLearner */
export type SavannaUpdateLearnerInput = {
  /** New country of the learner */
  addressCountry?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** New email of the learner */
  email?: InputMaybe<Scalars['String']['input']>;
  /** New first name of the learner */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** New last name of the learner */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** ID of the learner in SAND ecosystem */
  sandId: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateLearner. */
export type SavannaUpdateLearnerPayload = {
  __typename?: 'SavannaUpdateLearnerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors that prevented the learner from being updated */
  errors?: Maybe<Scalars['String']['output']>;
  /** The learner that was updated */
  learner?: Maybe<User>;
};

/** Autogenerated input type of UpdateSandId */
export type SavannaUpdateSandIdInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email of the user */
  email: Scalars['String']['input'];
  /** New SandId of the user */
  sandId: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateSandId. */
export type SavannaUpdateSandIdPayload = {
  __typename?: 'SavannaUpdateSandIdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Error that prevented the update */
  errors?: Maybe<Scalars['String']['output']>;
  /** User with updated SandId */
  user?: Maybe<User>;
};

/** Autogenerated input type of WithdrawLearner */
export type SavannaWithdrawLearnerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the curriculum to withdraw */
  curriculumId: Scalars['ID']['input'];
  /** Email of the learner to withdraw */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Sand Id of the learner to withdraw */
  sandId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of WithdrawLearner. */
export type SavannaWithdrawLearnerPayload = {
  __typename?: 'SavannaWithdrawLearnerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors which occurred during withdrawal */
  errors?: Maybe<Scalars['String']['output']>;
  /** User curriculum status of withdrawn learner */
  userCurriculumStatus?: Maybe<UserCurriculumStatus>;
};

/** A school location. */
export type SchoolLocation = {
  __typename?: 'SchoolLocation';
  /** The school location's unique identifier. */
  id: Scalars['ID']['output'];
  /** The school location's name. */
  name: Scalars['String']['output'];
  /** The school location's short name. */
  shortName: Scalars['String']['output'];
};

export type SelfCheckInInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
};

export type SelfCheckInPayload = {
  __typename?: 'SelfCheckInPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

/** The type of an event which represents that a platform wants to send a communication. */
export type SendCommunicationInput = {
  /** The communication identifier, for example the email template ID. */
  communicationIdentifier: Scalars['String']['input'];
  /** Object with keys and values used to render the correct information inside the communication template. */
  contactProperties?: InputMaybe<Scalars['JSON']['input']>;
  /** Object with keys and values used to render the correct information inside the communication template. */
  customProperties: Scalars['JSON']['input'];
  /** The email of the user that you want to send the communication to. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The communication medium used for this event */
  medium: CommunicationMedium;
  /** The sandId of the user that you want to send the communication to. If sandId is present email will be inferred. */
  sandId?: InputMaybe<Scalars['ID']['input']>;
};

export type SocialLinks = {
  __typename?: 'SocialLinks';
  /** The Facebook URL for this user. */
  facebook?: Maybe<Scalars['String']['output']>;
  /** The Github URL for this user. */
  github?: Maybe<Scalars['String']['output']>;
  /** The LinkedIn URL for this user. */
  linkedIn?: Maybe<Scalars['String']['output']>;
  /** The TikTok URL for this user. */
  tikTok?: Maybe<Scalars['String']['output']>;
  /** The Twitter URL for this user. */
  twitter?: Maybe<Scalars['String']['output']>;
  /** The Youtube URL for this user. */
  youtube?: Maybe<Scalars['String']['output']>;
};

export type StaffUser = {
  __typename?: 'StaffUser';
  activities: Array<UserActivity>;
  administersHub?: Maybe<Hub>;
  availableCourses: Array<CourseDefinition>;
  availableDashboards: Array<Dashboard>;
  availablePrograms: Array<Program>;
  /** The bio of the user. */
  bio?: Maybe<Scalars['String']['output']>;
  /** The date & time of birth for the user. */
  birthDate?: Maybe<Scalars['DateTime']['output']>;
  /** Indicates whether the user is blacklisted/banned from the Sand Ecosystem. */
  blacklistedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The reason for blacklisting this specific user. */
  blacklistedReason?: Maybe<Scalars['String']['output']>;
  /** Hub names of user's checkIns. */
  checkInsHubNames: Array<Scalars['String']['output']>;
  /** The home country of the user. */
  countryOfOrigin?: Maybe<Scalars['String']['output']>;
  /** The residence country of the user. */
  countryOfResidence?: Maybe<Scalars['String']['output']>;
  /** The home county of the user. */
  countyOfOrigin?: Maybe<Scalars['String']['output']>;
  /** The residence county of the user. */
  countyOfResidence?: Maybe<Scalars['String']['output']>;
  /** The cover photo of the user. */
  coverPhoto?: Maybe<Scalars['String']['output']>;
  /** Date & time when the user was initially created. */
  createdAt: Scalars['DateTime']['output'];
  currentCheckIn?: Maybe<HubCheckIn>;
  /** The latest CV of the user. */
  cv?: Maybe<Scalars['String']['output']>;
  /** Does the user have a disability? */
  disability?: Maybe<Disability>;
  educationHistory?: Maybe<Array<Education>>;
  /** The type of employment, e.g. full time or part time, etc. */
  employmentType?: Maybe<EmploymentTypeEnum>;
  enrollmentFeatureAccess: EnrollmentFeatureAccess;
  /** The field of study at the institution [ Mathematics, Agriculture,…]. */
  fieldOfStudy?: Maybe<Scalars['String']['output']>;
  /** The first name of the user. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The gender of the user. */
  gender?: Maybe<Gender>;
  /** The current guardianship of the user. */
  guardianship?: Maybe<Guardianship>;
  /** The level of education [high school, bachelors, master’s,…]. */
  highestLevelOfStudy?: Maybe<Scalars['String']['output']>;
  /** Household monthly income in USD. */
  householdMonthlyIncomeUSD?: Maybe<Scalars['Int']['output']>;
  hubCheckInCode: HubCheckInCode;
  /** The paginated list of user's hub checkins. checkInStartDate and checkInEndDate should have 'yyyy-mm-dd' format. checkInDateSortOrder should be either 'asc' or 'desc' */
  hubCheckIns?: Maybe<PaginatedHubCheckIns>;
  hubCheckOutCode: HubCheckOutCode;
  /** Is the user in a humanitarian status situation? (Yes, No, Prefer not to answer). */
  humanitarianStatus?: Maybe<HumanitarianStatus>;
  /** Which type of humanitarian status situation? (Refugee, Asylum seeker, Not Applicable, etc). */
  humanitarianStatusType?: Maybe<HumanitarianStatusType>;
  /** The interests of the user. */
  interests: Array<Scalars['String']['output']>;
  /** Indicates if the user is currently employed or unemployed. */
  isEmployed?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether this entry is not a true user of the platform, but an internal The Room staff member, or a test user. */
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  /** User's language skills. */
  languages: Array<LanguageSkill>;
  /** The middle name of the user. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Current living circumstances (Homeless, Shelter, Prefer not to say, etc). */
  livingCircumstances?: Maybe<LivingCircumstances>;
  /** The home locality of the user. */
  localityOfOrigin?: Maybe<Scalars['String']['output']>;
  /** The residence locality of the user. */
  localityOfResidence?: Maybe<Scalars['String']['output']>;
  /** Current location description (Urban, Rural, Prefer not to say). */
  locationDescription?: Maybe<LocationDescription>;
  /** Indicates whether the progression algorithm is locked for this user while an admin is manually updating enrollments. */
  lockedProgression?: Maybe<Scalars['Boolean']['output']>;
  /** The sandId of the admin who locked the progression. */
  lockedProgressionBy?: Maybe<Scalars['String']['output']>;
  /** Date & time when the progression was locked. */
  lockedProgressionByAt?: Maybe<Scalars['DateTime']['output']>;
  /** The admin user who locked the progression. */
  lockedProgressionByUser?: Maybe<StaffUser>;
  /** The middle name of the user. */
  middleName?: Maybe<Scalars['String']['output']>;
  nearbyHub?: Maybe<Hub>;
  notificationSettings?: Maybe<NotificationSettings>;
  /** The list of notifications for this user */
  notifications: NotificationConnection;
  onboardingPanel?: Maybe<OnboardingPanel>;
  /** If the user is open to new positions. */
  openToNewPositions?: Maybe<Scalars['Boolean']['output']>;
  /** List of permissions granted to the user based on their roles */
  permissions: Array<Permission>;
  /** The phone number of this user. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** A list of descriptions or urls (e.g. github repos, apps made by the user, etc). */
  portfolioAndProjects: Array<Scalars['String']['output']>;
  /** Has this user been enrolled in ALX programs in the past, including using other accounts. */
  previouslyEnrolledInALX?: Maybe<Scalars['Boolean']['output']>;
  /** The primary email of the user. */
  primaryEmail: Scalars['String']['output'];
  /** The profile picture of the user. */
  profilePhoto?: Maybe<Scalars['String']['output']>;
  programEnrollments?: Maybe<Array<AdminProgramEnrollmentView>>;
  /** Shareable referral URL for this user. */
  referralLink?: Maybe<Scalars['String']['output']>;
  /** The latest refugeeCard of the user. */
  refugeeCard?: Maybe<Scalars['String']['output']>;
  regularUser: User;
  removedPaywallAt?: Maybe<Scalars['DateTime']['output']>;
  roles: Array<Role>;
  /** A unique identifier for this person within the Sand Ecosystem. */
  sandId: Scalars['ID']['output'];
  /** The skills of the user. */
  skills: Array<Scalars['String']['output']>;
  skipPaywallReason?: Maybe<Scalars['String']['output']>;
  skipPaywallUntil?: Maybe<Scalars['DateTime']['output']>;
  socialLinks: SocialLinks;
  /** The tech work experience duration */
  techWorkExperienceDuration: Scalars['Int']['output'];
  /** The job title of this user */
  title?: Maybe<Scalars['String']['output']>;
  /** Top career goal (e.g. "become CEO of a company"). */
  topCareerGoal?: Maybe<Scalars['String']['output']>;
  /** The total work experience duration */
  totalWorkExperienceDuration: Scalars['Int']['output'];
  /** Date & time when the user was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The sandId of the user who last updated this user. */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Date & time when this user was last updated by an admin. */
  updatedByAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user who last updated this user. */
  updatedByUser?: Maybe<StaffUser>;
  /** The consents that user agreed to. */
  userConsent?: Maybe<UserConsent>;
  /** The WhatsApp phone number of this user. */
  whatsAppNumber?: Maybe<Scalars['String']['output']>;
  workExperience: Array<WorkExperience>;
};


export type StaffUserHubCheckInsArgs = {
  checkInDateSortOrder?: InputMaybe<Scalars['String']['input']>;
  checkInEndDate?: InputMaybe<Scalars['String']['input']>;
  checkInStartDate?: InputMaybe<Scalars['String']['input']>;
  hubNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type StaffUserNearbyHubArgs = {
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
};


export type StaffUserNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StaffUserSearchResult = {
  __typename?: 'StaffUserSearchResult';
  /** Whether there are more users available after the current page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether there are users available before the current page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The total number of users matching the search criteria */
  totalCount: Scalars['Int']['output'];
  /** The total number of pages based on the limit */
  totalPages: Scalars['Int']['output'];
  /** The list of users found in the search */
  users: Array<StaffUser>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<StringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAssessmentDetails = {
  __typename?: 'StudentAssessmentDetails';
  assessmentAdditionalSetAttempts?: Maybe<Scalars['Int']['output']>;
  assessmentDueDate?: Maybe<Scalars['DateTime']['output']>;
  assessmentId: Scalars['Int']['output'];
  assessmentName?: Maybe<Scalars['String']['output']>;
  assessmentPassMark?: Maybe<Scalars['Int']['output']>;
  assessmentStartDate?: Maybe<Scalars['DateTime']['output']>;
  assessmentStudentAttempts?: Maybe<Scalars['Int']['output']>;
  assessmentStudentScore?: Maybe<Scalars['Float']['output']>;
  assessmentStudentStatus?: Maybe<Scalars['Int']['output']>;
  assessmentStudentSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  assessmentType?: Maybe<Scalars['String']['output']>;
  athenaClassId?: Maybe<Scalars['Int']['output']>;
  athenaClassName?: Maybe<Scalars['String']['output']>;
  athenaEhubClassName?: Maybe<Scalars['String']['output']>;
  athenaProgrammeId?: Maybe<Scalars['Int']['output']>;
  athenaProgrammeName?: Maybe<Scalars['String']['output']>;
};

export type StudentAssessmentInput = {
  assessmentId: Scalars['Int']['input'];
  sandId: Scalars['ID']['input'];
};

export type StudentAssigned = {
  __typename?: 'StudentAssigned';
  studentAssignedClass?: Maybe<Scalars['Int']['output']>;
  studentAssignedEnrolled?: Maybe<Scalars['Int']['output']>;
  studentAssignedId?: Maybe<Scalars['ID']['output']>;
  studentAssignedUserId?: Maybe<Scalars['Int']['output']>;
};

export type StudentClass = {
  __typename?: 'StudentClass';
  studentClassISCurrent?: Maybe<Scalars['Int']['output']>;
  studentClassId?: Maybe<Scalars['Int']['output']>;
  studentClassName?: Maybe<Scalars['String']['output']>;
  studentClassProgrammeName?: Maybe<Scalars['String']['output']>;
  studentClassSlackChannel?: Maybe<Scalars['String']['output']>;
};

export type StudentEvaluationAssessmentDetails = {
  __typename?: 'StudentEvaluationAssessmentDetails';
  code?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  message?: Maybe<Scalars['String']['output']>;
  studentAssessmentDetails: Array<StudentAssessmentDetails>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type StudentInfoDetails = {
  __typename?: 'StudentInfoDetails';
  details?: Maybe<Array<Maybe<AthenaUserDetails>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type StudentProgramme = {
  __typename?: 'StudentProgramme';
  studentProgrammeAddedOnDate?: Maybe<Scalars['String']['output']>;
  studentProgrammeAdditionalAttempts?: Maybe<Scalars['Int']['output']>;
  studentProgrammeBugReporting?: Maybe<Scalars['Int']['output']>;
  studentProgrammeCategory?: Maybe<Scalars['Int']['output']>;
  studentProgrammeCourseDesigner?: Maybe<Scalars['Int']['output']>;
  studentProgrammeDescription?: Maybe<Scalars['String']['output']>;
  studentProgrammeId?: Maybe<Scalars['Int']['output']>;
  studentProgrammeIndividualContent?: Maybe<Scalars['Int']['output']>;
  studentProgrammeIsRecognition?: Maybe<Scalars['Boolean']['output']>;
  studentProgrammeIsSelfPaced?: Maybe<Scalars['Boolean']['output']>;
  studentProgrammeLessonBased?: Maybe<Scalars['Boolean']['output']>;
  studentProgrammeNameId?: Maybe<Scalars['String']['output']>;
  studentProgrammeNewPredicts?: Maybe<Scalars['Int']['output']>;
  studentProgrammeSetaAccredited?: Maybe<Scalars['Boolean']['output']>;
  studentProgrammeType?: Maybe<Scalars['Int']['output']>;
};

export type StudentProgrammeData = {
  __typename?: 'StudentProgrammeData';
  studentAssignedTo?: Maybe<Array<Maybe<StudentAssigned>>>;
  studentClasses?: Maybe<Array<Maybe<StudentClass>>>;
  studentProgrammes?: Maybe<Array<Maybe<StudentProgramme>>>;
  studentSprints?: Maybe<Array<Maybe<StudentSprint>>>;
  studentYears?: Maybe<Array<Maybe<StudentYear>>>;
};

export type StudentSprint = {
  __typename?: 'StudentSprint';
  sd_class?: Maybe<Scalars['Int']['output']>;
  sd_end_date?: Maybe<Scalars['String']['output']>;
  sd_id?: Maybe<Scalars['Int']['output']>;
  sd_phase?: Maybe<Scalars['Int']['output']>;
  sd_programme?: Maybe<Scalars['Int']['output']>;
  sd_release_date?: Maybe<Scalars['String']['output']>;
  sd_sprint?: Maybe<Scalars['Int']['output']>;
  sd_start_date?: Maybe<Scalars['String']['output']>;
};

export type StudentYear = {
  __typename?: 'StudentYear';
  yr_id?: Maybe<Scalars['Int']['output']>;
  yr_year?: Maybe<Scalars['String']['output']>;
};

export type SubmitAcademicConductAppealInput = {
  caseId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentName?: InputMaybe<Scalars['String']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  signature: Scalars['String']['input'];
};

export type SubmitAcademicConductAppealPayload = {
  __typename?: 'SubmitAcademicConductAppealPayload';
  academicConductCase: AcademicConductCaseLearnerView;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type TermGpa = {
  __typename?: 'TermGPA';
  /** The GPA value for this term. */
  gpa?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** The academic term identifier (e.g., "2026 Spring"). */
  term: Scalars['String']['output'];
};

export type TimeBucketUserCount = {
  __typename?: 'TimeBucketUserCount';
  timeBucket?: Maybe<Scalars['DateTime']['output']>;
  /** The index of the 15-minute time bucket starting from the Unix epoch (00:00:00 UTC on 1 January 1970). The first time bucket has index 0. */
  timeBucketIndex: Scalars['Int']['output'];
  /** Number of users active in this time bucket. */
  usersCount: Scalars['Int']['output'];
};

export enum TuitionFeePaymentType {
  BankTransfer = 'BANK_TRANSFER',
  DebitCard = 'DEBIT_CARD',
  Either = 'EITHER',
  No = 'NO'
}

export type UpdateBadgeDefinitionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  criteriaText?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BadgeDefinitionStatus>;
  templateConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateBadgeDefinitionPayload = {
  __typename?: 'UpdateBadgeDefinitionPayload';
  badgeDefinition: BadgeDefinition;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCancellationStatusInput = {
  cancellationStatus: CancellationStatus;
  paymentPlanId: Scalars['ID']['input'];
};

export type UpdateCertificateDefinitionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  criteriaText?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CertificateDefinitionStatus>;
  templateConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateCertificateDefinitionPayload = {
  __typename?: 'UpdateCertificateDefinitionPayload';
  certificateDefinition: CertificateDefinition;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCommsTemplateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  commsEvent?: InputMaybe<CommsTemplateEvent>;
  customProperties?: InputMaybe<Array<Scalars['String']['input']>>;
  dateType?: InputMaybe<CommsConditionTypeDateType>;
  id: Scalars['String']['input'];
  medium?: InputMaybe<CommsMediumType>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  planStatus?: InputMaybe<PaymentPlanStatus>;
  status?: InputMaybe<CommsTemplateStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCoverPhotoInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type UpdateCoverPhotoPayload = {
  __typename?: 'UpdateCoverPhotoPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type UpdateCvInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type UpdateCvPayload = {
  __typename?: 'UpdateCvPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type UpdateEducationInput = {
  /** The field of study for this education. */
  fieldOfStudy?: InputMaybe<Scalars['String']['input']>;
  /** True if the user graduated this education. */
  graduatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The id of the user education */
  id: Scalars['ID']['input'];
  /** The country of the institution. */
  institutionCountry?: InputMaybe<Scalars['String']['input']>;
  /** The county of the institution. */
  institutionCounty?: InputMaybe<Scalars['String']['input']>;
  /** The locality of the institution. */
  institutionLocality?: InputMaybe<Scalars['String']['input']>;
  /** The institution name of this education. */
  institutionName?: InputMaybe<Scalars['String']['input']>;
  /** An institution id from an external service. */
  knownInstitutionId?: InputMaybe<Scalars['String']['input']>;
  /** The level of study for this education. */
  levelOfStudy?: InputMaybe<Scalars['String']['input']>;
  /** The start date of the user education. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateEducationPayload = {
  __typename?: 'UpdateEducationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type UpdateInterestsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  interests: Array<Scalars['String']['input']>;
};

export type UpdateInterestsPayload = {
  __typename?: 'UpdateInterestsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type UpdateLanguageSkillInput = {
  /** The id of the language skill. */
  id: Scalars['ID']['input'];
  /** The language which the user knows. */
  language?: InputMaybe<LanguageEnum>;
  /** The proficiency level the user has in this language */
  proficiencyLevel?: InputMaybe<LanguageProficiencyLevel>;
};

export type UpdateNotificationSettingsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The notifications to be created. */
  notificationSettings: NotificationSettingsInput;
};

export type UpdateNotificationSettingsPayload = {
  __typename?: 'UpdateNotificationSettingsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The user whose notifications were marked as seen. */
  user: User;
};

/** Onboarding panel input. */
export type UpdateOnboardingPanelInput = {
  /** Did the user activate his profile. */
  activatedProfile?: InputMaybe<Scalars['DateTime']['input']>;
  /** Did the user explore community and engage. */
  exploredAndEngagedWithCommunity?: InputMaybe<Scalars['DateTime']['input']>;
  /** Did the user watch the onboarding video. */
  watchedOnboardingVideo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Did the user watch the welcome video. */
  watchedWelcomeVideo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdatePaymentPlanDatesInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  nextInstalmentDate?: InputMaybe<Scalars['String']['input']>;
  nextPaymentDate?: InputMaybe<Scalars['String']['input']>;
  paymentPlanId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePaymentPlanDefinitionInput = {
  daysOfGrace?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProfilePhotoInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type UpdateProfilePhotoPayload = {
  __typename?: 'UpdateProfilePhotoPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type UpdateProgramApplicationEnglishProficiencyProofInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  /** The type of english proficiency proof provided. */
  type?: InputMaybe<EnglishProficiencyType>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProgramApplicationEnglishProficiencyProofPayload = {
  __typename?: 'UpdateProgramApplicationEnglishProficiencyProofPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  programApplication: ProgramApplication;
};

export type UpdateProgramApplicationHighSchoolCertificateInput = {
  /** The city where the school is located. */
  city: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The country where the school is located. */
  country: Scalars['String']['input'];
  /** The month and year of graduation. */
  graduationDate: Scalars['DateTime']['input'];
  /** The id of the program application. */
  programApplicationId: Scalars['ID']['input'];
  /** The qualification obtained. */
  qualification: Scalars['String']['input'];
  /** The address of the school. */
  schoolAddress: Scalars['String']['input'];
  /** The name of the school. */
  schoolName: Scalars['String']['input'];
  /** The state where the school is located. */
  state: Scalars['String']['input'];
};

export type UpdateProgramApplicationHighSchoolCertificatePayload = {
  __typename?: 'UpdateProgramApplicationHighSchoolCertificatePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  highSchoolCertificate: HighSchoolCertificate;
};

export type UpdateRefugeeCardInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type UpdateRefugeeCardPayload = {
  __typename?: 'UpdateRefugeeCardPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type UpdateSkillsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  skills: Array<Scalars['String']['input']>;
};

export type UpdateSkillsPayload = {
  __typename?: 'UpdateSkillsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type UpdateUserConsentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  communityExpectationsConsentAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailStorageConsentAt?: InputMaybe<Scalars['DateTime']['input']>;
  infoAccuracyConsentAt?: InputMaybe<Scalars['DateTime']['input']>;
  marketingConsentAt?: InputMaybe<Scalars['DateTime']['input']>;
  paymentPolicyConsentAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateUserConsentPayload = {
  __typename?: 'UpdateUserConsentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userConsent: UserConsent;
};

export type UpdateUserInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The home country of the user. */
  countryOfOrigin?: InputMaybe<Scalars['String']['input']>;
  /** The residence country of the user. */
  countryOfResidence?: InputMaybe<Scalars['String']['input']>;
  /** The home county of the user. */
  countyOfOrigin?: InputMaybe<Scalars['String']['input']>;
  /** The residence county of the user. */
  countyOfResidence?: InputMaybe<Scalars['String']['input']>;
  /** Does the user have a disability? */
  disability?: InputMaybe<Disability>;
  /** The type of employment, e.g. full time or part time, etc. */
  employmentType?: InputMaybe<EmploymentTypeEnum>;
  facebookURL?: InputMaybe<Scalars['String']['input']>;
  /** The field of study at the institution [ Mathematics, Agriculture,…]. */
  fieldOfStudy?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  githubUrl?: InputMaybe<Scalars['String']['input']>;
  /** The current guardianship of the user. */
  guardianship?: InputMaybe<Guardianship>;
  /** The highest level of education [high school, bachelors, master’s,…]. */
  highestLevelOfStudy?: InputMaybe<Scalars['String']['input']>;
  /** Household monthly income in USD. */
  householdMonthlyIncomeUSD?: InputMaybe<Scalars['Int']['input']>;
  /** Is the user in a humanitarian status situation? (Yes, No, Prefer not to answer). */
  humanitarianStatus?: InputMaybe<HumanitarianStatus>;
  /** Which type of humanitarian status situation? (Refugee, Asylum seeker, Not Applicable, etc). */
  humanitarianStatusType?: InputMaybe<HumanitarianStatusType>;
  isEmployed?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedInURL?: InputMaybe<Scalars['String']['input']>;
  /** Current living circumstances (Homeless, Shelter, Prefer not to say, etc). */
  livingCircumstances?: InputMaybe<LivingCircumstances>;
  /** The home locality of the user. */
  localityOfOrigin?: InputMaybe<Scalars['String']['input']>;
  /** The residence locality of the user. */
  localityOfResidence?: InputMaybe<Scalars['String']['input']>;
  /** Current location description (Urban, Rural, Prefer not to say). */
  locationDescription?: InputMaybe<LocationDescription>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** If the user is open to new positions. */
  openToNewPositions?: InputMaybe<Scalars['Boolean']['input']>;
  /** The phone number of this user. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** A list of descriptions or urls (e.g. github repos, apps made by the user, etc). */
  portfolioAndProjects?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Has this user been enrolled in ALX programs in the past, including using other accounts. */
  previouslyEnrolledInALX?: InputMaybe<Scalars['Boolean']['input']>;
  tikTokUrl?: InputMaybe<Scalars['String']['input']>;
  /** The job title of this user. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Top career goal (e.g. "become CEO of a company"). */
  topCareerGoal?: InputMaybe<Scalars['String']['input']>;
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
  /** The WhatsApp phone number of this user. */
  whatsAppNumber?: InputMaybe<Scalars['String']['input']>;
  youtubeUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type UpdateWorkExperienceInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The updated work experience */
  workExperience: WorkExperienceUpdateInput;
};

export type UpdateWorkExperiencePayload = {
  __typename?: 'UpdateWorkExperiencePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated user */
  user: User;
};

export enum UploadScope {
  BadgeImage = 'badgeImage',
  ConductCaseDocument = 'conductCaseDocument',
  CoverPhoto = 'coverPhoto',
  Cv = 'cv',
  DashboardCoverPhoto = 'dashboardCoverPhoto',
  EnglishProficiencyDocument = 'englishProficiencyDocument',
  ProfilePhoto = 'profilePhoto',
  RefugeeCard = 'refugeeCard'
}

/** A user */
export type User = {
  __typename?: 'User';
  /** The user's active status. */
  active: Scalars['Boolean']['output'];
  athenaStudentInfo?: Maybe<AthenaStudentInfo>;
  athenaUserId?: Maybe<Scalars['Int']['output']>;
  athenaUserIsDeleted?: Maybe<Scalars['Int']['output']>;
  athenaUserName?: Maybe<Scalars['String']['output']>;
  athenaUserType?: Maybe<Scalars['Int']['output']>;
  availablePrograms?: Maybe<Array<Program>>;
  /** The bio of the user. */
  bio?: Maybe<Scalars['String']['output']>;
  /** The date & time of birth for the user. */
  birthDate?: Maybe<Scalars['DateTime']['output']>;
  /** Hub names of user's checkIns. */
  checkInsHubNames: Array<Scalars['String']['output']>;
  /** The home country of the user. */
  countryOfOrigin?: Maybe<Scalars['String']['output']>;
  /** The residence country of the user. */
  countryOfResidence?: Maybe<Scalars['String']['output']>;
  /** The home county of the user. */
  countyOfOrigin?: Maybe<Scalars['String']['output']>;
  /** The residence county of the user. */
  countyOfResidence?: Maybe<Scalars['String']['output']>;
  /** The cover photo of the user. */
  coverPhoto?: Maybe<Scalars['String']['output']>;
  currentCheckIn?: Maybe<HubCheckIn>;
  /** The latest CV of the user. */
  cv?: Maybe<Scalars['String']['output']>;
  /** Does the user have a disability? */
  disability?: Maybe<Disability>;
  educationHistory?: Maybe<Array<Education>>;
  /** The user's email address. */
  email: Scalars['String']['output'];
  /** The type of employment, e.g. full time or part time, etc. */
  employmentType?: Maybe<EmploymentTypeEnum>;
  enrollmentFeatureAccess: EnrollmentFeatureAccess;
  /** The field of study at the institution [ Mathematics, Agriculture,…]. */
  fieldOfStudy?: Maybe<Scalars['String']['output']>;
  /** The first name of the user. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The gender of the user. */
  gender?: Maybe<Gender>;
  /** The current guardianship of the user. */
  guardianship?: Maybe<Guardianship>;
  /** The level of education [high school, bachelors, master’s,…]. */
  highestLevelOfStudy?: Maybe<Scalars['String']['output']>;
  /** Household monthly income in USD. */
  householdMonthlyIncomeUSD?: Maybe<Scalars['Int']['output']>;
  hubCheckInCode: HubCheckInCode;
  /** The paginated list of user's hub checkins. checkInStartDate and checkInEndDate should have 'yyyy-mm-dd' format. checkInDateSortOrder should be either 'asc' or 'desc' */
  hubCheckIns?: Maybe<PaginatedHubCheckIns>;
  hubCheckOutCode: HubCheckOutCode;
  /** Is the user in a humanitarian status situation? (Yes, No, Prefer not to answer). */
  humanitarianStatus?: Maybe<HumanitarianStatus>;
  /** Which type of humanitarian status situation? (Refugee, Asylum seeker, Not Applicable, etc). */
  humanitarianStatusType?: Maybe<HumanitarianStatusType>;
  /** The interests of the user. */
  interests: Array<Scalars['String']['output']>;
  /** Whether this user currently has an active impersonation session. */
  isCurrentlyImpersonated: Scalars['Boolean']['output'];
  /** Indicates if the user is currently employed or unemployed. */
  isEmployed?: Maybe<Scalars['Boolean']['output']>;
  issuedBadges: Array<IssuedBadge>;
  /** User's language skills. */
  languages: Array<LanguageSkill>;
  /** The middle name of the user. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Current living circumstances (Homeless, Shelter, Prefer not to say, etc). */
  livingCircumstances?: Maybe<LivingCircumstances>;
  /** The home locality of the user. */
  localityOfOrigin?: Maybe<Scalars['String']['output']>;
  /** The residence locality of the user. */
  localityOfResidence?: Maybe<Scalars['String']['output']>;
  /** Current location description (Urban, Rural, Prefer not to say). */
  locationDescription?: Maybe<LocationDescription>;
  /** The middle name of the user. */
  middleName?: Maybe<Scalars['String']['output']>;
  nearbyHub?: Maybe<Hub>;
  notificationSettings?: Maybe<NotificationSettings>;
  /** The list of notifications for this user */
  notifications: NotificationConnection;
  onboardingPanel?: Maybe<OnboardingPanel>;
  /** If the user is open to new positions. */
  openToNewPositions?: Maybe<Scalars['Boolean']['output']>;
  paymentDashboardUrl?: Maybe<Scalars['String']['output']>;
  paymentPlans: Array<PaymentPlan>;
  payments: Array<Payment>;
  /** The phone number of this user. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** A list of descriptions or urls (e.g. github repos, apps made by the user, etc). */
  portfolioAndProjects: Array<Scalars['String']['output']>;
  /** Has this user been enrolled in ALX programs in the past, including using other accounts. */
  previouslyEnrolledInALX?: Maybe<Scalars['Boolean']['output']>;
  /** The primary email of the user. */
  primaryEmail: Scalars['String']['output'];
  /** The profile picture of the user. */
  profilePhoto?: Maybe<Scalars['String']['output']>;
  programApplications: Array<ProgramApplication>;
  programEnrollments: Array<ProgramEnrollment>;
  /** Shareable referral URL for this user. */
  referralLink?: Maybe<Scalars['String']['output']>;
  referralsMade: Array<Referral>;
  referredBy?: Maybe<Referral>;
  /** The latest refugeeCard of the user. */
  refugeeCard?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for this person within the Sand Ecosystem. */
  sandId?: Maybe<Scalars['ID']['output']>;
  /** The user's unique identifier. */
  savannaId: Scalars['ID']['output'];
  /** The skills of the user. */
  skills: Array<Scalars['String']['output']>;
  skipPaywallUntil?: Maybe<Scalars['DateTime']['output']>;
  socialLinks: SocialLinks;
  /** The tech work experience duration */
  techWorkExperienceDuration: Scalars['Int']['output'];
  /** The job title of this user */
  title?: Maybe<Scalars['String']['output']>;
  /** Top career goal (e.g. "become CEO of a company"). */
  topCareerGoal?: Maybe<Scalars['String']['output']>;
  /** The total work experience duration */
  totalWorkExperienceDuration: Scalars['Int']['output'];
  /** The consents that user agreed to. */
  userConsent?: Maybe<UserConsent>;
  /** The user's curriculum statuses. */
  userCurriculumStatuses?: Maybe<Array<UserCurriculumStatus>>;
  /** The WhatsApp phone number of this user. */
  whatsAppNumber?: Maybe<Scalars['String']['output']>;
  workExperience: Array<WorkExperience>;
};


/** A user */
export type UserHubCheckInsArgs = {
  checkInDateSortOrder?: InputMaybe<Scalars['String']['input']>;
  checkInEndDate?: InputMaybe<Scalars['String']['input']>;
  checkInStartDate?: InputMaybe<Scalars['String']['input']>;
  hubNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


/** A user */
export type UserNearbyHubArgs = {
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
};


/** A user */
export type UserNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserActivity = {
  __typename?: 'UserActivity';
  /** Date & time when the user activity was on android. */
  androidActivityAt?: Maybe<Scalars['DateTime']['output']>;
  /** City where the user made a request from. */
  city?: Maybe<Scalars['String']['output']>;
  /** Country where the user made a request from. */
  country?: Maybe<Scalars['String']['output']>;
  /** Country name where the user made a request from. */
  countryName?: Maybe<Scalars['String']['output']>;
  /** Country region where the user made a request from. */
  countryRegion?: Maybe<Scalars['String']['output']>;
  /** Country region name where the user made a request from. */
  countryRegionName?: Maybe<Scalars['String']['output']>;
  /** Date & time when the user activity was initially created. */
  createdAt: Scalars['DateTime']['output'];
  /** Date & time when the user activity was on desktop. */
  desktopActivityAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date & time when the user activity was on ios. */
  iosActivityAt?: Maybe<Scalars['DateTime']['output']>;
  /** Ip address where the user made a request from. */
  ipAddress?: Maybe<Scalars['String']['output']>;
  /** Latitude where the user made a request from. */
  latitude?: Maybe<Scalars['String']['output']>;
  /** Longitude where the user made a request from. */
  longitude?: Maybe<Scalars['String']['output']>;
  /** Metro code where the user made a request from. Only present for US requests */
  metroCode?: Maybe<Scalars['String']['output']>;
  /** Date & time when the user activity was on mobile. */
  mobileActivityAt?: Maybe<Scalars['DateTime']['output']>;
  /** Postal code where the user made a request from. */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** The sandId of the user of this activity. */
  sandId: Scalars['String']['output'];
  /** Date & time when the user activity was on smart tv. */
  smartTvActivityAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date & time when the user activity was on tablet. */
  tabletActivityAt?: Maybe<Scalars['DateTime']['output']>;
  /** The index of the 15-minute time bucket starting from the Unix epoch (00:00:00 UTC on 1 January 1970). The first time bucket has index 0. */
  timeBucketIndex: Scalars['Int']['output'];
  /** Time zone where the user made a request from. */
  timeZone?: Maybe<Scalars['String']['output']>;
  /** Date & time when the user activity was updated. */
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  /** User agent where the user made a request from. */
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type UserAttributes = {
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  /** Use either of the below to find user info */
  sandId: Scalars['String']['input'];
};

export type UserConsent = {
  __typename?: 'UserConsent';
  communityExpectationsConsentAt?: Maybe<Scalars['DateTime']['output']>;
  emailStorageConsentAt?: Maybe<Scalars['DateTime']['output']>;
  infoAccuracyConsentAt?: Maybe<Scalars['DateTime']['output']>;
  marketingConsentAt?: Maybe<Scalars['DateTime']['output']>;
  paymentPolicyConsentAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A user's curriculum status. */
export type UserCurriculumStatus = {
  __typename?: 'UserCurriculumStatus';
  /** The user's batch. */
  batch: Batch;
  /** The user's curriculum. */
  curriculum: Curriculum;
  /** The user's curriculum status unique identifier. */
  id: Scalars['ID']['output'];
  /** The user's learner. */
  learner: User;
  /** The user's curriculum status notes. */
  notes?: Maybe<Scalars['String']['output']>;
  /** The user's curriculum status. */
  status: Scalars['String']['output'];
};

export enum UserRoleEnum {
  Student = 'Student'
}

export type UserStats = {
  __typename?: 'UserStats';
  /** All active in users in every 15-minute time bucket in the last 24 hours  */
  activeUsersByTimeBucket: Array<TimeBucketUserCount>;
  /** The current index of the 15-minute time bucket starting from the Unix epoch (00:00:00 UTC on 1 January 1970). The first time bucket has index 0. */
  currentTimeBucketIndex: Scalars['Int']['output'];
  /** Total number of active users in the last 7 days. */
  last7DaysActive: Scalars['Int']['output'];
  /** How many active users were in the current week compared to last week as percentage */
  last7DaysActiveDiffPercentage: Scalars['Float']['output'];
  /** Total number of active users in the last 24 hours. */
  lastDayActive: Scalars['Int']['output'];
  /** How many active users were in the current day compared to last day as percentage */
  lastDayActiveDiffPercentage: Scalars['Float']['output'];
  /** Total number of active users in the last 15 minutes. */
  lastTimeBucketActive: Scalars['Int']['output'];
  /** How many active users were in the current completed time bucket compared to previous time bucket as percentage */
  lastTimeBucketActiveDiffPercentage: Scalars['Float']['output'];
  /** The last 10 most recent active users. */
  recentUsers: Array<UserActivity>;
  /** Total number of users across all time. */
  totalUsersCount: Scalars['Int']['output'];
  /** How many users are new in the last month in percentage. */
  totalUsersCountDiffPercentage: Scalars['Float']['output'];
};

export type WithdrawFromProgramInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The program enrollment id. */
  programEnrollmentId: Scalars['ID']['input'];
  /** The description why the student was withdrawn from the program. */
  withdrawalDescription?: InputMaybe<Scalars['String']['input']>;
  /** The reason category why the student was withdrawn from the program */
  withdrawalReason: DeferralReason;
};

export type WithdrawFromProgramPayload = {
  __typename?: 'WithdrawFromProgramPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The program enrollment. */
  programEnrollment: ProgramEnrollment;
};

export type WorkExperience = {
  __typename?: 'WorkExperience';
  /** The name of the company for which the person worked */
  companyName: Scalars['String']['output'];
  /** The country where this job is performed */
  country?: Maybe<Scalars['String']['output']>;
  /** The county where this job is performed */
  county?: Maybe<Scalars['String']['output']>;
  /** Creation datetime */
  createdAt: Scalars['DateTime']['output'];
  /** Description, up to 1024 characters */
  description?: Maybe<Scalars['String']['output']>;
  /** The type of employment, e.g. full time, part time, etc */
  employmentType: EmploymentTypeEnum;
  /** End date (month + year) of the employment, optional if isOngoing is true */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the work experience */
  id: Scalars['ID']['output'];
  /** Is this a technical job. Useful for determining the technical experience of the user separate from his total work experience. */
  isInTech: Scalars['Boolean']['output'];
  /** Is the person still working at this job at the present moment */
  isOngoing: Scalars['Boolean']['output'];
  /** The locality where this job is performed */
  locality?: Maybe<Scalars['String']['output']>;
  /** Start date (month + year) of the employment */
  startDate: Scalars['DateTime']['output'];
  /** Job title */
  title: Scalars['String']['output'];
  /** The last time this object was updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type WorkExperienceCreateInput = {
  /** The name of the company for which the person worked */
  companyName: Scalars['String']['input'];
  /** The country where this job is performed */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Description, up to 1024 characters */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The type of employment, e.g. full time, part time, etc */
  employmentType: EmploymentTypeEnum;
  /** End date (month + year) of the employment, optional if isOngoing is true */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Is this a technical job. Useful for determining the technical experience of the user separate from his total work experience. */
  isInTech: Scalars['Boolean']['input'];
  /** Is the person still working at this job at the present moment */
  isOngoing: Scalars['Boolean']['input'];
  /** The locality where this job is performed */
  locality?: InputMaybe<Scalars['String']['input']>;
  /** Start date (month + year) of the employment */
  startDate: Scalars['DateTime']['input'];
  /** Job title */
  title: Scalars['String']['input'];
};

export type WorkExperienceDeleteInput = {
  /** The id of the work experience */
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type WorkExperienceUpdateInput = {
  /** The name of the company for which the person worked */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** The country where this job is performed */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Description, up to 1024 characters */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The type of employment, e.g. full time, part time, etc */
  employmentType?: InputMaybe<EmploymentTypeEnum>;
  /** End date (month + year) of the employment, optional if isOngoing is true */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The id of the work experience */
  id: Scalars['ID']['input'];
  /** Is this a technical job. Useful for determining the technical experience of the user separate from his total work experience. */
  isInTech?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is the person still working at this job at the present moment */
  isOngoing?: InputMaybe<Scalars['Boolean']['input']>;
  /** The locality where this job is performed */
  locality?: InputMaybe<Scalars['String']['input']>;
  /** Start date (month + year) of the employment */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Job title */
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum Join__Graph {
  AccountSubgraph = 'ACCOUNT_SUBGRAPH',
  Athena = 'ATHENA',
  LegacyPointsSubgraph = 'LEGACY_POINTS_SUBGRAPH',
  Payments = 'PAYMENTS',
  Savanna = 'SAVANNA'
}

export enum Link__Purpose {
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  Execution = 'EXECUTION',
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  Security = 'SECURITY'
}

export type AdminViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminViewerQuery = { __typename?: 'Query', staffViewer: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null, primaryEmail: string, profilePhoto?: string | null, permissions: Array<Permission>, availableDashboards: Array<{ __typename?: 'Dashboard', createdAt: any, id: string, name: string, updatedAt: any }> } };

export type AdminCheckSavannaStatusQueryVariables = Exact<{
  sandId: Scalars['ID']['input'];
}>;


export type AdminCheckSavannaStatusQuery = { __typename?: 'Query', adminGetUserDetails?: { __typename?: 'User', sandId?: string | null, userCurriculumStatuses?: Array<{ __typename?: 'UserCurriculumStatus', status: string, batch: { __typename?: 'Batch', id: string, name: string }, curriculum: { __typename?: 'Curriculum', id: string, name: string } }> | null } | null };

export type AdminGetAvailableProgramsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminGetAvailableProgramsQuery = { __typename?: 'Query', adminGetAvailablePrograms: Array<{ __typename?: 'AdminProgramView', id: string, name: string, version: string, abbreviation: string, maxTermCredits: number, minTermCredits: number, addDropPeriodDays: number, description?: string | null, hasMultiCourseDisplay: boolean, allowsConcurrentEnrollments: boolean, hasCircleSupport: boolean, hasAnswerbaseSupport: boolean, hasCheckInSupport: boolean, openToEnrollments?: boolean | null, marketing: { __typename?: 'ProgramMarketing', timeCommitment?: string | null, video?: string | null, thumbnail?: string | null, highlights: Array<string>, title?: string | null, subtitle?: string | null, sectionTitle?: string | null, sectionSummary?: string | null, accessFee?: string | null, programDuration?: string | null } }> };

export type AdminGetUniversityProgramsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminGetUniversityProgramsQuery = { __typename?: 'Query', adminGetAvailablePrograms: Array<{ __typename?: 'AdminProgramView', id: string, name: string, abbreviation: string, isUniversityProgram: boolean }> };

export type AdminGetProgramsWithCoursesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminGetProgramsWithCoursesQuery = { __typename?: 'Query', adminGetAvailablePrograms: Array<{ __typename?: 'AdminProgramView', id: string, name: string, version: string, abbreviation: string, maxTermCredits: number, minTermCredits: number, addDropPeriodDays: number, description?: string | null, hasMultiCourseDisplay: boolean, allowsConcurrentEnrollments: boolean, hasCircleSupport: boolean, hasAnswerbaseSupport: boolean, hasCheckInSupport: boolean, openToEnrollments?: boolean | null, linkedProgramCourses: Array<{ __typename?: 'AdminProgramCourseView', id: string, name: string, priority: number, credits: number, courseDefinition: { __typename?: 'AdminCourseDefinitionView', id: string, name: string, abbreviation: string, description?: string | null, classes: Array<{ __typename?: 'AdminClassView', id: string, name: string, startDate?: any | null, endDate?: any | null, finished: boolean, cohortKey?: string | null, enrollmentCounts: Array<{ __typename?: 'ClassEnrollmentStatusCount', status: ClassEnrollmentStatus, count: number }>, lmsClassLocations: Array<{ __typename?: 'AdminLmsClassLocationView', id: string, name: string, learningPlatform?: LearningPlatform | null, lmsCohortId?: string | null, lmsCourseId: string } | null> }> }, mustHavePrerequisites: Array<{ __typename?: 'AdminCourseDefinitionView', id: string, name: string, abbreviation: string }>, oneOfPrerequisites: Array<{ __typename?: 'AdminCourseDefinitionView', id: string, name: string, abbreviation: string }>, doneWithPrerequisites: Array<{ __typename?: 'AdminCourseDefinitionView', id: string, name: string, abbreviation: string }> }> }> };

export type AdminGetAvailableCoursesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminGetAvailableCoursesQuery = { __typename?: 'Query', adminGetAvailableCourses: Array<{ __typename?: 'AdminCourseDefinitionView', id: string, name: string, abbreviation: string, category?: CourseCategory | null }> };

export type AdminGetCoursesWithClassesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminGetCoursesWithClassesQuery = { __typename?: 'Query', adminGetAvailableCourses: Array<{ __typename?: 'AdminCourseDefinitionView', id: string, name: string, abbreviation: string, category?: CourseCategory | null, description?: string | null, classes: Array<{ __typename?: 'AdminClassView', id: string, name: string, startDate?: any | null, endDate?: any | null, finished: boolean, enrollmentCounts: Array<{ __typename?: 'ClassEnrollmentStatusCount', status: ClassEnrollmentStatus, count: number }>, lmsClassLocations: Array<{ __typename?: 'AdminLmsClassLocationView', id: string, name: string, learningPlatform?: LearningPlatform | null } | null> }> }> };

export type AdminGetClassDetailsQueryVariables = Exact<{
  classId: Scalars['ID']['input'];
}>;


export type AdminGetClassDetailsQuery = { __typename?: 'Query', adminGetClassDetails?: { __typename?: 'AdminClassView', id: string, name: string, proofOfCompletionType: ProofOfCompletionType, startDate?: any | null, endDate?: any | null, course: { __typename?: 'AdminCourseDefinitionView', id: string, abbreviation: string, name: string }, lmsClassLocations: Array<{ __typename?: 'AdminLmsClassLocationView', id: string, name: string, learningPlatform?: LearningPlatform | null, lmsCourseId: string, lmsCohortId?: string | null, courseLink: string, preferredCountryOfResidence?: string | null, preferredHub?: string | null } | null> } | null };

export type AdminGetCohortDetailsQueryVariables = Exact<{
  cohortId: Scalars['ID']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchString?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminGetCohortDetailsQuery = { __typename?: 'Query', adminGetCohortDetails?: { __typename?: 'AdminCohortView', id: string, name: string, paginatedCohortEnrollments: { __typename?: 'AdminPaginatedProgramEnrollments', pageNumber: number, pageSize: number, totalCount: number, totalPages: number, programEnrollments: Array<{ __typename?: 'AdminProgramEnrollmentView', id: string, status?: ProgramEnrollmentStatus | null, user: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, middleName?: string | null, lastName?: string | null, primaryEmail: string } }> }, program: { __typename?: 'AdminProgramView', id: string, name: string } } | null };

export type AdminGetCourseDetailsQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type AdminGetCourseDetailsQuery = { __typename?: 'Query', adminGetCourseDetails?: { __typename?: 'AdminCourseDefinitionView', id: string, name: string, abbreviation: string, category?: CourseCategory | null, description?: string | null, programs: Array<{ __typename?: 'AdminProgramView', id: string, name: string, abbreviation: string }>, classes: Array<{ __typename?: 'AdminClassView', id: string, name: string, finished: boolean, startDate?: any | null, endDate?: any | null }> } | null };

export type AdminSearchPaginatedClassEnrollmentsQueryVariables = Exact<{
  classId: Scalars['String']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchString?: InputMaybe<Scalars['String']['input']>;
  showSelfReported?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AdminSearchPaginatedClassEnrollmentsQuery = { __typename?: 'Query', adminSearchPaginatedClassEnrollments: { __typename?: 'AdminPaginatedClassEnrollments', pageNumber: number, pageSize: number, totalCount: number, totalPages: number, classEnrollments?: Array<{ __typename?: 'AdminClassEnrollmentView', id: string, status?: ClassEnrollmentStatus | null, cancelled: boolean, createdAt: any, failedAt?: any | null, graduatedAt?: any | null, class: { __typename?: 'AdminClassView', id: string, proofOfCompletionType: ProofOfCompletionType }, courseEnrollment: { __typename?: 'AdminCourseEnrollmentView', course: { __typename?: 'AdminCourseDefinitionView', name: string } }, proofOfCompletion?: { __typename?: 'AdminProofOfCompletionView', email?: string | null, examScore?: number | null, examValidationNumber?: string | null, firstName?: string | null, lastName?: string | null, trailblazerProfileLink?: string | null, examStatement?: ExamStatementType | null, updatedAt?: any | null } | null, user: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null, profilePhoto?: string | null } }> | null } };

export type AdminGetPaginatedUsersQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchString?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminGetPaginatedUsersQuery = { __typename?: 'Query', adminGetPaginatedUsers: { __typename?: 'PaginatedStaffUsers', pageNumber: number, pageSize: number, totalCount: number, totalPages: number, users?: Array<{ __typename?: 'StaffUser', sandId: string, firstName?: string | null, middleName?: string | null, lastName?: string | null, primaryEmail: string, profilePhoto?: string | null }> | null } };

export type AdminGetProgramDetailsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type AdminGetProgramDetailsQuery = { __typename?: 'Query', adminGetProgramDetails?: { __typename?: 'AdminProgramView', id: string, name: string, abbreviation: string, version: string, maxTermCredits: number, minTermCredits: number, addDropPeriodDays: number, description?: string | null, hasMultiCourseDisplay: boolean, allowsConcurrentEnrollments: boolean, hasCircleSupport: boolean, hasAnswerbaseSupport: boolean, hasCheckInSupport: boolean, isUniversityProgram: boolean, openToEnrollments?: boolean | null, marketing: { __typename?: 'ProgramMarketing', timeCommitment?: string | null, video?: string | null, thumbnail?: string | null, highlights: Array<string>, title?: string | null, subtitle?: string | null, sectionTitle?: string | null, sectionSummary?: string | null, accessFee?: string | null, programDuration?: string | null }, cohorts: Array<{ __typename?: 'AdminCohortView', id: string, name: string }>, linkedProgramCourses: Array<{ __typename?: 'AdminProgramCourseView', id: string, name: string, createdAt: any, updatedAt: any, priority: number, credits: number, maxDeferrals: number, maxRetakes: number, program: { __typename?: 'AdminProgramView', id: string, name: string }, courseDefinition: { __typename?: 'AdminCourseDefinitionView', id: string, name: string, abbreviation: string, description?: string | null, createdAt: any, updatedAt: any, category?: CourseCategory | null, programs: Array<{ __typename?: 'AdminProgramView', id: string, name: string, abbreviation: string }>, linkedProgramCourses: Array<{ __typename?: 'AdminProgramCourseView', id: string, name: string, priority: number, credits: number }>, classes: Array<{ __typename?: 'AdminClassView', id: string }> }, mustHavePrerequisites: Array<{ __typename?: 'AdminCourseDefinitionView', id: string, name: string, abbreviation: string }>, oneOfPrerequisites: Array<{ __typename?: 'AdminCourseDefinitionView', id: string, name: string, abbreviation: string }>, doneWithPrerequisites: Array<{ __typename?: 'AdminCourseDefinitionView', id: string, name: string, abbreviation: string }> }> } | null };

export type AdminGetProgramApplicationsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchString?: InputMaybe<Scalars['String']['input']>;
  englishProficiencyStatus?: InputMaybe<Array<InputMaybe<EnglishProficiencyStatus>> | InputMaybe<EnglishProficiencyStatus>>;
  highSchoolVerificationMode?: InputMaybe<Array<HighSchoolVerificationMode> | HighSchoolVerificationMode>;
  personaIdentityInquiryLifecycleStatus?: InputMaybe<Array<PersonaInquiryLifecycleStatus> | PersonaInquiryLifecycleStatus>;
  personaIdentityInquiryDecisionStatus?: InputMaybe<Array<PersonaInquiryDecisionStatus> | PersonaInquiryDecisionStatus>;
  highSchoolCertificateStatus?: InputMaybe<Array<HighSchoolCertificateStatus> | HighSchoolCertificateStatus>;
  personaHighschoolInquiryLifecycleStatus?: InputMaybe<Array<PersonaInquiryLifecycleStatus> | PersonaInquiryLifecycleStatus>;
  personaHighschoolInquiryDecisionStatus?: InputMaybe<Array<PersonaInquiryDecisionStatus> | PersonaInquiryDecisionStatus>;
  partnershipType?: InputMaybe<Array<PartnershipType> | PartnershipType>;
  admissionStatus?: InputMaybe<Array<ProgramApplicationAdmissionStatus> | ProgramApplicationAdmissionStatus>;
}>;


export type AdminGetProgramApplicationsQuery = { __typename?: 'Query', adminGetProgramDetails?: { __typename?: 'AdminProgramView', id: string, paginatedProgramApplications: { __typename?: 'AdminPaginatedProgramApplications', pageNumber: number, pageSize: number, totalCount: number, totalPages: number, programApplications: Array<{ __typename?: 'AdminProgramApplicationView', englishProficiencyFile?: string | null, englishProficiencyStatus: EnglishProficiencyStatus, englishProficiencyType?: EnglishProficiencyType | null, id: string, createdAt: any, status: ProgramApplicationStatus, highSchoolVerificationMode: HighSchoolVerificationMode, admissionStatus: ProgramApplicationAdmissionStatus, partnershipType: PartnershipType, partnershipAcademicStanding?: string | null, partnershipPaymentStatus?: string | null, feePaymentMode?: FeePaymentMode | null, otherFeePaymentMode?: string | null, tuitionFeePaymentType?: TuitionFeePaymentType | null, anticipateChallenges?: boolean | null, additionalInfo?: string | null, sharePersonalDataConsent?: boolean | null, partnership?: { __typename?: 'AdminPartnership', id: string, name: string, paymentPlanId: string } | null, docusignEnrollmentAgreement?: { __typename?: 'AdminDocusignEnrollmentAgreement', envelopeId: string, envelopeStatus?: string | null, applicantStatus?: string | null, envelopeCompletedAt?: any | null, envelopeDeclinedAt?: any | null, envelopeVoidedAt?: any | null, envelopeSentAt?: any | null, envelopeDeliveredAt?: any | null, applicantCompletedAt?: any | null, applicantDeclinedAt?: any | null, applicantDeliveredAt?: any | null } | null, programEnrollment: { __typename?: 'AdminProgramEnrollmentView', id: string, status?: ProgramEnrollmentStatus | null, paymentPlan?: { __typename?: 'PaymentPlan', paymentPlanId: string } | null }, highSchoolCertificate?: { __typename?: 'AdminHighSchoolCertificate', id: string, status: HighSchoolCertificateStatus, schoolName: string, country: string, city: string, state: string, graduationDate: any, schoolAddress: string, qualification: string, createdAt: any, updatedAt: any } | null, personaHighschoolInquiry?: { __typename?: 'AdminPersonaInquiry', id: string, createdAt: any, updatedAt: any, type: PersonaInquiryType, inquiryTemplateId: string, accountId?: string | null, verificationId?: string | null, verificationLink?: string | null, lastEventId?: string | null, lastEventTimestamp?: any | null, lifecycleStatus: PersonaInquiryLifecycleStatus, decisionStatus: PersonaInquiryDecisionStatus, createdStatusAt?: any | null, pendingStatusAt?: any | null, completedStatusAt?: any | null, failedStatusAt?: any | null, expiredStatusAt?: any | null, approvedStatusAt?: any | null, declinedStatusAt?: any | null, needsReviewStatusAt?: any | null } | null, personaIdentityInquiry?: { __typename?: 'AdminPersonaInquiry', id: string, createdAt: any, updatedAt: any, type: PersonaInquiryType, inquiryTemplateId: string, accountId?: string | null, verificationId?: string | null, verificationLink?: string | null, lastEventId?: string | null, lastEventTimestamp?: any | null, lifecycleStatus: PersonaInquiryLifecycleStatus, decisionStatus: PersonaInquiryDecisionStatus, createdStatusAt?: any | null, pendingStatusAt?: any | null, completedStatusAt?: any | null, failedStatusAt?: any | null, expiredStatusAt?: any | null, approvedStatusAt?: any | null, declinedStatusAt?: any | null, needsReviewStatusAt?: any | null } | null, personaPriorLearningInquiry?: { __typename?: 'AdminPersonaInquiry', id: string, createdAt: any, updatedAt: any, type: PersonaInquiryType, inquiryTemplateId: string, accountId?: string | null, verificationId?: string | null, verificationLink?: string | null, lastEventId?: string | null, lastEventTimestamp?: any | null, lifecycleStatus: PersonaInquiryLifecycleStatus, decisionStatus: PersonaInquiryDecisionStatus, createdStatusAt?: any | null, pendingStatusAt?: any | null, completedStatusAt?: any | null, failedStatusAt?: any | null, expiredStatusAt?: any | null, approvedStatusAt?: any | null, declinedStatusAt?: any | null, needsReviewStatusAt?: any | null } | null, user: { __typename?: 'StaffUser', firstName?: string | null, middleName?: string | null, lastName?: string | null, sandId: string, profilePhoto?: string | null, primaryEmail: string } }> } } | null };

export type AdminUserStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminUserStatsQuery = { __typename?: 'Query', userStats?: { __typename?: 'UserStats', totalUsersCount: number, totalUsersCountDiffPercentage: number, last7DaysActive: number, last7DaysActiveDiffPercentage: number, lastDayActive: number, lastDayActiveDiffPercentage: number, lastTimeBucketActive: number, lastTimeBucketActiveDiffPercentage: number, activeUsersByTimeBucket: Array<{ __typename?: 'TimeBucketUserCount', timeBucketIndex: number, timeBucket?: any | null, usersCount: number }>, recentUsers: Array<{ __typename?: 'UserActivity', sandId: string, country?: string | null, city?: string | null, mobileActivityAt?: any | null, androidActivityAt?: any | null, iosActivityAt?: any | null, desktopActivityAt?: any | null, tabletActivityAt?: any | null, smartTvActivityAt?: any | null, user: { __typename?: 'User', sandId?: string | null, primaryEmail: string, profilePhoto?: string | null, firstName?: string | null, lastName?: string | null } }> } | null };

export type StaffViewUserQueryVariables = Exact<{
  sandId: Scalars['ID']['input'];
}>;


export type StaffViewUserQuery = { __typename?: 'Query', staffViewUser: { __typename?: 'StaffUser', sandId: string, bio?: string | null, birthDate?: any | null, countryOfOrigin?: string | null, countryOfResidence?: string | null, countyOfOrigin?: string | null, countyOfResidence?: string | null, coverPhoto?: string | null, cv?: string | null, firstName?: string | null, gender?: Gender | null, interests: Array<string>, isEmployed?: boolean | null, lastName?: string | null, localityOfOrigin?: string | null, localityOfResidence?: string | null, lockedProgression?: boolean | null, lockedProgressionBy?: string | null, lockedProgressionByAt?: any | null, middleName?: string | null, openToNewPositions?: boolean | null, phoneNumber?: string | null, primaryEmail: string, profilePhoto?: string | null, removedPaywallAt?: any | null, skills: Array<string>, skipPaywallUntil?: any | null, skipPaywallReason?: string | null, title?: string | null, whatsAppNumber?: string | null, educationHistory?: Array<{ __typename?: 'Education', fieldOfStudy: string, graduatedAt?: any | null, id: string, institutionCountry?: string | null, institutionCounty?: string | null, institutionLocality?: string | null, institutionName: string, levelOfStudy: string, startDate: any, createdAt: any, updatedAt: any }> | null, languages: Array<{ __typename?: 'LanguageSkill', id: string, language: LanguageEnum, proficiencyLevel: LanguageProficiencyLevel, createdAt: any, updatedAt: any }>, lockedProgressionByUser?: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null } | null, programEnrollments?: Array<{ __typename?: 'AdminProgramEnrollmentView', cumulativeGPA?: number | null, academicStanding?: AcademicStanding | null, id: string, createdAt: any, withdrawalReason?: ProgramWithdrawalReason | null, withdrawalDescription?: string | null, leaveOfAbsenceDescription?: string | null, leaveOfAbsenceReason?: DeferralReason | null, failedAt?: any | null, graduatedAt?: any | null, reinstatedAt?: any | null, status?: ProgramEnrollmentStatus | null, cancelled: boolean, academicConductCases: Array<{ __typename?: 'AcademicConductCaseView', id: string, createdAt: any, updatedAt: any, term: string, severity: ConductCaseSeverity, category: ConductCaseCategory, status: ConductCaseStatus, resolutionType?: ConductCaseResolutionType | null, appealDeadline?: any | null, appealSubmittedAt?: any | null, appealStatus?: AppealStatus | null, createdByUser: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null }, classEnrollment?: { __typename?: 'AdminClassEnrollmentView', id: string, gradeLockedForIntegrityViolation: boolean, class: { __typename?: 'AdminClassView', id: string, name: string, term?: string | null } } | null, history: Array<{ __typename?: 'AcademicConductCaseHistoryView', id: string, createdAt: any, action: ConductCaseHistoryAction, previousSeverity?: ConductCaseSeverity | null, newSeverity?: ConductCaseSeverity | null, previousStatus?: ConductCaseStatus | null, newStatus?: ConductCaseStatus | null, description?: string | null, internalNotes?: string | null, documentUrl?: string | null, documentName?: string | null, performedByUser: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null } }>, appeal?: { __typename?: 'AcademicConductCaseAppealView', id: string, createdAt: any, reason: string, signature: string, documentUrl?: string | null, documentName?: string | null, submittedByUser: { __typename?: 'User', sandId?: string | null, firstName?: string | null, lastName?: string | null } } | null }>, termGPAs: Array<{ __typename?: 'TermGPA', id: string, term: string, gpa?: number | null }>, program: { __typename?: 'AdminProgramView', isUniversityProgram: boolean, name: string, id: string, minTermCredits: number, maxTermCredits: number, abbreviation: string, description?: string | null, hasMultiCourseDisplay: boolean }, courseEnrollments: Array<{ __typename?: 'AdminCourseEnrollmentView', id: string, status?: CourseEnrollmentStatus | null, graduatedAt?: any | null, failedAt?: any | null, letterGrade?: string | null, gradePointsValue?: number | null, statusReason?: CourseEnrollmentStatusReason | null, createdAt: any, deferredAt?: any | null, course: { __typename?: 'AdminCourseDefinitionView', id: string, name: string, abbreviation: string, description?: string | null }, classEnrollments: Array<{ __typename?: 'AdminClassEnrollmentView', id: string, letterGrade?: string | null, gradePoints?: number | null, gradePointsValue?: number | null, status?: ClassEnrollmentStatus | null, graduatedAt?: any | null, failedAt?: any | null, cancelled: boolean, statusReason?: ClassEnrollmentStatusReason | null, createdAt: any, leaveOfAbsenceDescription?: string | null, leaveOfAbsenceReason?: DeferralReason | null, deferredAt?: any | null, deferralDescription?: string | null, deferralReason?: DeferralReason | null, reinstatedAt?: any | null, lastLeaveOfAbsenceAt?: any | null, class: { __typename?: 'AdminClassView', id: string, term?: string | null, startDate?: any | null, name: string, endDate?: any | null }, lmsClassLocation: { __typename?: 'AdminLmsClassLocationView', id: string, name: string, lmsCourseId: string, lmsCohortId?: string | null, courseLink: string, preferredHub?: string | null, preferredCountryOfResidence?: string | null, learningPlatform?: LearningPlatform | null } }> }>, plannedCourses: Array<{ __typename?: 'PlannedCourse', id: string, credits: number, courseGroupKey?: string | null, details: { __typename?: 'CourseDefinition', id: string, name: string, abbreviation: string }, enrollment?: { __typename?: 'CourseEnrollment', id: string, status: CourseEnrollmentStatus, graduatedAt?: any | null, failedAt?: any | null, letterGrade?: string | null, gradePointsValue?: number | null, currentClass?: { __typename?: 'ClassEnrollment', id: string, letterGrade?: string | null, gradePoints?: number | null, gradePointsValue?: number | null, status: ClassEnrollmentStatus } | null, classEnrollments: Array<{ __typename?: 'ClassEnrollment', id: string, letterGrade?: string | null, gradePoints?: number | null, gradePointsValue?: number | null, status: ClassEnrollmentStatus, graduatedAt?: any | null, failedAt?: any | null }> } | null }>, user: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null }, programChanges: Array<{ __typename?: 'ProgramChangeView', id: string, createdAt: any, fromProgram: { __typename?: 'AdminProgramView', id: string, name: string, abbreviation: string }, toProgram: { __typename?: 'AdminProgramView', id: string, name: string, abbreviation: string }, changedByUser: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null } }>, cohort?: { __typename?: 'AdminCohortView', allowCourseDeferral: boolean, allowLeaveOfAbsence: boolean, id: string, name: string, endDate?: any | null, startDate?: any | null } | null }> | null, socialLinks: { __typename?: 'SocialLinks', facebook?: string | null, github?: string | null, linkedIn?: string | null, tikTok?: string | null, twitter?: string | null, youtube?: string | null }, workExperience: Array<{ __typename?: 'WorkExperience', id: string, companyName: string, country?: string | null, createdAt: any, description?: string | null, employmentType: EmploymentTypeEnum, endDate?: any | null, isOngoing: boolean, locality?: string | null, startDate: any, title: string, updatedAt: any, isInTech: boolean }> } };

export type StaffViewSavannaDetailsQueryVariables = Exact<{
  sandId: Scalars['ID']['input'];
}>;


export type StaffViewSavannaDetailsQuery = { __typename?: 'Query', staffViewUser: { __typename?: 'StaffUser', sandId: string, regularUser: { __typename?: 'User', sandId?: string | null, userCurriculumStatuses?: Array<{ __typename?: 'UserCurriculumStatus', id: string, status: string, curriculum: { __typename?: 'Curriculum', id: string, name: string }, batch: { __typename?: 'Batch', id: string, name: string } }> | null } } };

export type StaffGetProgramEnrollmentPaymentPlansQueryVariables = Exact<{
  sandId: Scalars['ID']['input'];
}>;


export type StaffGetProgramEnrollmentPaymentPlansQuery = { __typename?: 'Query', staffViewUser: { __typename?: 'StaffUser', sandId: string, skipPaywallUntil?: any | null, skipPaywallReason?: string | null, removedPaywallAt?: any | null, regularUser: { __typename?: 'User', sandId?: string | null, programEnrollments: Array<{ __typename?: 'ProgramEnrollment', id: string, status: ProgramEnrollmentStatus, paymentPlan?: { __typename?: 'PaymentPlan', paymentPlanId: string } | null, program: { __typename?: 'Program', id: string, abbreviation: string } }>, paymentPlans: Array<{ __typename?: 'PaymentPlan', planIdentifier: string, paymentPlanId: string, status: PaymentPlanStatus, totalPaidAmount: number, totalAmount: number, billingState: BillingState, startDate: any, endDate?: any | null, viewUrl: string, secondsToCancellation?: number | null, secondsToNextPayment: number, code: string, nextInvoice?: { __typename?: 'Invoice', id: string, name: string, amount: number, status: InvoiceStatus, dueDate: any } | null, incompleteTransactions: Array<{ __typename?: 'PaymentHistoryTransaction', amount: number, createdAt: any, currency?: string | null, dismissedAt?: any | null, description?: string | null, gateway?: string | null, icon?: string | null, id: string, paymentId: number, reason?: string | null, retryUrl?: string | null, status: IncompleteTransactionStatus }>, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: any, dueDate: any, name: string, amount: number, updatedAt: any, status: InvoiceStatus, viewInvoiceUrl: string, downloadInvoiceUrl: string }> | null, payments: Array<{ __typename?: 'Payment', id: number, name: string, status: string, url?: string | null, currencyUsed?: string | null, amount: number, paidAt?: any | null, viewReceiptUrl?: string | null, downloadReceiptUrl?: string | null }>, definition?: { __typename?: 'PaymentPlanDefinition', id: string, amount: number, description: string, instalments: number, name: string } | null }> } } };

export type StaffGetSemesterPaymentPlansQueryVariables = Exact<{
  sandId: Scalars['ID']['input'];
}>;


export type StaffGetSemesterPaymentPlansQuery = { __typename?: 'Query', staffViewUser: { __typename?: 'StaffUser', sandId: string, skipPaywallUntil?: any | null, skipPaywallReason?: string | null, removedPaywallAt?: any | null, regularUser: { __typename?: 'User', sandId?: string | null, paymentPlans: Array<{ __typename?: 'PaymentPlan', instalmentsPaid: number, amountPerInstalment: number, amountPerSemester?: number | null, nextPaymentDate?: any | null, previousSemesterPaidAmount?: number | null, previousSemesterPaidInstalments?: number | null, previousSemesterRemainingAmount?: number | null, previousSemesterRemainingInstalments?: number | null, currentSemesterPaidAmount?: number | null, currentSemesterPaidInstalments?: number | null, currentSemesterRemainingAmount?: number | null, currentSemesterRemainingInstalments?: number | null, nextSemesterPaidAmount?: number | null, nextSemesterPaidInstalments?: number | null, nextSemesterRemainingAmount?: number | null, nextSemesterRemainingInstalments?: number | null, cancelDate?: any | null, totalPaidAmount: number, cancellationAmount?: number | null, planIdentifier: string, paymentPlanId: string, status: PaymentPlanStatus, totalAmount: number, billingState: BillingState, viewUrl: string, secondsToCancellation?: number | null, secondsToNextPayment: number, endDate?: any | null, code: string, payments: Array<{ __typename?: 'Payment', id: number, name: string, status: string, url?: string | null, currencyUsed?: string | null, amount: number, paidAt?: any | null, viewReceiptUrl?: string | null, downloadReceiptUrl?: string | null }>, nextInvoice?: { __typename?: 'Invoice', id: string, name: string, amount: number, status: InvoiceStatus, dueDate: any } | null, incompleteTransactions: Array<{ __typename?: 'PaymentHistoryTransaction', amount: number, createdAt: any, currency?: string | null, dismissedAt?: any | null, description?: string | null, icon?: string | null, id: string, paymentId: number, reason?: string | null, retryUrl?: string | null, status: IncompleteTransactionStatus }>, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: any, dueDate: any, name: string, amount: number, status: InvoiceStatus, viewInvoiceUrl: string, downloadInvoiceUrl: string }> | null, definition?: { __typename?: 'PaymentPlanDefinition', id: string, amount: number, description: string, instalments: number, name: string } | null }> } } };

export type AdminGetRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminGetRolesQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', id: string, name: string, permissions: Array<Permission>, userCount: number, createdAt: any, updatedAt: any }> };

export type AdminSearchUsersForRoleQueryVariables = Exact<{
  roleId: Scalars['Int']['input'];
  hasRole?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminSearchUsersForRoleQuery = { __typename?: 'Query', adminSearchUsersForRole?: { __typename?: 'StaffUserSearchResult', totalCount: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean, users: Array<{ __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null, primaryEmail: string }> } | null };

export type GetPaymentDashboardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentDashboardsQuery = { __typename?: 'Query', paymentDashboard: { __typename?: 'Dashboard', id: string, createdAt: any, updatedAt: any, url?: string | null, name: string } };

export type AdminGetSavannaStatusQueryVariables = Exact<{
  sandId: Scalars['ID']['input'];
}>;


export type AdminGetSavannaStatusQuery = { __typename?: 'Query', adminGetUserDetails?: { __typename?: 'User', sandId?: string | null, userCurriculumStatuses?: Array<{ __typename?: 'UserCurriculumStatus', status: string, batch: { __typename?: 'Batch', id: string }, curriculum: { __typename?: 'Curriculum', id: string } }> | null } | null };

export type AdminGetPaginatedAuditLogsQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  actorSandId?: InputMaybe<Scalars['String']['input']>;
  targetSandId?: InputMaybe<Scalars['String']['input']>;
  action?: InputMaybe<AuditAction>;
  actions?: InputMaybe<Array<AuditAction> | AuditAction>;
  operationType?: InputMaybe<OperationType>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminGetPaginatedAuditLogsQuery = { __typename?: 'Query', adminGetPaginatedAuditLogs: { __typename?: 'PaginatedAdminAuditLogs', pageNumber: number, pageSize: number, totalCount: number, totalPages: number, auditLogs: Array<{ __typename?: 'AdminAuditLog', id: string, createdAt: any, operationType: OperationType, action: AuditAction, actorSandId: string, actorRoles: Array<string>, targetSandId?: string | null, targetEntityType?: string | null, targetEntityId?: string | null, inputData: any, metadata?: any | null, actorUser?: { __typename?: 'StaffUser', sandId: string, primaryEmail: string, firstName?: string | null, lastName?: string | null, profilePhoto?: string | null } | null, targetUser?: { __typename?: 'StaffUser', sandId: string, primaryEmail: string, firstName?: string | null, lastName?: string | null, profilePhoto?: string | null } | null }> } };

export type AdminPartnershipsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminPartnershipsQuery = { __typename?: 'Query', adminPartnerships: Array<{ __typename?: 'AdminPartnership', id: string, createdAt: any, updatedAt: any, name: string, paymentPlanId: string, startDate: any, totalTuition: number, discount: number, termTuition: number, totalTuitionNetOfDiscounts: number }> };

export type AdminTrainingResourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminTrainingResourcesQuery = { __typename?: 'Query', adminTrainingResources: Array<{ __typename?: 'AdminTrainingResource', id: string, createdAt: any, updatedAt: any, title: string, description?: string | null, url: string, createdBy: string, creator?: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null } | null }> };

export type StaffBadgeDefinitionsQueryVariables = Exact<{
  status?: InputMaybe<BadgeDefinitionStatus>;
}>;


export type StaffBadgeDefinitionsQuery = { __typename?: 'Query', badgeDefinitions: Array<{ __typename?: 'BadgeDefinition', id: string, name: string, description: string, criteriaText: string, imageUrl?: string | null, status: BadgeDefinitionStatus, courseDefinitionId: string, courseName?: string | null, courseAbbreviation?: string | null, createdAt: any, updatedAt: any }> };

export type StaffBadgeDefinitionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type StaffBadgeDefinitionQuery = { __typename?: 'Query', badgeDefinition?: { __typename?: 'BadgeDefinition', id: string, name: string, description: string, criteriaText: string, imageUrl?: string | null, status: BadgeDefinitionStatus, courseDefinitionId: string, courseName?: string | null, courseAbbreviation?: string | null, createdAt: any, updatedAt: any } | null };

export type StaffCertificateDefinitionsQueryVariables = Exact<{
  status?: InputMaybe<CertificateDefinitionStatus>;
}>;


export type StaffCertificateDefinitionsQuery = { __typename?: 'Query', certificateDefinitions: Array<{ __typename?: 'CertificateDefinition', id: string, name: string, description: string, criteriaText: string, status: CertificateDefinitionStatus, programId: string, programName?: string | null, programAbbreviation?: string | null, createdAt: any, updatedAt: any }> };

export type StaffCertificateDefinitionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type StaffCertificateDefinitionQuery = { __typename?: 'Query', certificateDefinition?: { __typename?: 'CertificateDefinition', id: string, name: string, description: string, criteriaText: string, templateConfig?: any | null, status: CertificateDefinitionStatus, programId: string, programName?: string | null, programAbbreviation?: string | null, createdAt: any, updatedAt: any } | null };

export type AdminGetPaginatedProgramEnrollmentsQueryVariables = Exact<{
  programId: Scalars['String']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchString?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<ProgramEnrollmentStatus> | ProgramEnrollmentStatus>;
  hasWithdrawalReason?: InputMaybe<Scalars['Boolean']['input']>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  academicStandings?: InputMaybe<Array<AcademicStanding> | AcademicStanding>;
  orderByField?: InputMaybe<Scalars['String']['input']>;
  orderByDirection?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminGetPaginatedProgramEnrollmentsQuery = { __typename?: 'Query', adminGetPaginatedProgramEnrollments: { __typename?: 'AdminPaginatedProgramEnrollments', pageNumber: number, pageSize: number, totalCount: number, totalPages: number, programEnrollments: Array<{ __typename?: 'AdminProgramEnrollmentView', id: string, status?: ProgramEnrollmentStatus | null, createdAt: any, failedAt?: any | null, withdrawalReason?: ProgramWithdrawalReason | null, withdrawalDescription?: string | null, cancelled: boolean, cumulativeGPA?: number | null, academicStanding?: AcademicStanding | null, user: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null, primaryEmail: string, profilePhoto?: string | null } }> } };

export type AdminGetGradesMappingsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminGetGradesMappingsQuery = { __typename?: 'Query', adminGetGradesMappings: { __typename?: 'AdminGradesMappingsResult', hasProgramSpecificMappings: boolean, mappings: Array<{ __typename?: 'AdminGradesMappingView', id: string, letterGrade: string, minGradePoints: number, gradePointsValue: number, programId?: string | null }> } };

export type DashboardFragment = { __typename?: 'Dashboard', createdAt: any, id: string, name: string, updatedAt: any };

export type EducationFragment = { __typename?: 'Education', createdAt: any, fieldOfStudy: string, graduatedAt?: any | null, id: string, institutionCountry?: string | null, institutionCounty?: string | null, institutionLocality?: string | null, institutionName: string, knownInstitutionId?: string | null, levelOfStudy: string, startDate: any, updatedAt: any };

export type LanguageSkillFragment = { __typename?: 'LanguageSkill', createdAt: any, id: string, language: LanguageEnum, proficiencyLevel: LanguageProficiencyLevel, updatedAt: any };

export type NotificationFragment = { __typename?: 'NotificationEdge', node: { __typename?: 'Notification', createdAt: any, dismissed: boolean, id: number, platform: NotificationPlatform, seen: boolean, type: NotificationType, payload: { __typename?: 'EHubNewClassEnrollmentNotificationPayload', classEnrollmentId: string, classEnrollment?: { __typename?: 'ClassEnrollment', id: string, lmsClassLocation: { __typename?: 'LmsClassLocation', courseLink: string }, courseEnrollment: { __typename?: 'CourseEnrollment', id: string, course: { __typename?: 'CourseDefinition', id: string, abbreviation: string, name: string } } } | null } | { __typename?: 'EHubNewProgramEnrollmentNotificationPayload', programEnrollmentId: string, programEnrollment?: { __typename?: 'ProgramEnrollment', id: string, program: { __typename?: 'Program', id: string, name: string } } | null } | { __typename?: 'JoinCommunityPayload' } | { __typename?: 'NileAcceptedToProgramNotificationPayload', programEnrollmentId: string, programEnrollment?: { __typename?: 'ProgramEnrollment', id: string, program: { __typename?: 'Program', id: string, name: string } } | null } | { __typename?: 'OnboardingCompletedPayload' } | { __typename?: 'PaymentIsDueSoonPayload', paymentId: string, paymentPlan?: { __typename?: 'PaymentPlan', payments: Array<{ __typename?: 'Payment', id: number, url?: string | null }> } | null } | { __typename?: 'SavannaAssignmentDuePayload' } } };

export type ViewerNotificationsFragment = { __typename?: 'NotificationConnection', totalCount?: number | null, edges: Array<{ __typename?: 'NotificationEdge', cursor: string, node: { __typename?: 'Notification', createdAt: any, dismissed: boolean, id: number, platform: NotificationPlatform, seen: boolean, type: NotificationType, payload: { __typename?: 'EHubNewClassEnrollmentNotificationPayload', classEnrollmentId: string, classEnrollment?: { __typename?: 'ClassEnrollment', id: string, lmsClassLocation: { __typename?: 'LmsClassLocation', courseLink: string }, courseEnrollment: { __typename?: 'CourseEnrollment', id: string, course: { __typename?: 'CourseDefinition', id: string, abbreviation: string, name: string } } } | null } | { __typename?: 'EHubNewProgramEnrollmentNotificationPayload', programEnrollmentId: string, programEnrollment?: { __typename?: 'ProgramEnrollment', id: string, program: { __typename?: 'Program', id: string, name: string } } | null } | { __typename?: 'JoinCommunityPayload' } | { __typename?: 'NileAcceptedToProgramNotificationPayload', programEnrollmentId: string, programEnrollment?: { __typename?: 'ProgramEnrollment', id: string, program: { __typename?: 'Program', id: string, name: string } } | null } | { __typename?: 'OnboardingCompletedPayload' } | { __typename?: 'PaymentIsDueSoonPayload', paymentId: string, paymentPlan?: { __typename?: 'PaymentPlan', payments: Array<{ __typename?: 'Payment', id: number, url?: string | null }> } | null } | { __typename?: 'SavannaAssignmentDuePayload' } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } };

export type WorkExperienceFragment = { __typename?: 'WorkExperience', id: string, companyName: string, country?: string | null, createdAt: any, description?: string | null, employmentType: EmploymentTypeEnum, endDate?: any | null, isOngoing: boolean, locality?: string | null, startDate: any, title: string, updatedAt: any, isInTech: boolean };

export type ProgramEnrollmentFragment = { __typename?: 'ProgramEnrollment', id: string, createdAt: any, withdrawalReason?: ProgramWithdrawalReason | null, withdrawalDescription?: string | null, leaveOfAbsenceDescription?: string | null, leaveOfAbsenceReason?: DeferralReason | null, failedAt?: any | null, graduatedAt?: any | null, reinstatedAt?: any | null, status: ProgramEnrollmentStatus, academicStanding?: AcademicStanding | null, cohort?: { __typename?: 'Cohort', id: string, name: string, endDate?: any | null, startDate?: any | null } | null, program: { __typename?: 'Program', id: string, name: string, minTermCredits: number, maxTermCredits: number, abbreviation: string, description?: string | null, hasMultiCourseDisplay: boolean, allowCourseDeferral: boolean, allowLeaveOfAbsence: boolean, isUniversityProgram: boolean }, courseEnrollments: Array<{ __typename?: 'CourseEnrollment', id: string, status: CourseEnrollmentStatus, statusReason?: CourseEnrollmentStatusReason | null, createdAt: any, graduatedAt?: any | null, failedAt?: any | null, deferredAt?: any | null, course: { __typename?: 'CourseDefinition', id: string, name: string, abbreviation: string, description?: string | null }, classEnrollments: Array<{ __typename?: 'ClassEnrollment', id: string, status: ClassEnrollmentStatus, statusReason?: ClassEnrollmentStatusReason | null, createdAt: any, failedAt?: any | null, leaveOfAbsenceDescription?: string | null, leaveOfAbsenceReason?: DeferralReason | null, deferredAt?: any | null, deferralDescription?: string | null, deferralReason?: DeferralReason | null, graduatedAt?: any | null, reinstatedAt?: any | null, lastLeaveOfAbsenceAt?: any | null, class: { __typename?: 'Class', id: string, name: string, startDate?: any | null, endDate?: any | null }, lmsClassLocation: { __typename?: 'LmsClassLocation', id: string, name: string, courseLink: string, learningPlatform?: LearningPlatform | null } }> }> };

export type IssuedCourseBadgeFragment = { __typename?: 'IssuedBadge', id: string, status: BadgeStatus, issuedAt: any, verificationUrl: string, linkedInShareUrl: string, badgeDefinition?: { __typename?: 'BadgeDefinition', id: string, name: string, description: string, imageUrl?: string | null } | null };

export type ProgramEnrollmentDetailsFragment = { __typename?: 'ProgramEnrollment', id: string, cumulativeGPA?: number | null, plannedCourses: Array<{ __typename?: 'PlannedCourse', id: string, courseGroupKey?: string | null, credits: number, details: { __typename?: 'CourseDefinition', id: string, name: string, abbreviation: string, description?: string | null, type?: string | null, issuedBadge?: { __typename?: 'IssuedBadge', id: string, status: BadgeStatus, issuedAt: any, verificationUrl: string, linkedInShareUrl: string, badgeDefinition?: { __typename?: 'BadgeDefinition', id: string, name: string, description: string, imageUrl?: string | null } | null } | null }, enrollment?: { __typename?: 'CourseEnrollment', id: string, status: CourseEnrollmentStatus, currentClass?: { __typename?: 'ClassEnrollment', id: string, status: ClassEnrollmentStatus, lmsClassLocation: { __typename?: 'LmsClassLocation', id: string, courseLink: string }, proofOfCompletion?: { __typename?: 'ProofOfCompletion', email?: string | null, user: { __typename?: 'User', sandId?: string | null } } | null, class: { __typename?: 'Class', id: string, startDate?: any | null, endDate?: any | null, proofOfCompletionType: ProofOfCompletionType, requiresProofOfCompletionAfter?: any | null, canShowUniversityUpsellAfter?: any | null } } | null } | null }> };

export type AvailableProgramToApplyFragment = { __typename?: 'User', sandId?: string | null, availablePrograms?: Array<{ __typename?: 'Program', id: string, name: string, abbreviation: string, description?: string | null, isEnrolled: boolean, marketing: { __typename?: 'ProgramMarketing', title?: string | null, subtitle?: string | null, sectionSummary?: string | null, sectionTitle?: string | null, timeCommitment?: string | null, video?: string | null, thumbnail?: string | null, highlights: Array<string> }, potentialProgramJourney?: { __typename?: 'PotentialProgramJourney', startDate?: any | null, potentialCourseEnrollments: Array<{ __typename?: 'PotentialCourseEnrollment', existingEnrollment?: { __typename?: 'ClassEnrollment', id: string, status: ClassEnrollmentStatus, class: { __typename?: 'Class', id: string, startDate?: any | null, endDate?: any | null }, courseEnrollment: { __typename?: 'CourseEnrollment', id: string, status: CourseEnrollmentStatus } } | null, firstAvailableClass?: { __typename?: 'Class', id: string, startDate?: any | null, endDate?: any | null } | null, courseDetails?: { __typename?: 'CourseDefinition', id: string, name: string, abbreviation: string, description?: string | null } | null }> } | null }> | null };

export type AdminProgramEnrollmentViewFragment = { __typename?: 'AdminProgramEnrollmentView', id: string, createdAt: any, withdrawalReason?: ProgramWithdrawalReason | null, withdrawalDescription?: string | null, leaveOfAbsenceDescription?: string | null, leaveOfAbsenceReason?: DeferralReason | null, failedAt?: any | null, graduatedAt?: any | null, reinstatedAt?: any | null, status?: ProgramEnrollmentStatus | null, cancelled: boolean, programChanges: Array<{ __typename?: 'ProgramChangeView', id: string, createdAt: any, fromProgram: { __typename?: 'AdminProgramView', id: string, name: string, abbreviation: string }, toProgram: { __typename?: 'AdminProgramView', id: string, name: string, abbreviation: string }, changedByUser: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null } }>, cohort?: { __typename?: 'AdminCohortView', allowCourseDeferral: boolean, allowLeaveOfAbsence: boolean, id: string, name: string, endDate?: any | null, startDate?: any | null } | null, program: { __typename?: 'AdminProgramView', id: string, name: string, minTermCredits: number, maxTermCredits: number, abbreviation: string, description?: string | null, hasMultiCourseDisplay: boolean }, courseEnrollments: Array<{ __typename?: 'AdminCourseEnrollmentView', id: string, status?: CourseEnrollmentStatus | null, statusReason?: CourseEnrollmentStatusReason | null, createdAt: any, graduatedAt?: any | null, failedAt?: any | null, deferredAt?: any | null, course: { __typename?: 'AdminCourseDefinitionView', id: string, name: string, abbreviation: string, description?: string | null }, classEnrollments: Array<{ __typename?: 'AdminClassEnrollmentView', id: string, status?: ClassEnrollmentStatus | null, statusReason?: ClassEnrollmentStatusReason | null, createdAt: any, failedAt?: any | null, leaveOfAbsenceDescription?: string | null, leaveOfAbsenceReason?: DeferralReason | null, deferredAt?: any | null, deferralDescription?: string | null, deferralReason?: DeferralReason | null, graduatedAt?: any | null, reinstatedAt?: any | null, lastLeaveOfAbsenceAt?: any | null, class: { __typename?: 'AdminClassView', id: string, name: string, startDate?: any | null, endDate?: any | null }, lmsClassLocation: { __typename?: 'AdminLmsClassLocationView', id: string, name: string, lmsCourseId: string, lmsCohortId?: string | null, courseLink: string, preferredHub?: string | null, preferredCountryOfResidence?: string | null, learningPlatform?: LearningPlatform | null } }> }> };

export type AcademicConductCaseFragment = { __typename?: 'AcademicConductCaseView', id: string, createdAt: any, updatedAt: any, term: string, severity: ConductCaseSeverity, category: ConductCaseCategory, status: ConductCaseStatus, resolutionType?: ConductCaseResolutionType | null, appealDeadline?: any | null, appealSubmittedAt?: any | null, appealStatus?: AppealStatus | null, createdByUser: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null }, classEnrollment?: { __typename?: 'AdminClassEnrollmentView', id: string, gradeLockedForIntegrityViolation: boolean, class: { __typename?: 'AdminClassView', id: string, name: string, term?: string | null } } | null, history: Array<{ __typename?: 'AcademicConductCaseHistoryView', id: string, createdAt: any, action: ConductCaseHistoryAction, previousSeverity?: ConductCaseSeverity | null, newSeverity?: ConductCaseSeverity | null, previousStatus?: ConductCaseStatus | null, newStatus?: ConductCaseStatus | null, description?: string | null, internalNotes?: string | null, documentUrl?: string | null, documentName?: string | null, performedByUser: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null } }>, appeal?: { __typename?: 'AcademicConductCaseAppealView', id: string, createdAt: any, reason: string, signature: string, documentUrl?: string | null, documentName?: string | null, submittedByUser: { __typename?: 'User', sandId?: string | null, firstName?: string | null, lastName?: string | null } } | null };

export type AcademicConductCaseLearnerFragment = { __typename?: 'AcademicConductCaseLearnerView', id: string, createdAt: any, term: string, severity: ConductCaseSeverity, category: ConductCaseCategory, status: ConductCaseStatus, resolutionType?: ConductCaseResolutionType | null, className?: string | null, appealDeadline?: any | null, appealSubmittedAt?: any | null, appealStatus?: AppealStatus | null, history: Array<{ __typename?: 'AcademicConductCaseLearnerHistoryView', id: string, createdAt: any, action: ConductCaseHistoryAction, previousSeverity?: ConductCaseSeverity | null, newSeverity?: ConductCaseSeverity | null, previousStatus?: ConductCaseStatus | null, newStatus?: ConductCaseStatus | null, description?: string | null, documentUrl?: string | null, documentName?: string | null }>, appeal?: { __typename?: 'AcademicConductCaseAppealView', id: string, createdAt: any, reason: string, signature: string, documentUrl?: string | null, documentName?: string | null } | null };

export type RoleFragment = { __typename?: 'Role', id: string, name: string, permissions: Array<Permission>, userCount: number, createdAt: any, updatedAt: any };

export type AdminPersonaInquiryFragment = { __typename?: 'AdminPersonaInquiry', id: string, createdAt: any, updatedAt: any, type: PersonaInquiryType, inquiryTemplateId: string, accountId?: string | null, verificationId?: string | null, verificationLink?: string | null, lastEventId?: string | null, lastEventTimestamp?: any | null, lifecycleStatus: PersonaInquiryLifecycleStatus, decisionStatus: PersonaInquiryDecisionStatus, createdStatusAt?: any | null, pendingStatusAt?: any | null, completedStatusAt?: any | null, failedStatusAt?: any | null, expiredStatusAt?: any | null, approvedStatusAt?: any | null, declinedStatusAt?: any | null, needsReviewStatusAt?: any | null };

export type PaymentPlanFragment = { __typename?: 'PaymentPlan', planIdentifier: string, paymentPlanId: string, status: PaymentPlanStatus, totalPaidAmount: number, totalAmount: number, billingState: BillingState, viewUrl: string, secondsToCancellation?: number | null, secondsToNextPayment: number, endDate?: any | null, code: string, nextInvoice?: { __typename?: 'Invoice', id: string, name: string, amount: number, status: InvoiceStatus, dueDate: any } | null, incompleteTransactions: Array<{ __typename?: 'PaymentHistoryTransaction', amount: number, createdAt: any, currency?: string | null, dismissedAt?: any | null, description?: string | null, icon?: string | null, id: string, paymentId: number, reason?: string | null, retryUrl?: string | null, status: IncompleteTransactionStatus }>, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: any, dueDate: any, name: string, amount: number, status: InvoiceStatus, viewInvoiceUrl: string, downloadInvoiceUrl: string }> | null, payments: Array<{ __typename?: 'Payment', id: number, name: string, status: string, url?: string | null, currencyUsed?: string | null, amount: number, paidAt?: any | null, viewReceiptUrl?: string | null, downloadReceiptUrl?: string | null }>, definition?: { __typename?: 'PaymentPlanDefinition', id: string, amount: number, description: string, instalments: number, name: string } | null };

export type PersonaInquiryBasicsFragment = { __typename?: 'PersonaInquiry', id: string, lifecycleStatus: PersonaInquiryLifecycleStatus, decisionStatus: PersonaInquiryDecisionStatus };

export type ProgramApplicationForLearnerFragment = { __typename?: 'ProgramApplication', id: string, status: ProgramApplicationStatus, additionalInfo?: string | null, anticipateChallenges?: boolean | null, englishProficiencyStatus: EnglishProficiencyStatus, englishProficiencyType?: EnglishProficiencyType | null, feePaymentMode?: FeePaymentMode | null, otherFeePaymentMode?: string | null, highSchoolVerificationMode: HighSchoolVerificationMode, user: { __typename?: 'User', sandId?: string | null }, highSchoolCertificate?: { __typename?: 'HighSchoolCertificate', id: string, status: HighSchoolCertificateStatus, schoolName: string, country: string, city: string, state: string, graduationDate: any, schoolAddress: string, qualification: string } | null, personaIdentityInquiry?: { __typename?: 'PersonaInquiry', id: string, lifecycleStatus: PersonaInquiryLifecycleStatus, decisionStatus: PersonaInquiryDecisionStatus } | null, personaHighschoolInquiry?: { __typename?: 'PersonaInquiry', id: string, lifecycleStatus: PersonaInquiryLifecycleStatus, decisionStatus: PersonaInquiryDecisionStatus } | null, personaPriorLearningInquiry?: { __typename?: 'PersonaInquiry', id: string, lifecycleStatus: PersonaInquiryLifecycleStatus, decisionStatus: PersonaInquiryDecisionStatus } | null, docusignEnrollmentAgreement?: { __typename?: 'DocusignEnrollmentAgreement', applicantStatus?: string | null, envelopeStatus?: string | null, link?: string | null } | null, program: { __typename?: 'Program', id: string, name: string, description?: string | null, requiresTuitionQuestionnaire: boolean, marketing: { __typename?: 'ProgramMarketing', thumbnail?: string | null, programDuration?: string | null } } };

export type AddEducationMutationVariables = Exact<{
  input: AddEducationInput;
}>;


export type AddEducationMutation = { __typename?: 'Mutation', addEducation: { __typename?: 'AddEducationPayload', user: { __typename?: 'User', sandId?: string | null, educationHistory?: Array<{ __typename?: 'Education', createdAt: any, fieldOfStudy: string, graduatedAt?: any | null, id: string, institutionCountry?: string | null, institutionCounty?: string | null, institutionLocality?: string | null, institutionName: string, knownInstitutionId?: string | null, levelOfStudy: string, startDate: any, updatedAt: any }> | null } } };

export type AddLanguageSkillsMutationVariables = Exact<{
  input: AddLanguageSkillsInput;
}>;


export type AddLanguageSkillsMutation = { __typename?: 'Mutation', addLanguageSkills: { __typename?: 'AddLanguageSkillsPayload', user: { __typename?: 'User', sandId?: string | null, languages: Array<{ __typename?: 'LanguageSkill', createdAt: any, id: string, language: LanguageEnum, proficiencyLevel: LanguageProficiencyLevel, updatedAt: any }> } } };

export type CreateDashboardMutationVariables = Exact<{
  dashboardId: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type CreateDashboardMutation = { __typename?: 'Mutation', createDashboard: { __typename?: 'CreateDashboardPayload', user: { __typename?: 'StaffUser', sandId: string, availableDashboards: Array<{ __typename?: 'Dashboard', createdAt: any, id: string, name: string, updatedAt: any }> } } };

export type CreateOrUpdateProofOfCompletionMutationVariables = Exact<{
  input: CreateOrUpdateProofOfCompletionInput;
}>;


export type CreateOrUpdateProofOfCompletionMutation = { __typename?: 'Mutation', createOrUpdateProofOfCompletion: { __typename?: 'CreateOrUpdateProofOfCompletionPayload', proofOfCompletion: { __typename?: 'ProofOfCompletion', classEnrollment: { __typename?: 'ClassEnrollment', id: string, status: ClassEnrollmentStatus, proofOfCompletion?: { __typename?: 'ProofOfCompletion', email?: string | null, examLocation?: ProofOfCompletionExamLocation | null, examScore?: number | null, examValidationNumber?: string | null, firstName?: string | null, lastName?: string | null, examStatement?: ExamStatementType | null, user: { __typename?: 'User', sandId?: string | null } } | null } } } };

export type CreateUploadMutationVariables = Exact<{
  input: CreateUploadInput;
}>;


export type CreateUploadMutation = { __typename?: 'Mutation', createUpload: { __typename?: 'CreateUploadPayload', fileUrl: string, uploadUrl: string, fields: Array<{ __typename?: 'FormDataField', key: string, value: string }> } };

export type CreateWorkExperienceMutationVariables = Exact<{
  input: CreateWorkExperienceInput;
}>;


export type CreateWorkExperienceMutation = { __typename?: 'Mutation', createWorkExperience: { __typename?: 'CreateWorkExperiencePayload', user: { __typename?: 'User', sandId?: string | null, workExperience: Array<{ __typename?: 'WorkExperience', id: string, companyName: string, country?: string | null, createdAt: any, description?: string | null, employmentType: EmploymentTypeEnum, endDate?: any | null, isOngoing: boolean, locality?: string | null, startDate: any, title: string, updatedAt: any, isInTech: boolean }> } } };

export type DeleteCvMutationVariables = Exact<{
  input: DeleteCvInput;
}>;


export type DeleteCvMutation = { __typename?: 'Mutation', deleteCv: { __typename?: 'DeleteCvPayload', user: { __typename?: 'User', cv?: string | null, sandId?: string | null } } };

export type DeleteRefugeeCardMutationVariables = Exact<{
  input: DeleteRefugeeCardInput;
}>;


export type DeleteRefugeeCardMutation = { __typename?: 'Mutation', deleteRefugeeCard: { __typename?: 'DeleteRefugeeCardPayload', user: { __typename?: 'User', refugeeCard?: string | null, sandId?: string | null } } };

export type DeleteDashboardMutationVariables = Exact<{
  deleteDashboardId: Scalars['ID']['input'];
}>;


export type DeleteDashboardMutation = { __typename?: 'Mutation', deleteDashboard: { __typename?: 'DeleteDashboardPayload', user: { __typename?: 'StaffUser', sandId: string, availableDashboards: Array<{ __typename?: 'Dashboard', createdAt: any, id: string, name: string, updatedAt: any }> } } };

export type DeleteEducationMutationVariables = Exact<{
  input: DeleteEducationInput;
}>;


export type DeleteEducationMutation = { __typename?: 'Mutation', deleteEducation: { __typename?: 'DeleteEducationPayload', user: { __typename?: 'User', sandId?: string | null, educationHistory?: Array<{ __typename?: 'Education', id: string, fieldOfStudy: string, institutionCountry?: string | null, institutionCounty?: string | null, institutionLocality?: string | null, institutionName: string, knownInstitutionId?: string | null, levelOfStudy: string, startDate: any, updatedAt: any }> | null } } };

export type DeleteWorkExperienceMutationVariables = Exact<{
  input: DeleteWorkExperienceInput;
}>;


export type DeleteWorkExperienceMutation = { __typename?: 'Mutation', deleteWorkExperience: { __typename?: 'DeleteWorkExperiencePayload', user: { __typename?: 'User', sandId?: string | null, workExperience: Array<{ __typename?: 'WorkExperience', companyName: string, country?: string | null, county?: string | null, description?: string | null, employmentType: EmploymentTypeEnum, endDate?: any | null, id: string, isOngoing: boolean, locality?: string | null, title: string, startDate: any }> } } };

export type MarkActivatedProfileAsCompletedMutationVariables = Exact<{
  input: MarkActivatedProfileAsCompletedInput;
}>;


export type MarkActivatedProfileAsCompletedMutation = { __typename?: 'Mutation', markActivatedProfileAsCompleted: { __typename?: 'MarkActivatedProfileAsCompletedPayload', user: { __typename?: 'User', sandId?: string | null, onboardingPanel?: { __typename?: 'OnboardingPanel', sandId: string, activatedProfile?: any | null } | null } } };

export type MarkExploredAndEngagedWithCommunityAsCompletedMutationVariables = Exact<{
  input: MarkExploredAndEngagedWithCommunityAsCompletedInput;
}>;


export type MarkExploredAndEngagedWithCommunityAsCompletedMutation = { __typename?: 'Mutation', markExploredAndEngagedWithCommunityAsCompleted: { __typename?: 'MarkExploredAndEngagedWithCommunityAsCompletedPayload', user: { __typename?: 'User', sandId?: string | null, onboardingPanel?: { __typename?: 'OnboardingPanel', sandId: string, exploredAndEngagedWithCommunity?: any | null } | null } } };

export type MarkNotificationsAsDismissedMutationVariables = Exact<{
  input: MarkNotificationsAsDismissedInput;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MarkNotificationsAsDismissedMutation = { __typename?: 'Mutation', markNotificationsAsDismissed: { __typename?: 'MarkNotificationsAsDismissedPayload', user: { __typename?: 'User', sandId?: string | null, notifications: { __typename?: 'NotificationConnection', totalCount?: number | null, edges: Array<{ __typename?: 'NotificationEdge', cursor: string, node: { __typename?: 'Notification', createdAt: any, dismissed: boolean, id: number, platform: NotificationPlatform, seen: boolean, type: NotificationType, payload: { __typename?: 'EHubNewClassEnrollmentNotificationPayload', classEnrollmentId: string, classEnrollment?: { __typename?: 'ClassEnrollment', id: string, lmsClassLocation: { __typename?: 'LmsClassLocation', courseLink: string }, courseEnrollment: { __typename?: 'CourseEnrollment', id: string, course: { __typename?: 'CourseDefinition', id: string, abbreviation: string, name: string } } } | null } | { __typename?: 'EHubNewProgramEnrollmentNotificationPayload', programEnrollmentId: string, programEnrollment?: { __typename?: 'ProgramEnrollment', id: string, program: { __typename?: 'Program', id: string, name: string } } | null } | { __typename?: 'JoinCommunityPayload' } | { __typename?: 'NileAcceptedToProgramNotificationPayload', programEnrollmentId: string, programEnrollment?: { __typename?: 'ProgramEnrollment', id: string, program: { __typename?: 'Program', id: string, name: string } } | null } | { __typename?: 'OnboardingCompletedPayload' } | { __typename?: 'PaymentIsDueSoonPayload', paymentId: string, paymentPlan?: { __typename?: 'PaymentPlan', payments: Array<{ __typename?: 'Payment', id: number, url?: string | null }> } | null } | { __typename?: 'SavannaAssignmentDuePayload' } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } } };

export type MarkNotificationsAsSeenMutationVariables = Exact<{
  input: MarkNotificationsAsSeenInput;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MarkNotificationsAsSeenMutation = { __typename?: 'Mutation', markNotificationsAsSeen: { __typename?: 'MarkNotificationsAsSeenPayload', user: { __typename?: 'User', sandId?: string | null, notifications: { __typename?: 'NotificationConnection', totalCount?: number | null, edges: Array<{ __typename?: 'NotificationEdge', cursor: string, node: { __typename?: 'Notification', createdAt: any, dismissed: boolean, id: number, platform: NotificationPlatform, seen: boolean, type: NotificationType, payload: { __typename?: 'EHubNewClassEnrollmentNotificationPayload', classEnrollmentId: string, classEnrollment?: { __typename?: 'ClassEnrollment', id: string, lmsClassLocation: { __typename?: 'LmsClassLocation', courseLink: string }, courseEnrollment: { __typename?: 'CourseEnrollment', id: string, course: { __typename?: 'CourseDefinition', id: string, abbreviation: string, name: string } } } | null } | { __typename?: 'EHubNewProgramEnrollmentNotificationPayload', programEnrollmentId: string, programEnrollment?: { __typename?: 'ProgramEnrollment', id: string, program: { __typename?: 'Program', id: string, name: string } } | null } | { __typename?: 'JoinCommunityPayload' } | { __typename?: 'NileAcceptedToProgramNotificationPayload', programEnrollmentId: string, programEnrollment?: { __typename?: 'ProgramEnrollment', id: string, program: { __typename?: 'Program', id: string, name: string } } | null } | { __typename?: 'OnboardingCompletedPayload' } | { __typename?: 'PaymentIsDueSoonPayload', paymentId: string, paymentPlan?: { __typename?: 'PaymentPlan', payments: Array<{ __typename?: 'Payment', id: number, url?: string | null }> } | null } | { __typename?: 'SavannaAssignmentDuePayload' } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } } };

export type MarkOnboardingAsFinishedMutationVariables = Exact<{
  input: MarkOnboardingAsFinishedInput;
}>;


export type MarkOnboardingAsFinishedMutation = { __typename?: 'Mutation', markOnboardingAsFinished: { __typename?: 'MarkOnboardingAsFinishedPayload', user: { __typename?: 'User', sandId?: string | null, onboardingPanel?: { __typename?: 'OnboardingPanel', sandId: string, finishedOnboardingAt?: any | null } | null } } };

export type MarkWatchedWelcomeVideoAsCompletedMutationVariables = Exact<{
  input: MarkWatchedWelcomeVideoAsCompletedInput;
}>;


export type MarkWatchedWelcomeVideoAsCompletedMutation = { __typename?: 'Mutation', markWatchedWelcomeVideoAsCompleted: { __typename?: 'MarkWatchedWelcomeVideoAsCompletedPayload', user: { __typename?: 'User', sandId?: string | null, onboardingPanel?: { __typename?: 'OnboardingPanel', sandId: string, watchedWelcomeVideo?: any | null } | null } } };

export type MarkWatchedOnboardingVideoAsCompletedMutationVariables = Exact<{
  input: MarkWatchedOnboardingVideoAsCompletedInput;
}>;


export type MarkWatchedOnboardingVideoAsCompletedMutation = { __typename?: 'Mutation', markWatchedOnboardingVideoAsCompleted: { __typename?: 'MarkWatchedOnboardingVideoAsCompletedPayload', user: { __typename?: 'User', sandId?: string | null, onboardingPanel?: { __typename?: 'OnboardingPanel', sandId: string, watchedOnboardingVideo?: any | null } | null } } };

export type UpdateCoverPhotoMutationVariables = Exact<{
  input: UpdateCoverPhotoInput;
}>;


export type UpdateCoverPhotoMutation = { __typename?: 'Mutation', updateCoverPhoto: { __typename?: 'UpdateCoverPhotoPayload', user: { __typename?: 'User', sandId?: string | null, coverPhoto?: string | null } } };

export type UpdateCvMutationVariables = Exact<{
  input: UpdateCvInput;
}>;


export type UpdateCvMutation = { __typename?: 'Mutation', updateCv: { __typename?: 'UpdateCvPayload', user: { __typename?: 'User', sandId?: string | null, cv?: string | null } } };

export type UpdateRefugeeCardMutationVariables = Exact<{
  input: UpdateRefugeeCardInput;
}>;


export type UpdateRefugeeCardMutation = { __typename?: 'Mutation', updateRefugeeCard: { __typename?: 'UpdateRefugeeCardPayload', user: { __typename?: 'User', sandId?: string | null, refugeeCard?: string | null } } };

export type UpdateEducationMutationVariables = Exact<{
  input: UpdateEducationInput;
}>;


export type UpdateEducationMutation = { __typename?: 'Mutation', updateEducation: { __typename?: 'UpdateEducationPayload', user: { __typename?: 'User', sandId?: string | null, educationHistory?: Array<{ __typename?: 'Education', createdAt: any, fieldOfStudy: string, graduatedAt?: any | null, id: string, institutionCountry?: string | null, institutionCounty?: string | null, institutionLocality?: string | null, institutionName: string, knownInstitutionId?: string | null, levelOfStudy: string, startDate: any, updatedAt: any }> | null } } };

export type UpdateInterestsMutationVariables = Exact<{
  input: UpdateInterestsInput;
}>;


export type UpdateInterestsMutation = { __typename?: 'Mutation', updateInterests: { __typename?: 'UpdateInterestsPayload', user: { __typename?: 'User', interests: Array<string>, sandId?: string | null } } };

export type UpdateNotificationSettingsMutationVariables = Exact<{
  input: UpdateNotificationSettingsInput;
}>;


export type UpdateNotificationSettingsMutation = { __typename?: 'Mutation', updateNotificationSettings: { __typename?: 'UpdateNotificationSettingsPayload', user: { __typename?: 'User', sandId?: string | null, notificationSettings?: { __typename?: 'NotificationSettings', admissionEmail: boolean, admissionInApp: boolean, communityEmail: boolean, communityEmailMentions: boolean, communityEmailSpaces: boolean, communityInApp: boolean, communityInAppMentions: boolean, communityInAppSpaces: boolean, createdAt: any, customerSupportEmail: boolean, customerSupportInApp: boolean, eHubEmail: boolean, eHubInApp: boolean, eventsEmail: boolean, eventsPush: boolean, learningEmail: boolean, learningInApp: boolean, sandId: string, securityAndPrivacyEmail: boolean, securityAndPrivacyInApp: boolean, securityAndPrivacyPush: boolean, updatedAt: any } | null } } };

export type UpdateProfilePhotoMutationVariables = Exact<{
  input: UpdateProfilePhotoInput;
}>;


export type UpdateProfilePhotoMutation = { __typename?: 'Mutation', updateProfilePhoto: { __typename?: 'UpdateProfilePhotoPayload', user: { __typename?: 'User', sandId?: string | null, profilePhoto?: string | null } } };

export type UpdateSkillsMutationVariables = Exact<{
  input: UpdateSkillsInput;
}>;


export type UpdateSkillsMutation = { __typename?: 'Mutation', updateSkills: { __typename?: 'UpdateSkillsPayload', user: { __typename?: 'User', sandId?: string | null, skills: Array<string> } } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UpdateUserPayload', user: { __typename?: 'User', bio?: string | null, birthDate?: any | null, countryOfOrigin?: string | null, countryOfResidence?: string | null, countyOfOrigin?: string | null, countyOfResidence?: string | null, coverPhoto?: string | null, cv?: string | null, firstName?: string | null, gender?: Gender | null, isEmployed?: boolean | null, lastName?: string | null, localityOfOrigin?: string | null, localityOfResidence?: string | null, middleName?: string | null, profilePhoto?: string | null, phoneNumber?: string | null, sandId?: string | null, primaryEmail: string, whatsAppNumber?: string | null, previouslyEnrolledInALX?: boolean | null, highestLevelOfStudy?: string | null, fieldOfStudy?: string | null, portfolioAndProjects: Array<string>, employmentType?: EmploymentTypeEnum | null, topCareerGoal?: string | null, guardianship?: Guardianship | null, locationDescription?: LocationDescription | null, livingCircumstances?: LivingCircumstances | null, householdMonthlyIncomeUSD?: number | null, disability?: Disability | null, humanitarianStatus?: HumanitarianStatus | null, humanitarianStatusType?: HumanitarianStatusType | null, refugeeCard?: string | null, educationHistory?: Array<{ __typename?: 'Education', createdAt: any, fieldOfStudy: string, graduatedAt?: any | null, id: string, institutionCountry?: string | null, institutionCounty?: string | null, institutionLocality?: string | null, institutionName: string, knownInstitutionId?: string | null, levelOfStudy: string, startDate: any, updatedAt: any }> | null, socialLinks: { __typename?: 'SocialLinks', facebook?: string | null, github?: string | null, linkedIn?: string | null, twitter?: string | null }, workExperience: Array<{ __typename?: 'WorkExperience', id: string, companyName: string, country?: string | null, createdAt: any, description?: string | null, employmentType: EmploymentTypeEnum, endDate?: any | null, isOngoing: boolean, locality?: string | null, startDate: any, title: string, updatedAt: any, isInTech: boolean }> } } };

export type UpdateWorkExperienceMutationVariables = Exact<{
  input: UpdateWorkExperienceInput;
}>;


export type UpdateWorkExperienceMutation = { __typename?: 'Mutation', updateWorkExperience: { __typename?: 'UpdateWorkExperiencePayload', user: { __typename?: 'User', sandId?: string | null, workExperience: Array<{ __typename?: 'WorkExperience', id: string, companyName: string, country?: string | null, createdAt: any, description?: string | null, employmentType: EmploymentTypeEnum, endDate?: any | null, isOngoing: boolean, locality?: string | null, startDate: any, title: string, updatedAt: any, isInTech: boolean }> } } };

export type AdminAddClassMutationVariables = Exact<{
  input: AdminAddClassInput;
}>;


export type AdminAddClassMutation = { __typename?: 'Mutation', adminAddClass: { __typename?: 'AdminAddClassPayload', class: { __typename?: 'AdminClassView', id: string } } };

export type AdminAddCohortMutationVariables = Exact<{
  input: AdminAddCohortInput;
}>;


export type AdminAddCohortMutation = { __typename?: 'Mutation', adminAddCohort: { __typename?: 'AdminAddCohortPayload', cohort: { __typename?: 'AdminCohortView', id: string, name: string } } };

export type AdminAddCourseDefinitionMutationVariables = Exact<{
  input: AdminAddCourseDefinitionInput;
}>;


export type AdminAddCourseDefinitionMutation = { __typename?: 'Mutation', adminAddCourseDefinition: { __typename?: 'AdminAddCourseDefinitionPayload', course: { __typename?: 'AdminCourseDefinitionView', id: string, name: string, description?: string | null, abbreviation: string } } };

export type AdminAddCoursePrerequisitesMutationVariables = Exact<{
  input: AdminAddCoursePrerequisitesInput;
}>;


export type AdminAddCoursePrerequisitesMutation = { __typename?: 'Mutation', adminAddCoursePrerequisites: { __typename?: 'AdminAddCoursePrerequisitesPayload', programCourse: { __typename?: 'AdminProgramCourseView', id: string, mustHavePrerequisites: Array<{ __typename?: 'AdminCourseDefinitionView', id: string }>, oneOfPrerequisites: Array<{ __typename?: 'AdminCourseDefinitionView', id: string }>, doneWithPrerequisites: Array<{ __typename?: 'AdminCourseDefinitionView', id: string }> } } };

export type AdminAddLeaveOfAbsenceToLearnerMutationVariables = Exact<{
  input: AdminAddLeaveOfAbsenceToLearnerInput;
}>;


export type AdminAddLeaveOfAbsenceToLearnerMutation = { __typename?: 'Mutation', adminAddLeaveOfAbsenceToLearner: { __typename?: 'AdminAddLeaveOfAbsenceToLearnerPayload', programEnrollment: { __typename?: 'AdminProgramEnrollmentView', id: string, leaveOfAbsenceDescription?: string | null, leaveOfAbsenceReason?: DeferralReason | null } } };

export type AdminAddProgramMutationVariables = Exact<{
  input: AdminAddProgramInput;
}>;


export type AdminAddProgramMutation = { __typename?: 'Mutation', adminAddProgram: { __typename?: 'AdminAddProgramPayload', program: { __typename?: 'AdminProgramView', id: string } } };

export type AdminUpdateProgramMutationVariables = Exact<{
  input: AdminUpdateProgramInput;
}>;


export type AdminUpdateProgramMutation = { __typename?: 'Mutation', adminUpdateProgram: { __typename?: 'AdminUpdateProgramPayload', program: { __typename?: 'AdminProgramView', id: string } } };

export type AdminUpdateProgramApplicationEnglishProficiencyMutationVariables = Exact<{
  input: AdminUpdateProgramApplicationEnglishProficiencyInput;
}>;


export type AdminUpdateProgramApplicationEnglishProficiencyMutation = { __typename?: 'Mutation', adminUpdateProgramApplicationEnglishProficiency: { __typename?: 'AdminUpdateProgramApplicationEnglishProficiencyPayload', programApplication: { __typename?: 'AdminProgramApplicationView', id: string, englishProficiencyStatus: EnglishProficiencyStatus } } };

export type AdminUpdateProgramApplicationAdmissionStatusMutationVariables = Exact<{
  input: AdminUpdateProgramApplicationAdmissionStatusInput;
}>;


export type AdminUpdateProgramApplicationAdmissionStatusMutation = { __typename?: 'Mutation', adminUpdateProgramApplicationAdmissionStatus: { __typename?: 'AdminUpdateProgramApplicationAdmissionStatusPayload', programApplication: { __typename?: 'AdminProgramApplicationView', id: string, admissionStatus: ProgramApplicationAdmissionStatus, docusignEnrollmentAgreement?: { __typename?: 'AdminDocusignEnrollmentAgreement', envelopeId: string, envelopeStatus?: string | null, applicantStatus?: string | null } | null } } };

export type AdminUpdateProgramApplicationPartnershipTypeMutationVariables = Exact<{
  input: AdminUpdateProgramApplicationPartnershipTypeInput;
}>;


export type AdminUpdateProgramApplicationPartnershipTypeMutation = { __typename?: 'Mutation', adminUpdateProgramApplicationPartnershipType: { __typename?: 'AdminUpdateProgramApplicationPartnershipTypePayload', programApplication: { __typename?: 'AdminProgramApplicationView', id: string, partnershipType: PartnershipType } } };

export type AdminFinalizeDocusignAgreementMutationVariables = Exact<{
  input: AdminFinalizeDocusignAgreementInput;
}>;


export type AdminFinalizeDocusignAgreementMutation = { __typename?: 'Mutation', adminFinalizeDocusignAgreement: { __typename?: 'AdminFinalizeDocusignAgreementPayload', programApplication: { __typename?: 'AdminProgramApplicationView', id: string, status: ProgramApplicationStatus, docusignEnrollmentAgreement?: { __typename?: 'AdminDocusignEnrollmentAgreement', envelopeId: string, envelopeStatus?: string | null, applicantStatus?: string | null, envelopeCompletedAt?: any | null } | null, programEnrollment: { __typename?: 'AdminProgramEnrollmentView', id: string, status?: ProgramEnrollmentStatus | null, paymentPlan?: { __typename?: 'PaymentPlan', paymentPlanId: string } | null } } } };

export type AdminUpdateProgramApplicationPartnershipMutationVariables = Exact<{
  input: AdminUpdateProgramApplicationPartnershipInput;
}>;


export type AdminUpdateProgramApplicationPartnershipMutation = { __typename?: 'Mutation', adminUpdateProgramApplicationPartnership: { __typename?: 'AdminUpdateProgramApplicationPartnershipPayload', programApplication: { __typename?: 'AdminProgramApplicationView', id: string, partnership?: { __typename?: 'AdminPartnership', id: string, name: string, paymentPlanId: string } | null } } };

export type AdminAddProgramEnrollmentMutationVariables = Exact<{
  input: AdminAddProgramEnrollmentInput;
}>;


export type AdminAddProgramEnrollmentMutation = { __typename?: 'Mutation', adminAddProgramEnrollment: { __typename?: 'AdminAddProgramEnrollmentPayload', programEnrollment: { __typename?: 'AdminProgramEnrollmentView', id: string, program: { __typename?: 'AdminProgramView', id: string } } } };

export type AdminAddCourseEnrollmentMutationVariables = Exact<{
  input: AdminAddCourseEnrollmentInput;
}>;


export type AdminAddCourseEnrollmentMutation = { __typename?: 'Mutation', adminAddCourseEnrollment: { __typename?: 'AdminAddCourseEnrollmentPayload', courseEnrollment: { __typename?: 'AdminCourseEnrollmentView', id: string, status?: CourseEnrollmentStatus | null } } };

export type AdminAddClassEnrollmentMutationVariables = Exact<{
  input: AdminAddClassEnrollmentInput;
}>;


export type AdminAddClassEnrollmentMutation = { __typename?: 'Mutation', adminAddClassEnrollment: { __typename?: 'AdminAddClassEnrollmentPayload', classEnrollment: { __typename?: 'AdminClassEnrollmentView', id: string, status?: ClassEnrollmentStatus | null, class: { __typename?: 'AdminClassView', id: string, name: string } } } };

export type AdminLinkCourseToProgramMutationVariables = Exact<{
  input: AdminLinkCourseToProgramInput;
}>;


export type AdminLinkCourseToProgramMutation = { __typename?: 'Mutation', adminLinkCourseToProgram: { __typename?: 'AdminLinkCourseToProgramPayload', programCourse: { __typename?: 'AdminProgramCourseView', id: string } } };

export type AdminAddLmsClassLocationMutationVariables = Exact<{
  input: AdminAddLmsClassLocationInput;
}>;


export type AdminAddLmsClassLocationMutation = { __typename?: 'Mutation', adminAddLmsClassLocation: { __typename?: 'AdminAddLmsClassLocationPayload', lmsClassLocation: { __typename?: 'AdminLmsClassLocationView', id: string, class: { __typename?: 'AdminClassView', id: string } } } };

export type AdminDeleteProgramCourseMutationVariables = Exact<{
  input: AdminDeleteProgramCourseInput;
}>;


export type AdminDeleteProgramCourseMutation = { __typename?: 'Mutation', adminDeleteProgramCourse: { __typename?: 'AdminDeleteProgramCoursePayload', programCourse?: { __typename?: 'AdminProgramCourseView', id: string } | null } };

export type AdminUpdateClassMutationVariables = Exact<{
  input: AdminUpdateClassInput;
}>;


export type AdminUpdateClassMutation = { __typename?: 'Mutation', adminUpdateClass: { __typename?: 'AdminUpdateClassPayload', class: { __typename?: 'AdminClassView', id: string, name: string, startDate?: any | null, endDate?: any | null } } };

export type AdminUpdateCohortMutationVariables = Exact<{
  input: AdminUpdateCohortInput;
}>;


export type AdminUpdateCohortMutation = { __typename?: 'Mutation', adminUpdateCohort: { __typename?: 'AdminUpdateCohortPayload', cohort: { __typename?: 'AdminCohortView', id: string, name: string } } };

export type AdminUpdateCourseDefinitionMutationVariables = Exact<{
  input: AdminUpdateCourseDefinitionInput;
}>;


export type AdminUpdateCourseDefinitionMutation = { __typename?: 'Mutation', adminUpdateCourseDefinition: { __typename?: 'AdminUpdateCourseDefinitionPayload', course: { __typename?: 'AdminCourseDefinitionView', id: string, name: string, category?: CourseCategory | null, description?: string | null } } };

export type AdminUpdateProgramCourseMutationVariables = Exact<{
  input: AdminUpdateProgramCourseInput;
}>;


export type AdminUpdateProgramCourseMutation = { __typename?: 'Mutation', adminUpdateProgramCourse: { __typename?: 'AdminUpdateProgramCoursePayload', programCourse: { __typename?: 'AdminProgramCourseView', id: string, maxDeferrals: number, maxRetakes: number, priority: number, credits: number } } };

export type AdminWithdrawLearnerFromProgramMutationVariables = Exact<{
  input: AdminWithdrawLearnerFromProgramInput;
}>;


export type AdminWithdrawLearnerFromProgramMutation = { __typename?: 'Mutation', adminWithdrawLearnerFromProgram: { __typename?: 'AdminWithdrawLearnerFromProgramPayload', programEnrollment: { __typename?: 'AdminProgramEnrollmentView', id: string, createdAt: any, withdrawalReason?: ProgramWithdrawalReason | null, withdrawalDescription?: string | null, leaveOfAbsenceDescription?: string | null, leaveOfAbsenceReason?: DeferralReason | null, failedAt?: any | null, graduatedAt?: any | null, reinstatedAt?: any | null, status?: ProgramEnrollmentStatus | null, cancelled: boolean, user: { __typename?: 'StaffUser', sandId: string }, programChanges: Array<{ __typename?: 'ProgramChangeView', id: string, createdAt: any, fromProgram: { __typename?: 'AdminProgramView', id: string, name: string, abbreviation: string }, toProgram: { __typename?: 'AdminProgramView', id: string, name: string, abbreviation: string }, changedByUser: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null } }>, cohort?: { __typename?: 'AdminCohortView', allowCourseDeferral: boolean, allowLeaveOfAbsence: boolean, id: string, name: string, endDate?: any | null, startDate?: any | null } | null, program: { __typename?: 'AdminProgramView', id: string, name: string, minTermCredits: number, maxTermCredits: number, abbreviation: string, description?: string | null, hasMultiCourseDisplay: boolean }, courseEnrollments: Array<{ __typename?: 'AdminCourseEnrollmentView', id: string, status?: CourseEnrollmentStatus | null, statusReason?: CourseEnrollmentStatusReason | null, createdAt: any, graduatedAt?: any | null, failedAt?: any | null, deferredAt?: any | null, course: { __typename?: 'AdminCourseDefinitionView', id: string, name: string, abbreviation: string, description?: string | null }, classEnrollments: Array<{ __typename?: 'AdminClassEnrollmentView', id: string, status?: ClassEnrollmentStatus | null, statusReason?: ClassEnrollmentStatusReason | null, createdAt: any, failedAt?: any | null, leaveOfAbsenceDescription?: string | null, leaveOfAbsenceReason?: DeferralReason | null, deferredAt?: any | null, deferralDescription?: string | null, deferralReason?: DeferralReason | null, graduatedAt?: any | null, reinstatedAt?: any | null, lastLeaveOfAbsenceAt?: any | null, class: { __typename?: 'AdminClassView', id: string, name: string, startDate?: any | null, endDate?: any | null }, lmsClassLocation: { __typename?: 'AdminLmsClassLocationView', id: string, name: string, lmsCourseId: string, lmsCohortId?: string | null, courseLink: string, preferredHub?: string | null, preferredCountryOfResidence?: string | null, learningPlatform?: LearningPlatform | null } }> }> } } };

export type AdminRecomputeProgramEnrollmentGpAsMutationVariables = Exact<{
  input: AdminRecomputeProgramEnrollmentGpAsInput;
}>;


export type AdminRecomputeProgramEnrollmentGpAsMutation = { __typename?: 'Mutation', adminRecomputeProgramEnrollmentGPAs: { __typename?: 'AdminRecomputeProgramEnrollmentGPAsPayload', programEnrollment: { __typename?: 'AdminProgramEnrollmentView', id: string, createdAt: any, withdrawalReason?: ProgramWithdrawalReason | null, withdrawalDescription?: string | null, leaveOfAbsenceDescription?: string | null, leaveOfAbsenceReason?: DeferralReason | null, failedAt?: any | null, graduatedAt?: any | null, reinstatedAt?: any | null, status?: ProgramEnrollmentStatus | null, cancelled: boolean, programChanges: Array<{ __typename?: 'ProgramChangeView', id: string, createdAt: any, fromProgram: { __typename?: 'AdminProgramView', id: string, name: string, abbreviation: string }, toProgram: { __typename?: 'AdminProgramView', id: string, name: string, abbreviation: string }, changedByUser: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null } }>, cohort?: { __typename?: 'AdminCohortView', allowCourseDeferral: boolean, allowLeaveOfAbsence: boolean, id: string, name: string, endDate?: any | null, startDate?: any | null } | null, program: { __typename?: 'AdminProgramView', id: string, name: string, minTermCredits: number, maxTermCredits: number, abbreviation: string, description?: string | null, hasMultiCourseDisplay: boolean }, courseEnrollments: Array<{ __typename?: 'AdminCourseEnrollmentView', id: string, status?: CourseEnrollmentStatus | null, statusReason?: CourseEnrollmentStatusReason | null, createdAt: any, graduatedAt?: any | null, failedAt?: any | null, deferredAt?: any | null, course: { __typename?: 'AdminCourseDefinitionView', id: string, name: string, abbreviation: string, description?: string | null }, classEnrollments: Array<{ __typename?: 'AdminClassEnrollmentView', id: string, status?: ClassEnrollmentStatus | null, statusReason?: ClassEnrollmentStatusReason | null, createdAt: any, failedAt?: any | null, leaveOfAbsenceDescription?: string | null, leaveOfAbsenceReason?: DeferralReason | null, deferredAt?: any | null, deferralDescription?: string | null, deferralReason?: DeferralReason | null, graduatedAt?: any | null, reinstatedAt?: any | null, lastLeaveOfAbsenceAt?: any | null, class: { __typename?: 'AdminClassView', id: string, name: string, startDate?: any | null, endDate?: any | null }, lmsClassLocation: { __typename?: 'AdminLmsClassLocationView', id: string, name: string, lmsCourseId: string, lmsCohortId?: string | null, courseLink: string, preferredHub?: string | null, preferredCountryOfResidence?: string | null, learningPlatform?: LearningPlatform | null } }> }> } } };

export type MarkClassEnrollmentAsDeferredMutationVariables = Exact<{
  input: MarkClassEnrollmentAsDeferredInput;
}>;


export type MarkClassEnrollmentAsDeferredMutation = { __typename?: 'Mutation', markClassEnrollmentAsDeferred: { __typename?: 'MarkClassEnrollmentAsDeferredPayload', classEnrollments: Array<{ __typename?: 'ClassEnrollment', id: string, status: ClassEnrollmentStatus, statusReason?: ClassEnrollmentStatusReason | null }> } };

export type AddLeaveOfAbsenceToLearnerMutationVariables = Exact<{
  input: AddLeaveOfAbsenceToLearnerInput;
}>;


export type AddLeaveOfAbsenceToLearnerMutation = { __typename?: 'Mutation', addLeaveOfAbsenceToLearner: { __typename?: 'AddLeaveOfAbsenceToLearnerPayload', programEnrollment: { __typename?: 'ProgramEnrollment', id: string, createdAt: any, withdrawalReason?: ProgramWithdrawalReason | null, withdrawalDescription?: string | null, leaveOfAbsenceDescription?: string | null, leaveOfAbsenceReason?: DeferralReason | null, failedAt?: any | null, graduatedAt?: any | null, reinstatedAt?: any | null, status: ProgramEnrollmentStatus, cumulativeGPA?: number | null, program: { __typename?: 'Program', id: string, name: string, abbreviation: string, description?: string | null, hasMultiCourseDisplay: boolean, minTermCredits: number, allowLeaveOfAbsence: boolean, allowCourseDeferral: boolean }, plannedCourses: Array<{ __typename?: 'PlannedCourse', id: string, courseGroupKey?: string | null, credits: number, details: { __typename?: 'CourseDefinition', id: string, name: string, abbreviation: string, description?: string | null, type?: string | null, issuedBadge?: { __typename?: 'IssuedBadge', id: string, status: BadgeStatus, issuedAt: any, verificationUrl: string, linkedInShareUrl: string, badgeDefinition?: { __typename?: 'BadgeDefinition', id: string, name: string, description: string, imageUrl?: string | null } | null } | null }, enrollment?: { __typename?: 'CourseEnrollment', id: string, status: CourseEnrollmentStatus, currentClass?: { __typename?: 'ClassEnrollment', id: string, status: ClassEnrollmentStatus, lmsClassLocation: { __typename?: 'LmsClassLocation', id: string, courseLink: string }, proofOfCompletion?: { __typename?: 'ProofOfCompletion', email?: string | null, user: { __typename?: 'User', sandId?: string | null } } | null, class: { __typename?: 'Class', id: string, startDate?: any | null, endDate?: any | null, proofOfCompletionType: ProofOfCompletionType, requiresProofOfCompletionAfter?: any | null, canShowUniversityUpsellAfter?: any | null } } | null } | null }> } } };

export type WithdrawFromProgramMutationVariables = Exact<{
  input: WithdrawFromProgramInput;
}>;


export type WithdrawFromProgramMutation = { __typename?: 'Mutation', withdrawFromProgram: { __typename?: 'WithdrawFromProgramPayload', programEnrollment: { __typename?: 'ProgramEnrollment', id: string, createdAt: any, withdrawalReason?: ProgramWithdrawalReason | null, withdrawalDescription?: string | null, leaveOfAbsenceDescription?: string | null, leaveOfAbsenceReason?: DeferralReason | null, failedAt?: any | null, graduatedAt?: any | null, reinstatedAt?: any | null, status: ProgramEnrollmentStatus, cumulativeGPA?: number | null, user: { __typename?: 'User', sandId?: string | null, availablePrograms?: Array<{ __typename?: 'Program', id: string, name: string, abbreviation: string, description?: string | null, isEnrolled: boolean, marketing: { __typename?: 'ProgramMarketing', title?: string | null, subtitle?: string | null, sectionSummary?: string | null, sectionTitle?: string | null, timeCommitment?: string | null, video?: string | null, thumbnail?: string | null, highlights: Array<string> }, potentialProgramJourney?: { __typename?: 'PotentialProgramJourney', startDate?: any | null, potentialCourseEnrollments: Array<{ __typename?: 'PotentialCourseEnrollment', existingEnrollment?: { __typename?: 'ClassEnrollment', id: string, status: ClassEnrollmentStatus, class: { __typename?: 'Class', id: string, startDate?: any | null, endDate?: any | null }, courseEnrollment: { __typename?: 'CourseEnrollment', id: string, status: CourseEnrollmentStatus } } | null, firstAvailableClass?: { __typename?: 'Class', id: string, startDate?: any | null, endDate?: any | null } | null, courseDetails?: { __typename?: 'CourseDefinition', id: string, name: string, abbreviation: string, description?: string | null } | null }> } | null }> | null }, program: { __typename?: 'Program', id: string, name: string, abbreviation: string, description?: string | null, hasMultiCourseDisplay: boolean, minTermCredits: number, allowLeaveOfAbsence: boolean, allowCourseDeferral: boolean }, plannedCourses: Array<{ __typename?: 'PlannedCourse', id: string, courseGroupKey?: string | null, credits: number, details: { __typename?: 'CourseDefinition', id: string, name: string, abbreviation: string, description?: string | null, type?: string | null, issuedBadge?: { __typename?: 'IssuedBadge', id: string, status: BadgeStatus, issuedAt: any, verificationUrl: string, linkedInShareUrl: string, badgeDefinition?: { __typename?: 'BadgeDefinition', id: string, name: string, description: string, imageUrl?: string | null } | null } | null }, enrollment?: { __typename?: 'CourseEnrollment', id: string, status: CourseEnrollmentStatus, currentClass?: { __typename?: 'ClassEnrollment', id: string, status: ClassEnrollmentStatus, lmsClassLocation: { __typename?: 'LmsClassLocation', id: string, courseLink: string }, proofOfCompletion?: { __typename?: 'ProofOfCompletion', email?: string | null, user: { __typename?: 'User', sandId?: string | null } } | null, class: { __typename?: 'Class', id: string, startDate?: any | null, endDate?: any | null, proofOfCompletionType: ProofOfCompletionType, requiresProofOfCompletionAfter?: any | null, canShowUniversityUpsellAfter?: any | null } } | null } | null }> } } };

export type AdminCheckInUserMutationVariables = Exact<{
  input: AdminCheckInUserInput;
}>;


export type AdminCheckInUserMutation = { __typename?: 'Mutation', adminCheckInUser: { __typename?: 'AdminCheckInUserPayload', user: { __typename?: 'User', sandId?: string | null, firstName?: string | null, lastName?: string | null, profilePhoto?: string | null, title?: string | null, programEnrollments: Array<{ __typename?: 'ProgramEnrollment', id: string, createdAt: any, withdrawalReason?: ProgramWithdrawalReason | null, withdrawalDescription?: string | null, leaveOfAbsenceDescription?: string | null, leaveOfAbsenceReason?: DeferralReason | null, failedAt?: any | null, graduatedAt?: any | null, reinstatedAt?: any | null, status: ProgramEnrollmentStatus, academicStanding?: AcademicStanding | null, cohort?: { __typename?: 'Cohort', id: string, name: string, endDate?: any | null, startDate?: any | null } | null, program: { __typename?: 'Program', id: string, name: string, minTermCredits: number, maxTermCredits: number, abbreviation: string, description?: string | null, hasMultiCourseDisplay: boolean, allowCourseDeferral: boolean, allowLeaveOfAbsence: boolean, isUniversityProgram: boolean }, courseEnrollments: Array<{ __typename?: 'CourseEnrollment', id: string, status: CourseEnrollmentStatus, statusReason?: CourseEnrollmentStatusReason | null, createdAt: any, graduatedAt?: any | null, failedAt?: any | null, deferredAt?: any | null, course: { __typename?: 'CourseDefinition', id: string, name: string, abbreviation: string, description?: string | null }, classEnrollments: Array<{ __typename?: 'ClassEnrollment', id: string, status: ClassEnrollmentStatus, statusReason?: ClassEnrollmentStatusReason | null, createdAt: any, failedAt?: any | null, leaveOfAbsenceDescription?: string | null, leaveOfAbsenceReason?: DeferralReason | null, deferredAt?: any | null, deferralDescription?: string | null, deferralReason?: DeferralReason | null, graduatedAt?: any | null, reinstatedAt?: any | null, lastLeaveOfAbsenceAt?: any | null, class: { __typename?: 'Class', id: string, name: string, startDate?: any | null, endDate?: any | null }, lmsClassLocation: { __typename?: 'LmsClassLocation', id: string, name: string, courseLink: string, learningPlatform?: LearningPlatform | null } }> }> }>, currentCheckIn?: { __typename?: 'HubCheckIn', checkedInAt: any, checkedOutAt?: any | null, checkInDay: string, createdAt: any, hub: { __typename?: 'Hub', id: string, address?: string | null, name: string, description: string, country?: string | null, county?: string | null, locality?: string | null } } | null } } };

export type SelfCheckInMutationVariables = Exact<{
  input: SelfCheckInInput;
}>;


export type SelfCheckInMutation = { __typename?: 'Mutation', selfCheckIn: { __typename?: 'SelfCheckInPayload', user: { __typename?: 'User', sandId?: string | null, currentCheckIn?: { __typename?: 'HubCheckIn', checkInDay: string, createdAt: any, hub: { __typename?: 'Hub', id: string, address?: string | null, name: string, description: string, country?: string | null, county?: string | null, locality?: string | null } } | null } } };

export type AdminReinstateLearnerIntoProgramMutationVariables = Exact<{
  input: AdminReinstateLearnerIntoProgramInput;
}>;


export type AdminReinstateLearnerIntoProgramMutation = { __typename?: 'Mutation', adminReinstateLearnerIntoProgram: { __typename?: 'AdminReinstateLearnerIntoProgramPayload', programEnrollment: { __typename?: 'AdminProgramEnrollmentView', id: string, createdAt: any, withdrawalReason?: ProgramWithdrawalReason | null, withdrawalDescription?: string | null, leaveOfAbsenceDescription?: string | null, leaveOfAbsenceReason?: DeferralReason | null, failedAt?: any | null, graduatedAt?: any | null, reinstatedAt?: any | null, status?: ProgramEnrollmentStatus | null, cancelled: boolean, user: { __typename?: 'StaffUser', sandId: string }, programChanges: Array<{ __typename?: 'ProgramChangeView', id: string, createdAt: any, fromProgram: { __typename?: 'AdminProgramView', id: string, name: string, abbreviation: string }, toProgram: { __typename?: 'AdminProgramView', id: string, name: string, abbreviation: string }, changedByUser: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null } }>, cohort?: { __typename?: 'AdminCohortView', allowCourseDeferral: boolean, allowLeaveOfAbsence: boolean, id: string, name: string, endDate?: any | null, startDate?: any | null } | null, program: { __typename?: 'AdminProgramView', id: string, name: string, minTermCredits: number, maxTermCredits: number, abbreviation: string, description?: string | null, hasMultiCourseDisplay: boolean }, courseEnrollments: Array<{ __typename?: 'AdminCourseEnrollmentView', id: string, status?: CourseEnrollmentStatus | null, statusReason?: CourseEnrollmentStatusReason | null, createdAt: any, graduatedAt?: any | null, failedAt?: any | null, deferredAt?: any | null, course: { __typename?: 'AdminCourseDefinitionView', id: string, name: string, abbreviation: string, description?: string | null }, classEnrollments: Array<{ __typename?: 'AdminClassEnrollmentView', id: string, status?: ClassEnrollmentStatus | null, statusReason?: ClassEnrollmentStatusReason | null, createdAt: any, failedAt?: any | null, leaveOfAbsenceDescription?: string | null, leaveOfAbsenceReason?: DeferralReason | null, deferredAt?: any | null, deferralDescription?: string | null, deferralReason?: DeferralReason | null, graduatedAt?: any | null, reinstatedAt?: any | null, lastLeaveOfAbsenceAt?: any | null, class: { __typename?: 'AdminClassView', id: string, name: string, startDate?: any | null, endDate?: any | null }, lmsClassLocation: { __typename?: 'AdminLmsClassLocationView', id: string, name: string, lmsCourseId: string, lmsCohortId?: string | null, courseLink: string, preferredHub?: string | null, preferredCountryOfResidence?: string | null, learningPlatform?: LearningPlatform | null } }> }> } } };

export type AdminRemoveGraduationFromProgramEnrollmentMutationVariables = Exact<{
  input: AdminRemoveGraduationFromProgramEnrollmentInput;
}>;


export type AdminRemoveGraduationFromProgramEnrollmentMutation = { __typename?: 'Mutation', adminRemoveGraduationFromProgramEnrollment: { __typename?: 'AdminRemoveGraduationFromProgramEnrollmentPayload', programEnrollment: { __typename?: 'AdminProgramEnrollmentView', id: string, createdAt: any, withdrawalReason?: ProgramWithdrawalReason | null, withdrawalDescription?: string | null, leaveOfAbsenceDescription?: string | null, leaveOfAbsenceReason?: DeferralReason | null, failedAt?: any | null, graduatedAt?: any | null, reinstatedAt?: any | null, status?: ProgramEnrollmentStatus | null, cancelled: boolean, user: { __typename?: 'StaffUser', sandId: string }, programChanges: Array<{ __typename?: 'ProgramChangeView', id: string, createdAt: any, fromProgram: { __typename?: 'AdminProgramView', id: string, name: string, abbreviation: string }, toProgram: { __typename?: 'AdminProgramView', id: string, name: string, abbreviation: string }, changedByUser: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null } }>, cohort?: { __typename?: 'AdminCohortView', allowCourseDeferral: boolean, allowLeaveOfAbsence: boolean, id: string, name: string, endDate?: any | null, startDate?: any | null } | null, program: { __typename?: 'AdminProgramView', id: string, name: string, minTermCredits: number, maxTermCredits: number, abbreviation: string, description?: string | null, hasMultiCourseDisplay: boolean }, courseEnrollments: Array<{ __typename?: 'AdminCourseEnrollmentView', id: string, status?: CourseEnrollmentStatus | null, statusReason?: CourseEnrollmentStatusReason | null, createdAt: any, graduatedAt?: any | null, failedAt?: any | null, deferredAt?: any | null, course: { __typename?: 'AdminCourseDefinitionView', id: string, name: string, abbreviation: string, description?: string | null }, classEnrollments: Array<{ __typename?: 'AdminClassEnrollmentView', id: string, status?: ClassEnrollmentStatus | null, statusReason?: ClassEnrollmentStatusReason | null, createdAt: any, failedAt?: any | null, leaveOfAbsenceDescription?: string | null, leaveOfAbsenceReason?: DeferralReason | null, deferredAt?: any | null, deferralDescription?: string | null, deferralReason?: DeferralReason | null, graduatedAt?: any | null, reinstatedAt?: any | null, lastLeaveOfAbsenceAt?: any | null, class: { __typename?: 'AdminClassView', id: string, name: string, startDate?: any | null, endDate?: any | null }, lmsClassLocation: { __typename?: 'AdminLmsClassLocationView', id: string, name: string, lmsCourseId: string, lmsCohortId?: string | null, courseLink: string, preferredHub?: string | null, preferredCountryOfResidence?: string | null, learningPlatform?: LearningPlatform | null } }> }> } } };

export type AdminRemoveCoursePrerequisitesMutationVariables = Exact<{
  input: AdminRemoveCoursePrerequisitesInput;
}>;


export type AdminRemoveCoursePrerequisitesMutation = { __typename?: 'Mutation', adminRemoveCoursePrerequisites: { __typename?: 'AdminRemoveCoursePrerequisitesPayload', programCourse: { __typename?: 'AdminProgramCourseView', id: string, mustHavePrerequisites: Array<{ __typename?: 'AdminCourseDefinitionView', id: string }>, oneOfPrerequisites: Array<{ __typename?: 'AdminCourseDefinitionView', id: string }>, doneWithPrerequisites: Array<{ __typename?: 'AdminCourseDefinitionView', id: string }> } } };

export type AdminRunEnrollmentProgressionMutationVariables = Exact<{
  input: AdminRunEnrollmentProgressionInput;
}>;


export type AdminRunEnrollmentProgressionMutation = { __typename?: 'Mutation', adminRunEnrollmentProgression: { __typename?: 'AdminRunEnrollmentProgressionPayload', programEnrollment: { __typename?: 'AdminProgramEnrollmentView', id: string, createdAt: any, withdrawalReason?: ProgramWithdrawalReason | null, withdrawalDescription?: string | null, leaveOfAbsenceDescription?: string | null, leaveOfAbsenceReason?: DeferralReason | null, failedAt?: any | null, graduatedAt?: any | null, reinstatedAt?: any | null, status?: ProgramEnrollmentStatus | null, cancelled: boolean, programChanges: Array<{ __typename?: 'ProgramChangeView', id: string, createdAt: any, fromProgram: { __typename?: 'AdminProgramView', id: string, name: string, abbreviation: string }, toProgram: { __typename?: 'AdminProgramView', id: string, name: string, abbreviation: string }, changedByUser: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null } }>, cohort?: { __typename?: 'AdminCohortView', allowCourseDeferral: boolean, allowLeaveOfAbsence: boolean, id: string, name: string, endDate?: any | null, startDate?: any | null } | null, program: { __typename?: 'AdminProgramView', id: string, name: string, minTermCredits: number, maxTermCredits: number, abbreviation: string, description?: string | null, hasMultiCourseDisplay: boolean }, courseEnrollments: Array<{ __typename?: 'AdminCourseEnrollmentView', id: string, status?: CourseEnrollmentStatus | null, statusReason?: CourseEnrollmentStatusReason | null, createdAt: any, graduatedAt?: any | null, failedAt?: any | null, deferredAt?: any | null, course: { __typename?: 'AdminCourseDefinitionView', id: string, name: string, abbreviation: string, description?: string | null }, classEnrollments: Array<{ __typename?: 'AdminClassEnrollmentView', id: string, status?: ClassEnrollmentStatus | null, statusReason?: ClassEnrollmentStatusReason | null, createdAt: any, failedAt?: any | null, leaveOfAbsenceDescription?: string | null, leaveOfAbsenceReason?: DeferralReason | null, deferredAt?: any | null, deferralDescription?: string | null, deferralReason?: DeferralReason | null, graduatedAt?: any | null, reinstatedAt?: any | null, lastLeaveOfAbsenceAt?: any | null, class: { __typename?: 'AdminClassView', id: string, name: string, startDate?: any | null, endDate?: any | null }, lmsClassLocation: { __typename?: 'AdminLmsClassLocationView', id: string, name: string, lmsCourseId: string, lmsCohortId?: string | null, courseLink: string, preferredHub?: string | null, preferredCountryOfResidence?: string | null, learningPlatform?: LearningPlatform | null } }> }> } } };

export type SavannaCreateLearnerMutationVariables = Exact<{
  input: SavannaCreateLearnerInput;
}>;


export type SavannaCreateLearnerMutation = { __typename?: 'Mutation', savannaCreateLearner?: { __typename?: 'SavannaCreateLearnerPayload', errors?: string | null, learner?: { __typename?: 'User', sandId?: string | null, savannaId: string } | null } | null };

export type AdminAthenaCreateLearnerMutationVariables = Exact<{
  sandId: Scalars['String']['input'];
  input: CreateANewAthenaUserData;
}>;


export type AdminAthenaCreateLearnerMutation = { __typename?: 'Mutation', athenaCreateANewUserAccount?: { __typename?: 'CreateNewUserResponse', success?: boolean | null, message?: string | null } | null };

export type AdminAthenaAssignLearnerToProgramMutationVariables = Exact<{
  sandId: Scalars['String']['input'];
  input: AllocateToProgramme;
}>;


export type AdminAthenaAssignLearnerToProgramMutation = { __typename?: 'Mutation', athenaAssignStudentToAProgramme?: { __typename?: 'AssignStudentToProgrammeResponse', success?: boolean | null, message?: string | null } | null };

export type SavannaAssignLearnerToProgramMutationVariables = Exact<{
  input: SavannaAssignLearnerToProgramInput;
}>;


export type SavannaAssignLearnerToProgramMutation = { __typename?: 'Mutation', savannaAssignLearnerToProgram?: { __typename?: 'SavannaAssignLearnerToProgramPayload', errors?: string | null, learner?: { __typename?: 'User', savannaId: string } | null } | null };

export type CreateProgramPaymentPlanMutationVariables = Exact<{
  paymentPlanDefinitionId: Scalars['String']['input'];
  sandId: Scalars['String']['input'];
  planIdentifier: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
}>;


export type CreateProgramPaymentPlanMutation = { __typename?: 'Mutation', createPaymentPlan: { __typename?: 'PaymentPlan', paymentPlanId: string } };

export type AdminCreateNotificationsMutationVariables = Exact<{
  input: AdminCreateNotificationsInput;
}>;


export type AdminCreateNotificationsMutation = { __typename?: 'Mutation', adminCreateNotifications: { __typename?: 'AdminCreateNotificationsPayload', count: number } };

export type AdminPushEventsToBusMutationVariables = Exact<{
  input: AdminPushEventsToBusInput;
}>;


export type AdminPushEventsToBusMutation = { __typename?: 'Mutation', adminPushEventsToBus: { __typename?: 'AdminPushEventsToBusPayload', count: number } };

export type SavannaWithdrawLearnerMutationVariables = Exact<{
  input: SavannaWithdrawLearnerInput;
}>;


export type SavannaWithdrawLearnerMutation = { __typename?: 'Mutation', savannaWithdrawLearner?: { __typename?: 'SavannaWithdrawLearnerPayload', errors?: string | null, userCurriculumStatus?: { __typename?: 'UserCurriculumStatus', status: string, batch: { __typename?: 'Batch', id: string }, curriculum: { __typename?: 'Curriculum', id: string } } | null } | null };

export type CancelPaymentPlanMutationVariables = Exact<{
  paymentPlanId: Scalars['String']['input'];
}>;


export type CancelPaymentPlanMutation = { __typename?: 'Mutation', cancelPaymentPlan: { __typename?: 'PaymentPlan', sandId: string } };

export type AdminManualCheckInMutationVariables = Exact<{
  input: AdminManualCheckInInput;
}>;


export type AdminManualCheckInMutation = { __typename?: 'Mutation', adminManualCheckIn: { __typename?: 'AdminManualCheckInPayload', checkIn: { __typename?: 'HubCheckIn', checkedInAt: any, checkedOutAt?: any | null, hub: { __typename?: 'Hub', id: string, name: string }, user: { __typename?: 'User', sandId?: string | null, firstName?: string | null, lastName?: string | null, profilePhoto?: string | null, programEnrollments: Array<{ __typename?: 'ProgramEnrollment', program: { __typename?: 'Program', abbreviation: string, name: string } }>, currentCheckIn?: { __typename?: 'HubCheckIn', checkInDay: string, checkedInAt: any, checkedOutAt?: any | null, hub: { __typename?: 'Hub', id: string, name: string, locality?: string | null }, user: { __typename?: 'User', sandId?: string | null } } | null } } } };

export type AdminMarkOngoingClassEnrollmentAsFailedMutationVariables = Exact<{
  input: AdminMarkOngoingClassEnrollmentAsFailedInput;
}>;


export type AdminMarkOngoingClassEnrollmentAsFailedMutation = { __typename?: 'Mutation', adminMarkOngoingClassEnrollmentAsFailed: { __typename?: 'AdminMarkOngoingClassEnrollmentAsFailedPayload', classEnrollment: { __typename?: 'AdminClassEnrollmentView', id: string, status?: ClassEnrollmentStatus | null, createdAt: any, failedAt?: any | null, graduatedAt?: any | null } } };

export type AdminMarkOngoingClassEnrollmentAsGraduatedMutationVariables = Exact<{
  input: AdminMarkOngoingClassEnrollmentAsGraduatedInput;
}>;


export type AdminMarkOngoingClassEnrollmentAsGraduatedMutation = { __typename?: 'Mutation', adminMarkOngoingClassEnrollmentAsGraduated: { __typename?: 'AdminMarkOngoingClassEnrollmentAsGraduatedPayload', classEnrollment: { __typename?: 'AdminClassEnrollmentView', id: string, status?: ClassEnrollmentStatus | null, createdAt: any, failedAt?: any | null, graduatedAt?: any | null } } };

export type AdminMarkFailedClassEnrollmentAsOngoingMutationVariables = Exact<{
  input: AdminMarkFailedClassEnrollmentAsOngoingInput;
}>;


export type AdminMarkFailedClassEnrollmentAsOngoingMutation = { __typename?: 'Mutation', adminMarkFailedClassEnrollmentAsOngoing: { __typename?: 'AdminMarkFailedClassEnrollmentAsOngoingPayload', classEnrollment: { __typename?: 'AdminClassEnrollmentView', id: string, status?: ClassEnrollmentStatus | null, createdAt: any, failedAt?: any | null, graduatedAt?: any | null } } };

export type AdminMarkFailedClassEnrollmentAsGraduatedMutationVariables = Exact<{
  input: AdminMarkFailedClassEnrollmentAsGraduatedInput;
}>;


export type AdminMarkFailedClassEnrollmentAsGraduatedMutation = { __typename?: 'Mutation', adminMarkFailedClassEnrollmentAsGraduated: { __typename?: 'AdminMarkFailedClassEnrollmentAsGraduatedPayload', classEnrollment: { __typename?: 'AdminClassEnrollmentView', id: string, status?: ClassEnrollmentStatus | null, createdAt: any, failedAt?: any | null, graduatedAt?: any | null } } };

export type AdminMarkGraduatedClassEnrollmentAsOngoingMutationVariables = Exact<{
  input: AdminMarkGraduatedClassEnrollmentAsOngoingInput;
}>;


export type AdminMarkGraduatedClassEnrollmentAsOngoingMutation = { __typename?: 'Mutation', adminMarkGraduatedClassEnrollmentAsOngoing: { __typename?: 'AdminMarkGraduatedClassEnrollmentAsOngoingPayload', classEnrollment: { __typename?: 'AdminClassEnrollmentView', id: string, status?: ClassEnrollmentStatus | null, createdAt: any, failedAt?: any | null, graduatedAt?: any | null } } };

export type AdminMarkGraduatedClassEnrollmentAsFailedMutationVariables = Exact<{
  input: AdminMarkGraduatedClassEnrollmentAsFailedInput;
}>;


export type AdminMarkGraduatedClassEnrollmentAsFailedMutation = { __typename?: 'Mutation', adminMarkGraduatedClassEnrollmentAsFailed: { __typename?: 'AdminMarkGraduatedClassEnrollmentAsFailedPayload', classEnrollment: { __typename?: 'AdminClassEnrollmentView', id: string, status?: ClassEnrollmentStatus | null, createdAt: any, failedAt?: any | null, graduatedAt?: any | null } } };

export type ApplyToProgramMutationVariables = Exact<{
  programInput: ApplyToProgramInput;
}>;


export type ApplyToProgramMutation = { __typename?: 'Mutation', applyToProgram: { __typename?: 'ApplyToProgramPayload', user: { __typename?: 'User', sandId?: string | null, phoneNumber?: string | null, birthDate?: any | null, countryOfResidence?: string | null, programEnrollments: Array<{ __typename?: 'ProgramEnrollment', id: string, status: ProgramEnrollmentStatus, cumulativeGPA?: number | null, program: { __typename?: 'Program', id: string, name: string, abbreviation: string, description?: string | null, hasMultiCourseDisplay: boolean, minTermCredits: number, allowLeaveOfAbsence: boolean, allowCourseDeferral: boolean }, plannedCourses: Array<{ __typename?: 'PlannedCourse', id: string, courseGroupKey?: string | null, credits: number, details: { __typename?: 'CourseDefinition', id: string, name: string, abbreviation: string, description?: string | null, type?: string | null, issuedBadge?: { __typename?: 'IssuedBadge', id: string, status: BadgeStatus, issuedAt: any, verificationUrl: string, linkedInShareUrl: string, badgeDefinition?: { __typename?: 'BadgeDefinition', id: string, name: string, description: string, imageUrl?: string | null } | null } | null }, enrollment?: { __typename?: 'CourseEnrollment', id: string, status: CourseEnrollmentStatus, currentClass?: { __typename?: 'ClassEnrollment', id: string, status: ClassEnrollmentStatus, lmsClassLocation: { __typename?: 'LmsClassLocation', id: string, courseLink: string }, proofOfCompletion?: { __typename?: 'ProofOfCompletion', email?: string | null, user: { __typename?: 'User', sandId?: string | null } } | null, class: { __typename?: 'Class', id: string, startDate?: any | null, endDate?: any | null, proofOfCompletionType: ProofOfCompletionType, requiresProofOfCompletionAfter?: any | null, canShowUniversityUpsellAfter?: any | null } } | null } | null }> }>, availablePrograms?: Array<{ __typename?: 'Program', id: string, name: string, abbreviation: string, description?: string | null, isEnrolled: boolean, marketing: { __typename?: 'ProgramMarketing', title?: string | null, subtitle?: string | null, sectionSummary?: string | null, sectionTitle?: string | null, timeCommitment?: string | null, video?: string | null, thumbnail?: string | null, highlights: Array<string> }, potentialProgramJourney?: { __typename?: 'PotentialProgramJourney', startDate?: any | null, potentialCourseEnrollments: Array<{ __typename?: 'PotentialCourseEnrollment', existingEnrollment?: { __typename?: 'ClassEnrollment', id: string, status: ClassEnrollmentStatus, class: { __typename?: 'Class', id: string, startDate?: any | null, endDate?: any | null }, courseEnrollment: { __typename?: 'CourseEnrollment', id: string, status: CourseEnrollmentStatus } } | null, firstAvailableClass?: { __typename?: 'Class', id: string, startDate?: any | null, endDate?: any | null } | null, courseDetails?: { __typename?: 'CourseDefinition', id: string, name: string, abbreviation: string, description?: string | null } | null }> } | null }> | null } } };

export type ApplyToProgramAndUpdateUserMutationVariables = Exact<{
  programInput: ApplyToProgramInput;
  updateUserInput: UpdateUserInput;
}>;


export type ApplyToProgramAndUpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UpdateUserPayload', user: { __typename?: 'User', sandId?: string | null, phoneNumber?: string | null, whatsAppNumber?: string | null, gender?: Gender | null, birthDate?: any | null, countryOfResidence?: string | null } }, applyToProgram: { __typename?: 'ApplyToProgramPayload', user: { __typename?: 'User', sandId?: string | null, availablePrograms?: Array<{ __typename?: 'Program', id: string, name: string, abbreviation: string, description?: string | null, isEnrolled: boolean, marketing: { __typename?: 'ProgramMarketing', title?: string | null, subtitle?: string | null, sectionSummary?: string | null, sectionTitle?: string | null, timeCommitment?: string | null, video?: string | null, thumbnail?: string | null, highlights: Array<string> }, potentialProgramJourney?: { __typename?: 'PotentialProgramJourney', startDate?: any | null, potentialCourseEnrollments: Array<{ __typename?: 'PotentialCourseEnrollment', existingEnrollment?: { __typename?: 'ClassEnrollment', id: string, status: ClassEnrollmentStatus, class: { __typename?: 'Class', id: string, startDate?: any | null, endDate?: any | null }, courseEnrollment: { __typename?: 'CourseEnrollment', id: string, status: CourseEnrollmentStatus } } | null, firstAvailableClass?: { __typename?: 'Class', id: string, startDate?: any | null, endDate?: any | null } | null, courseDetails?: { __typename?: 'CourseDefinition', id: string, name: string, abbreviation: string, description?: string | null } | null }> } | null }> | null, programEnrollments: Array<{ __typename?: 'ProgramEnrollment', id: string, status: ProgramEnrollmentStatus, cumulativeGPA?: number | null, program: { __typename?: 'Program', id: string, name: string, abbreviation: string, description?: string | null, hasMultiCourseDisplay: boolean, minTermCredits: number, allowLeaveOfAbsence: boolean, allowCourseDeferral: boolean }, plannedCourses: Array<{ __typename?: 'PlannedCourse', id: string, courseGroupKey?: string | null, credits: number, details: { __typename?: 'CourseDefinition', id: string, name: string, abbreviation: string, description?: string | null, type?: string | null, issuedBadge?: { __typename?: 'IssuedBadge', id: string, status: BadgeStatus, issuedAt: any, verificationUrl: string, linkedInShareUrl: string, badgeDefinition?: { __typename?: 'BadgeDefinition', id: string, name: string, description: string, imageUrl?: string | null } | null } | null }, enrollment?: { __typename?: 'CourseEnrollment', id: string, status: CourseEnrollmentStatus, currentClass?: { __typename?: 'ClassEnrollment', id: string, status: ClassEnrollmentStatus, lmsClassLocation: { __typename?: 'LmsClassLocation', id: string, courseLink: string }, proofOfCompletion?: { __typename?: 'ProofOfCompletion', email?: string | null, user: { __typename?: 'User', sandId?: string | null } } | null, class: { __typename?: 'Class', id: string, startDate?: any | null, endDate?: any | null, proofOfCompletionType: ProofOfCompletionType, requiresProofOfCompletionAfter?: any | null, canShowUniversityUpsellAfter?: any | null } } | null } | null }> }> } } };

export type CreateProgramApplicationMutationVariables = Exact<{
  input: CreateProgramApplicationInput;
}>;


export type CreateProgramApplicationMutation = { __typename?: 'Mutation', createProgramApplication: { __typename?: 'CreateProgramApplicationPayload', programApplication: { __typename?: 'ProgramApplication', id: string, status: ProgramApplicationStatus } } };

export type UpdateProgramApplicationEnglishProficiencyProofMutationVariables = Exact<{
  input: UpdateProgramApplicationEnglishProficiencyProofInput;
}>;


export type UpdateProgramApplicationEnglishProficiencyProofMutation = { __typename?: 'Mutation', updateProgramApplicationEnglishProficiencyProof: { __typename?: 'UpdateProgramApplicationEnglishProficiencyProofPayload', programApplication: { __typename?: 'ProgramApplication', id: string, englishProficiencyStatus: EnglishProficiencyStatus, englishProficiencyType?: EnglishProficiencyType | null } } };

export type UpdateProgramApplicationHighSchoolCertificateMutationVariables = Exact<{
  input: UpdateProgramApplicationHighSchoolCertificateInput;
}>;


export type UpdateProgramApplicationHighSchoolCertificateMutation = { __typename?: 'Mutation', updateProgramApplicationHighSchoolCertificate: { __typename?: 'UpdateProgramApplicationHighSchoolCertificatePayload', highSchoolCertificate: { __typename?: 'HighSchoolCertificate', id: string, schoolName: string, country: string, city: string, state: string, graduationDate: any, schoolAddress: string, qualification: string } } };

export type AdminUpdateProgramApplicationHighSchoolCertificateMutationVariables = Exact<{
  input: AdminUpdateProgramApplicationHighSchoolCertificateInput;
}>;


export type AdminUpdateProgramApplicationHighSchoolCertificateMutation = { __typename?: 'Mutation', adminUpdateProgramApplicationHighSchoolCertificate: { __typename?: 'AdminUpdateProgramApplicationHighSchoolCertificatePayload', highSchoolCertificate: { __typename?: 'AdminHighSchoolCertificate', id: string, status: HighSchoolCertificateStatus } } };

export type SavannaUpdateLearnerMutationVariables = Exact<{
  input: SavannaUpdateLearnerInput;
}>;


export type SavannaUpdateLearnerMutation = { __typename?: 'Mutation', savannaUpdateLearner?: { __typename?: 'SavannaUpdateLearnerPayload', errors?: string | null, learner?: { __typename?: 'User', sandId?: string | null } | null } | null };

export type AdminUpdateUserMutationVariables = Exact<{
  input: AdminUpdateUserInput;
}>;


export type AdminUpdateUserMutation = { __typename?: 'Mutation', adminUpdateUser: { __typename?: 'AdminUpdateUserPayload', user: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null, middleName?: string | null, phoneNumber?: string | null, birthDate?: any | null, countryOfResidence?: string | null, countyOfResidence?: string | null, localityOfResidence?: string | null } } };

export type AdminUpdateUserSkipPaywallMutationVariables = Exact<{
  input: AdminUpdateUserSkipPaywallInput;
}>;


export type AdminUpdateUserSkipPaywallMutation = { __typename?: 'Mutation', adminUpdateUserSkipPaywall: { __typename?: 'AdminUpdateUserSkipPaywallPayload', user: { __typename?: 'StaffUser', sandId: string, skipPaywallReason?: string | null, skipPaywallUntil?: any | null, removedPaywallAt?: any | null } } };

export type AdminCreateRoleMutationVariables = Exact<{
  input: AdminCreateRoleInput;
}>;


export type AdminCreateRoleMutation = { __typename?: 'Mutation', adminCreateRole: { __typename?: 'AdminCreateRolePayload', role: { __typename?: 'Role', id: string, name: string, permissions: Array<Permission>, userCount: number, createdAt: any, updatedAt: any } } };

export type AdminUpdateRoleMutationVariables = Exact<{
  input: AdminUpdateRoleInput;
}>;


export type AdminUpdateRoleMutation = { __typename?: 'Mutation', adminUpdateRole: { __typename?: 'AdminUpdateRolePayload', role: { __typename?: 'Role', id: string, name: string, permissions: Array<Permission>, userCount: number, createdAt: any, updatedAt: any } } };

export type AdminDeleteRoleMutationVariables = Exact<{
  input: AdminDeleteRoleInput;
}>;


export type AdminDeleteRoleMutation = { __typename?: 'Mutation', adminDeleteRole: { __typename?: 'AdminDeleteRolePayload', role: { __typename?: 'Role', id: string, name: string, permissions: Array<Permission>, userCount: number, createdAt: any, updatedAt: any } } };

export type AdminAddPermissionToRoleMutationVariables = Exact<{
  input: AdminAddPermissionToRoleInput;
}>;


export type AdminAddPermissionToRoleMutation = { __typename?: 'Mutation', adminAddPermissionToRole: { __typename?: 'AdminAddPermissionToRolePayload', role: { __typename?: 'Role', id: string, name: string, permissions: Array<Permission>, userCount: number, createdAt: any, updatedAt: any } } };

export type AdminRemovePermissionFromRoleMutationVariables = Exact<{
  input: AdminRemovePermissionFromRoleInput;
}>;


export type AdminRemovePermissionFromRoleMutation = { __typename?: 'Mutation', adminRemovePermissionFromRole: { __typename?: 'AdminRemovePermissionFromRolePayload', role: { __typename?: 'Role', id: string, name: string, permissions: Array<Permission>, userCount: number, createdAt: any, updatedAt: any } } };

export type AdminAssignUserToRoleMutationVariables = Exact<{
  input: AdminAssignUserToRoleInput;
}>;


export type AdminAssignUserToRoleMutation = { __typename?: 'Mutation', adminAssignUserToRole: { __typename?: 'AdminAssignUserToRolePayload', user: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null, primaryEmail: string } } };

export type AdminRemoveUserFromRoleMutationVariables = Exact<{
  input: AdminRemoveUserFromRoleInput;
}>;


export type AdminRemoveUserFromRoleMutation = { __typename?: 'Mutation', adminRemoveUserFromRole: { __typename?: 'AdminRemoveUserFromRolePayload', user: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null, primaryEmail: string } } };

export type AdminBulkAssignUsersToRoleMutationVariables = Exact<{
  input: AdminBulkAssignUsersToRoleInput;
}>;


export type AdminBulkAssignUsersToRoleMutation = { __typename?: 'Mutation', adminBulkAssignUsersToRole: { __typename?: 'AdminBulkAssignUsersToRolePayload', successCount: number, users: Array<{ __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null, primaryEmail: string }> } };

export type AdminLockProgressionMutationVariables = Exact<{
  input: AdminLockProgressionInput;
}>;


export type AdminLockProgressionMutation = { __typename?: 'Mutation', adminLockProgression: { __typename?: 'AdminLockProgressionPayload', user: { __typename?: 'StaffUser', sandId: string, lockedProgression?: boolean | null, lockedProgressionBy?: string | null, lockedProgressionByAt?: any | null, lockedProgressionByUser?: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null } | null } } };

export type AdminUnlockProgressionMutationVariables = Exact<{
  input: AdminUnlockProgressionInput;
}>;


export type AdminUnlockProgressionMutation = { __typename?: 'Mutation', adminUnlockProgression: { __typename?: 'AdminUnlockProgressionPayload', user: { __typename?: 'StaffUser', sandId: string, lockedProgression?: boolean | null, lockedProgressionBy?: string | null, lockedProgressionByAt?: any | null, lockedProgressionByUser?: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null } | null } } };

export type SavannaUpdateSandIdMutationVariables = Exact<{
  input: SavannaUpdateSandIdInput;
}>;


export type SavannaUpdateSandIdMutation = { __typename?: 'Mutation', savannaUpdateSandId?: { __typename?: 'SavannaUpdateSandIdPayload', errors?: string | null, user?: { __typename?: 'User', sandId?: string | null } | null } | null };

export type ManagePersonaInquiryMutationVariables = Exact<{
  input: ManagePersonaInquiryInput;
}>;


export type ManagePersonaInquiryMutation = { __typename?: 'Mutation', managePersonaInquiry: { __typename?: 'ManagePersonaInquiryPayload', redirectUrl: string } };

export type AdminAddPartnershipMutationVariables = Exact<{
  input: AdminAddPartnershipInput;
}>;


export type AdminAddPartnershipMutation = { __typename?: 'Mutation', adminAddPartnership: { __typename?: 'AdminAddPartnershipPayload', partnership: { __typename?: 'AdminPartnership', id: string, createdAt: any, updatedAt: any, name: string, paymentPlanId: string, startDate: any, totalTuition: number, discount: number, termTuition: number, totalTuitionNetOfDiscounts: number } } };

export type AdminUpdatePartnershipMutationVariables = Exact<{
  input: AdminUpdatePartnershipInput;
}>;


export type AdminUpdatePartnershipMutation = { __typename?: 'Mutation', adminUpdatePartnership: { __typename?: 'AdminUpdatePartnershipPayload', partnership: { __typename?: 'AdminPartnership', id: string, createdAt: any, updatedAt: any, name: string, paymentPlanId: string, startDate: any, totalTuition: number, discount: number, termTuition: number, totalTuitionNetOfDiscounts: number } } };

export type AdminCreateTrainingResourceMutationVariables = Exact<{
  input: AdminCreateTrainingResourceInput;
}>;


export type AdminCreateTrainingResourceMutation = { __typename?: 'Mutation', adminCreateTrainingResource: { __typename?: 'AdminCreateTrainingResourcePayload', trainingResource: { __typename?: 'AdminTrainingResource', id: string, createdAt: any, updatedAt: any, title: string, description?: string | null, url: string, createdBy: string, creator?: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null } | null } } };

export type AdminDeleteTrainingResourceMutationVariables = Exact<{
  input: AdminDeleteTrainingResourceInput;
}>;


export type AdminDeleteTrainingResourceMutation = { __typename?: 'Mutation', adminDeleteTrainingResource: { __typename?: 'AdminDeleteTrainingResourcePayload', trainingResource: { __typename?: 'AdminTrainingResource', id: string } } };

export type ResendVerificationCodeMutationVariables = Exact<{
  input: ResendVerificationCodeInput;
}>;


export type ResendVerificationCodeMutation = { __typename?: 'Mutation', resendVerificationCode: { __typename?: 'ResendVerificationCodePayload', success: boolean } };

export type ForgotPasswordMutationVariables = Exact<{
  input: ForgotPasswordInput;
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: { __typename?: 'ForgotPasswordPayload', success: boolean } };

export type CreateBadgeDefinitionMutationVariables = Exact<{
  input: CreateBadgeDefinitionInput;
}>;


export type CreateBadgeDefinitionMutation = { __typename?: 'Mutation', createBadgeDefinition: { __typename?: 'CreateBadgeDefinitionPayload', badgeDefinition: { __typename?: 'BadgeDefinition', id: string, name: string, description: string, status: BadgeDefinitionStatus, courseDefinitionId: string } } };

export type UpdateBadgeDefinitionMutationVariables = Exact<{
  input: UpdateBadgeDefinitionInput;
}>;


export type UpdateBadgeDefinitionMutation = { __typename?: 'Mutation', updateBadgeDefinition: { __typename?: 'UpdateBadgeDefinitionPayload', badgeDefinition: { __typename?: 'BadgeDefinition', id: string, name: string, description: string, criteriaText: string, imageUrl?: string | null, status: BadgeDefinitionStatus, courseDefinitionId: string, createdAt: any, updatedAt: any } } };

export type CreateCertificateDefinitionMutationVariables = Exact<{
  input: CreateCertificateDefinitionInput;
}>;


export type CreateCertificateDefinitionMutation = { __typename?: 'Mutation', createCertificateDefinition: { __typename?: 'CreateCertificateDefinitionPayload', certificateDefinition: { __typename?: 'CertificateDefinition', id: string, name: string, description: string, status: CertificateDefinitionStatus, programId: string } } };

export type UpdateCertificateDefinitionMutationVariables = Exact<{
  input: UpdateCertificateDefinitionInput;
}>;


export type UpdateCertificateDefinitionMutation = { __typename?: 'Mutation', updateCertificateDefinition: { __typename?: 'UpdateCertificateDefinitionPayload', certificateDefinition: { __typename?: 'CertificateDefinition', id: string, name: string, description: string, criteriaText: string, status: CertificateDefinitionStatus, programId: string, createdAt: any, updatedAt: any } } };

export type AdminChangeProgramEnrollmentProgramMutationVariables = Exact<{
  input: AdminChangeProgramEnrollmentProgramInput;
}>;


export type AdminChangeProgramEnrollmentProgramMutation = { __typename?: 'Mutation', adminChangeProgramEnrollmentProgram: { __typename?: 'AdminChangeProgramEnrollmentProgramPayload', programEnrollment: { __typename?: 'AdminProgramEnrollmentView', id: string, createdAt: any, withdrawalReason?: ProgramWithdrawalReason | null, withdrawalDescription?: string | null, leaveOfAbsenceDescription?: string | null, leaveOfAbsenceReason?: DeferralReason | null, failedAt?: any | null, graduatedAt?: any | null, reinstatedAt?: any | null, status?: ProgramEnrollmentStatus | null, cancelled: boolean, programChanges: Array<{ __typename?: 'ProgramChangeView', id: string, createdAt: any, fromProgram: { __typename?: 'AdminProgramView', id: string, name: string, abbreviation: string }, toProgram: { __typename?: 'AdminProgramView', id: string, name: string, abbreviation: string }, changedByUser: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null } }>, cohort?: { __typename?: 'AdminCohortView', allowCourseDeferral: boolean, allowLeaveOfAbsence: boolean, id: string, name: string, endDate?: any | null, startDate?: any | null } | null, program: { __typename?: 'AdminProgramView', id: string, name: string, minTermCredits: number, maxTermCredits: number, abbreviation: string, description?: string | null, hasMultiCourseDisplay: boolean }, courseEnrollments: Array<{ __typename?: 'AdminCourseEnrollmentView', id: string, status?: CourseEnrollmentStatus | null, statusReason?: CourseEnrollmentStatusReason | null, createdAt: any, graduatedAt?: any | null, failedAt?: any | null, deferredAt?: any | null, course: { __typename?: 'AdminCourseDefinitionView', id: string, name: string, abbreviation: string, description?: string | null }, classEnrollments: Array<{ __typename?: 'AdminClassEnrollmentView', id: string, status?: ClassEnrollmentStatus | null, statusReason?: ClassEnrollmentStatusReason | null, createdAt: any, failedAt?: any | null, leaveOfAbsenceDescription?: string | null, leaveOfAbsenceReason?: DeferralReason | null, deferredAt?: any | null, deferralDescription?: string | null, deferralReason?: DeferralReason | null, graduatedAt?: any | null, reinstatedAt?: any | null, lastLeaveOfAbsenceAt?: any | null, class: { __typename?: 'AdminClassView', id: string, name: string, startDate?: any | null, endDate?: any | null }, lmsClassLocation: { __typename?: 'AdminLmsClassLocationView', id: string, name: string, lmsCourseId: string, lmsCohortId?: string | null, courseLink: string, preferredHub?: string | null, preferredCountryOfResidence?: string | null, learningPlatform?: LearningPlatform | null } }> }> } } };

export type AdminUpdateClassEnrollmentGradePointsMutationVariables = Exact<{
  input: AdminUpdateClassEnrollmentGradePointsInput;
}>;


export type AdminUpdateClassEnrollmentGradePointsMutation = { __typename?: 'Mutation', adminUpdateClassEnrollmentGradePoints: { __typename?: 'AdminUpdateClassEnrollmentGradePointsPayload', classEnrollment: { __typename?: 'AdminClassEnrollmentView', id: string, gradePoints?: number | null, letterGrade?: string | null, gradePointsValue?: number | null, cancelled: boolean, status?: ClassEnrollmentStatus | null } } };

export type AdminCreateStaffUserMutationVariables = Exact<{
  input: AdminCreateStaffUserInput;
}>;


export type AdminCreateStaffUserMutation = { __typename?: 'Mutation', adminCreateStaffUser: { __typename?: 'AdminCreateStaffUserPayload', user: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null, primaryEmail: string } } };

export type AdminCreateAcademicConductCaseMutationVariables = Exact<{
  input: AdminCreateAcademicConductCaseInput;
}>;


export type AdminCreateAcademicConductCaseMutation = { __typename?: 'Mutation', adminCreateAcademicConductCase: { __typename?: 'AdminCreateAcademicConductCasePayload', academicConductCase: { __typename?: 'AcademicConductCaseView', id: string, createdAt: any, updatedAt: any, term: string, severity: ConductCaseSeverity, category: ConductCaseCategory, status: ConductCaseStatus, resolutionType?: ConductCaseResolutionType | null, appealDeadline?: any | null, appealSubmittedAt?: any | null, appealStatus?: AppealStatus | null, createdByUser: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null }, classEnrollment?: { __typename?: 'AdminClassEnrollmentView', id: string, gradeLockedForIntegrityViolation: boolean, class: { __typename?: 'AdminClassView', id: string, name: string, term?: string | null } } | null, history: Array<{ __typename?: 'AcademicConductCaseHistoryView', id: string, createdAt: any, action: ConductCaseHistoryAction, previousSeverity?: ConductCaseSeverity | null, newSeverity?: ConductCaseSeverity | null, previousStatus?: ConductCaseStatus | null, newStatus?: ConductCaseStatus | null, description?: string | null, internalNotes?: string | null, documentUrl?: string | null, documentName?: string | null, performedByUser: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null } }>, appeal?: { __typename?: 'AcademicConductCaseAppealView', id: string, createdAt: any, reason: string, signature: string, documentUrl?: string | null, documentName?: string | null, submittedByUser: { __typename?: 'User', sandId?: string | null, firstName?: string | null, lastName?: string | null } } | null } } };

export type AdminUpdateAcademicConductCaseMutationVariables = Exact<{
  input: AdminUpdateAcademicConductCaseInput;
}>;


export type AdminUpdateAcademicConductCaseMutation = { __typename?: 'Mutation', adminUpdateAcademicConductCase: { __typename?: 'AdminUpdateAcademicConductCasePayload', academicConductCase: { __typename?: 'AcademicConductCaseView', id: string, createdAt: any, updatedAt: any, term: string, severity: ConductCaseSeverity, category: ConductCaseCategory, status: ConductCaseStatus, resolutionType?: ConductCaseResolutionType | null, appealDeadline?: any | null, appealSubmittedAt?: any | null, appealStatus?: AppealStatus | null, createdByUser: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null }, classEnrollment?: { __typename?: 'AdminClassEnrollmentView', id: string, gradeLockedForIntegrityViolation: boolean, class: { __typename?: 'AdminClassView', id: string, name: string, term?: string | null } } | null, history: Array<{ __typename?: 'AcademicConductCaseHistoryView', id: string, createdAt: any, action: ConductCaseHistoryAction, previousSeverity?: ConductCaseSeverity | null, newSeverity?: ConductCaseSeverity | null, previousStatus?: ConductCaseStatus | null, newStatus?: ConductCaseStatus | null, description?: string | null, internalNotes?: string | null, documentUrl?: string | null, documentName?: string | null, performedByUser: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null } }>, appeal?: { __typename?: 'AcademicConductCaseAppealView', id: string, createdAt: any, reason: string, signature: string, documentUrl?: string | null, documentName?: string | null, submittedByUser: { __typename?: 'User', sandId?: string | null, firstName?: string | null, lastName?: string | null } } | null } } };

export type AdminResolveAcademicConductCaseMutationVariables = Exact<{
  input: AdminResolveAcademicConductCaseInput;
}>;


export type AdminResolveAcademicConductCaseMutation = { __typename?: 'Mutation', adminResolveAcademicConductCase: { __typename?: 'AdminResolveAcademicConductCasePayload', academicConductCase: { __typename?: 'AcademicConductCaseView', id: string, createdAt: any, updatedAt: any, term: string, severity: ConductCaseSeverity, category: ConductCaseCategory, status: ConductCaseStatus, resolutionType?: ConductCaseResolutionType | null, appealDeadline?: any | null, appealSubmittedAt?: any | null, appealStatus?: AppealStatus | null, createdByUser: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null }, classEnrollment?: { __typename?: 'AdminClassEnrollmentView', id: string, gradeLockedForIntegrityViolation: boolean, class: { __typename?: 'AdminClassView', id: string, name: string, term?: string | null } } | null, history: Array<{ __typename?: 'AcademicConductCaseHistoryView', id: string, createdAt: any, action: ConductCaseHistoryAction, previousSeverity?: ConductCaseSeverity | null, newSeverity?: ConductCaseSeverity | null, previousStatus?: ConductCaseStatus | null, newStatus?: ConductCaseStatus | null, description?: string | null, internalNotes?: string | null, documentUrl?: string | null, documentName?: string | null, performedByUser: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null } }>, appeal?: { __typename?: 'AcademicConductCaseAppealView', id: string, createdAt: any, reason: string, signature: string, documentUrl?: string | null, documentName?: string | null, submittedByUser: { __typename?: 'User', sandId?: string | null, firstName?: string | null, lastName?: string | null } } | null } } };

export type AdminApproveAcademicConductAppealMutationVariables = Exact<{
  input: AdminApproveAcademicConductAppealInput;
}>;


export type AdminApproveAcademicConductAppealMutation = { __typename?: 'Mutation', adminApproveAcademicConductAppeal: { __typename?: 'AdminApproveAcademicConductAppealPayload', academicConductCase: { __typename?: 'AcademicConductCaseView', id: string, createdAt: any, updatedAt: any, term: string, severity: ConductCaseSeverity, category: ConductCaseCategory, status: ConductCaseStatus, resolutionType?: ConductCaseResolutionType | null, appealDeadline?: any | null, appealSubmittedAt?: any | null, appealStatus?: AppealStatus | null, createdByUser: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null }, classEnrollment?: { __typename?: 'AdminClassEnrollmentView', id: string, gradeLockedForIntegrityViolation: boolean, class: { __typename?: 'AdminClassView', id: string, name: string, term?: string | null } } | null, history: Array<{ __typename?: 'AcademicConductCaseHistoryView', id: string, createdAt: any, action: ConductCaseHistoryAction, previousSeverity?: ConductCaseSeverity | null, newSeverity?: ConductCaseSeverity | null, previousStatus?: ConductCaseStatus | null, newStatus?: ConductCaseStatus | null, description?: string | null, internalNotes?: string | null, documentUrl?: string | null, documentName?: string | null, performedByUser: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null } }>, appeal?: { __typename?: 'AcademicConductCaseAppealView', id: string, createdAt: any, reason: string, signature: string, documentUrl?: string | null, documentName?: string | null, submittedByUser: { __typename?: 'User', sandId?: string | null, firstName?: string | null, lastName?: string | null } } | null } } };

export type AdminDenyAcademicConductAppealMutationVariables = Exact<{
  input: AdminDenyAcademicConductAppealInput;
}>;


export type AdminDenyAcademicConductAppealMutation = { __typename?: 'Mutation', adminDenyAcademicConductAppeal: { __typename?: 'AdminDenyAcademicConductAppealPayload', academicConductCase: { __typename?: 'AcademicConductCaseView', id: string, createdAt: any, updatedAt: any, term: string, severity: ConductCaseSeverity, category: ConductCaseCategory, status: ConductCaseStatus, resolutionType?: ConductCaseResolutionType | null, appealDeadline?: any | null, appealSubmittedAt?: any | null, appealStatus?: AppealStatus | null, createdByUser: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null }, classEnrollment?: { __typename?: 'AdminClassEnrollmentView', id: string, gradeLockedForIntegrityViolation: boolean, class: { __typename?: 'AdminClassView', id: string, name: string, term?: string | null } } | null, history: Array<{ __typename?: 'AcademicConductCaseHistoryView', id: string, createdAt: any, action: ConductCaseHistoryAction, previousSeverity?: ConductCaseSeverity | null, newSeverity?: ConductCaseSeverity | null, previousStatus?: ConductCaseStatus | null, newStatus?: ConductCaseStatus | null, description?: string | null, internalNotes?: string | null, documentUrl?: string | null, documentName?: string | null, performedByUser: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null } }>, appeal?: { __typename?: 'AcademicConductCaseAppealView', id: string, createdAt: any, reason: string, signature: string, documentUrl?: string | null, documentName?: string | null, submittedByUser: { __typename?: 'User', sandId?: string | null, firstName?: string | null, lastName?: string | null } } | null } } };

export type SubmitAcademicConductAppealMutationVariables = Exact<{
  input: SubmitAcademicConductAppealInput;
}>;


export type SubmitAcademicConductAppealMutation = { __typename?: 'Mutation', submitAcademicConductAppeal: { __typename?: 'SubmitAcademicConductAppealPayload', academicConductCase: { __typename?: 'AcademicConductCaseLearnerView', id: string, status: ConductCaseStatus, appealSubmittedAt?: any | null, appealStatus?: AppealStatus | null } } };

export type AdminReopenAcademicConductCaseMutationVariables = Exact<{
  input: AdminReopenAcademicConductCaseInput;
}>;


export type AdminReopenAcademicConductCaseMutation = { __typename?: 'Mutation', adminReopenAcademicConductCase: { __typename?: 'AdminReopenAcademicConductCasePayload', academicConductCase: { __typename?: 'AcademicConductCaseView', id: string, createdAt: any, updatedAt: any, term: string, severity: ConductCaseSeverity, category: ConductCaseCategory, status: ConductCaseStatus, resolutionType?: ConductCaseResolutionType | null, appealDeadline?: any | null, appealSubmittedAt?: any | null, appealStatus?: AppealStatus | null, createdByUser: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null }, classEnrollment?: { __typename?: 'AdminClassEnrollmentView', id: string, gradeLockedForIntegrityViolation: boolean, class: { __typename?: 'AdminClassView', id: string, name: string, term?: string | null } } | null, history: Array<{ __typename?: 'AcademicConductCaseHistoryView', id: string, createdAt: any, action: ConductCaseHistoryAction, previousSeverity?: ConductCaseSeverity | null, newSeverity?: ConductCaseSeverity | null, previousStatus?: ConductCaseStatus | null, newStatus?: ConductCaseStatus | null, description?: string | null, internalNotes?: string | null, documentUrl?: string | null, documentName?: string | null, performedByUser: { __typename?: 'StaffUser', sandId: string, firstName?: string | null, lastName?: string | null } }>, appeal?: { __typename?: 'AcademicConductCaseAppealView', id: string, createdAt: any, reason: string, signature: string, documentUrl?: string | null, documentName?: string | null, submittedByUser: { __typename?: 'User', sandId?: string | null, firstName?: string | null, lastName?: string | null } } | null } } };

export type AdminAddGradesMappingMutationVariables = Exact<{
  input: AdminAddGradesMappingInput;
}>;


export type AdminAddGradesMappingMutation = { __typename?: 'Mutation', adminAddGradesMapping: { __typename?: 'AdminAddGradesMappingPayload', gradesMapping: { __typename?: 'AdminGradesMappingView', id: string, letterGrade: string, minGradePoints: number, gradePointsValue: number, programId?: string | null } } };

export type AdminUpdateGradesMappingMutationVariables = Exact<{
  input: AdminUpdateGradesMappingInput;
}>;


export type AdminUpdateGradesMappingMutation = { __typename?: 'Mutation', adminUpdateGradesMapping: { __typename?: 'AdminUpdateGradesMappingPayload', gradesMapping: { __typename?: 'AdminGradesMappingView', id: string, letterGrade: string, minGradePoints: number, gradePointsValue: number, programId?: string | null } } };

export type AdminDeleteGradesMappingMutationVariables = Exact<{
  input: AdminDeleteGradesMappingInput;
}>;


export type AdminDeleteGradesMappingMutation = { __typename?: 'Mutation', adminDeleteGradesMapping: { __typename?: 'AdminDeleteGradesMappingPayload', deletedId: string } };

export type AdminBulkRecalculateGpAsMutationVariables = Exact<{
  input: AdminBulkRecalculateGpAsInput;
}>;


export type AdminBulkRecalculateGpAsMutation = { __typename?: 'Mutation', adminBulkRecalculateGPAs: { __typename?: 'AdminBulkRecalculateGPAsPayload', queuedCount: number } };

export type VerifyBadgeQueryVariables = Exact<{
  verificationCode: Scalars['String']['input'];
}>;


export type VerifyBadgeQuery = { __typename?: 'Query', verifyBadge?: { __typename?: 'BadgeVerification', badgeName: string, badgeDescription: string, criteriaText: string, issuer: string, badgeImageUrl?: string | null, recipientName: string, issuedAt: any, status: BadgeStatus, isValid: boolean } | null };

export type VerifyCertificateQueryVariables = Exact<{
  verificationCode: Scalars['String']['input'];
}>;


export type VerifyCertificateQuery = { __typename?: 'Query', verifyCertificate?: { __typename?: 'CertificateVerification', certificateName: string, certificateDescription: string, criteriaText: string, issuer: string, recipientName: string, issuedAt: any, status: CertificateStatus, isValid: boolean, programName?: string | null, recipientSandId?: string | null, linkedInCertificateUrl?: string | null, imageUrl?: string | null } | null };

export type DashboardQueryVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
}>;


export type DashboardQuery = { __typename?: 'Query', dashboard?: { __typename?: 'Dashboard', id: string, createdAt: any, updatedAt: any, url?: string | null, name: string } | null };

export type GetViewerNotificationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetViewerNotificationsQuery = { __typename?: 'Query', viewer: { __typename?: 'User', sandId?: string | null, notifications: { __typename?: 'NotificationConnection', totalCount?: number | null, edges: Array<{ __typename?: 'NotificationEdge', cursor: string, node: { __typename?: 'Notification', createdAt: any, dismissed: boolean, id: number, platform: NotificationPlatform, seen: boolean, type: NotificationType, payload: { __typename?: 'EHubNewClassEnrollmentNotificationPayload', classEnrollmentId: string, classEnrollment?: { __typename?: 'ClassEnrollment', id: string, lmsClassLocation: { __typename?: 'LmsClassLocation', courseLink: string }, courseEnrollment: { __typename?: 'CourseEnrollment', id: string, course: { __typename?: 'CourseDefinition', id: string, abbreviation: string, name: string } } } | null } | { __typename?: 'EHubNewProgramEnrollmentNotificationPayload', programEnrollmentId: string, programEnrollment?: { __typename?: 'ProgramEnrollment', id: string, program: { __typename?: 'Program', id: string, name: string } } | null } | { __typename?: 'JoinCommunityPayload' } | { __typename?: 'NileAcceptedToProgramNotificationPayload', programEnrollmentId: string, programEnrollment?: { __typename?: 'ProgramEnrollment', id: string, program: { __typename?: 'Program', id: string, name: string } } | null } | { __typename?: 'OnboardingCompletedPayload' } | { __typename?: 'PaymentIsDueSoonPayload', paymentId: string, paymentPlan?: { __typename?: 'PaymentPlan', payments: Array<{ __typename?: 'Payment', id: number, url?: string | null }> } | null } | { __typename?: 'SavannaAssignmentDuePayload' } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type GetCheckingCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCheckingCodeQuery = { __typename?: 'Query', viewer: { __typename?: 'User', sandId?: string | null, hubCheckInCode: { __typename?: 'HubCheckInCode', value?: string | null, timeLeft?: number | null }, hubCheckOutCode: { __typename?: 'HubCheckOutCode', value?: string | null, timeLeft?: number | null } } };

export type GetProgramEnrollmentPaymentPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProgramEnrollmentPaymentPlansQuery = { __typename?: 'Query', viewer: { __typename?: 'User', sandId?: string | null, programEnrollments: Array<{ __typename?: 'ProgramEnrollment', id: string, status: ProgramEnrollmentStatus, paymentPlan?: { __typename?: 'PaymentPlan', paymentPlanId: string } | null, program: { __typename?: 'Program', id: string, abbreviation: string } }>, paymentPlans: Array<{ __typename?: 'PaymentPlan', planIdentifier: string, paymentPlanId: string, status: PaymentPlanStatus, totalPaidAmount: number, totalAmount: number, billingState: BillingState, viewUrl: string, secondsToCancellation?: number | null, secondsToNextPayment: number, endDate?: any | null, code: string, nextInvoice?: { __typename?: 'Invoice', id: string, name: string, amount: number, status: InvoiceStatus, dueDate: any } | null, incompleteTransactions: Array<{ __typename?: 'PaymentHistoryTransaction', amount: number, createdAt: any, currency?: string | null, dismissedAt?: any | null, description?: string | null, icon?: string | null, id: string, paymentId: number, reason?: string | null, retryUrl?: string | null, status: IncompleteTransactionStatus }>, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: any, dueDate: any, name: string, amount: number, status: InvoiceStatus, viewInvoiceUrl: string, downloadInvoiceUrl: string }> | null, payments: Array<{ __typename?: 'Payment', id: number, name: string, status: string, url?: string | null, currencyUsed?: string | null, amount: number, paidAt?: any | null, viewReceiptUrl?: string | null, downloadReceiptUrl?: string | null }>, definition?: { __typename?: 'PaymentPlanDefinition', id: string, amount: number, description: string, instalments: number, name: string } | null }> } };

export type ViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerQuery = { __typename?: 'Query', viewer: { __typename?: 'User', bio?: string | null, birthDate?: any | null, countryOfOrigin?: string | null, countryOfResidence?: string | null, countyOfOrigin?: string | null, countyOfResidence?: string | null, coverPhoto?: string | null, cv?: string | null, firstName?: string | null, gender?: Gender | null, interests: Array<string>, isEmployed?: boolean | null, lastName?: string | null, localityOfOrigin?: string | null, localityOfResidence?: string | null, middleName?: string | null, openToNewPositions?: boolean | null, phoneNumber?: string | null, primaryEmail: string, profilePhoto?: string | null, sandId?: string | null, skills: Array<string>, title?: string | null, whatsAppNumber?: string | null, previouslyEnrolledInALX?: boolean | null, highestLevelOfStudy?: string | null, fieldOfStudy?: string | null, portfolioAndProjects: Array<string>, employmentType?: EmploymentTypeEnum | null, totalWorkExperienceDuration: number, techWorkExperienceDuration: number, topCareerGoal?: string | null, guardianship?: Guardianship | null, locationDescription?: LocationDescription | null, livingCircumstances?: LivingCircumstances | null, householdMonthlyIncomeUSD?: number | null, disability?: Disability | null, humanitarianStatus?: HumanitarianStatus | null, humanitarianStatusType?: HumanitarianStatusType | null, refugeeCard?: string | null, skipPaywallUntil?: any | null, programEnrollments: Array<{ __typename?: 'ProgramEnrollment', id: string }>, currentCheckIn?: { __typename?: 'HubCheckIn', checkedInAt: any, checkedOutAt?: any | null } | null, educationHistory?: Array<{ __typename?: 'Education', createdAt: any, fieldOfStudy: string, graduatedAt?: any | null, id: string, institutionCountry?: string | null, institutionCounty?: string | null, institutionLocality?: string | null, institutionName: string, knownInstitutionId?: string | null, levelOfStudy: string, startDate: any, updatedAt: any }> | null, languages: Array<{ __typename?: 'LanguageSkill', createdAt: any, id: string, language: LanguageEnum, proficiencyLevel: LanguageProficiencyLevel, updatedAt: any }>, onboardingPanel?: { __typename?: 'OnboardingPanel', sandId: string, activatedProfile?: any | null, exploredAndEngagedWithCommunity?: any | null, finishedOnboardingAt?: any | null, watchedWelcomeVideo?: any | null, watchedOnboardingVideo?: any | null } | null, socialLinks: { __typename?: 'SocialLinks', facebook?: string | null, github?: string | null, linkedIn?: string | null, tikTok?: string | null, twitter?: string | null, youtube?: string | null }, workExperience: Array<{ __typename?: 'WorkExperience', id: string, companyName: string, country?: string | null, createdAt: any, description?: string | null, employmentType: EmploymentTypeEnum, endDate?: any | null, isOngoing: boolean, locality?: string | null, startDate: any, title: string, updatedAt: any, isInTech: boolean }>, enrollmentFeatureAccess: { __typename?: 'EnrollmentFeatureAccess', hasCircleAccess: boolean, hasAnswerbaseAccess: boolean, hasCheckInAccess: boolean } } };

export type GetViewerAvailableProgramsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetViewerAvailableProgramsQuery = { __typename?: 'Query', viewer: { __typename?: 'User', sandId?: string | null, availablePrograms?: Array<{ __typename?: 'Program', id: string, name: string, requiresAdditionalQuestionnaire: boolean, abbreviation: string, description?: string | null, requiresPreferredHubForEnrollment: boolean, isUniversityProgram: boolean, requiresTuitionQuestionnaire: boolean, isEnrolled: boolean, isGraduated: boolean, canEnroll: boolean, wasEnrolled: boolean, preferredHubOption: Array<{ __typename?: 'PreferredHubOption', displayName: string, value: string }>, marketing: { __typename?: 'ProgramMarketing', title?: string | null, subtitle?: string | null, sectionSummary?: string | null, sectionTitle?: string | null, timeCommitment?: string | null, video?: string | null, thumbnail?: string | null, highlights: Array<string>, accessFee?: string | null, programDuration?: string | null, legacyPoints?: string | null }, certificateDefinition?: { __typename?: 'CertificateDefinition', id: string, name: string, description: string, criteriaText: string, templateConfig?: any | null } | null, issuedCertificate?: { __typename?: 'IssuedCertificate', id: string, issuedAt: any, verificationCode: string, linkedInCertificateUrl: string, imageUrl?: string | null } | null, potentialProgramJourney?: { __typename?: 'PotentialProgramJourney', startDate?: any | null, potentialCourseEnrollments: Array<{ __typename?: 'PotentialCourseEnrollment', existingEnrollment?: { __typename?: 'ClassEnrollment', id: string, status: ClassEnrollmentStatus, class: { __typename?: 'Class', id: string, startDate?: any | null, endDate?: any | null }, courseEnrollment: { __typename?: 'CourseEnrollment', id: string, status: CourseEnrollmentStatus } } | null, firstAvailableClass?: { __typename?: 'Class', id: string, startDate?: any | null, endDate?: any | null } | null, courseDetails?: { __typename?: 'CourseDefinition', id: string, name: string, abbreviation: string, description?: string | null, badgeDefinition?: { __typename?: 'BadgeDefinition', id: string, name: string, imageUrl?: string | null } | null, issuedBadge?: { __typename?: 'IssuedBadge', id: string, status: BadgeStatus, issuedAt: any, verificationUrl: string, linkedInShareUrl: string, badgeDefinition?: { __typename?: 'BadgeDefinition', id: string, name: string, description: string, imageUrl?: string | null } | null } | null } | null }> } | null }> | null } };

export type GetViewerLearningDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetViewerLearningDetailsQuery = { __typename?: 'Query', viewer: { __typename?: 'User', sandId?: string | null, programEnrollments: Array<{ __typename?: 'ProgramEnrollment', id: string, status: ProgramEnrollmentStatus, cumulativeGPA?: number | null, program: { __typename?: 'Program', id: string, name: string, abbreviation: string, description?: string | null, hasMultiCourseDisplay: boolean, minTermCredits: number, allowLeaveOfAbsence: boolean, allowCourseDeferral: boolean, allAccessPaymentPlan: boolean, issuedCertificate?: { __typename?: 'IssuedCertificate', id: string, imageUrl?: string | null, linkedInCertificateUrl: string, verificationCode: string, issuedAt: any } | null }, paymentPlan?: { __typename?: 'PaymentPlan', paymentPlanId: string } | null, plannedCourses: Array<{ __typename?: 'PlannedCourse', id: string, courseGroupKey?: string | null, credits: number, details: { __typename?: 'CourseDefinition', id: string, name: string, abbreviation: string, description?: string | null, type?: string | null, issuedBadge?: { __typename?: 'IssuedBadge', id: string, status: BadgeStatus, issuedAt: any, verificationUrl: string, linkedInShareUrl: string, badgeDefinition?: { __typename?: 'BadgeDefinition', id: string, name: string, description: string, imageUrl?: string | null } | null } | null }, enrollment?: { __typename?: 'CourseEnrollment', id: string, status: CourseEnrollmentStatus, currentClass?: { __typename?: 'ClassEnrollment', id: string, status: ClassEnrollmentStatus, lmsClassLocation: { __typename?: 'LmsClassLocation', id: string, courseLink: string }, proofOfCompletion?: { __typename?: 'ProofOfCompletion', email?: string | null, user: { __typename?: 'User', sandId?: string | null } } | null, class: { __typename?: 'Class', id: string, startDate?: any | null, endDate?: any | null, proofOfCompletionType: ProofOfCompletionType, requiresProofOfCompletionAfter?: any | null, canShowUniversityUpsellAfter?: any | null } } | null } | null }> }> } };

export type GetUsersProgramEnrollmentPaymentPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersProgramEnrollmentPaymentPlansQuery = { __typename?: 'Query', viewer: { __typename?: 'User', sandId?: string | null, programEnrollments: Array<{ __typename?: 'ProgramEnrollment', id: string, program: { __typename?: 'Program', id: string, abbreviation: string }, paymentPlan?: { __typename?: 'PaymentPlan', planIdentifier: string, paymentPlanId: string, status: PaymentPlanStatus, totalPaidAmount: number, totalAmount: number, billingState: BillingState, viewUrl: string, secondsToCancellation?: number | null, secondsToNextPayment: number, endDate?: any | null, code: string, nextInvoice?: { __typename?: 'Invoice', id: string, name: string, amount: number, status: InvoiceStatus, dueDate: any } | null, incompleteTransactions: Array<{ __typename?: 'PaymentHistoryTransaction', amount: number, createdAt: any, currency?: string | null, dismissedAt?: any | null, description?: string | null, icon?: string | null, id: string, paymentId: number, reason?: string | null, retryUrl?: string | null, status: IncompleteTransactionStatus }>, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: any, dueDate: any, name: string, amount: number, status: InvoiceStatus, viewInvoiceUrl: string, downloadInvoiceUrl: string }> | null, payments: Array<{ __typename?: 'Payment', id: number, name: string, status: string, url?: string | null, currencyUsed?: string | null, amount: number, paidAt?: any | null, viewReceiptUrl?: string | null, downloadReceiptUrl?: string | null }>, definition?: { __typename?: 'PaymentPlanDefinition', id: string, amount: number, description: string, instalments: number, name: string } | null } | null }> } };

export type PublicViewerQueryVariables = Exact<{
  sandId: Scalars['ID']['input'];
}>;


export type PublicViewerQuery = { __typename?: 'Query', publicViewer: { __typename?: 'PublicUser', bio?: string | null, countryOfResidence?: string | null, coverPhoto?: string | null, firstName?: string | null, lastName?: string | null, localityOfResidence?: string | null, middleName?: string | null, openToNewPositions?: boolean | null, profilePhoto?: string | null, sandId: string, skills: Array<string>, title?: string | null, whatsAppNumber?: string | null, educationHistory?: Array<{ __typename?: 'PublicEducation', fieldOfStudy: string, graduatedAt?: any | null, id: string, institutionCountry?: string | null, institutionLocality?: string | null, institutionName: string, knownInstitutionId?: string | null, levelOfStudy: string, startDate: any }> | null, languages: Array<{ __typename?: 'PublicLanguageSkill', id: string, language: LanguageEnum, proficiencyLevel: LanguageProficiencyLevel }>, socialLinks: { __typename?: 'SocialLinks', facebook?: string | null, github?: string | null, linkedIn?: string | null, tikTok?: string | null, twitter?: string | null, youtube?: string | null }, workExperience: Array<{ __typename?: 'PublicWorkExperience', companyName: string, country?: string | null, description?: string | null, employmentType: EmploymentTypeEnum, endDate?: any | null, isOngoing: boolean, locality?: string | null, startDate: any, title: string, isInTech: boolean }> } };

export type GetLegacyPointsUserQueryVariables = Exact<{
  where: LpUserWhereUniqueInput;
}>;


export type GetLegacyPointsUserQuery = { __typename?: 'Query', lpUser?: { __typename?: 'LpUser', balance?: number | null } | null };

export type GetNearbyHubQueryVariables = Exact<{
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
}>;


export type GetNearbyHubQuery = { __typename?: 'Query', viewer: { __typename?: 'User', sandId?: string | null, nearbyHub?: { __typename?: 'Hub', id: string, address?: string | null, name: string, description: string, country?: string | null, county?: string | null, locality?: string | null } | null } };

export type GetCurrentCheckInQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentCheckInQuery = { __typename?: 'Query', viewer: { __typename?: 'User', sandId?: string | null, currentCheckIn?: { __typename?: 'HubCheckIn', checkInDay: string, createdAt: any, checkedInAt: any, checkedOutAt?: any | null, hub: { __typename?: 'Hub', id: string, address?: string | null, name: string, description: string, country?: string | null, county?: string | null, locality?: string | null, equippedWith: Array<string> } } | null } };

export type GetAttendanceStatsQueryVariables = Exact<{
  hubIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetAttendanceStatsQuery = { __typename?: 'Query', attendanceStats?: { __typename?: 'AttendanceStats', hubIds: Array<string>, totalDaily: number, totalDailyDiffPercentage: number, totalMonthly: number, totalMonthlyDiffPercentage: number, totalWeekly: number, totalWeeklyDiffPercentage: number, top10MostRecentCheckIns: Array<{ __typename?: 'HubCheckIn', createdAt: any, type?: HubCheckInType | null, hub: { __typename?: 'Hub', name: string }, user: { __typename?: 'User', sandId?: string | null, firstName?: string | null, lastName?: string | null, primaryEmail: string, profilePhoto?: string | null } }>, totalPerHourLast24Hours: { __typename?: 'AttendanceBucketsType', buckets: Array<number>, bucketsActive: Array<number>, now: any } } | null };

export type GetLearnersQueryVariables = Exact<{
  hubIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  lastCheckInStartDate?: InputMaybe<Scalars['String']['input']>;
  lastCheckInEndDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLearnersQuery = { __typename?: 'Query', attendanceStats?: { __typename?: 'AttendanceStats', learners: { __typename?: 'PaginatedUsers', totalCount: number, totalPages: number, users: Array<{ __typename?: 'User', sandId?: string | null, primaryEmail: string, firstName?: string | null, lastName?: string | null, profilePhoto?: string | null, programEnrollments: Array<{ __typename?: 'ProgramEnrollment', status: ProgramEnrollmentStatus, preferredHub?: string | null }>, currentCheckIn?: { __typename?: 'HubCheckIn', checkInDay: string, checkedInAt: any, checkedOutAt?: any | null, hub: { __typename?: 'Hub', id: string, name: string, locality?: string | null } } | null } | null> } } | null };

export type GetStaffHubsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStaffHubsQuery = { __typename?: 'Query', staffHubs: Array<{ __typename?: 'Hub', id: string, country?: string | null, locality?: string | null, name: string }> };

export type GetHubCheckInsQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  checkInStartDate?: InputMaybe<Scalars['String']['input']>;
  checkInEndDate?: InputMaybe<Scalars['String']['input']>;
  checkInDateSortOrder?: InputMaybe<Scalars['String']['input']>;
  hubNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetHubCheckInsQuery = { __typename?: 'Query', viewer: { __typename?: 'User', sandId?: string | null, checkInsHubNames: Array<string>, hubCheckIns?: { __typename?: 'PaginatedHubCheckIns', totalCount: number, pageNumber: number, pageSize: number, totalPages: number, hubCheckIns: Array<{ __typename?: 'HubCheckIn', createdAt: any, checkedInAt: any, checkedOutAt?: any | null, hub: { __typename?: 'Hub', name: string } } | null> } | null } };

export type GetViewerProgramEnrollmentsWithApplicationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetViewerProgramEnrollmentsWithApplicationQuery = { __typename?: 'Query', viewer: { __typename?: 'User', sandId?: string | null, programEnrollments: Array<{ __typename?: 'ProgramEnrollment', id: string, status: ProgramEnrollmentStatus, academicStanding?: AcademicStanding | null, cumulativeGPA?: number | null, program: { __typename?: 'Program', id: string, name: string, abbreviation: string, description?: string | null, hasMultiCourseDisplay: boolean, minTermCredits: number, allowLeaveOfAbsence: boolean, allowCourseDeferral: boolean, marketing: { __typename?: 'ProgramMarketing', thumbnail?: string | null, programDuration?: string | null } }, paymentPlan?: { __typename?: 'PaymentPlan', paymentPlanId: string, status: PaymentPlanStatus, viewUrl: string, instalmentsPaid: number } | null, academicConductCases: Array<{ __typename?: 'AcademicConductCaseLearnerView', id: string, createdAt: any, term: string, severity: ConductCaseSeverity, category: ConductCaseCategory, status: ConductCaseStatus, resolutionType?: ConductCaseResolutionType | null, className?: string | null, appealDeadline?: any | null, appealSubmittedAt?: any | null, appealStatus?: AppealStatus | null, history: Array<{ __typename?: 'AcademicConductCaseLearnerHistoryView', id: string, createdAt: any, action: ConductCaseHistoryAction, previousSeverity?: ConductCaseSeverity | null, newSeverity?: ConductCaseSeverity | null, previousStatus?: ConductCaseStatus | null, newStatus?: ConductCaseStatus | null, description?: string | null, documentUrl?: string | null, documentName?: string | null }>, appeal?: { __typename?: 'AcademicConductCaseAppealView', id: string, createdAt: any, reason: string, signature: string, documentUrl?: string | null, documentName?: string | null } | null }>, programApplication?: { __typename?: 'ProgramApplication', id: string, status: ProgramApplicationStatus, additionalInfo?: string | null, anticipateChallenges?: boolean | null, englishProficiencyStatus: EnglishProficiencyStatus, englishProficiencyType?: EnglishProficiencyType | null, feePaymentMode?: FeePaymentMode | null, otherFeePaymentMode?: string | null, highSchoolVerificationMode: HighSchoolVerificationMode, user: { __typename?: 'User', sandId?: string | null }, highSchoolCertificate?: { __typename?: 'HighSchoolCertificate', id: string, status: HighSchoolCertificateStatus, schoolName: string, country: string, city: string, state: string, graduationDate: any, schoolAddress: string, qualification: string } | null, personaIdentityInquiry?: { __typename?: 'PersonaInquiry', id: string, lifecycleStatus: PersonaInquiryLifecycleStatus, decisionStatus: PersonaInquiryDecisionStatus } | null, personaHighschoolInquiry?: { __typename?: 'PersonaInquiry', id: string, lifecycleStatus: PersonaInquiryLifecycleStatus, decisionStatus: PersonaInquiryDecisionStatus } | null, personaPriorLearningInquiry?: { __typename?: 'PersonaInquiry', id: string, lifecycleStatus: PersonaInquiryLifecycleStatus, decisionStatus: PersonaInquiryDecisionStatus } | null, docusignEnrollmentAgreement?: { __typename?: 'DocusignEnrollmentAgreement', applicantStatus?: string | null, envelopeStatus?: string | null, link?: string | null } | null, program: { __typename?: 'Program', id: string, name: string, description?: string | null, requiresTuitionQuestionnaire: boolean, marketing: { __typename?: 'ProgramMarketing', thumbnail?: string | null, programDuration?: string | null } } } | null, plannedCourses: Array<{ __typename?: 'PlannedCourse', id: string, courseGroupKey?: string | null, credits: number, details: { __typename?: 'CourseDefinition', id: string, name: string, abbreviation: string, description?: string | null, type?: string | null, issuedBadge?: { __typename?: 'IssuedBadge', id: string, status: BadgeStatus, issuedAt: any, verificationUrl: string, linkedInShareUrl: string, badgeDefinition?: { __typename?: 'BadgeDefinition', id: string, name: string, description: string, imageUrl?: string | null } | null } | null }, enrollment?: { __typename?: 'CourseEnrollment', id: string, status: CourseEnrollmentStatus, currentClass?: { __typename?: 'ClassEnrollment', id: string, status: ClassEnrollmentStatus, lmsClassLocation: { __typename?: 'LmsClassLocation', id: string, courseLink: string }, proofOfCompletion?: { __typename?: 'ProofOfCompletion', email?: string | null, user: { __typename?: 'User', sandId?: string | null } } | null, class: { __typename?: 'Class', id: string, startDate?: any | null, endDate?: any | null, proofOfCompletionType: ProofOfCompletionType, requiresProofOfCompletionAfter?: any | null, canShowUniversityUpsellAfter?: any | null } } | null } | null }> }> } };

export type AdminGetPathwayPaymentStatusQueryVariables = Exact<{
  sandId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AdminGetPathwayPaymentStatusQuery = { __typename?: 'Query', adminGetUserDetails?: { __typename?: 'User', sandId?: string | null, programEnrollments: Array<{ __typename?: 'ProgramEnrollment', id: string, paymentPlan?: { __typename?: 'PaymentPlan', paymentPlanId: string, status: PaymentPlanStatus } | null }> } | null };

export type GetSemesterPaymentPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSemesterPaymentPlansQuery = { __typename?: 'Query', viewer: { __typename?: 'User', sandId?: string | null, paymentPlans: Array<{ __typename?: 'PaymentPlan', instalmentsPaid: number, amountPerInstalment: number, amountPerSemester?: number | null, nextPaymentDate?: any | null, previousSemesterPaidAmount?: number | null, previousSemesterPaidInstalments?: number | null, previousSemesterRemainingAmount?: number | null, previousSemesterRemainingInstalments?: number | null, currentSemesterPaidAmount?: number | null, currentSemesterPaidInstalments?: number | null, currentSemesterRemainingAmount?: number | null, currentSemesterRemainingInstalments?: number | null, nextSemesterPaidAmount?: number | null, nextSemesterPaidInstalments?: number | null, nextSemesterRemainingAmount?: number | null, nextSemesterRemainingInstalments?: number | null, cancelDate?: any | null, totalPaidAmount: number, cancellationAmount?: number | null, planIdentifier: string, paymentPlanId: string, status: PaymentPlanStatus, totalAmount: number, billingState: BillingState, viewUrl: string, secondsToCancellation?: number | null, secondsToNextPayment: number, endDate?: any | null, code: string, nextInvoice?: { __typename?: 'Invoice', id: string, name: string, amount: number, status: InvoiceStatus, dueDate: any } | null, incompleteTransactions: Array<{ __typename?: 'PaymentHistoryTransaction', amount: number, createdAt: any, currency?: string | null, dismissedAt?: any | null, description?: string | null, icon?: string | null, id: string, paymentId: number, reason?: string | null, retryUrl?: string | null, status: IncompleteTransactionStatus }>, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: any, dueDate: any, name: string, amount: number, status: InvoiceStatus, viewInvoiceUrl: string, downloadInvoiceUrl: string }> | null, payments: Array<{ __typename?: 'Payment', id: number, name: string, status: string, url?: string | null, currencyUsed?: string | null, amount: number, paidAt?: any | null, viewReceiptUrl?: string | null, downloadReceiptUrl?: string | null }>, definition?: { __typename?: 'PaymentPlanDefinition', id: string, amount: number, description: string, instalments: number, name: string } | null }> } };

export type GetViewerTranscriptQueryVariables = Exact<{ [key: string]: never; }>;


export type GetViewerTranscriptQuery = { __typename?: 'Query', viewer: { __typename?: 'User', sandId?: string | null, firstName?: string | null, lastName?: string | null, primaryEmail: string, countryOfOrigin?: string | null, birthDate?: any | null, programEnrollments: Array<{ __typename?: 'ProgramEnrollment', id: string, status: ProgramEnrollmentStatus, graduatedAt?: any | null, failedAt?: any | null, cumulativeGPA?: number | null, academicStanding?: AcademicStanding | null, termGPAs: Array<{ __typename?: 'TermGPA', id: string, term: string, gpa?: number | null }>, program: { __typename?: 'Program', id: string, name: string, abbreviation: string, description?: string | null, isUniversityProgram: boolean }, academicConductCases: Array<{ __typename?: 'AcademicConductCaseLearnerView', id: string, createdAt: any, term: string, severity: ConductCaseSeverity, category: ConductCaseCategory, status: ConductCaseStatus, resolutionType?: ConductCaseResolutionType | null, className?: string | null, appealDeadline?: any | null, appealSubmittedAt?: any | null, appealStatus?: AppealStatus | null, history: Array<{ __typename?: 'AcademicConductCaseLearnerHistoryView', id: string, createdAt: any, action: ConductCaseHistoryAction, previousSeverity?: ConductCaseSeverity | null, newSeverity?: ConductCaseSeverity | null, previousStatus?: ConductCaseStatus | null, newStatus?: ConductCaseStatus | null, description?: string | null, documentUrl?: string | null, documentName?: string | null }>, appeal?: { __typename?: 'AcademicConductCaseAppealView', id: string, createdAt: any, reason: string, signature: string, documentUrl?: string | null, documentName?: string | null } | null }>, plannedCourses: Array<{ __typename?: 'PlannedCourse', id: string, credits: number, courseGroupKey?: string | null, details: { __typename?: 'CourseDefinition', id: string, name: string, abbreviation: string, type?: string | null }, enrollment?: { __typename?: 'CourseEnrollment', id: string, status: CourseEnrollmentStatus, graduatedAt?: any | null, failedAt?: any | null, letterGrade?: string | null, gradePointsValue?: number | null, currentClass?: { __typename?: 'ClassEnrollment', id: string, letterGrade?: string | null, gradePoints?: number | null, gradePointsValue?: number | null, status: ClassEnrollmentStatus } | null, classEnrollments: Array<{ __typename?: 'ClassEnrollment', id: string, letterGrade?: string | null, gradePoints?: number | null, gradePointsValue?: number | null, status: ClassEnrollmentStatus, graduatedAt?: any | null, failedAt?: any | null, class: { __typename?: 'Class', term?: string | null, startDate?: any | null, name: string } }> } | null }> }> } };

export const DashboardFragmentDoc = gql`
    fragment Dashboard on Dashboard {
  createdAt
  id
  name
  updatedAt
}
    `;
export const EducationFragmentDoc = gql`
    fragment Education on Education {
  createdAt
  fieldOfStudy
  graduatedAt
  id
  institutionCountry
  institutionCounty
  institutionLocality
  institutionName
  knownInstitutionId
  levelOfStudy
  startDate
  updatedAt
}
    `;
export const LanguageSkillFragmentDoc = gql`
    fragment LanguageSkill on LanguageSkill {
  createdAt
  id
  language
  proficiencyLevel
  updatedAt
}
    `;
export const NotificationFragmentDoc = gql`
    fragment Notification on NotificationEdge {
  node {
    createdAt
    dismissed
    id
    platform
    seen
    type
    payload {
      ... on NileAcceptedToProgramNotificationPayload {
        programEnrollmentId
        programEnrollment {
          id
          program {
            id
            name
          }
        }
      }
      ... on EHubNewProgramEnrollmentNotificationPayload {
        programEnrollmentId
        programEnrollment {
          id
          program {
            id
            name
          }
        }
      }
      ... on PaymentIsDueSoonPayload {
        paymentId
        paymentPlan {
          payments {
            id
            url
          }
        }
      }
      ... on EHubNewClassEnrollmentNotificationPayload {
        classEnrollmentId
        classEnrollment {
          id
          lmsClassLocation {
            courseLink
          }
          courseEnrollment {
            id
            course {
              id
              abbreviation
              name
            }
          }
        }
      }
    }
  }
}
    `;
export const ViewerNotificationsFragmentDoc = gql`
    fragment ViewerNotifications on NotificationConnection {
  edges {
    cursor
    ...Notification
  }
  pageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
  totalCount
}
    ${NotificationFragmentDoc}`;
export const WorkExperienceFragmentDoc = gql`
    fragment WorkExperience on WorkExperience {
  id
  companyName
  country
  createdAt
  description
  employmentType
  endDate
  isOngoing
  locality
  startDate
  title
  updatedAt
  isInTech
}
    `;
export const ProgramEnrollmentFragmentDoc = gql`
    fragment ProgramEnrollment on ProgramEnrollment {
  id
  createdAt
  withdrawalReason
  withdrawalDescription
  leaveOfAbsenceDescription
  leaveOfAbsenceReason
  failedAt
  graduatedAt
  reinstatedAt
  status
  academicStanding
  cohort {
    id
    name
    endDate
    startDate
  }
  program {
    id
    name
    minTermCredits
    maxTermCredits
    abbreviation
    description
    hasMultiCourseDisplay
    allowCourseDeferral
    allowLeaveOfAbsence
    isUniversityProgram
  }
  courseEnrollments {
    id
    status
    statusReason
    createdAt
    graduatedAt
    failedAt
    deferredAt
    course {
      id
      name
      abbreviation
      description
    }
    classEnrollments {
      id
      status
      statusReason
      createdAt
      failedAt
      leaveOfAbsenceDescription
      leaveOfAbsenceReason
      deferredAt
      deferralDescription
      deferralReason
      graduatedAt
      reinstatedAt
      lastLeaveOfAbsenceAt
      class {
        id
        name
        startDate
        endDate
      }
      lmsClassLocation {
        id
        name
        courseLink
        learningPlatform
      }
    }
  }
}
    `;
export const IssuedCourseBadgeFragmentDoc = gql`
    fragment IssuedCourseBadge on IssuedBadge {
  id
  status
  issuedAt
  verificationUrl
  linkedInShareUrl
  badgeDefinition {
    id
    name
    description
    imageUrl
  }
}
    `;
export const ProgramEnrollmentDetailsFragmentDoc = gql`
    fragment ProgramEnrollmentDetails on ProgramEnrollment {
  id
  cumulativeGPA
  plannedCourses {
    id
    courseGroupKey
    credits
    details {
      id
      name
      abbreviation
      description
      type
      issuedBadge {
        ...IssuedCourseBadge
      }
    }
    enrollment {
      id
      status
      currentClass {
        id
        status
        lmsClassLocation {
          id
          courseLink
        }
        proofOfCompletion {
          email
          user {
            sandId
          }
        }
        class {
          id
          startDate
          endDate
          proofOfCompletionType
          requiresProofOfCompletionAfter
          canShowUniversityUpsellAfter
        }
      }
    }
  }
}
    ${IssuedCourseBadgeFragmentDoc}`;
export const AvailableProgramToApplyFragmentDoc = gql`
    fragment AvailableProgramToApply on User {
  sandId
  availablePrograms {
    id
    name
    abbreviation
    description
    marketing {
      title
      subtitle
      sectionSummary
      sectionTitle
      timeCommitment
      video
      thumbnail
      highlights
    }
    isEnrolled
    potentialProgramJourney {
      startDate
      potentialCourseEnrollments {
        existingEnrollment {
          id
          status
          class {
            id
            startDate
            endDate
          }
          courseEnrollment {
            id
            status
          }
        }
        firstAvailableClass {
          id
          startDate
          endDate
        }
        courseDetails {
          id
          name
          abbreviation
          description
        }
      }
    }
  }
}
    `;
export const AdminProgramEnrollmentViewFragmentDoc = gql`
    fragment AdminProgramEnrollmentView on AdminProgramEnrollmentView {
  id
  createdAt
  withdrawalReason
  withdrawalDescription
  leaveOfAbsenceDescription
  leaveOfAbsenceReason
  failedAt
  graduatedAt
  reinstatedAt
  status
  cancelled
  programChanges {
    id
    createdAt
    fromProgram {
      id
      name
      abbreviation
    }
    toProgram {
      id
      name
      abbreviation
    }
    changedByUser {
      sandId
      firstName
      lastName
    }
  }
  cohort {
    allowCourseDeferral
    allowLeaveOfAbsence
    id
    name
    endDate
    startDate
  }
  program {
    id
    name
    minTermCredits
    maxTermCredits
    abbreviation
    description
    hasMultiCourseDisplay
  }
  courseEnrollments {
    id
    status
    statusReason
    createdAt
    graduatedAt
    failedAt
    deferredAt
    course {
      id
      name
      abbreviation
      description
    }
    classEnrollments {
      id
      status
      statusReason
      createdAt
      failedAt
      leaveOfAbsenceDescription
      leaveOfAbsenceReason
      deferredAt
      deferralDescription
      deferralReason
      graduatedAt
      reinstatedAt
      lastLeaveOfAbsenceAt
      class {
        id
        name
        startDate
        endDate
      }
      lmsClassLocation {
        id
        name
        lmsCourseId
        lmsCohortId
        courseLink
        preferredHub
        preferredCountryOfResidence
        learningPlatform
      }
    }
  }
}
    `;
export const AcademicConductCaseFragmentDoc = gql`
    fragment AcademicConductCase on AcademicConductCaseView {
  id
  createdAt
  updatedAt
  term
  severity
  category
  status
  resolutionType
  appealDeadline
  appealSubmittedAt
  appealStatus
  createdByUser {
    sandId
    firstName
    lastName
  }
  classEnrollment {
    id
    gradeLockedForIntegrityViolation
    class {
      id
      name
      term
    }
  }
  history {
    id
    createdAt
    action
    previousSeverity
    newSeverity
    previousStatus
    newStatus
    description
    internalNotes
    documentUrl
    documentName
    performedByUser {
      sandId
      firstName
      lastName
    }
  }
  appeal {
    id
    createdAt
    reason
    signature
    documentUrl
    documentName
    submittedByUser {
      sandId
      firstName
      lastName
    }
  }
}
    `;
export const AcademicConductCaseLearnerFragmentDoc = gql`
    fragment AcademicConductCaseLearner on AcademicConductCaseLearnerView {
  id
  createdAt
  term
  severity
  category
  status
  resolutionType
  className
  appealDeadline
  appealSubmittedAt
  appealStatus
  history {
    id
    createdAt
    action
    previousSeverity
    newSeverity
    previousStatus
    newStatus
    description
    documentUrl
    documentName
  }
  appeal {
    id
    createdAt
    reason
    signature
    documentUrl
    documentName
  }
}
    `;
export const RoleFragmentDoc = gql`
    fragment Role on Role {
  id
  name
  permissions
  userCount
  createdAt
  updatedAt
}
    `;
export const AdminPersonaInquiryFragmentDoc = gql`
    fragment AdminPersonaInquiry on AdminPersonaInquiry {
  id
  createdAt
  updatedAt
  type
  inquiryTemplateId
  accountId
  verificationId
  verificationLink
  lastEventId
  lastEventTimestamp
  lifecycleStatus
  decisionStatus
  createdStatusAt
  pendingStatusAt
  completedStatusAt
  failedStatusAt
  expiredStatusAt
  approvedStatusAt
  declinedStatusAt
  needsReviewStatusAt
}
    `;
export const PaymentPlanFragmentDoc = gql`
    fragment PaymentPlan on PaymentPlan {
  planIdentifier
  paymentPlanId
  status
  totalPaidAmount
  totalAmount
  billingState
  viewUrl
  secondsToCancellation
  secondsToNextPayment
  endDate
  code
  nextInvoice {
    id
    name
    amount
    status
    dueDate
  }
  incompleteTransactions {
    amount
    createdAt
    currency
    dismissedAt
    description
    icon
    id
    paymentId
    reason
    retryUrl
    status
  }
  invoices {
    id
    createdAt
    dueDate
    name
    amount
    status
    viewInvoiceUrl
    downloadInvoiceUrl
  }
  payments {
    id
    name
    status
    url
    currencyUsed
    amount
    paidAt
    viewReceiptUrl
    downloadReceiptUrl
  }
  definition {
    id
    amount
    description
    instalments
    name
  }
}
    `;
export const PersonaInquiryBasicsFragmentDoc = gql`
    fragment PersonaInquiryBasics on PersonaInquiry {
  id
  lifecycleStatus
  decisionStatus
}
    `;
export const ProgramApplicationForLearnerFragmentDoc = gql`
    fragment ProgramApplicationForLearner on ProgramApplication {
  user {
    sandId
  }
  id
  status
  additionalInfo
  anticipateChallenges
  englishProficiencyStatus
  englishProficiencyType
  feePaymentMode
  otherFeePaymentMode
  highSchoolCertificate {
    id
    status
    schoolName
    country
    city
    state
    graduationDate
    schoolAddress
    qualification
  }
  highSchoolVerificationMode
  personaIdentityInquiry {
    ...PersonaInquiryBasics
  }
  personaHighschoolInquiry {
    ...PersonaInquiryBasics
  }
  personaPriorLearningInquiry {
    ...PersonaInquiryBasics
  }
  docusignEnrollmentAgreement {
    applicantStatus
    envelopeStatus
    link
  }
  program {
    id
    name
    description
    requiresTuitionQuestionnaire
    marketing {
      thumbnail
      programDuration
    }
  }
}
    ${PersonaInquiryBasicsFragmentDoc}`;
export const AdminViewerDocument = gql`
    query AdminViewer {
  staffViewer {
    sandId
    firstName
    lastName
    primaryEmail
    profilePhoto
    permissions
    availableDashboards {
      ...Dashboard
    }
  }
}
    ${DashboardFragmentDoc}`;
export const AdminCheckSavannaStatusDocument = gql`
    query AdminCheckSavannaStatus($sandId: ID!) {
  adminGetUserDetails(sandId: $sandId) {
    sandId
    userCurriculumStatuses {
      batch {
        id
        name
      }
      status
      curriculum {
        id
        name
      }
    }
  }
}
    `;
export const AdminGetAvailableProgramsDocument = gql`
    query AdminGetAvailablePrograms {
  adminGetAvailablePrograms {
    id
    name
    version
    abbreviation
    maxTermCredits
    minTermCredits
    addDropPeriodDays
    description
    hasMultiCourseDisplay
    allowsConcurrentEnrollments
    hasCircleSupport
    hasAnswerbaseSupport
    hasCheckInSupport
    openToEnrollments
    marketing {
      timeCommitment
      video
      thumbnail
      highlights
      title
      subtitle
      sectionTitle
      sectionSummary
      accessFee
      programDuration
    }
  }
}
    `;
export const AdminGetUniversityProgramsDocument = gql`
    query AdminGetUniversityPrograms {
  adminGetAvailablePrograms {
    id
    name
    abbreviation
    isUniversityProgram
  }
}
    `;
export const AdminGetProgramsWithCoursesDocument = gql`
    query AdminGetProgramsWithCourses {
  adminGetAvailablePrograms {
    id
    name
    version
    abbreviation
    maxTermCredits
    minTermCredits
    addDropPeriodDays
    description
    hasMultiCourseDisplay
    allowsConcurrentEnrollments
    hasCircleSupport
    hasAnswerbaseSupport
    hasCheckInSupport
    openToEnrollments
    linkedProgramCourses {
      id
      name
      priority
      credits
      courseDefinition {
        id
        name
        abbreviation
        description
        classes {
          id
          name
          startDate
          endDate
          finished
          cohortKey
          enrollmentCounts {
            status
            count
          }
          lmsClassLocations {
            id
            name
            learningPlatform
            lmsCohortId
            lmsCourseId
          }
        }
      }
      mustHavePrerequisites {
        id
        name
        abbreviation
      }
      oneOfPrerequisites {
        id
        name
        abbreviation
      }
      doneWithPrerequisites {
        id
        name
        abbreviation
      }
    }
  }
}
    `;
export const AdminGetAvailableCoursesDocument = gql`
    query AdminGetAvailableCourses {
  adminGetAvailableCourses {
    id
    name
    abbreviation
    category
  }
}
    `;
export const AdminGetCoursesWithClassesDocument = gql`
    query AdminGetCoursesWithClasses {
  adminGetAvailableCourses {
    id
    name
    abbreviation
    category
    description
    classes {
      id
      name
      startDate
      endDate
      finished
      enrollmentCounts {
        status
        count
      }
      lmsClassLocations {
        id
        name
        learningPlatform
      }
    }
  }
}
    `;
export const AdminGetClassDetailsDocument = gql`
    query AdminGetClassDetails($classId: ID!) {
  adminGetClassDetails(classId: $classId) {
    id
    name
    proofOfCompletionType
    course {
      id
      abbreviation
      name
    }
    lmsClassLocations {
      id
      name
      learningPlatform
      lmsCourseId
      lmsCohortId
      courseLink
      preferredCountryOfResidence
      preferredHub
    }
    startDate
    endDate
  }
}
    `;
export const AdminGetCohortDetailsDocument = gql`
    query AdminGetCohortDetails($cohortId: ID!, $pageNumber: Int!, $pageSize: Int!, $searchString: String) {
  adminGetCohortDetails(cohortId: $cohortId) {
    id
    name
    paginatedCohortEnrollments(
      pageNumber: $pageNumber
      pageSize: $pageSize
      searchString: $searchString
    ) {
      pageNumber
      pageSize
      totalCount
      totalPages
      programEnrollments {
        id
        status
        user {
          sandId
          firstName
          middleName
          lastName
          primaryEmail
        }
      }
    }
    program {
      id
      name
    }
  }
}
    `;
export const AdminGetCourseDetailsDocument = gql`
    query AdminGetCourseDetails($courseId: ID!) {
  adminGetCourseDetails(courseId: $courseId) {
    id
    name
    abbreviation
    category
    description
    programs {
      id
      name
      abbreviation
    }
    classes {
      id
      name
      finished
      startDate
      endDate
    }
  }
}
    `;
export const AdminSearchPaginatedClassEnrollmentsDocument = gql`
    query AdminSearchPaginatedClassEnrollments($classId: String!, $pageNumber: Int!, $pageSize: Int!, $searchString: String, $showSelfReported: Boolean) {
  adminSearchPaginatedClassEnrollments(
    classId: $classId
    pageNumber: $pageNumber
    pageSize: $pageSize
    searchString: $searchString
    showSelfReported: $showSelfReported
  ) {
    pageNumber
    pageSize
    totalCount
    totalPages
    classEnrollments {
      id
      status
      cancelled
      createdAt
      failedAt
      graduatedAt
      class {
        id
        proofOfCompletionType
      }
      courseEnrollment {
        course {
          name
        }
      }
      proofOfCompletion {
        email
        examScore
        examValidationNumber
        firstName
        lastName
        trailblazerProfileLink
        examStatement
        updatedAt
      }
      user {
        sandId
        firstName
        lastName
        profilePhoto
      }
    }
  }
}
    `;
export const AdminGetPaginatedUsersDocument = gql`
    query AdminGetPaginatedUsers($pageNumber: Int!, $pageSize: Int!, $searchString: String) {
  adminGetPaginatedUsers(
    pageNumber: $pageNumber
    pageSize: $pageSize
    searchString: $searchString
  ) {
    pageNumber
    pageSize
    totalCount
    totalPages
    users {
      sandId
      firstName
      middleName
      lastName
      primaryEmail
      profilePhoto
    }
  }
}
    `;
export const AdminGetProgramDetailsDocument = gql`
    query AdminGetProgramDetails($programId: ID!) {
  adminGetProgramDetails(programId: $programId) {
    id
    name
    abbreviation
    version
    maxTermCredits
    minTermCredits
    addDropPeriodDays
    description
    hasMultiCourseDisplay
    allowsConcurrentEnrollments
    hasCircleSupport
    hasAnswerbaseSupport
    hasCheckInSupport
    isUniversityProgram
    openToEnrollments
    marketing {
      timeCommitment
      video
      thumbnail
      highlights
      title
      subtitle
      sectionTitle
      sectionSummary
      accessFee
      programDuration
    }
    cohorts {
      id
      name
    }
    linkedProgramCourses {
      id
      name
      createdAt
      updatedAt
      priority
      credits
      program {
        id
        name
      }
      courseDefinition {
        id
        name
        abbreviation
        description
        createdAt
        updatedAt
        category
        programs {
          id
          name
          abbreviation
        }
        linkedProgramCourses {
          id
          name
          priority
          credits
        }
        classes {
          id
        }
      }
      mustHavePrerequisites {
        id
        name
        abbreviation
      }
      oneOfPrerequisites {
        id
        name
        abbreviation
      }
      doneWithPrerequisites {
        id
        name
        abbreviation
      }
      maxDeferrals
      maxRetakes
    }
  }
}
    `;
export const AdminGetProgramApplicationsDocument = gql`
    query AdminGetProgramApplications($programId: ID!, $pageNumber: Int!, $pageSize: Int!, $searchString: String, $englishProficiencyStatus: [EnglishProficiencyStatus], $highSchoolVerificationMode: [HighSchoolVerificationMode!], $personaIdentityInquiryLifecycleStatus: [PersonaInquiryLifecycleStatus!], $personaIdentityInquiryDecisionStatus: [PersonaInquiryDecisionStatus!], $highSchoolCertificateStatus: [HighSchoolCertificateStatus!], $personaHighschoolInquiryLifecycleStatus: [PersonaInquiryLifecycleStatus!], $personaHighschoolInquiryDecisionStatus: [PersonaInquiryDecisionStatus!], $partnershipType: [PartnershipType!], $admissionStatus: [ProgramApplicationAdmissionStatus!]) {
  adminGetProgramDetails(programId: $programId) {
    id
    paginatedProgramApplications(
      pageNumber: $pageNumber
      pageSize: $pageSize
      searchString: $searchString
      englishProficiencyStatus: $englishProficiencyStatus
      highSchoolVerificationMode: $highSchoolVerificationMode
      personaIdentityInquiryLifecycleStatus: $personaIdentityInquiryLifecycleStatus
      personaIdentityInquiryDecisionStatus: $personaIdentityInquiryDecisionStatus
      highSchoolCertificateStatus: $highSchoolCertificateStatus
      personaHighschoolInquiryLifecycleStatus: $personaHighschoolInquiryLifecycleStatus
      personaHighschoolInquiryDecisionStatus: $personaHighschoolInquiryDecisionStatus
      partnershipType: $partnershipType
      admissionStatus: $admissionStatus
    ) {
      pageNumber
      pageSize
      totalCount
      totalPages
      programApplications {
        englishProficiencyFile
        englishProficiencyStatus
        englishProficiencyType
        id
        createdAt
        status
        highSchoolVerificationMode
        admissionStatus
        partnershipType
        partnershipAcademicStanding
        partnershipPaymentStatus
        feePaymentMode
        otherFeePaymentMode
        tuitionFeePaymentType
        anticipateChallenges
        additionalInfo
        sharePersonalDataConsent
        partnership {
          id
          name
          paymentPlanId
        }
        docusignEnrollmentAgreement {
          envelopeId
          envelopeStatus
          applicantStatus
          envelopeCompletedAt
          envelopeDeclinedAt
          envelopeVoidedAt
          envelopeSentAt
          envelopeDeliveredAt
          applicantCompletedAt
          applicantDeclinedAt
          applicantDeliveredAt
        }
        programEnrollment {
          id
          status
          paymentPlan {
            paymentPlanId
          }
        }
        highSchoolCertificate {
          id
          status
          schoolName
          country
          city
          state
          graduationDate
          schoolAddress
          qualification
          createdAt
          updatedAt
        }
        personaHighschoolInquiry {
          ...AdminPersonaInquiry
        }
        personaIdentityInquiry {
          ...AdminPersonaInquiry
        }
        personaPriorLearningInquiry {
          ...AdminPersonaInquiry
        }
        user {
          firstName
          middleName
          lastName
          sandId
          profilePhoto
          primaryEmail
        }
      }
    }
  }
}
    ${AdminPersonaInquiryFragmentDoc}`;
export const AdminUserStatsDocument = gql`
    query AdminUserStats {
  userStats {
    totalUsersCount
    totalUsersCountDiffPercentage
    last7DaysActive
    last7DaysActiveDiffPercentage
    lastDayActive
    lastDayActiveDiffPercentage
    lastTimeBucketActive
    lastTimeBucketActiveDiffPercentage
    activeUsersByTimeBucket {
      timeBucketIndex
      timeBucket
      usersCount
    }
    recentUsers {
      sandId
      country
      city
      mobileActivityAt
      androidActivityAt
      iosActivityAt
      desktopActivityAt
      tabletActivityAt
      smartTvActivityAt
      user {
        sandId
        primaryEmail
        profilePhoto
        firstName
        lastName
      }
    }
  }
}
    `;
export const StaffViewUserDocument = gql`
    query staffViewUser($sandId: ID!) {
  staffViewUser(sandId: $sandId) {
    sandId
    bio
    birthDate
    countryOfOrigin
    countryOfResidence
    countyOfOrigin
    countyOfResidence
    coverPhoto
    cv
    educationHistory {
      fieldOfStudy
      graduatedAt
      id
      institutionCountry
      institutionCounty
      institutionLocality
      institutionName
      levelOfStudy
      startDate
      createdAt
      updatedAt
    }
    firstName
    gender
    interests
    isEmployed
    languages {
      id
      language
      proficiencyLevel
      createdAt
      updatedAt
    }
    lastName
    localityOfOrigin
    localityOfResidence
    lockedProgression
    lockedProgressionBy
    lockedProgressionByAt
    lockedProgressionByUser {
      sandId
      firstName
      lastName
    }
    middleName
    openToNewPositions
    phoneNumber
    primaryEmail
    profilePhoto
    programEnrollments {
      ...AdminProgramEnrollmentView
      cumulativeGPA
      academicStanding
      academicConductCases {
        ...AcademicConductCase
      }
      termGPAs {
        id
        term
        gpa
      }
      program {
        isUniversityProgram
        name
      }
      courseEnrollments {
        id
        status
        graduatedAt
        failedAt
        letterGrade
        gradePointsValue
        course {
          id
          name
          abbreviation
        }
        classEnrollments {
          id
          letterGrade
          gradePoints
          gradePointsValue
          status
          graduatedAt
          failedAt
          cancelled
          class {
            id
            term
            startDate
            name
          }
        }
      }
      plannedCourses {
        id
        credits
        courseGroupKey
        details {
          id
          name
          abbreviation
        }
        enrollment {
          id
          status
          graduatedAt
          failedAt
          letterGrade
          gradePointsValue
          currentClass {
            id
            letterGrade
            gradePoints
            gradePointsValue
            status
          }
          classEnrollments {
            id
            letterGrade
            gradePoints
            gradePointsValue
            status
            graduatedAt
            failedAt
          }
        }
      }
      user {
        sandId
        firstName
        lastName
      }
    }
    removedPaywallAt
    sandId
    skills
    skipPaywallUntil
    skipPaywallReason
    socialLinks {
      facebook
      github
      linkedIn
      tikTok
      twitter
      youtube
    }
    title
    whatsAppNumber
    workExperience {
      ...WorkExperience
    }
  }
}
    ${AdminProgramEnrollmentViewFragmentDoc}
${AcademicConductCaseFragmentDoc}
${WorkExperienceFragmentDoc}`;
export const StaffViewSavannaDetailsDocument = gql`
    query staffViewSavannaDetails($sandId: ID!) {
  staffViewUser(sandId: $sandId) {
    sandId
    regularUser {
      sandId
      userCurriculumStatuses {
        id
        status
        curriculum {
          id
          name
        }
        batch {
          id
          name
        }
      }
    }
  }
}
    `;
export const StaffGetProgramEnrollmentPaymentPlansDocument = gql`
    query staffGetProgramEnrollmentPaymentPlans($sandId: ID!) {
  staffViewUser(sandId: $sandId) {
    sandId
    skipPaywallUntil
    skipPaywallReason
    removedPaywallAt
    regularUser {
      sandId
      programEnrollments {
        id
        status
        paymentPlan {
          paymentPlanId
        }
        program {
          id
          abbreviation
        }
      }
      paymentPlans {
        planIdentifier
        paymentPlanId
        status
        totalPaidAmount
        totalAmount
        billingState
        startDate
        endDate
        viewUrl
        secondsToCancellation
        secondsToNextPayment
        endDate
        code
        nextInvoice {
          id
          name
          amount
          status
          dueDate
        }
        incompleteTransactions {
          amount
          createdAt
          currency
          dismissedAt
          description
          gateway
          icon
          id
          paymentId
          reason
          retryUrl
          status
        }
        invoices {
          id
          createdAt
          dueDate
          name
          amount
          updatedAt
          status
          viewInvoiceUrl
          downloadInvoiceUrl
        }
        payments {
          id
          name
          status
          url
          currencyUsed
          amount
          paidAt
          viewReceiptUrl
          downloadReceiptUrl
        }
        definition {
          id
          amount
          description
          instalments
          name
        }
      }
    }
  }
}
    `;
export const StaffGetSemesterPaymentPlansDocument = gql`
    query StaffGetSemesterPaymentPlans($sandId: ID!) {
  staffViewUser(sandId: $sandId) {
    sandId
    skipPaywallUntil
    skipPaywallReason
    removedPaywallAt
    regularUser {
      sandId
      paymentPlans {
        ...PaymentPlan
        instalmentsPaid
        amountPerInstalment
        amountPerSemester
        nextPaymentDate
        previousSemesterPaidAmount
        previousSemesterPaidInstalments
        previousSemesterRemainingAmount
        previousSemesterRemainingInstalments
        currentSemesterPaidAmount
        currentSemesterPaidInstalments
        currentSemesterRemainingAmount
        currentSemesterRemainingInstalments
        nextSemesterPaidAmount
        nextSemesterPaidInstalments
        nextSemesterRemainingAmount
        nextSemesterRemainingInstalments
        cancelDate
        totalPaidAmount
        cancellationAmount
        payments {
          id
          name
          status
          url
          currencyUsed
          amount
          paidAt
          viewReceiptUrl
          downloadReceiptUrl
        }
      }
    }
  }
}
    ${PaymentPlanFragmentDoc}`;
export const AdminGetRolesDocument = gql`
    query AdminGetRoles {
  roles {
    ...Role
  }
}
    ${RoleFragmentDoc}`;
export const AdminSearchUsersForRoleDocument = gql`
    query AdminSearchUsersForRole($roleId: Int!, $hasRole: Boolean, $search: String, $limit: Int, $offset: Int) {
  adminSearchUsersForRole(
    roleId: $roleId
    hasRole: $hasRole
    search: $search
    limit: $limit
    offset: $offset
  ) {
    users {
      sandId
      firstName
      lastName
      primaryEmail
    }
    totalCount
    totalPages
    hasNextPage
    hasPreviousPage
  }
}
    `;
export const GetPaymentDashboardsDocument = gql`
    query GetPaymentDashboards {
  paymentDashboard {
    id
    createdAt
    updatedAt
    url
    name
  }
}
    `;
export const AdminGetSavannaStatusDocument = gql`
    query AdminGetSavannaStatus($sandId: ID!) {
  adminGetUserDetails(sandId: $sandId) {
    sandId
    userCurriculumStatuses {
      batch {
        id
      }
      curriculum {
        id
      }
      status
    }
  }
}
    `;
export const AdminGetPaginatedAuditLogsDocument = gql`
    query AdminGetPaginatedAuditLogs($pageNumber: Int!, $pageSize: Int!, $actorSandId: String, $targetSandId: String, $action: AuditAction, $actions: [AuditAction!], $operationType: OperationType, $startDate: String, $endDate: String) {
  adminGetPaginatedAuditLogs(
    pageNumber: $pageNumber
    pageSize: $pageSize
    actorSandId: $actorSandId
    targetSandId: $targetSandId
    action: $action
    actions: $actions
    operationType: $operationType
    startDate: $startDate
    endDate: $endDate
  ) {
    pageNumber
    pageSize
    totalCount
    totalPages
    auditLogs {
      id
      createdAt
      operationType
      action
      actorSandId
      actorRoles
      targetSandId
      targetEntityType
      targetEntityId
      inputData
      metadata
      actorUser {
        sandId
        primaryEmail
        firstName
        lastName
        profilePhoto
      }
      targetUser {
        sandId
        primaryEmail
        firstName
        lastName
        profilePhoto
      }
    }
  }
}
    `;
export const AdminPartnershipsDocument = gql`
    query AdminPartnerships {
  adminPartnerships {
    id
    createdAt
    updatedAt
    name
    paymentPlanId
    startDate
    totalTuition
    discount
    termTuition
    totalTuitionNetOfDiscounts
  }
}
    `;
export const AdminTrainingResourcesDocument = gql`
    query AdminTrainingResources {
  adminTrainingResources {
    id
    createdAt
    updatedAt
    title
    description
    url
    createdBy
    creator {
      sandId
      firstName
      lastName
    }
  }
}
    `;
export const StaffBadgeDefinitionsDocument = gql`
    query StaffBadgeDefinitions($status: BadgeDefinitionStatus) {
  badgeDefinitions(status: $status) {
    id
    name
    description
    criteriaText
    imageUrl
    status
    courseDefinitionId
    courseName
    courseAbbreviation
    createdAt
    updatedAt
  }
}
    `;
export const StaffBadgeDefinitionDocument = gql`
    query StaffBadgeDefinition($id: String!) {
  badgeDefinition(id: $id) {
    id
    name
    description
    criteriaText
    imageUrl
    status
    courseDefinitionId
    courseName
    courseAbbreviation
    createdAt
    updatedAt
  }
}
    `;
export const StaffCertificateDefinitionsDocument = gql`
    query StaffCertificateDefinitions($status: CertificateDefinitionStatus) {
  certificateDefinitions(status: $status) {
    id
    name
    description
    criteriaText
    status
    programId
    programName
    programAbbreviation
    createdAt
    updatedAt
  }
}
    `;
export const StaffCertificateDefinitionDocument = gql`
    query StaffCertificateDefinition($id: String!) {
  certificateDefinition(id: $id) {
    id
    name
    description
    criteriaText
    templateConfig
    status
    programId
    programName
    programAbbreviation
    createdAt
    updatedAt
  }
}
    `;
export const AdminGetPaginatedProgramEnrollmentsDocument = gql`
    query AdminGetPaginatedProgramEnrollments($programId: String!, $pageNumber: Int!, $pageSize: Int!, $searchString: String, $statuses: [ProgramEnrollmentStatus!], $hasWithdrawalReason: Boolean, $cancelled: Boolean, $academicStandings: [AcademicStanding!], $orderByField: String, $orderByDirection: String) {
  adminGetPaginatedProgramEnrollments(
    programId: $programId
    pageNumber: $pageNumber
    pageSize: $pageSize
    searchString: $searchString
    statuses: $statuses
    hasWithdrawalReason: $hasWithdrawalReason
    cancelled: $cancelled
    academicStandings: $academicStandings
    orderByField: $orderByField
    orderByDirection: $orderByDirection
  ) {
    pageNumber
    pageSize
    totalCount
    totalPages
    programEnrollments {
      id
      status
      createdAt
      failedAt
      withdrawalReason
      withdrawalDescription
      cancelled
      cumulativeGPA
      academicStanding
      user {
        sandId
        firstName
        lastName
        primaryEmail
        profilePhoto
      }
    }
  }
}
    `;
export const AdminGetGradesMappingsDocument = gql`
    query AdminGetGradesMappings {
  adminGetGradesMappings {
    mappings {
      id
      letterGrade
      minGradePoints
      gradePointsValue
      programId
    }
    hasProgramSpecificMappings
  }
}
    `;
export const AddEducationDocument = gql`
    mutation AddEducation($input: AddEducationInput!) {
  addEducation(input: $input) {
    user {
      educationHistory {
        ...Education
      }
      sandId
    }
  }
}
    ${EducationFragmentDoc}`;
export const AddLanguageSkillsDocument = gql`
    mutation AddLanguageSkills($input: AddLanguageSkillsInput!) {
  addLanguageSkills(input: $input) {
    user {
      languages {
        ...LanguageSkill
      }
      sandId
    }
  }
}
    ${LanguageSkillFragmentDoc}`;
export const CreateDashboardDocument = gql`
    mutation CreateDashboard($dashboardId: String!, $name: String!) {
  createDashboard(input: {dashboardId: $dashboardId, name: $name}) {
    user {
      sandId
      availableDashboards {
        ...Dashboard
      }
    }
  }
}
    ${DashboardFragmentDoc}`;
export const CreateOrUpdateProofOfCompletionDocument = gql`
    mutation CreateOrUpdateProofOfCompletion($input: CreateOrUpdateProofOfCompletionInput!) {
  createOrUpdateProofOfCompletion(input: $input) {
    proofOfCompletion {
      classEnrollment {
        id
        status
        proofOfCompletion {
          email
          examLocation
          examScore
          examValidationNumber
          firstName
          lastName
          examStatement
          user {
            sandId
          }
        }
      }
    }
  }
}
    `;
export const CreateUploadDocument = gql`
    mutation CreateUpload($input: CreateUploadInput!) {
  createUpload(input: $input) {
    fields {
      key
      value
    }
    fileUrl
    uploadUrl
  }
}
    `;
export const CreateWorkExperienceDocument = gql`
    mutation CreateWorkExperience($input: CreateWorkExperienceInput!) {
  createWorkExperience(input: $input) {
    user {
      sandId
      workExperience {
        ...WorkExperience
      }
    }
  }
}
    ${WorkExperienceFragmentDoc}`;
export const DeleteCvDocument = gql`
    mutation DeleteCv($input: DeleteCvInput!) {
  deleteCv(input: $input) {
    user {
      cv
      sandId
    }
  }
}
    `;
export const DeleteRefugeeCardDocument = gql`
    mutation DeleteRefugeeCard($input: DeleteRefugeeCardInput!) {
  deleteRefugeeCard(input: $input) {
    user {
      refugeeCard
      sandId
    }
  }
}
    `;
export const DeleteDashboardDocument = gql`
    mutation DeleteDashboard($deleteDashboardId: ID!) {
  deleteDashboard(input: {id: $deleteDashboardId}) {
    user {
      sandId
      availableDashboards {
        ...Dashboard
      }
    }
  }
}
    ${DashboardFragmentDoc}`;
export const DeleteEducationDocument = gql`
    mutation DeleteEducation($input: DeleteEducationInput!) {
  deleteEducation(input: $input) {
    user {
      sandId
      educationHistory {
        id
        fieldOfStudy
        institutionCountry
        institutionCounty
        institutionLocality
        institutionName
        knownInstitutionId
        levelOfStudy
        startDate
        updatedAt
      }
    }
  }
}
    `;
export const DeleteWorkExperienceDocument = gql`
    mutation DeleteWorkExperience($input: DeleteWorkExperienceInput!) {
  deleteWorkExperience(input: $input) {
    user {
      sandId
      workExperience {
        companyName
        country
        county
        description
        employmentType
        endDate
        id
        isOngoing
        locality
        title
        startDate
      }
    }
  }
}
    `;
export const MarkActivatedProfileAsCompletedDocument = gql`
    mutation MarkActivatedProfileAsCompleted($input: MarkActivatedProfileAsCompletedInput!) {
  markActivatedProfileAsCompleted(input: $input) {
    user {
      sandId
      onboardingPanel {
        sandId
        activatedProfile
      }
    }
  }
}
    `;
export const MarkExploredAndEngagedWithCommunityAsCompletedDocument = gql`
    mutation MarkExploredAndEngagedWithCommunityAsCompleted($input: MarkExploredAndEngagedWithCommunityAsCompletedInput!) {
  markExploredAndEngagedWithCommunityAsCompleted(input: $input) {
    user {
      sandId
      onboardingPanel {
        sandId
        exploredAndEngagedWithCommunity
      }
    }
  }
}
    `;
export const MarkNotificationsAsDismissedDocument = gql`
    mutation MarkNotificationsAsDismissed($input: MarkNotificationsAsDismissedInput!, $after: String, $before: String, $first: Int, $last: Int) {
  markNotificationsAsDismissed(input: $input) {
    user {
      notifications(after: $after, before: $before, first: $first, last: $last) {
        ...ViewerNotifications
      }
      sandId
    }
  }
}
    ${ViewerNotificationsFragmentDoc}`;
export const MarkNotificationsAsSeenDocument = gql`
    mutation MarkNotificationsAsSeen($input: MarkNotificationsAsSeenInput!, $after: String, $before: String, $first: Int, $last: Int) {
  markNotificationsAsSeen(input: $input) {
    user {
      notifications(after: $after, before: $before, first: $first, last: $last) {
        ...ViewerNotifications
      }
      sandId
    }
  }
}
    ${ViewerNotificationsFragmentDoc}`;
export const MarkOnboardingAsFinishedDocument = gql`
    mutation MarkOnboardingAsFinished($input: MarkOnboardingAsFinishedInput!) {
  markOnboardingAsFinished(input: $input) {
    user {
      sandId
      onboardingPanel {
        sandId
        finishedOnboardingAt
      }
    }
  }
}
    `;
export const MarkWatchedWelcomeVideoAsCompletedDocument = gql`
    mutation MarkWatchedWelcomeVideoAsCompleted($input: MarkWatchedWelcomeVideoAsCompletedInput!) {
  markWatchedWelcomeVideoAsCompleted(input: $input) {
    user {
      sandId
      onboardingPanel {
        sandId
        watchedWelcomeVideo
      }
    }
  }
}
    `;
export const MarkWatchedOnboardingVideoAsCompletedDocument = gql`
    mutation MarkWatchedOnboardingVideoAsCompleted($input: MarkWatchedOnboardingVideoAsCompletedInput!) {
  markWatchedOnboardingVideoAsCompleted(input: $input) {
    user {
      sandId
      onboardingPanel {
        sandId
        watchedOnboardingVideo
      }
    }
  }
}
    `;
export const UpdateCoverPhotoDocument = gql`
    mutation UpdateCoverPhoto($input: UpdateCoverPhotoInput!) {
  updateCoverPhoto(input: $input) {
    user {
      sandId
      coverPhoto
    }
  }
}
    `;
export const UpdateCvDocument = gql`
    mutation UpdateCv($input: UpdateCvInput!) {
  updateCv(input: $input) {
    user {
      sandId
      cv
    }
  }
}
    `;
export const UpdateRefugeeCardDocument = gql`
    mutation UpdateRefugeeCard($input: UpdateRefugeeCardInput!) {
  updateRefugeeCard(input: $input) {
    user {
      sandId
      refugeeCard
    }
  }
}
    `;
export const UpdateEducationDocument = gql`
    mutation UpdateEducation($input: UpdateEducationInput!) {
  updateEducation(input: $input) {
    user {
      educationHistory {
        ...Education
      }
      sandId
    }
  }
}
    ${EducationFragmentDoc}`;
export const UpdateInterestsDocument = gql`
    mutation UpdateInterests($input: UpdateInterestsInput!) {
  updateInterests(input: $input) {
    user {
      interests
      sandId
    }
  }
}
    `;
export const UpdateNotificationSettingsDocument = gql`
    mutation UpdateNotificationSettings($input: UpdateNotificationSettingsInput!) {
  updateNotificationSettings(input: $input) {
    user {
      notificationSettings {
        admissionEmail
        admissionInApp
        communityEmail
        communityEmailMentions
        communityEmailSpaces
        communityInApp
        communityInAppMentions
        communityInAppSpaces
        createdAt
        customerSupportEmail
        customerSupportInApp
        eHubEmail
        eHubInApp
        eventsEmail
        eventsPush
        learningEmail
        learningInApp
        sandId
        securityAndPrivacyEmail
        securityAndPrivacyInApp
        securityAndPrivacyPush
        updatedAt
      }
      sandId
    }
  }
}
    `;
export const UpdateProfilePhotoDocument = gql`
    mutation UpdateProfilePhoto($input: UpdateProfilePhotoInput!) {
  updateProfilePhoto(input: $input) {
    user {
      sandId
      profilePhoto
    }
  }
}
    `;
export const UpdateSkillsDocument = gql`
    mutation UpdateSkills($input: UpdateSkillsInput!) {
  updateSkills(input: $input) {
    user {
      sandId
      skills
    }
  }
}
    `;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    user {
      bio
      birthDate
      countryOfOrigin
      countryOfResidence
      countyOfOrigin
      countyOfResidence
      coverPhoto
      cv
      educationHistory {
        ...Education
      }
      firstName
      gender
      isEmployed
      lastName
      localityOfOrigin
      localityOfResidence
      middleName
      profilePhoto
      phoneNumber
      sandId
      socialLinks {
        facebook
        github
        linkedIn
        twitter
      }
      primaryEmail
      whatsAppNumber
      workExperience {
        ...WorkExperience
      }
      previouslyEnrolledInALX
      highestLevelOfStudy
      fieldOfStudy
      portfolioAndProjects
      employmentType
      topCareerGoal
      guardianship
      locationDescription
      livingCircumstances
      householdMonthlyIncomeUSD
      disability
      humanitarianStatus
      humanitarianStatusType
      refugeeCard
    }
  }
}
    ${EducationFragmentDoc}
${WorkExperienceFragmentDoc}`;
export const UpdateWorkExperienceDocument = gql`
    mutation UpdateWorkExperience($input: UpdateWorkExperienceInput!) {
  updateWorkExperience(input: $input) {
    user {
      sandId
      workExperience {
        ...WorkExperience
      }
    }
  }
}
    ${WorkExperienceFragmentDoc}`;
export const AdminAddClassDocument = gql`
    mutation AdminAddClass($input: AdminAddClassInput!) {
  adminAddClass(input: $input) {
    class {
      id
    }
  }
}
    `;
export const AdminAddCohortDocument = gql`
    mutation AdminAddCohort($input: AdminAddCohortInput!) {
  adminAddCohort(input: $input) {
    cohort {
      id
      name
    }
  }
}
    `;
export const AdminAddCourseDefinitionDocument = gql`
    mutation AdminAddCourseDefinition($input: AdminAddCourseDefinitionInput!) {
  adminAddCourseDefinition(input: $input) {
    course {
      id
      name
      description
      abbreviation
    }
  }
}
    `;
export const AdminAddCoursePrerequisitesDocument = gql`
    mutation AdminAddCoursePrerequisites($input: AdminAddCoursePrerequisitesInput!) {
  adminAddCoursePrerequisites(input: $input) {
    programCourse {
      id
      mustHavePrerequisites {
        id
      }
      oneOfPrerequisites {
        id
      }
      doneWithPrerequisites {
        id
      }
    }
  }
}
    `;
export const AdminAddLeaveOfAbsenceToLearnerDocument = gql`
    mutation AdminAddLeaveOfAbsenceToLearner($input: AdminAddLeaveOfAbsenceToLearnerInput!) {
  adminAddLeaveOfAbsenceToLearner(input: $input) {
    programEnrollment {
      id
      leaveOfAbsenceDescription
      leaveOfAbsenceReason
    }
  }
}
    `;
export const AdminAddProgramDocument = gql`
    mutation AdminAddProgram($input: AdminAddProgramInput!) {
  adminAddProgram(input: $input) {
    program {
      id
    }
  }
}
    `;
export const AdminUpdateProgramDocument = gql`
    mutation AdminUpdateProgram($input: AdminUpdateProgramInput!) {
  adminUpdateProgram(input: $input) {
    program {
      id
    }
  }
}
    `;
export const AdminUpdateProgramApplicationEnglishProficiencyDocument = gql`
    mutation AdminUpdateProgramApplicationEnglishProficiency($input: AdminUpdateProgramApplicationEnglishProficiencyInput!) {
  adminUpdateProgramApplicationEnglishProficiency(input: $input) {
    programApplication {
      id
      englishProficiencyStatus
    }
  }
}
    `;
export const AdminUpdateProgramApplicationAdmissionStatusDocument = gql`
    mutation AdminUpdateProgramApplicationAdmissionStatus($input: AdminUpdateProgramApplicationAdmissionStatusInput!) {
  adminUpdateProgramApplicationAdmissionStatus(input: $input) {
    programApplication {
      id
      admissionStatus
      docusignEnrollmentAgreement {
        envelopeId
        envelopeStatus
        applicantStatus
      }
    }
  }
}
    `;
export const AdminUpdateProgramApplicationPartnershipTypeDocument = gql`
    mutation AdminUpdateProgramApplicationPartnershipType($input: AdminUpdateProgramApplicationPartnershipTypeInput!) {
  adminUpdateProgramApplicationPartnershipType(input: $input) {
    programApplication {
      id
      partnershipType
    }
  }
}
    `;
export const AdminFinalizeDocusignAgreementDocument = gql`
    mutation AdminFinalizeDocusignAgreement($input: AdminFinalizeDocusignAgreementInput!) {
  adminFinalizeDocusignAgreement(input: $input) {
    programApplication {
      id
      status
      docusignEnrollmentAgreement {
        envelopeId
        envelopeStatus
        applicantStatus
        envelopeCompletedAt
      }
      programEnrollment {
        id
        status
        paymentPlan {
          paymentPlanId
        }
      }
    }
  }
}
    `;
export const AdminUpdateProgramApplicationPartnershipDocument = gql`
    mutation AdminUpdateProgramApplicationPartnership($input: AdminUpdateProgramApplicationPartnershipInput!) {
  adminUpdateProgramApplicationPartnership(input: $input) {
    programApplication {
      id
      partnership {
        id
        name
        paymentPlanId
      }
    }
  }
}
    `;
export const AdminAddProgramEnrollmentDocument = gql`
    mutation AdminAddProgramEnrollment($input: AdminAddProgramEnrollmentInput!) {
  adminAddProgramEnrollment(input: $input) {
    programEnrollment {
      id
      program {
        id
      }
    }
  }
}
    `;
export const AdminAddCourseEnrollmentDocument = gql`
    mutation AdminAddCourseEnrollment($input: AdminAddCourseEnrollmentInput!) {
  adminAddCourseEnrollment(input: $input) {
    courseEnrollment {
      id
      status
    }
  }
}
    `;
export const AdminAddClassEnrollmentDocument = gql`
    mutation AdminAddClassEnrollment($input: AdminAddClassEnrollmentInput!) {
  adminAddClassEnrollment(input: $input) {
    classEnrollment {
      id
      status
      class {
        id
        name
      }
    }
  }
}
    `;
export const AdminLinkCourseToProgramDocument = gql`
    mutation AdminLinkCourseToProgram($input: AdminLinkCourseToProgramInput!) {
  adminLinkCourseToProgram(input: $input) {
    programCourse {
      id
    }
  }
}
    `;
export const AdminAddLmsClassLocationDocument = gql`
    mutation AdminAddLmsClassLocation($input: AdminAddLmsClassLocationInput!) {
  adminAddLmsClassLocation(input: $input) {
    lmsClassLocation {
      id
      class {
        id
      }
    }
  }
}
    `;
export const AdminDeleteProgramCourseDocument = gql`
    mutation AdminDeleteProgramCourse($input: AdminDeleteProgramCourseInput!) {
  adminDeleteProgramCourse(input: $input) {
    programCourse {
      id
    }
  }
}
    `;
export const AdminUpdateClassDocument = gql`
    mutation AdminUpdateClass($input: AdminUpdateClassInput!) {
  adminUpdateClass(input: $input) {
    class {
      id
      name
      startDate
      endDate
    }
  }
}
    `;
export const AdminUpdateCohortDocument = gql`
    mutation AdminUpdateCohort($input: AdminUpdateCohortInput!) {
  adminUpdateCohort(input: $input) {
    cohort {
      id
      name
    }
  }
}
    `;
export const AdminUpdateCourseDefinitionDocument = gql`
    mutation AdminUpdateCourseDefinition($input: AdminUpdateCourseDefinitionInput!) {
  adminUpdateCourseDefinition(input: $input) {
    course {
      id
      name
      category
      description
    }
  }
}
    `;
export const AdminUpdateProgramCourseDocument = gql`
    mutation AdminUpdateProgramCourse($input: AdminUpdateProgramCourseInput!) {
  adminUpdateProgramCourse(input: $input) {
    programCourse {
      id
      maxDeferrals
      maxRetakes
      priority
      credits
    }
  }
}
    `;
export const AdminWithdrawLearnerFromProgramDocument = gql`
    mutation AdminWithdrawLearnerFromProgram($input: AdminWithdrawLearnerFromProgramInput!) {
  adminWithdrawLearnerFromProgram(input: $input) {
    programEnrollment {
      id
      ...AdminProgramEnrollmentView
      user {
        sandId
      }
    }
  }
}
    ${AdminProgramEnrollmentViewFragmentDoc}`;
export const AdminRecomputeProgramEnrollmentGpAsDocument = gql`
    mutation AdminRecomputeProgramEnrollmentGPAs($input: AdminRecomputeProgramEnrollmentGPAsInput!) {
  adminRecomputeProgramEnrollmentGPAs(input: $input) {
    programEnrollment {
      id
      ...AdminProgramEnrollmentView
    }
  }
}
    ${AdminProgramEnrollmentViewFragmentDoc}`;
export const MarkClassEnrollmentAsDeferredDocument = gql`
    mutation MarkClassEnrollmentAsDeferred($input: MarkClassEnrollmentAsDeferredInput!) {
  markClassEnrollmentAsDeferred(input: $input) {
    classEnrollments {
      id
      status
      statusReason
    }
  }
}
    `;
export const AddLeaveOfAbsenceToLearnerDocument = gql`
    mutation AddLeaveOfAbsenceToLearner($input: AddLeaveOfAbsenceToLearnerInput!) {
  addLeaveOfAbsenceToLearner(input: $input) {
    programEnrollment {
      id
      createdAt
      withdrawalReason
      withdrawalDescription
      leaveOfAbsenceDescription
      leaveOfAbsenceReason
      failedAt
      graduatedAt
      reinstatedAt
      status
      program {
        id
        name
        abbreviation
        description
        hasMultiCourseDisplay
        minTermCredits
        allowLeaveOfAbsence
        allowCourseDeferral
      }
      ...ProgramEnrollmentDetails
    }
  }
}
    ${ProgramEnrollmentDetailsFragmentDoc}`;
export const WithdrawFromProgramDocument = gql`
    mutation WithdrawFromProgram($input: WithdrawFromProgramInput!) {
  withdrawFromProgram(input: $input) {
    programEnrollment {
      id
      createdAt
      withdrawalReason
      withdrawalDescription
      leaveOfAbsenceDescription
      leaveOfAbsenceReason
      failedAt
      graduatedAt
      reinstatedAt
      status
      user {
        ...AvailableProgramToApply
      }
      program {
        id
        name
        abbreviation
        description
        hasMultiCourseDisplay
        minTermCredits
        allowLeaveOfAbsence
        allowCourseDeferral
      }
      ...ProgramEnrollmentDetails
    }
  }
}
    ${AvailableProgramToApplyFragmentDoc}
${ProgramEnrollmentDetailsFragmentDoc}`;
export const AdminCheckInUserDocument = gql`
    mutation AdminCheckInUser($input: AdminCheckInUserInput!) {
  adminCheckInUser(input: $input) {
    user {
      sandId
      firstName
      lastName
      profilePhoto
      title
      programEnrollments {
        ...ProgramEnrollment
      }
      currentCheckIn {
        checkedInAt
        checkedOutAt
        checkInDay
        createdAt
        hub {
          id
          address
          name
          description
          country
          county
          locality
        }
      }
    }
  }
}
    ${ProgramEnrollmentFragmentDoc}`;
export const SelfCheckInDocument = gql`
    mutation SelfCheckIn($input: SelfCheckInInput!) {
  selfCheckIn(input: $input) {
    user {
      sandId
      currentCheckIn {
        checkInDay
        createdAt
        hub {
          id
          address
          name
          description
          country
          county
          locality
        }
      }
    }
  }
}
    `;
export const AdminReinstateLearnerIntoProgramDocument = gql`
    mutation AdminReinstateLearnerIntoProgram($input: AdminReinstateLearnerIntoProgramInput!) {
  adminReinstateLearnerIntoProgram(input: $input) {
    programEnrollment {
      id
      ...AdminProgramEnrollmentView
      user {
        sandId
      }
    }
  }
}
    ${AdminProgramEnrollmentViewFragmentDoc}`;
export const AdminRemoveGraduationFromProgramEnrollmentDocument = gql`
    mutation AdminRemoveGraduationFromProgramEnrollment($input: AdminRemoveGraduationFromProgramEnrollmentInput!) {
  adminRemoveGraduationFromProgramEnrollment(input: $input) {
    programEnrollment {
      id
      ...AdminProgramEnrollmentView
      user {
        sandId
      }
    }
  }
}
    ${AdminProgramEnrollmentViewFragmentDoc}`;
export const AdminRemoveCoursePrerequisitesDocument = gql`
    mutation AdminRemoveCoursePrerequisites($input: AdminRemoveCoursePrerequisitesInput!) {
  adminRemoveCoursePrerequisites(input: $input) {
    programCourse {
      id
      mustHavePrerequisites {
        id
      }
      oneOfPrerequisites {
        id
      }
      doneWithPrerequisites {
        id
      }
    }
  }
}
    `;
export const AdminRunEnrollmentProgressionDocument = gql`
    mutation AdminRunEnrollmentProgression($input: AdminRunEnrollmentProgressionInput!) {
  adminRunEnrollmentProgression(input: $input) {
    programEnrollment {
      ...AdminProgramEnrollmentView
    }
  }
}
    ${AdminProgramEnrollmentViewFragmentDoc}`;
export const SavannaCreateLearnerDocument = gql`
    mutation SavannaCreateLearner($input: SavannaCreateLearnerInput!) {
  savannaCreateLearner(input: $input) {
    learner {
      sandId
      savannaId
    }
    errors
  }
}
    `;
export const AdminAthenaCreateLearnerDocument = gql`
    mutation AdminAthenaCreateLearner($sandId: String!, $input: CreateANewAthenaUserData!) {
  athenaCreateANewUserAccount(sandId: $sandId, input: $input) {
    success
    message
  }
}
    `;
export const AdminAthenaAssignLearnerToProgramDocument = gql`
    mutation AdminAthenaAssignLearnerToProgram($sandId: String!, $input: AllocateToProgramme!) {
  athenaAssignStudentToAProgramme(sandId: $sandId, input: $input) {
    success
    message
  }
}
    `;
export const SavannaAssignLearnerToProgramDocument = gql`
    mutation SavannaAssignLearnerToProgram($input: SavannaAssignLearnerToProgramInput!) {
  savannaAssignLearnerToProgram(input: $input) {
    learner {
      savannaId
    }
    errors
  }
}
    `;
export const CreateProgramPaymentPlanDocument = gql`
    mutation CreateProgramPaymentPlan($paymentPlanDefinitionId: String!, $sandId: String!, $planIdentifier: String!, $startDate: String!) {
  createPaymentPlan(
    paymentPlanDefinitionId: $paymentPlanDefinitionId
    sandId: $sandId
    planIdentifier: $planIdentifier
    startDate: $startDate
  ) {
    paymentPlanId
  }
}
    `;
export const AdminCreateNotificationsDocument = gql`
    mutation AdminCreateNotifications($input: AdminCreateNotificationsInput!) {
  adminCreateNotifications(input: $input) {
    count
  }
}
    `;
export const AdminPushEventsToBusDocument = gql`
    mutation AdminPushEventsToBus($input: AdminPushEventsToBusInput!) {
  adminPushEventsToBus(input: $input) {
    count
  }
}
    `;
export const SavannaWithdrawLearnerDocument = gql`
    mutation SavannaWithdrawLearner($input: SavannaWithdrawLearnerInput!) {
  savannaWithdrawLearner(input: $input) {
    userCurriculumStatus {
      status
      batch {
        id
      }
      curriculum {
        id
      }
    }
    errors
  }
}
    `;
export const CancelPaymentPlanDocument = gql`
    mutation CancelPaymentPlan($paymentPlanId: String!) {
  cancelPaymentPlan(paymentPlanId: $paymentPlanId) {
    sandId
  }
}
    `;
export const AdminManualCheckInDocument = gql`
    mutation AdminManualCheckIn($input: AdminManualCheckInInput!) {
  adminManualCheckIn(input: $input) {
    checkIn {
      hub {
        id
        name
      }
      checkedInAt
      checkedOutAt
      user {
        sandId
        firstName
        lastName
        profilePhoto
        programEnrollments {
          program {
            abbreviation
            name
          }
        }
        currentCheckIn {
          checkInDay
          checkedInAt
          checkedOutAt
          hub {
            id
            name
            locality
          }
          user {
            sandId
          }
        }
      }
    }
  }
}
    `;
export const AdminMarkOngoingClassEnrollmentAsFailedDocument = gql`
    mutation AdminMarkOngoingClassEnrollmentAsFailed($input: AdminMarkOngoingClassEnrollmentAsFailedInput!) {
  adminMarkOngoingClassEnrollmentAsFailed(input: $input) {
    classEnrollment {
      id
      status
      createdAt
      failedAt
      graduatedAt
    }
  }
}
    `;
export const AdminMarkOngoingClassEnrollmentAsGraduatedDocument = gql`
    mutation AdminMarkOngoingClassEnrollmentAsGraduated($input: AdminMarkOngoingClassEnrollmentAsGraduatedInput!) {
  adminMarkOngoingClassEnrollmentAsGraduated(input: $input) {
    classEnrollment {
      id
      status
      createdAt
      failedAt
      graduatedAt
    }
  }
}
    `;
export const AdminMarkFailedClassEnrollmentAsOngoingDocument = gql`
    mutation AdminMarkFailedClassEnrollmentAsOngoing($input: AdminMarkFailedClassEnrollmentAsOngoingInput!) {
  adminMarkFailedClassEnrollmentAsOngoing(input: $input) {
    classEnrollment {
      id
      status
      createdAt
      failedAt
      graduatedAt
    }
  }
}
    `;
export const AdminMarkFailedClassEnrollmentAsGraduatedDocument = gql`
    mutation AdminMarkFailedClassEnrollmentAsGraduated($input: AdminMarkFailedClassEnrollmentAsGraduatedInput!) {
  adminMarkFailedClassEnrollmentAsGraduated(input: $input) {
    classEnrollment {
      id
      status
      createdAt
      failedAt
      graduatedAt
    }
  }
}
    `;
export const AdminMarkGraduatedClassEnrollmentAsOngoingDocument = gql`
    mutation AdminMarkGraduatedClassEnrollmentAsOngoing($input: AdminMarkGraduatedClassEnrollmentAsOngoingInput!) {
  adminMarkGraduatedClassEnrollmentAsOngoing(input: $input) {
    classEnrollment {
      id
      status
      createdAt
      failedAt
      graduatedAt
    }
  }
}
    `;
export const AdminMarkGraduatedClassEnrollmentAsFailedDocument = gql`
    mutation AdminMarkGraduatedClassEnrollmentAsFailed($input: AdminMarkGraduatedClassEnrollmentAsFailedInput!) {
  adminMarkGraduatedClassEnrollmentAsFailed(input: $input) {
    classEnrollment {
      id
      status
      createdAt
      failedAt
      graduatedAt
    }
  }
}
    `;
export const ApplyToProgramDocument = gql`
    mutation ApplyToProgram($programInput: ApplyToProgramInput!) {
  applyToProgram(input: $programInput) {
    user {
      sandId
      phoneNumber
      birthDate
      countryOfResidence
      ...AvailableProgramToApply
      programEnrollments {
        id
        status
        program {
          id
          name
          abbreviation
          description
          hasMultiCourseDisplay
          minTermCredits
          allowLeaveOfAbsence
          allowCourseDeferral
        }
        ...ProgramEnrollmentDetails
      }
    }
  }
}
    ${AvailableProgramToApplyFragmentDoc}
${ProgramEnrollmentDetailsFragmentDoc}`;
export const ApplyToProgramAndUpdateUserDocument = gql`
    mutation ApplyToProgramAndUpdateUser($programInput: ApplyToProgramInput!, $updateUserInput: UpdateUserInput!) {
  updateUser(input: $updateUserInput) {
    user {
      sandId
      phoneNumber
      whatsAppNumber
      gender
      birthDate
      countryOfResidence
    }
  }
  applyToProgram(input: $programInput) {
    user {
      sandId
      availablePrograms {
        id
        name
        abbreviation
        description
        marketing {
          title
          subtitle
          sectionSummary
          sectionTitle
          timeCommitment
          video
          thumbnail
          highlights
        }
        isEnrolled
        potentialProgramJourney {
          startDate
          potentialCourseEnrollments {
            existingEnrollment {
              id
              status
              class {
                id
                startDate
                endDate
              }
              courseEnrollment {
                id
                status
              }
            }
            firstAvailableClass {
              id
              startDate
              endDate
            }
            courseDetails {
              id
              name
              abbreviation
              description
            }
          }
        }
      }
      programEnrollments {
        id
        status
        program {
          id
          name
          abbreviation
          description
          hasMultiCourseDisplay
          minTermCredits
          allowLeaveOfAbsence
          allowCourseDeferral
        }
        ...ProgramEnrollmentDetails
      }
    }
  }
}
    ${ProgramEnrollmentDetailsFragmentDoc}`;
export const CreateProgramApplicationDocument = gql`
    mutation CreateProgramApplication($input: CreateProgramApplicationInput!) {
  createProgramApplication(input: $input) {
    programApplication {
      id
      status
    }
  }
}
    `;
export const UpdateProgramApplicationEnglishProficiencyProofDocument = gql`
    mutation UpdateProgramApplicationEnglishProficiencyProof($input: UpdateProgramApplicationEnglishProficiencyProofInput!) {
  updateProgramApplicationEnglishProficiencyProof(input: $input) {
    programApplication {
      id
      englishProficiencyStatus
      englishProficiencyType
    }
  }
}
    `;
export const UpdateProgramApplicationHighSchoolCertificateDocument = gql`
    mutation UpdateProgramApplicationHighSchoolCertificate($input: UpdateProgramApplicationHighSchoolCertificateInput!) {
  updateProgramApplicationHighSchoolCertificate(input: $input) {
    highSchoolCertificate {
      id
      schoolName
      country
      city
      state
      graduationDate
      schoolAddress
      qualification
    }
  }
}
    `;
export const AdminUpdateProgramApplicationHighSchoolCertificateDocument = gql`
    mutation AdminUpdateProgramApplicationHighSchoolCertificate($input: AdminUpdateProgramApplicationHighSchoolCertificateInput!) {
  adminUpdateProgramApplicationHighSchoolCertificate(input: $input) {
    highSchoolCertificate {
      id
      status
    }
  }
}
    `;
export const SavannaUpdateLearnerDocument = gql`
    mutation SavannaUpdateLearner($input: SavannaUpdateLearnerInput!) {
  savannaUpdateLearner(input: $input) {
    errors
    learner {
      sandId
    }
  }
}
    `;
export const AdminUpdateUserDocument = gql`
    mutation AdminUpdateUser($input: AdminUpdateUserInput!) {
  adminUpdateUser(input: $input) {
    user {
      sandId
      firstName
      lastName
      middleName
      phoneNumber
      birthDate
      countryOfResidence
      countyOfResidence
      localityOfResidence
    }
  }
}
    `;
export const AdminUpdateUserSkipPaywallDocument = gql`
    mutation AdminUpdateUserSkipPaywall($input: AdminUpdateUserSkipPaywallInput!) {
  adminUpdateUserSkipPaywall(input: $input) {
    user {
      sandId
      skipPaywallReason
      skipPaywallUntil
      removedPaywallAt
    }
  }
}
    `;
export const AdminCreateRoleDocument = gql`
    mutation AdminCreateRole($input: AdminCreateRoleInput!) {
  adminCreateRole(input: $input) {
    role {
      ...Role
    }
  }
}
    ${RoleFragmentDoc}`;
export const AdminUpdateRoleDocument = gql`
    mutation AdminUpdateRole($input: AdminUpdateRoleInput!) {
  adminUpdateRole(input: $input) {
    role {
      ...Role
    }
  }
}
    ${RoleFragmentDoc}`;
export const AdminDeleteRoleDocument = gql`
    mutation AdminDeleteRole($input: AdminDeleteRoleInput!) {
  adminDeleteRole(input: $input) {
    role {
      ...Role
    }
  }
}
    ${RoleFragmentDoc}`;
export const AdminAddPermissionToRoleDocument = gql`
    mutation AdminAddPermissionToRole($input: AdminAddPermissionToRoleInput!) {
  adminAddPermissionToRole(input: $input) {
    role {
      ...Role
    }
  }
}
    ${RoleFragmentDoc}`;
export const AdminRemovePermissionFromRoleDocument = gql`
    mutation AdminRemovePermissionFromRole($input: AdminRemovePermissionFromRoleInput!) {
  adminRemovePermissionFromRole(input: $input) {
    role {
      ...Role
    }
  }
}
    ${RoleFragmentDoc}`;
export const AdminAssignUserToRoleDocument = gql`
    mutation AdminAssignUserToRole($input: AdminAssignUserToRoleInput!) {
  adminAssignUserToRole(input: $input) {
    user {
      sandId
      firstName
      lastName
      primaryEmail
    }
  }
}
    `;
export const AdminRemoveUserFromRoleDocument = gql`
    mutation AdminRemoveUserFromRole($input: AdminRemoveUserFromRoleInput!) {
  adminRemoveUserFromRole(input: $input) {
    user {
      sandId
      firstName
      lastName
      primaryEmail
    }
  }
}
    `;
export const AdminBulkAssignUsersToRoleDocument = gql`
    mutation AdminBulkAssignUsersToRole($input: AdminBulkAssignUsersToRoleInput!) {
  adminBulkAssignUsersToRole(input: $input) {
    users {
      sandId
      firstName
      lastName
      primaryEmail
    }
    successCount
  }
}
    `;
export const AdminLockProgressionDocument = gql`
    mutation AdminLockProgression($input: AdminLockProgressionInput!) {
  adminLockProgression(input: $input) {
    user {
      sandId
      lockedProgression
      lockedProgressionBy
      lockedProgressionByAt
      lockedProgressionByUser {
        sandId
        firstName
        lastName
      }
    }
  }
}
    `;
export const AdminUnlockProgressionDocument = gql`
    mutation AdminUnlockProgression($input: AdminUnlockProgressionInput!) {
  adminUnlockProgression(input: $input) {
    user {
      sandId
      lockedProgression
      lockedProgressionBy
      lockedProgressionByAt
      lockedProgressionByUser {
        sandId
        firstName
        lastName
      }
    }
  }
}
    `;
export const SavannaUpdateSandIdDocument = gql`
    mutation SavannaUpdateSandId($input: SavannaUpdateSandIdInput!) {
  savannaUpdateSandId(input: $input) {
    user {
      sandId
    }
    errors
  }
}
    `;
export const ManagePersonaInquiryDocument = gql`
    mutation ManagePersonaInquiry($input: ManagePersonaInquiryInput!) {
  managePersonaInquiry(input: $input) {
    redirectUrl
  }
}
    `;
export const AdminAddPartnershipDocument = gql`
    mutation AdminAddPartnership($input: AdminAddPartnershipInput!) {
  adminAddPartnership(input: $input) {
    partnership {
      id
      createdAt
      updatedAt
      name
      paymentPlanId
      startDate
      totalTuition
      discount
      termTuition
      totalTuitionNetOfDiscounts
    }
  }
}
    `;
export const AdminUpdatePartnershipDocument = gql`
    mutation AdminUpdatePartnership($input: AdminUpdatePartnershipInput!) {
  adminUpdatePartnership(input: $input) {
    partnership {
      id
      createdAt
      updatedAt
      name
      paymentPlanId
      startDate
      totalTuition
      discount
      termTuition
      totalTuitionNetOfDiscounts
    }
  }
}
    `;
export const AdminCreateTrainingResourceDocument = gql`
    mutation AdminCreateTrainingResource($input: AdminCreateTrainingResourceInput!) {
  adminCreateTrainingResource(input: $input) {
    trainingResource {
      id
      createdAt
      updatedAt
      title
      description
      url
      createdBy
      creator {
        sandId
        firstName
        lastName
      }
    }
  }
}
    `;
export const AdminDeleteTrainingResourceDocument = gql`
    mutation AdminDeleteTrainingResource($input: AdminDeleteTrainingResourceInput!) {
  adminDeleteTrainingResource(input: $input) {
    trainingResource {
      id
    }
  }
}
    `;
export const ResendVerificationCodeDocument = gql`
    mutation ResendVerificationCode($input: ResendVerificationCodeInput!) {
  resendVerificationCode(input: $input) {
    success
  }
}
    `;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($input: ForgotPasswordInput!) {
  forgotPassword(input: $input) {
    success
  }
}
    `;
export const CreateBadgeDefinitionDocument = gql`
    mutation CreateBadgeDefinition($input: CreateBadgeDefinitionInput!) {
  createBadgeDefinition(input: $input) {
    badgeDefinition {
      id
      name
      description
      status
      courseDefinitionId
    }
  }
}
    `;
export const UpdateBadgeDefinitionDocument = gql`
    mutation UpdateBadgeDefinition($input: UpdateBadgeDefinitionInput!) {
  updateBadgeDefinition(input: $input) {
    badgeDefinition {
      id
      name
      description
      criteriaText
      imageUrl
      status
      courseDefinitionId
      createdAt
      updatedAt
    }
  }
}
    `;
export const CreateCertificateDefinitionDocument = gql`
    mutation CreateCertificateDefinition($input: CreateCertificateDefinitionInput!) {
  createCertificateDefinition(input: $input) {
    certificateDefinition {
      id
      name
      description
      status
      programId
    }
  }
}
    `;
export const UpdateCertificateDefinitionDocument = gql`
    mutation UpdateCertificateDefinition($input: UpdateCertificateDefinitionInput!) {
  updateCertificateDefinition(input: $input) {
    certificateDefinition {
      id
      name
      description
      criteriaText
      status
      programId
      createdAt
      updatedAt
    }
  }
}
    `;
export const AdminChangeProgramEnrollmentProgramDocument = gql`
    mutation AdminChangeProgramEnrollmentProgram($input: AdminChangeProgramEnrollmentProgramInput!) {
  adminChangeProgramEnrollmentProgram(input: $input) {
    programEnrollment {
      id
      ...AdminProgramEnrollmentView
    }
  }
}
    ${AdminProgramEnrollmentViewFragmentDoc}`;
export const AdminUpdateClassEnrollmentGradePointsDocument = gql`
    mutation AdminUpdateClassEnrollmentGradePoints($input: AdminUpdateClassEnrollmentGradePointsInput!) {
  adminUpdateClassEnrollmentGradePoints(input: $input) {
    classEnrollment {
      id
      gradePoints
      letterGrade
      gradePointsValue
      cancelled
      status
    }
  }
}
    `;
export const AdminCreateStaffUserDocument = gql`
    mutation AdminCreateStaffUser($input: AdminCreateStaffUserInput!) {
  adminCreateStaffUser(input: $input) {
    user {
      sandId
      firstName
      lastName
      primaryEmail
    }
  }
}
    `;
export const AdminCreateAcademicConductCaseDocument = gql`
    mutation AdminCreateAcademicConductCase($input: AdminCreateAcademicConductCaseInput!) {
  adminCreateAcademicConductCase(input: $input) {
    academicConductCase {
      ...AcademicConductCase
    }
  }
}
    ${AcademicConductCaseFragmentDoc}`;
export const AdminUpdateAcademicConductCaseDocument = gql`
    mutation AdminUpdateAcademicConductCase($input: AdminUpdateAcademicConductCaseInput!) {
  adminUpdateAcademicConductCase(input: $input) {
    academicConductCase {
      ...AcademicConductCase
    }
  }
}
    ${AcademicConductCaseFragmentDoc}`;
export const AdminResolveAcademicConductCaseDocument = gql`
    mutation AdminResolveAcademicConductCase($input: AdminResolveAcademicConductCaseInput!) {
  adminResolveAcademicConductCase(input: $input) {
    academicConductCase {
      ...AcademicConductCase
    }
  }
}
    ${AcademicConductCaseFragmentDoc}`;
export const AdminApproveAcademicConductAppealDocument = gql`
    mutation AdminApproveAcademicConductAppeal($input: AdminApproveAcademicConductAppealInput!) {
  adminApproveAcademicConductAppeal(input: $input) {
    academicConductCase {
      ...AcademicConductCase
    }
  }
}
    ${AcademicConductCaseFragmentDoc}`;
export const AdminDenyAcademicConductAppealDocument = gql`
    mutation AdminDenyAcademicConductAppeal($input: AdminDenyAcademicConductAppealInput!) {
  adminDenyAcademicConductAppeal(input: $input) {
    academicConductCase {
      ...AcademicConductCase
    }
  }
}
    ${AcademicConductCaseFragmentDoc}`;
export const SubmitAcademicConductAppealDocument = gql`
    mutation SubmitAcademicConductAppeal($input: SubmitAcademicConductAppealInput!) {
  submitAcademicConductAppeal(input: $input) {
    academicConductCase {
      id
      status
      appealSubmittedAt
      appealStatus
    }
  }
}
    `;
export const AdminReopenAcademicConductCaseDocument = gql`
    mutation AdminReopenAcademicConductCase($input: AdminReopenAcademicConductCaseInput!) {
  adminReopenAcademicConductCase(input: $input) {
    academicConductCase {
      ...AcademicConductCase
    }
  }
}
    ${AcademicConductCaseFragmentDoc}`;
export const AdminAddGradesMappingDocument = gql`
    mutation AdminAddGradesMapping($input: AdminAddGradesMappingInput!) {
  adminAddGradesMapping(input: $input) {
    gradesMapping {
      id
      letterGrade
      minGradePoints
      gradePointsValue
      programId
    }
  }
}
    `;
export const AdminUpdateGradesMappingDocument = gql`
    mutation AdminUpdateGradesMapping($input: AdminUpdateGradesMappingInput!) {
  adminUpdateGradesMapping(input: $input) {
    gradesMapping {
      id
      letterGrade
      minGradePoints
      gradePointsValue
      programId
    }
  }
}
    `;
export const AdminDeleteGradesMappingDocument = gql`
    mutation AdminDeleteGradesMapping($input: AdminDeleteGradesMappingInput!) {
  adminDeleteGradesMapping(input: $input) {
    deletedId
  }
}
    `;
export const AdminBulkRecalculateGpAsDocument = gql`
    mutation AdminBulkRecalculateGPAs($input: AdminBulkRecalculateGPAsInput!) {
  adminBulkRecalculateGPAs(input: $input) {
    queuedCount
  }
}
    `;
export const VerifyBadgeDocument = gql`
    query VerifyBadge($verificationCode: String!) {
  verifyBadge(verificationCode: $verificationCode) {
    badgeName
    badgeDescription
    criteriaText
    issuer
    badgeImageUrl
    recipientName
    issuedAt
    status
    isValid
  }
}
    `;
export const VerifyCertificateDocument = gql`
    query VerifyCertificate($verificationCode: String!) {
  verifyCertificate(verificationCode: $verificationCode) {
    certificateName
    certificateDescription
    criteriaText
    issuer
    recipientName
    issuedAt
    status
    isValid
    programName
    recipientSandId
    linkedInCertificateUrl
    imageUrl
  }
}
    `;
export const DashboardDocument = gql`
    query dashboard($dashboardId: ID!) {
  dashboard(id: $dashboardId) {
    id
    createdAt
    updatedAt
    url
    name
  }
}
    `;
export const GetViewerNotificationsDocument = gql`
    query getViewerNotifications($after: String, $before: String, $first: Int, $last: Int) {
  viewer {
    notifications(after: $after, before: $before, first: $first, last: $last) {
      ...ViewerNotifications
    }
    sandId
  }
}
    ${ViewerNotificationsFragmentDoc}`;
export const GetCheckingCodeDocument = gql`
    query getCheckingCode {
  viewer {
    sandId
    hubCheckInCode {
      value
      timeLeft
    }
    hubCheckOutCode {
      value
      timeLeft
    }
  }
}
    `;
export const GetProgramEnrollmentPaymentPlansDocument = gql`
    query GetProgramEnrollmentPaymentPlans {
  viewer {
    sandId
    programEnrollments {
      id
      status
      paymentPlan {
        paymentPlanId
      }
      program {
        id
        abbreviation
      }
    }
    paymentPlans {
      ...PaymentPlan
    }
  }
}
    ${PaymentPlanFragmentDoc}`;
export const ViewerDocument = gql`
    query Viewer {
  viewer {
    bio
    birthDate
    countryOfOrigin
    countryOfResidence
    countyOfOrigin
    countyOfResidence
    coverPhoto
    cv
    programEnrollments {
      id
    }
    currentCheckIn {
      checkedInAt
      checkedOutAt
    }
    educationHistory {
      ...Education
    }
    firstName
    gender
    interests
    isEmployed
    languages {
      ...LanguageSkill
    }
    lastName
    localityOfOrigin
    localityOfResidence
    middleName
    onboardingPanel {
      sandId
      activatedProfile
      exploredAndEngagedWithCommunity
      finishedOnboardingAt
      watchedWelcomeVideo
      watchedOnboardingVideo
    }
    openToNewPositions
    phoneNumber
    primaryEmail
    profilePhoto
    sandId
    skills
    socialLinks {
      facebook
      github
      linkedIn
      tikTok
      twitter
      youtube
    }
    title
    whatsAppNumber
    workExperience {
      ...WorkExperience
    }
    enrollmentFeatureAccess {
      hasCircleAccess
      hasAnswerbaseAccess
      hasCheckInAccess
    }
    previouslyEnrolledInALX
    highestLevelOfStudy
    fieldOfStudy
    portfolioAndProjects
    employmentType
    totalWorkExperienceDuration
    techWorkExperienceDuration
    topCareerGoal
    guardianship
    locationDescription
    livingCircumstances
    householdMonthlyIncomeUSD
    disability
    humanitarianStatus
    humanitarianStatusType
    refugeeCard
    skipPaywallUntil
  }
}
    ${EducationFragmentDoc}
${LanguageSkillFragmentDoc}
${WorkExperienceFragmentDoc}`;
export const GetViewerAvailableProgramsDocument = gql`
    query GetViewerAvailablePrograms {
  viewer {
    sandId
    availablePrograms {
      id
      name
      requiresAdditionalQuestionnaire
      abbreviation
      description
      requiresPreferredHubForEnrollment
      isUniversityProgram
      requiresTuitionQuestionnaire
      preferredHubOption {
        displayName
        value
      }
      marketing {
        title
        subtitle
        sectionSummary
        sectionTitle
        timeCommitment
        video
        thumbnail
        highlights
        accessFee
        programDuration
        legacyPoints
      }
      isEnrolled
      isGraduated
      canEnroll
      wasEnrolled
      certificateDefinition {
        id
        name
        description
        criteriaText
        templateConfig
      }
      issuedCertificate {
        id
        issuedAt
        verificationCode
        linkedInCertificateUrl
        imageUrl
      }
      potentialProgramJourney {
        startDate
        potentialCourseEnrollments {
          existingEnrollment {
            id
            status
            class {
              id
              startDate
              endDate
            }
            courseEnrollment {
              id
              status
            }
          }
          firstAvailableClass {
            id
            startDate
            endDate
          }
          courseDetails {
            id
            name
            abbreviation
            description
            badgeDefinition {
              id
              name
              imageUrl
            }
            issuedBadge {
              ...IssuedCourseBadge
            }
          }
        }
      }
    }
  }
}
    ${IssuedCourseBadgeFragmentDoc}`;
export const GetViewerLearningDetailsDocument = gql`
    query GetViewerLearningDetails {
  viewer {
    sandId
    programEnrollments {
      id
      status
      program {
        id
        name
        abbreviation
        description
        hasMultiCourseDisplay
        minTermCredits
        allowLeaveOfAbsence
        allowCourseDeferral
        allAccessPaymentPlan
        issuedCertificate {
          id
          imageUrl
          linkedInCertificateUrl
          verificationCode
          issuedAt
        }
      }
      paymentPlan {
        paymentPlanId
      }
      ...ProgramEnrollmentDetails
    }
  }
}
    ${ProgramEnrollmentDetailsFragmentDoc}`;
export const GetUsersProgramEnrollmentPaymentPlansDocument = gql`
    query GetUsersProgramEnrollmentPaymentPlans {
  viewer {
    sandId
    programEnrollments {
      id
      program {
        id
        abbreviation
      }
      paymentPlan {
        ...PaymentPlan
      }
    }
  }
}
    ${PaymentPlanFragmentDoc}`;
export const PublicViewerDocument = gql`
    query PublicViewer($sandId: ID!) {
  publicViewer(sandId: $sandId) {
    bio
    countryOfResidence
    coverPhoto
    educationHistory {
      fieldOfStudy
      graduatedAt
      id
      institutionCountry
      institutionLocality
      institutionName
      knownInstitutionId
      levelOfStudy
      startDate
    }
    firstName
    languages {
      id
      language
      proficiencyLevel
    }
    lastName
    localityOfResidence
    middleName
    openToNewPositions
    profilePhoto
    sandId
    skills
    socialLinks {
      facebook
      github
      linkedIn
      tikTok
      twitter
      youtube
    }
    title
    whatsAppNumber
    workExperience {
      companyName
      country
      description
      employmentType
      endDate
      isOngoing
      locality
      startDate
      title
      isInTech
    }
  }
}
    `;
export const GetLegacyPointsUserDocument = gql`
    query getLegacyPointsUser($where: LpUserWhereUniqueInput!) {
  lpUser(where: $where) {
    balance
  }
}
    `;
export const GetNearbyHubDocument = gql`
    query getNearbyHub($lat: Float!, $lon: Float!) {
  viewer {
    sandId
    nearbyHub(lat: $lat, lon: $lon) {
      id
      address
      name
      description
      country
      county
      locality
    }
  }
}
    `;
export const GetCurrentCheckInDocument = gql`
    query getCurrentCheckIn {
  viewer {
    sandId
    currentCheckIn {
      checkInDay
      createdAt
      checkedInAt
      checkedOutAt
      hub {
        id
        address
        name
        description
        country
        county
        locality
        equippedWith
      }
    }
  }
}
    `;
export const GetAttendanceStatsDocument = gql`
    query getAttendanceStats($hubIds: [String]) {
  attendanceStats(hubIds: $hubIds) {
    hubIds
    totalDaily
    totalDailyDiffPercentage
    totalMonthly
    totalMonthlyDiffPercentage
    totalWeekly
    totalWeeklyDiffPercentage
    top10MostRecentCheckIns {
      createdAt
      hub {
        name
      }
      type
      user {
        sandId
        firstName
        lastName
        primaryEmail
        profilePhoto
      }
    }
    totalPerHourLast24Hours {
      buckets
      bucketsActive
      now
    }
  }
}
    `;
export const GetLearnersDocument = gql`
    query getLearners($hubIds: [String], $searchString: String, $pageNumber: Int, $pageSize: Int, $lastCheckInStartDate: String, $lastCheckInEndDate: String) {
  attendanceStats(
    hubIds: $hubIds
    searchString: $searchString
    pageNumber: $pageNumber
    pageSize: $pageSize
    lastCheckInStartDate: $lastCheckInStartDate
    lastCheckInEndDate: $lastCheckInEndDate
  ) {
    learners {
      users {
        sandId
        primaryEmail
        firstName
        lastName
        profilePhoto
        programEnrollments {
          status
          preferredHub
        }
        currentCheckIn {
          checkInDay
          checkedInAt
          checkedOutAt
          hub {
            id
            name
            locality
          }
        }
      }
      totalCount
      totalPages
    }
  }
}
    `;
export const GetStaffHubsDocument = gql`
    query getStaffHubs {
  staffHubs {
    id
    country
    locality
    name
  }
}
    `;
export const GetHubCheckInsDocument = gql`
    query getHubCheckIns($pageNumber: Int, $pageSize: Int, $checkInStartDate: String, $checkInEndDate: String, $checkInDateSortOrder: String, $hubNames: [String]) {
  viewer {
    sandId
    checkInsHubNames
    hubCheckIns(
      pageNumber: $pageNumber
      pageSize: $pageSize
      checkInStartDate: $checkInStartDate
      checkInEndDate: $checkInEndDate
      checkInDateSortOrder: $checkInDateSortOrder
      hubNames: $hubNames
    ) {
      hubCheckIns {
        createdAt
        checkedInAt
        checkedOutAt
        hub {
          name
        }
      }
      totalCount
      pageNumber
      pageSize
      totalPages
    }
  }
}
    `;
export const GetViewerProgramEnrollmentsWithApplicationDocument = gql`
    query GetViewerProgramEnrollmentsWithApplication {
  viewer {
    sandId
    programEnrollments {
      id
      status
      academicStanding
      program {
        id
        name
        abbreviation
        description
        hasMultiCourseDisplay
        minTermCredits
        allowLeaveOfAbsence
        allowCourseDeferral
        marketing {
          thumbnail
          programDuration
        }
      }
      paymentPlan {
        paymentPlanId
        status
        viewUrl
        instalmentsPaid
      }
      academicConductCases {
        ...AcademicConductCaseLearner
      }
      ...ProgramEnrollmentDetails
      programApplication {
        ...ProgramApplicationForLearner
      }
    }
  }
}
    ${AcademicConductCaseLearnerFragmentDoc}
${ProgramEnrollmentDetailsFragmentDoc}
${ProgramApplicationForLearnerFragmentDoc}`;
export const AdminGetPathwayPaymentStatusDocument = gql`
    query adminGetPathwayPaymentStatus($sandId: ID) {
  adminGetUserDetails(sandId: $sandId) {
    sandId
    programEnrollments {
      id
      paymentPlan {
        paymentPlanId
        status
      }
    }
  }
}
    `;
export const GetSemesterPaymentPlansDocument = gql`
    query GetSemesterPaymentPlans {
  viewer {
    sandId
    paymentPlans {
      ...PaymentPlan
      instalmentsPaid
      amountPerInstalment
      amountPerSemester
      nextPaymentDate
      previousSemesterPaidAmount
      previousSemesterPaidInstalments
      previousSemesterRemainingAmount
      previousSemesterRemainingInstalments
      currentSemesterPaidAmount
      currentSemesterPaidInstalments
      currentSemesterRemainingAmount
      currentSemesterRemainingInstalments
      nextSemesterPaidAmount
      nextSemesterPaidInstalments
      nextSemesterRemainingAmount
      nextSemesterRemainingInstalments
      cancelDate
      totalPaidAmount
      cancellationAmount
    }
  }
}
    ${PaymentPlanFragmentDoc}`;
export const GetViewerTranscriptDocument = gql`
    query GetViewerTranscript {
  viewer {
    sandId
    firstName
    lastName
    primaryEmail
    countryOfOrigin
    birthDate
    programEnrollments {
      id
      status
      graduatedAt
      failedAt
      cumulativeGPA
      academicStanding
      termGPAs {
        id
        term
        gpa
      }
      program {
        id
        name
        abbreviation
        description
        isUniversityProgram
      }
      academicConductCases {
        ...AcademicConductCaseLearner
      }
      plannedCourses {
        id
        credits
        courseGroupKey
        details {
          id
          name
          abbreviation
          type
        }
        enrollment {
          id
          status
          graduatedAt
          failedAt
          letterGrade
          gradePointsValue
          currentClass {
            id
            letterGrade
            gradePoints
            gradePointsValue
            status
          }
          classEnrollments {
            id
            letterGrade
            gradePoints
            gradePointsValue
            status
            graduatedAt
            failedAt
            class {
              term
              startDate
              name
            }
          }
        }
      }
    }
  }
}
    ${AcademicConductCaseLearnerFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    AdminViewer(variables?: AdminViewerQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminViewerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminViewerQuery>(AdminViewerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminViewer', 'query', variables);
    },
    AdminCheckSavannaStatus(variables: AdminCheckSavannaStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminCheckSavannaStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCheckSavannaStatusQuery>(AdminCheckSavannaStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminCheckSavannaStatus', 'query', variables);
    },
    AdminGetAvailablePrograms(variables?: AdminGetAvailableProgramsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminGetAvailableProgramsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminGetAvailableProgramsQuery>(AdminGetAvailableProgramsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminGetAvailablePrograms', 'query', variables);
    },
    AdminGetUniversityPrograms(variables?: AdminGetUniversityProgramsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminGetUniversityProgramsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminGetUniversityProgramsQuery>(AdminGetUniversityProgramsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminGetUniversityPrograms', 'query', variables);
    },
    AdminGetProgramsWithCourses(variables?: AdminGetProgramsWithCoursesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminGetProgramsWithCoursesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminGetProgramsWithCoursesQuery>(AdminGetProgramsWithCoursesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminGetProgramsWithCourses', 'query', variables);
    },
    AdminGetAvailableCourses(variables?: AdminGetAvailableCoursesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminGetAvailableCoursesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminGetAvailableCoursesQuery>(AdminGetAvailableCoursesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminGetAvailableCourses', 'query', variables);
    },
    AdminGetCoursesWithClasses(variables?: AdminGetCoursesWithClassesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminGetCoursesWithClassesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminGetCoursesWithClassesQuery>(AdminGetCoursesWithClassesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminGetCoursesWithClasses', 'query', variables);
    },
    AdminGetClassDetails(variables: AdminGetClassDetailsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminGetClassDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminGetClassDetailsQuery>(AdminGetClassDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminGetClassDetails', 'query', variables);
    },
    AdminGetCohortDetails(variables: AdminGetCohortDetailsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminGetCohortDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminGetCohortDetailsQuery>(AdminGetCohortDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminGetCohortDetails', 'query', variables);
    },
    AdminGetCourseDetails(variables: AdminGetCourseDetailsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminGetCourseDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminGetCourseDetailsQuery>(AdminGetCourseDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminGetCourseDetails', 'query', variables);
    },
    AdminSearchPaginatedClassEnrollments(variables: AdminSearchPaginatedClassEnrollmentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminSearchPaginatedClassEnrollmentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSearchPaginatedClassEnrollmentsQuery>(AdminSearchPaginatedClassEnrollmentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSearchPaginatedClassEnrollments', 'query', variables);
    },
    AdminGetPaginatedUsers(variables: AdminGetPaginatedUsersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminGetPaginatedUsersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminGetPaginatedUsersQuery>(AdminGetPaginatedUsersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminGetPaginatedUsers', 'query', variables);
    },
    AdminGetProgramDetails(variables: AdminGetProgramDetailsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminGetProgramDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminGetProgramDetailsQuery>(AdminGetProgramDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminGetProgramDetails', 'query', variables);
    },
    AdminGetProgramApplications(variables: AdminGetProgramApplicationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminGetProgramApplicationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminGetProgramApplicationsQuery>(AdminGetProgramApplicationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminGetProgramApplications', 'query', variables);
    },
    AdminUserStats(variables?: AdminUserStatsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUserStatsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUserStatsQuery>(AdminUserStatsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUserStats', 'query', variables);
    },
    staffViewUser(variables: StaffViewUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StaffViewUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StaffViewUserQuery>(StaffViewUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'staffViewUser', 'query', variables);
    },
    staffViewSavannaDetails(variables: StaffViewSavannaDetailsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StaffViewSavannaDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StaffViewSavannaDetailsQuery>(StaffViewSavannaDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'staffViewSavannaDetails', 'query', variables);
    },
    staffGetProgramEnrollmentPaymentPlans(variables: StaffGetProgramEnrollmentPaymentPlansQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StaffGetProgramEnrollmentPaymentPlansQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StaffGetProgramEnrollmentPaymentPlansQuery>(StaffGetProgramEnrollmentPaymentPlansDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'staffGetProgramEnrollmentPaymentPlans', 'query', variables);
    },
    StaffGetSemesterPaymentPlans(variables: StaffGetSemesterPaymentPlansQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StaffGetSemesterPaymentPlansQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StaffGetSemesterPaymentPlansQuery>(StaffGetSemesterPaymentPlansDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'StaffGetSemesterPaymentPlans', 'query', variables);
    },
    AdminGetRoles(variables?: AdminGetRolesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminGetRolesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminGetRolesQuery>(AdminGetRolesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminGetRoles', 'query', variables);
    },
    AdminSearchUsersForRole(variables: AdminSearchUsersForRoleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminSearchUsersForRoleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSearchUsersForRoleQuery>(AdminSearchUsersForRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSearchUsersForRole', 'query', variables);
    },
    GetPaymentDashboards(variables?: GetPaymentDashboardsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPaymentDashboardsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPaymentDashboardsQuery>(GetPaymentDashboardsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPaymentDashboards', 'query', variables);
    },
    AdminGetSavannaStatus(variables: AdminGetSavannaStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminGetSavannaStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminGetSavannaStatusQuery>(AdminGetSavannaStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminGetSavannaStatus', 'query', variables);
    },
    AdminGetPaginatedAuditLogs(variables: AdminGetPaginatedAuditLogsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminGetPaginatedAuditLogsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminGetPaginatedAuditLogsQuery>(AdminGetPaginatedAuditLogsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminGetPaginatedAuditLogs', 'query', variables);
    },
    AdminPartnerships(variables?: AdminPartnershipsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminPartnershipsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPartnershipsQuery>(AdminPartnershipsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPartnerships', 'query', variables);
    },
    AdminTrainingResources(variables?: AdminTrainingResourcesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminTrainingResourcesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminTrainingResourcesQuery>(AdminTrainingResourcesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminTrainingResources', 'query', variables);
    },
    StaffBadgeDefinitions(variables?: StaffBadgeDefinitionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StaffBadgeDefinitionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StaffBadgeDefinitionsQuery>(StaffBadgeDefinitionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'StaffBadgeDefinitions', 'query', variables);
    },
    StaffBadgeDefinition(variables: StaffBadgeDefinitionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StaffBadgeDefinitionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StaffBadgeDefinitionQuery>(StaffBadgeDefinitionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'StaffBadgeDefinition', 'query', variables);
    },
    StaffCertificateDefinitions(variables?: StaffCertificateDefinitionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StaffCertificateDefinitionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StaffCertificateDefinitionsQuery>(StaffCertificateDefinitionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'StaffCertificateDefinitions', 'query', variables);
    },
    StaffCertificateDefinition(variables: StaffCertificateDefinitionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StaffCertificateDefinitionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StaffCertificateDefinitionQuery>(StaffCertificateDefinitionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'StaffCertificateDefinition', 'query', variables);
    },
    AdminGetPaginatedProgramEnrollments(variables: AdminGetPaginatedProgramEnrollmentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminGetPaginatedProgramEnrollmentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminGetPaginatedProgramEnrollmentsQuery>(AdminGetPaginatedProgramEnrollmentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminGetPaginatedProgramEnrollments', 'query', variables);
    },
    AdminGetGradesMappings(variables?: AdminGetGradesMappingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminGetGradesMappingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminGetGradesMappingsQuery>(AdminGetGradesMappingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminGetGradesMappings', 'query', variables);
    },
    AddEducation(variables: AddEducationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddEducationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddEducationMutation>(AddEducationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AddEducation', 'mutation', variables);
    },
    AddLanguageSkills(variables: AddLanguageSkillsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddLanguageSkillsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddLanguageSkillsMutation>(AddLanguageSkillsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AddLanguageSkills', 'mutation', variables);
    },
    CreateDashboard(variables: CreateDashboardMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateDashboardMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateDashboardMutation>(CreateDashboardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateDashboard', 'mutation', variables);
    },
    CreateOrUpdateProofOfCompletion(variables: CreateOrUpdateProofOfCompletionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOrUpdateProofOfCompletionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOrUpdateProofOfCompletionMutation>(CreateOrUpdateProofOfCompletionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateOrUpdateProofOfCompletion', 'mutation', variables);
    },
    CreateUpload(variables: CreateUploadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateUploadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateUploadMutation>(CreateUploadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateUpload', 'mutation', variables);
    },
    CreateWorkExperience(variables: CreateWorkExperienceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateWorkExperienceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateWorkExperienceMutation>(CreateWorkExperienceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateWorkExperience', 'mutation', variables);
    },
    DeleteCv(variables: DeleteCvMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteCvMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteCvMutation>(DeleteCvDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteCv', 'mutation', variables);
    },
    DeleteRefugeeCard(variables: DeleteRefugeeCardMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteRefugeeCardMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteRefugeeCardMutation>(DeleteRefugeeCardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteRefugeeCard', 'mutation', variables);
    },
    DeleteDashboard(variables: DeleteDashboardMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteDashboardMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteDashboardMutation>(DeleteDashboardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteDashboard', 'mutation', variables);
    },
    DeleteEducation(variables: DeleteEducationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteEducationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteEducationMutation>(DeleteEducationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteEducation', 'mutation', variables);
    },
    DeleteWorkExperience(variables: DeleteWorkExperienceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteWorkExperienceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteWorkExperienceMutation>(DeleteWorkExperienceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteWorkExperience', 'mutation', variables);
    },
    MarkActivatedProfileAsCompleted(variables: MarkActivatedProfileAsCompletedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkActivatedProfileAsCompletedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkActivatedProfileAsCompletedMutation>(MarkActivatedProfileAsCompletedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MarkActivatedProfileAsCompleted', 'mutation', variables);
    },
    MarkExploredAndEngagedWithCommunityAsCompleted(variables: MarkExploredAndEngagedWithCommunityAsCompletedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkExploredAndEngagedWithCommunityAsCompletedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkExploredAndEngagedWithCommunityAsCompletedMutation>(MarkExploredAndEngagedWithCommunityAsCompletedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MarkExploredAndEngagedWithCommunityAsCompleted', 'mutation', variables);
    },
    MarkNotificationsAsDismissed(variables: MarkNotificationsAsDismissedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkNotificationsAsDismissedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkNotificationsAsDismissedMutation>(MarkNotificationsAsDismissedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MarkNotificationsAsDismissed', 'mutation', variables);
    },
    MarkNotificationsAsSeen(variables: MarkNotificationsAsSeenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkNotificationsAsSeenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkNotificationsAsSeenMutation>(MarkNotificationsAsSeenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MarkNotificationsAsSeen', 'mutation', variables);
    },
    MarkOnboardingAsFinished(variables: MarkOnboardingAsFinishedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOnboardingAsFinishedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOnboardingAsFinishedMutation>(MarkOnboardingAsFinishedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MarkOnboardingAsFinished', 'mutation', variables);
    },
    MarkWatchedWelcomeVideoAsCompleted(variables: MarkWatchedWelcomeVideoAsCompletedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkWatchedWelcomeVideoAsCompletedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkWatchedWelcomeVideoAsCompletedMutation>(MarkWatchedWelcomeVideoAsCompletedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MarkWatchedWelcomeVideoAsCompleted', 'mutation', variables);
    },
    MarkWatchedOnboardingVideoAsCompleted(variables: MarkWatchedOnboardingVideoAsCompletedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkWatchedOnboardingVideoAsCompletedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkWatchedOnboardingVideoAsCompletedMutation>(MarkWatchedOnboardingVideoAsCompletedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MarkWatchedOnboardingVideoAsCompleted', 'mutation', variables);
    },
    UpdateCoverPhoto(variables: UpdateCoverPhotoMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCoverPhotoMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCoverPhotoMutation>(UpdateCoverPhotoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateCoverPhoto', 'mutation', variables);
    },
    UpdateCv(variables: UpdateCvMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCvMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCvMutation>(UpdateCvDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateCv', 'mutation', variables);
    },
    UpdateRefugeeCard(variables: UpdateRefugeeCardMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateRefugeeCardMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateRefugeeCardMutation>(UpdateRefugeeCardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateRefugeeCard', 'mutation', variables);
    },
    UpdateEducation(variables: UpdateEducationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateEducationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateEducationMutation>(UpdateEducationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateEducation', 'mutation', variables);
    },
    UpdateInterests(variables: UpdateInterestsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateInterestsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateInterestsMutation>(UpdateInterestsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateInterests', 'mutation', variables);
    },
    UpdateNotificationSettings(variables: UpdateNotificationSettingsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateNotificationSettingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateNotificationSettingsMutation>(UpdateNotificationSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateNotificationSettings', 'mutation', variables);
    },
    UpdateProfilePhoto(variables: UpdateProfilePhotoMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateProfilePhotoMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateProfilePhotoMutation>(UpdateProfilePhotoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateProfilePhoto', 'mutation', variables);
    },
    UpdateSkills(variables: UpdateSkillsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateSkillsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSkillsMutation>(UpdateSkillsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateSkills', 'mutation', variables);
    },
    UpdateUser(variables: UpdateUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserMutation>(UpdateUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateUser', 'mutation', variables);
    },
    UpdateWorkExperience(variables: UpdateWorkExperienceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateWorkExperienceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateWorkExperienceMutation>(UpdateWorkExperienceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateWorkExperience', 'mutation', variables);
    },
    AdminAddClass(variables: AdminAddClassMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminAddClassMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminAddClassMutation>(AdminAddClassDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminAddClass', 'mutation', variables);
    },
    AdminAddCohort(variables: AdminAddCohortMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminAddCohortMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminAddCohortMutation>(AdminAddCohortDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminAddCohort', 'mutation', variables);
    },
    AdminAddCourseDefinition(variables: AdminAddCourseDefinitionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminAddCourseDefinitionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminAddCourseDefinitionMutation>(AdminAddCourseDefinitionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminAddCourseDefinition', 'mutation', variables);
    },
    AdminAddCoursePrerequisites(variables: AdminAddCoursePrerequisitesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminAddCoursePrerequisitesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminAddCoursePrerequisitesMutation>(AdminAddCoursePrerequisitesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminAddCoursePrerequisites', 'mutation', variables);
    },
    AdminAddLeaveOfAbsenceToLearner(variables: AdminAddLeaveOfAbsenceToLearnerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminAddLeaveOfAbsenceToLearnerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminAddLeaveOfAbsenceToLearnerMutation>(AdminAddLeaveOfAbsenceToLearnerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminAddLeaveOfAbsenceToLearner', 'mutation', variables);
    },
    AdminAddProgram(variables: AdminAddProgramMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminAddProgramMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminAddProgramMutation>(AdminAddProgramDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminAddProgram', 'mutation', variables);
    },
    AdminUpdateProgram(variables: AdminUpdateProgramMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUpdateProgramMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdateProgramMutation>(AdminUpdateProgramDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUpdateProgram', 'mutation', variables);
    },
    AdminUpdateProgramApplicationEnglishProficiency(variables: AdminUpdateProgramApplicationEnglishProficiencyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUpdateProgramApplicationEnglishProficiencyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdateProgramApplicationEnglishProficiencyMutation>(AdminUpdateProgramApplicationEnglishProficiencyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUpdateProgramApplicationEnglishProficiency', 'mutation', variables);
    },
    AdminUpdateProgramApplicationAdmissionStatus(variables: AdminUpdateProgramApplicationAdmissionStatusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUpdateProgramApplicationAdmissionStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdateProgramApplicationAdmissionStatusMutation>(AdminUpdateProgramApplicationAdmissionStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUpdateProgramApplicationAdmissionStatus', 'mutation', variables);
    },
    AdminUpdateProgramApplicationPartnershipType(variables: AdminUpdateProgramApplicationPartnershipTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUpdateProgramApplicationPartnershipTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdateProgramApplicationPartnershipTypeMutation>(AdminUpdateProgramApplicationPartnershipTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUpdateProgramApplicationPartnershipType', 'mutation', variables);
    },
    AdminFinalizeDocusignAgreement(variables: AdminFinalizeDocusignAgreementMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminFinalizeDocusignAgreementMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminFinalizeDocusignAgreementMutation>(AdminFinalizeDocusignAgreementDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminFinalizeDocusignAgreement', 'mutation', variables);
    },
    AdminUpdateProgramApplicationPartnership(variables: AdminUpdateProgramApplicationPartnershipMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUpdateProgramApplicationPartnershipMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdateProgramApplicationPartnershipMutation>(AdminUpdateProgramApplicationPartnershipDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUpdateProgramApplicationPartnership', 'mutation', variables);
    },
    AdminAddProgramEnrollment(variables: AdminAddProgramEnrollmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminAddProgramEnrollmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminAddProgramEnrollmentMutation>(AdminAddProgramEnrollmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminAddProgramEnrollment', 'mutation', variables);
    },
    AdminAddCourseEnrollment(variables: AdminAddCourseEnrollmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminAddCourseEnrollmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminAddCourseEnrollmentMutation>(AdminAddCourseEnrollmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminAddCourseEnrollment', 'mutation', variables);
    },
    AdminAddClassEnrollment(variables: AdminAddClassEnrollmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminAddClassEnrollmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminAddClassEnrollmentMutation>(AdminAddClassEnrollmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminAddClassEnrollment', 'mutation', variables);
    },
    AdminLinkCourseToProgram(variables: AdminLinkCourseToProgramMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminLinkCourseToProgramMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminLinkCourseToProgramMutation>(AdminLinkCourseToProgramDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminLinkCourseToProgram', 'mutation', variables);
    },
    AdminAddLmsClassLocation(variables: AdminAddLmsClassLocationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminAddLmsClassLocationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminAddLmsClassLocationMutation>(AdminAddLmsClassLocationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminAddLmsClassLocation', 'mutation', variables);
    },
    AdminDeleteProgramCourse(variables: AdminDeleteProgramCourseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminDeleteProgramCourseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDeleteProgramCourseMutation>(AdminDeleteProgramCourseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminDeleteProgramCourse', 'mutation', variables);
    },
    AdminUpdateClass(variables: AdminUpdateClassMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUpdateClassMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdateClassMutation>(AdminUpdateClassDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUpdateClass', 'mutation', variables);
    },
    AdminUpdateCohort(variables: AdminUpdateCohortMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUpdateCohortMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdateCohortMutation>(AdminUpdateCohortDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUpdateCohort', 'mutation', variables);
    },
    AdminUpdateCourseDefinition(variables: AdminUpdateCourseDefinitionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUpdateCourseDefinitionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdateCourseDefinitionMutation>(AdminUpdateCourseDefinitionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUpdateCourseDefinition', 'mutation', variables);
    },
    AdminUpdateProgramCourse(variables: AdminUpdateProgramCourseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUpdateProgramCourseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdateProgramCourseMutation>(AdminUpdateProgramCourseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUpdateProgramCourse', 'mutation', variables);
    },
    AdminWithdrawLearnerFromProgram(variables: AdminWithdrawLearnerFromProgramMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminWithdrawLearnerFromProgramMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminWithdrawLearnerFromProgramMutation>(AdminWithdrawLearnerFromProgramDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminWithdrawLearnerFromProgram', 'mutation', variables);
    },
    AdminRecomputeProgramEnrollmentGPAs(variables: AdminRecomputeProgramEnrollmentGpAsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminRecomputeProgramEnrollmentGpAsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminRecomputeProgramEnrollmentGpAsMutation>(AdminRecomputeProgramEnrollmentGpAsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminRecomputeProgramEnrollmentGPAs', 'mutation', variables);
    },
    MarkClassEnrollmentAsDeferred(variables: MarkClassEnrollmentAsDeferredMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkClassEnrollmentAsDeferredMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkClassEnrollmentAsDeferredMutation>(MarkClassEnrollmentAsDeferredDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MarkClassEnrollmentAsDeferred', 'mutation', variables);
    },
    AddLeaveOfAbsenceToLearner(variables: AddLeaveOfAbsenceToLearnerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddLeaveOfAbsenceToLearnerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddLeaveOfAbsenceToLearnerMutation>(AddLeaveOfAbsenceToLearnerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AddLeaveOfAbsenceToLearner', 'mutation', variables);
    },
    WithdrawFromProgram(variables: WithdrawFromProgramMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WithdrawFromProgramMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<WithdrawFromProgramMutation>(WithdrawFromProgramDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'WithdrawFromProgram', 'mutation', variables);
    },
    AdminCheckInUser(variables: AdminCheckInUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminCheckInUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCheckInUserMutation>(AdminCheckInUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminCheckInUser', 'mutation', variables);
    },
    SelfCheckIn(variables: SelfCheckInMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SelfCheckInMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SelfCheckInMutation>(SelfCheckInDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SelfCheckIn', 'mutation', variables);
    },
    AdminReinstateLearnerIntoProgram(variables: AdminReinstateLearnerIntoProgramMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminReinstateLearnerIntoProgramMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminReinstateLearnerIntoProgramMutation>(AdminReinstateLearnerIntoProgramDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminReinstateLearnerIntoProgram', 'mutation', variables);
    },
    AdminRemoveGraduationFromProgramEnrollment(variables: AdminRemoveGraduationFromProgramEnrollmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminRemoveGraduationFromProgramEnrollmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminRemoveGraduationFromProgramEnrollmentMutation>(AdminRemoveGraduationFromProgramEnrollmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminRemoveGraduationFromProgramEnrollment', 'mutation', variables);
    },
    AdminRemoveCoursePrerequisites(variables: AdminRemoveCoursePrerequisitesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminRemoveCoursePrerequisitesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminRemoveCoursePrerequisitesMutation>(AdminRemoveCoursePrerequisitesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminRemoveCoursePrerequisites', 'mutation', variables);
    },
    AdminRunEnrollmentProgression(variables: AdminRunEnrollmentProgressionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminRunEnrollmentProgressionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminRunEnrollmentProgressionMutation>(AdminRunEnrollmentProgressionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminRunEnrollmentProgression', 'mutation', variables);
    },
    SavannaCreateLearner(variables: SavannaCreateLearnerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SavannaCreateLearnerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SavannaCreateLearnerMutation>(SavannaCreateLearnerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SavannaCreateLearner', 'mutation', variables);
    },
    AdminAthenaCreateLearner(variables: AdminAthenaCreateLearnerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminAthenaCreateLearnerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminAthenaCreateLearnerMutation>(AdminAthenaCreateLearnerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminAthenaCreateLearner', 'mutation', variables);
    },
    AdminAthenaAssignLearnerToProgram(variables: AdminAthenaAssignLearnerToProgramMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminAthenaAssignLearnerToProgramMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminAthenaAssignLearnerToProgramMutation>(AdminAthenaAssignLearnerToProgramDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminAthenaAssignLearnerToProgram', 'mutation', variables);
    },
    SavannaAssignLearnerToProgram(variables: SavannaAssignLearnerToProgramMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SavannaAssignLearnerToProgramMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SavannaAssignLearnerToProgramMutation>(SavannaAssignLearnerToProgramDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SavannaAssignLearnerToProgram', 'mutation', variables);
    },
    CreateProgramPaymentPlan(variables: CreateProgramPaymentPlanMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateProgramPaymentPlanMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateProgramPaymentPlanMutation>(CreateProgramPaymentPlanDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateProgramPaymentPlan', 'mutation', variables);
    },
    AdminCreateNotifications(variables: AdminCreateNotificationsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminCreateNotificationsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCreateNotificationsMutation>(AdminCreateNotificationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminCreateNotifications', 'mutation', variables);
    },
    AdminPushEventsToBus(variables: AdminPushEventsToBusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminPushEventsToBusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPushEventsToBusMutation>(AdminPushEventsToBusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPushEventsToBus', 'mutation', variables);
    },
    SavannaWithdrawLearner(variables: SavannaWithdrawLearnerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SavannaWithdrawLearnerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SavannaWithdrawLearnerMutation>(SavannaWithdrawLearnerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SavannaWithdrawLearner', 'mutation', variables);
    },
    CancelPaymentPlan(variables: CancelPaymentPlanMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CancelPaymentPlanMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CancelPaymentPlanMutation>(CancelPaymentPlanDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CancelPaymentPlan', 'mutation', variables);
    },
    AdminManualCheckIn(variables: AdminManualCheckInMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminManualCheckInMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminManualCheckInMutation>(AdminManualCheckInDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminManualCheckIn', 'mutation', variables);
    },
    AdminMarkOngoingClassEnrollmentAsFailed(variables: AdminMarkOngoingClassEnrollmentAsFailedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminMarkOngoingClassEnrollmentAsFailedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminMarkOngoingClassEnrollmentAsFailedMutation>(AdminMarkOngoingClassEnrollmentAsFailedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminMarkOngoingClassEnrollmentAsFailed', 'mutation', variables);
    },
    AdminMarkOngoingClassEnrollmentAsGraduated(variables: AdminMarkOngoingClassEnrollmentAsGraduatedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminMarkOngoingClassEnrollmentAsGraduatedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminMarkOngoingClassEnrollmentAsGraduatedMutation>(AdminMarkOngoingClassEnrollmentAsGraduatedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminMarkOngoingClassEnrollmentAsGraduated', 'mutation', variables);
    },
    AdminMarkFailedClassEnrollmentAsOngoing(variables: AdminMarkFailedClassEnrollmentAsOngoingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminMarkFailedClassEnrollmentAsOngoingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminMarkFailedClassEnrollmentAsOngoingMutation>(AdminMarkFailedClassEnrollmentAsOngoingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminMarkFailedClassEnrollmentAsOngoing', 'mutation', variables);
    },
    AdminMarkFailedClassEnrollmentAsGraduated(variables: AdminMarkFailedClassEnrollmentAsGraduatedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminMarkFailedClassEnrollmentAsGraduatedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminMarkFailedClassEnrollmentAsGraduatedMutation>(AdminMarkFailedClassEnrollmentAsGraduatedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminMarkFailedClassEnrollmentAsGraduated', 'mutation', variables);
    },
    AdminMarkGraduatedClassEnrollmentAsOngoing(variables: AdminMarkGraduatedClassEnrollmentAsOngoingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminMarkGraduatedClassEnrollmentAsOngoingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminMarkGraduatedClassEnrollmentAsOngoingMutation>(AdminMarkGraduatedClassEnrollmentAsOngoingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminMarkGraduatedClassEnrollmentAsOngoing', 'mutation', variables);
    },
    AdminMarkGraduatedClassEnrollmentAsFailed(variables: AdminMarkGraduatedClassEnrollmentAsFailedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminMarkGraduatedClassEnrollmentAsFailedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminMarkGraduatedClassEnrollmentAsFailedMutation>(AdminMarkGraduatedClassEnrollmentAsFailedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminMarkGraduatedClassEnrollmentAsFailed', 'mutation', variables);
    },
    ApplyToProgram(variables: ApplyToProgramMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ApplyToProgramMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApplyToProgramMutation>(ApplyToProgramDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ApplyToProgram', 'mutation', variables);
    },
    ApplyToProgramAndUpdateUser(variables: ApplyToProgramAndUpdateUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ApplyToProgramAndUpdateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApplyToProgramAndUpdateUserMutation>(ApplyToProgramAndUpdateUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ApplyToProgramAndUpdateUser', 'mutation', variables);
    },
    CreateProgramApplication(variables: CreateProgramApplicationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateProgramApplicationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateProgramApplicationMutation>(CreateProgramApplicationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateProgramApplication', 'mutation', variables);
    },
    UpdateProgramApplicationEnglishProficiencyProof(variables: UpdateProgramApplicationEnglishProficiencyProofMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateProgramApplicationEnglishProficiencyProofMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateProgramApplicationEnglishProficiencyProofMutation>(UpdateProgramApplicationEnglishProficiencyProofDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateProgramApplicationEnglishProficiencyProof', 'mutation', variables);
    },
    UpdateProgramApplicationHighSchoolCertificate(variables: UpdateProgramApplicationHighSchoolCertificateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateProgramApplicationHighSchoolCertificateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateProgramApplicationHighSchoolCertificateMutation>(UpdateProgramApplicationHighSchoolCertificateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateProgramApplicationHighSchoolCertificate', 'mutation', variables);
    },
    AdminUpdateProgramApplicationHighSchoolCertificate(variables: AdminUpdateProgramApplicationHighSchoolCertificateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUpdateProgramApplicationHighSchoolCertificateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdateProgramApplicationHighSchoolCertificateMutation>(AdminUpdateProgramApplicationHighSchoolCertificateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUpdateProgramApplicationHighSchoolCertificate', 'mutation', variables);
    },
    SavannaUpdateLearner(variables: SavannaUpdateLearnerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SavannaUpdateLearnerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SavannaUpdateLearnerMutation>(SavannaUpdateLearnerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SavannaUpdateLearner', 'mutation', variables);
    },
    AdminUpdateUser(variables: AdminUpdateUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUpdateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdateUserMutation>(AdminUpdateUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUpdateUser', 'mutation', variables);
    },
    AdminUpdateUserSkipPaywall(variables: AdminUpdateUserSkipPaywallMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUpdateUserSkipPaywallMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdateUserSkipPaywallMutation>(AdminUpdateUserSkipPaywallDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUpdateUserSkipPaywall', 'mutation', variables);
    },
    AdminCreateRole(variables: AdminCreateRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminCreateRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCreateRoleMutation>(AdminCreateRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminCreateRole', 'mutation', variables);
    },
    AdminUpdateRole(variables: AdminUpdateRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUpdateRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdateRoleMutation>(AdminUpdateRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUpdateRole', 'mutation', variables);
    },
    AdminDeleteRole(variables: AdminDeleteRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminDeleteRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDeleteRoleMutation>(AdminDeleteRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminDeleteRole', 'mutation', variables);
    },
    AdminAddPermissionToRole(variables: AdminAddPermissionToRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminAddPermissionToRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminAddPermissionToRoleMutation>(AdminAddPermissionToRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminAddPermissionToRole', 'mutation', variables);
    },
    AdminRemovePermissionFromRole(variables: AdminRemovePermissionFromRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminRemovePermissionFromRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminRemovePermissionFromRoleMutation>(AdminRemovePermissionFromRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminRemovePermissionFromRole', 'mutation', variables);
    },
    AdminAssignUserToRole(variables: AdminAssignUserToRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminAssignUserToRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminAssignUserToRoleMutation>(AdminAssignUserToRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminAssignUserToRole', 'mutation', variables);
    },
    AdminRemoveUserFromRole(variables: AdminRemoveUserFromRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminRemoveUserFromRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminRemoveUserFromRoleMutation>(AdminRemoveUserFromRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminRemoveUserFromRole', 'mutation', variables);
    },
    AdminBulkAssignUsersToRole(variables: AdminBulkAssignUsersToRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminBulkAssignUsersToRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminBulkAssignUsersToRoleMutation>(AdminBulkAssignUsersToRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminBulkAssignUsersToRole', 'mutation', variables);
    },
    AdminLockProgression(variables: AdminLockProgressionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminLockProgressionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminLockProgressionMutation>(AdminLockProgressionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminLockProgression', 'mutation', variables);
    },
    AdminUnlockProgression(variables: AdminUnlockProgressionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUnlockProgressionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUnlockProgressionMutation>(AdminUnlockProgressionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUnlockProgression', 'mutation', variables);
    },
    SavannaUpdateSandId(variables: SavannaUpdateSandIdMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SavannaUpdateSandIdMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SavannaUpdateSandIdMutation>(SavannaUpdateSandIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SavannaUpdateSandId', 'mutation', variables);
    },
    ManagePersonaInquiry(variables: ManagePersonaInquiryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ManagePersonaInquiryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ManagePersonaInquiryMutation>(ManagePersonaInquiryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ManagePersonaInquiry', 'mutation', variables);
    },
    AdminAddPartnership(variables: AdminAddPartnershipMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminAddPartnershipMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminAddPartnershipMutation>(AdminAddPartnershipDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminAddPartnership', 'mutation', variables);
    },
    AdminUpdatePartnership(variables: AdminUpdatePartnershipMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUpdatePartnershipMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdatePartnershipMutation>(AdminUpdatePartnershipDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUpdatePartnership', 'mutation', variables);
    },
    AdminCreateTrainingResource(variables: AdminCreateTrainingResourceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminCreateTrainingResourceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCreateTrainingResourceMutation>(AdminCreateTrainingResourceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminCreateTrainingResource', 'mutation', variables);
    },
    AdminDeleteTrainingResource(variables: AdminDeleteTrainingResourceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminDeleteTrainingResourceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDeleteTrainingResourceMutation>(AdminDeleteTrainingResourceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminDeleteTrainingResource', 'mutation', variables);
    },
    ResendVerificationCode(variables: ResendVerificationCodeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ResendVerificationCodeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ResendVerificationCodeMutation>(ResendVerificationCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ResendVerificationCode', 'mutation', variables);
    },
    ForgotPassword(variables: ForgotPasswordMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ForgotPasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ForgotPasswordMutation>(ForgotPasswordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ForgotPassword', 'mutation', variables);
    },
    CreateBadgeDefinition(variables: CreateBadgeDefinitionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateBadgeDefinitionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateBadgeDefinitionMutation>(CreateBadgeDefinitionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateBadgeDefinition', 'mutation', variables);
    },
    UpdateBadgeDefinition(variables: UpdateBadgeDefinitionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateBadgeDefinitionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateBadgeDefinitionMutation>(UpdateBadgeDefinitionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateBadgeDefinition', 'mutation', variables);
    },
    CreateCertificateDefinition(variables: CreateCertificateDefinitionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateCertificateDefinitionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCertificateDefinitionMutation>(CreateCertificateDefinitionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateCertificateDefinition', 'mutation', variables);
    },
    UpdateCertificateDefinition(variables: UpdateCertificateDefinitionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCertificateDefinitionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCertificateDefinitionMutation>(UpdateCertificateDefinitionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateCertificateDefinition', 'mutation', variables);
    },
    AdminChangeProgramEnrollmentProgram(variables: AdminChangeProgramEnrollmentProgramMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminChangeProgramEnrollmentProgramMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminChangeProgramEnrollmentProgramMutation>(AdminChangeProgramEnrollmentProgramDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminChangeProgramEnrollmentProgram', 'mutation', variables);
    },
    AdminUpdateClassEnrollmentGradePoints(variables: AdminUpdateClassEnrollmentGradePointsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUpdateClassEnrollmentGradePointsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdateClassEnrollmentGradePointsMutation>(AdminUpdateClassEnrollmentGradePointsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUpdateClassEnrollmentGradePoints', 'mutation', variables);
    },
    AdminCreateStaffUser(variables: AdminCreateStaffUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminCreateStaffUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCreateStaffUserMutation>(AdminCreateStaffUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminCreateStaffUser', 'mutation', variables);
    },
    AdminCreateAcademicConductCase(variables: AdminCreateAcademicConductCaseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminCreateAcademicConductCaseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCreateAcademicConductCaseMutation>(AdminCreateAcademicConductCaseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminCreateAcademicConductCase', 'mutation', variables);
    },
    AdminUpdateAcademicConductCase(variables: AdminUpdateAcademicConductCaseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUpdateAcademicConductCaseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdateAcademicConductCaseMutation>(AdminUpdateAcademicConductCaseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUpdateAcademicConductCase', 'mutation', variables);
    },
    AdminResolveAcademicConductCase(variables: AdminResolveAcademicConductCaseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminResolveAcademicConductCaseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminResolveAcademicConductCaseMutation>(AdminResolveAcademicConductCaseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminResolveAcademicConductCase', 'mutation', variables);
    },
    AdminApproveAcademicConductAppeal(variables: AdminApproveAcademicConductAppealMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminApproveAcademicConductAppealMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminApproveAcademicConductAppealMutation>(AdminApproveAcademicConductAppealDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminApproveAcademicConductAppeal', 'mutation', variables);
    },
    AdminDenyAcademicConductAppeal(variables: AdminDenyAcademicConductAppealMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminDenyAcademicConductAppealMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDenyAcademicConductAppealMutation>(AdminDenyAcademicConductAppealDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminDenyAcademicConductAppeal', 'mutation', variables);
    },
    SubmitAcademicConductAppeal(variables: SubmitAcademicConductAppealMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SubmitAcademicConductAppealMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SubmitAcademicConductAppealMutation>(SubmitAcademicConductAppealDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SubmitAcademicConductAppeal', 'mutation', variables);
    },
    AdminReopenAcademicConductCase(variables: AdminReopenAcademicConductCaseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminReopenAcademicConductCaseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminReopenAcademicConductCaseMutation>(AdminReopenAcademicConductCaseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminReopenAcademicConductCase', 'mutation', variables);
    },
    AdminAddGradesMapping(variables: AdminAddGradesMappingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminAddGradesMappingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminAddGradesMappingMutation>(AdminAddGradesMappingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminAddGradesMapping', 'mutation', variables);
    },
    AdminUpdateGradesMapping(variables: AdminUpdateGradesMappingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUpdateGradesMappingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdateGradesMappingMutation>(AdminUpdateGradesMappingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUpdateGradesMapping', 'mutation', variables);
    },
    AdminDeleteGradesMapping(variables: AdminDeleteGradesMappingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminDeleteGradesMappingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDeleteGradesMappingMutation>(AdminDeleteGradesMappingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminDeleteGradesMapping', 'mutation', variables);
    },
    AdminBulkRecalculateGPAs(variables: AdminBulkRecalculateGpAsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminBulkRecalculateGpAsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminBulkRecalculateGpAsMutation>(AdminBulkRecalculateGpAsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminBulkRecalculateGPAs', 'mutation', variables);
    },
    VerifyBadge(variables: VerifyBadgeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VerifyBadgeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerifyBadgeQuery>(VerifyBadgeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VerifyBadge', 'query', variables);
    },
    VerifyCertificate(variables: VerifyCertificateQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VerifyCertificateQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerifyCertificateQuery>(VerifyCertificateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VerifyCertificate', 'query', variables);
    },
    dashboard(variables: DashboardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DashboardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DashboardQuery>(DashboardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'dashboard', 'query', variables);
    },
    getViewerNotifications(variables?: GetViewerNotificationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetViewerNotificationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetViewerNotificationsQuery>(GetViewerNotificationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getViewerNotifications', 'query', variables);
    },
    getCheckingCode(variables?: GetCheckingCodeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCheckingCodeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCheckingCodeQuery>(GetCheckingCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCheckingCode', 'query', variables);
    },
    GetProgramEnrollmentPaymentPlans(variables?: GetProgramEnrollmentPaymentPlansQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetProgramEnrollmentPaymentPlansQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProgramEnrollmentPaymentPlansQuery>(GetProgramEnrollmentPaymentPlansDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetProgramEnrollmentPaymentPlans', 'query', variables);
    },
    Viewer(variables?: ViewerQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ViewerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ViewerQuery>(ViewerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Viewer', 'query', variables);
    },
    GetViewerAvailablePrograms(variables?: GetViewerAvailableProgramsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetViewerAvailableProgramsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetViewerAvailableProgramsQuery>(GetViewerAvailableProgramsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetViewerAvailablePrograms', 'query', variables);
    },
    GetViewerLearningDetails(variables?: GetViewerLearningDetailsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetViewerLearningDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetViewerLearningDetailsQuery>(GetViewerLearningDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetViewerLearningDetails', 'query', variables);
    },
    GetUsersProgramEnrollmentPaymentPlans(variables?: GetUsersProgramEnrollmentPaymentPlansQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetUsersProgramEnrollmentPaymentPlansQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUsersProgramEnrollmentPaymentPlansQuery>(GetUsersProgramEnrollmentPaymentPlansDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetUsersProgramEnrollmentPaymentPlans', 'query', variables);
    },
    PublicViewer(variables: PublicViewerQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PublicViewerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PublicViewerQuery>(PublicViewerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PublicViewer', 'query', variables);
    },
    getLegacyPointsUser(variables: GetLegacyPointsUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetLegacyPointsUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetLegacyPointsUserQuery>(GetLegacyPointsUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getLegacyPointsUser', 'query', variables);
    },
    getNearbyHub(variables: GetNearbyHubQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetNearbyHubQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetNearbyHubQuery>(GetNearbyHubDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getNearbyHub', 'query', variables);
    },
    getCurrentCheckIn(variables?: GetCurrentCheckInQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCurrentCheckInQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCurrentCheckInQuery>(GetCurrentCheckInDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCurrentCheckIn', 'query', variables);
    },
    getAttendanceStats(variables?: GetAttendanceStatsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAttendanceStatsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAttendanceStatsQuery>(GetAttendanceStatsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAttendanceStats', 'query', variables);
    },
    getLearners(variables?: GetLearnersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetLearnersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetLearnersQuery>(GetLearnersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getLearners', 'query', variables);
    },
    getStaffHubs(variables?: GetStaffHubsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetStaffHubsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetStaffHubsQuery>(GetStaffHubsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getStaffHubs', 'query', variables);
    },
    getHubCheckIns(variables?: GetHubCheckInsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetHubCheckInsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetHubCheckInsQuery>(GetHubCheckInsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getHubCheckIns', 'query', variables);
    },
    GetViewerProgramEnrollmentsWithApplication(variables?: GetViewerProgramEnrollmentsWithApplicationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetViewerProgramEnrollmentsWithApplicationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetViewerProgramEnrollmentsWithApplicationQuery>(GetViewerProgramEnrollmentsWithApplicationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetViewerProgramEnrollmentsWithApplication', 'query', variables);
    },
    adminGetPathwayPaymentStatus(variables?: AdminGetPathwayPaymentStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminGetPathwayPaymentStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminGetPathwayPaymentStatusQuery>(AdminGetPathwayPaymentStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'adminGetPathwayPaymentStatus', 'query', variables);
    },
    GetSemesterPaymentPlans(variables?: GetSemesterPaymentPlansQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSemesterPaymentPlansQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSemesterPaymentPlansQuery>(GetSemesterPaymentPlansDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSemesterPaymentPlans', 'query', variables);
    },
    GetViewerTranscript(variables?: GetViewerTranscriptQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetViewerTranscriptQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetViewerTranscriptQuery>(GetViewerTranscriptDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetViewerTranscript', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;